














































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/* EXT_OPTS_JS_EMBED_START */

if (window["ext_opts_js_external"])
{
  //console.log('exit embedded js, discovered external');
}
else
{
  window["ext_opts_js_external"] = true;
  //console.log('run embedded code');
}





(function()
{

var myAppJavaScript = function($)
{

  $(document).on("ext-opts-refresh", function(e)
  {
    console.log('refresh opts');
    extOptsMain($);
  });

  extOptsMain($);


};


function extOptsMain($)
{
  var path_to_attr = {};

  // $ in this scope references the jQuery object we'll use.
  // Don't use jQuery, or jQuery191, use the dollar sign.
  // Do this and do that, using $.


  //[type=text][data-ext-opts-path^="' + attr.id + '-"], [type=text][data-ext-opts-path-tmp^="' + attr.id + '-"]

  function toggleInputsInBox($box, mode)
  {
    var a_from, a_to;
    var a_root = 'data-ext-opts-path';

    a_from = a_root;
    a_to = a_root + '-tmp';

    if (mode)
    {
      a_to = a_root;
      a_from = a_root + '-tmp';
    }

    $box.find(`[${a_from}]`).each(function(k, el)
    {
      var $el = $(el);

      if (!$el.attr(a_to))
      {
        $el.attr(a_to, $el.attr(a_from));
        $el.removeAttr(a_from);
      }
    });

  }


  $(document).on("change", '[data-select-one-of-nested]', function(e)
  {
    var $el = $(this);
    console.log('ne- $el', $el);

    var val = $el.val();

    var base_path = $el.attr('data-ext-opts-path');
    var show_path = base_path + "-" + val;

    //data-path-box="679-2267-1811"
    // chk has nested
    //var show_sel = "[data-path-box^="679-2267-1811""
    var show_sel = `[data-path-box^="${show_path}"]`;
    console.log('ne- show_sel', show_sel);

    var $show_boxes = $(show_sel);
    console.log('ne- $show_boxes', $show_boxes);

    if ($show_boxes.find('.ext-opts-visible').length)
    {
      $show_boxes.show();
    }
    else
    {
      $show_boxes.hide();
    }

    toggleInputsInBox($show_boxes, true);

    //console.log('ne- val', val);

    var hide_paths = [];

    var $opts = $el.find('option');
    //console.log('ne- $opts', $opts);

    $opts.each(function(k, opt)
    {
      var $opt = $(opt);
      var opt_val = $opt.attr('value');
      //console.log('ne- opt_val', opt_val);

      if (opt_val != val)
      {
        var hide_path = base_path + "-" + opt_val;
        var hide_sel = `[data-path-box^="${hide_path}"]`;

        console.log('ne- hide_sel', hide_sel);

        //hide_paths.push(hide_path);
        var $hide_boxes = $(hide_sel);
        $hide_boxes.hide();
        toggleInputsInBox($hide_boxes, false);
      }

    });

    // hide items
    //data-path-box="679-2267-1811"


    // remove input names
    //           var selector_text_input =
    //'[type=text][data-ext-opts-path^="' + attr.id + '-"], [type=text][data-ext-opts-path-tmp^="' + attr.id + '-"]'

  });

  $(document).on('ext-opts-form-serialized', function()
  {
    if (!$("[data-select-one-of-nested]").length)
    {
      return;
    }

    console.log('es3-');

    if (!params.test_page || !params.localhost)
    {
      return;
    }

    var a_ser = 'data-ser'
    var $div = $(`[${a_ser}]`);

    if (0 == $div.length)
    {
      $div = $("<div/>");
      $div.attr(a_ser, 1);
      $("[data-select-one-of-nested]").after($div);
    }

    var data = $('[name*=_ext_opts_serialize]').val();

    data = data.split(",").join("<br>");
    $div.html(data);

  });


  $('.product-option').each(function(k, el)
  {
    var $el = $(el);

    $el.find('dt').each(function(k, dt)
    {
      var $dt = $(dt);

      if ($dt.text() == 'Title:')
      {
        $el.remove();
      }
    });

  });


  if (isPageCart())
  {

    /////////////////////
    /////////////////////

    console.log('ccheck - start');

    var cart_refreshed_param = 'cart_refreshed_param';

    //if (!get_url_param(cart_refreshed_param))

    if (!location.href.includes(cart_refreshed_param))
    {
      console.log('ccheck - no refreshed cart');


      fetch("/cart.js",
      {
        method: "GET",
      })
      .then(function (response)
      {
        console.log('response', response);
        return response.json();
      })
      .then (function (data)
      {
        console.log('cart JS data', data);

        //var $cart_items_html = jQuery('tr.cart-item');
        //var count = $cart_items_html.length;
        var $cart_items = document.querySelectorAll('tr.cart-item');
        var count = $cart_items.length;

        console.log('ccheck - cart_items_html, count: ', count);

        var js_count = data.item_count;
        console.log('ccheck - JS count: ', js_count);

        if (js_count > count)
        {
          console.log('go refreshing');

          var cart_url = '/cart?' + cart_refreshed_param + '=1';

          console.log('ccheck - cart_url: ', cart_url);

          location.href = cart_url;
          return;
        }

      });
    }

    console.log('ccheck - end');

    /////////////////////
    /////////////////////
  }

  
  

  $(document).on('click', '[data-question-answer]', function(e)
  {
    var $header = $(this);

    var $a = $header.closest('[data-question-answer]').find('[data-answer]');

    $a.toggle('slide');

  });
  
if (isPageCart())
{
  //fixAttributesForCart();

  if (typeof fixHiddenAttributesInCart != "undefined")
  {
    fixHiddenAttributesInCart();
  }

}

var sku = getShopifySku();

var params = getExtOptsStorefrontParams();

var $form = $('form[method=post][action*=cart]');

var input_name = 'properties[__ext_opts_js_loaded]';

var $input = $('<input/>');
$input.attr('type', 'hidden');
$input.attr('name', input_name);
$input.attr('value', params.ver_name);

$form.append($input);



if (!sku)
{
  addExtOptsJsError("SKU is not filled, exit");
  return;
}

var api_data = params.api_data;

if (!api_data[sku])
{

  console.log('Data for this SKU is not available in API data, restore options (2)');

  $('.selector-wrapper').attr('style', 'display: block !important');
  $('.selector-wrapper').find('select').attr('style', 'display: block !important');

  addExtOptsJsError("Data for SKU `" + sku + "` is not available in API data, exit");
  return;
}

function addExtOptsJsError(err_msg)
{
  //$('form[method=post][action*=cart] [type=submit]').show();

  console.log(err_msg);

  var input_name = 'properties[__ext_opts_js_errors][]';

  var $input = $('<input/>');
  $input.attr('type', 'hidden');
  $input.attr('name', input_name);
  $input.attr('value', err_msg);

  var $form = $('form[method=post][action*=cart]');
  $form.append($input);
}



;

  



function getShopifySku()
{
  if (!window.ShopifyAnalytics)
  {
    console.log('sku- no window.ShopifyAnalytics');

    var sku_attr = 'data-ext-opts-tpl-sku';
    var sku_attr_sel = '[' + sku_attr + ']';

    var $sku_el = $(sku_attr_sel);
    console.log('sku- $sku_el', $sku_el);

    if ($sku_el.length > 0)
    {
      var sku = $sku_el.attr(sku_attr);
      console.log('sku- attr', sku);

      return sku;
    }


    addExtOptsJsError("no access to window.ShopifyAnalytics, exit");
    return false;
  }

  if (!window.ShopifyAnalytics.meta)
  {
    addExtOptsJsError("no access to window.ShopifyAnalytics.meta, exit");
    return false;
  }

  var sku = '-';

  if (window.ShopifyAnalytics.meta['product'])
  {
    sku = window.ShopifyAnalytics.meta['product']['variants'][0]['sku'];
  }

  return sku;
}

// fix contact form
  var $msg = $('label[for*="ContactFormMessage-"]');
  if ($msg.length > 0)
  {
    //console.log('page has contact form, adding order number field');

    $msg.before('<label for="ContactFormOrderNumber">Order Number</label><input type="text" id="ContactFormOrderNumber" class="input-full" name="contact[order_number]" value="">');
  }

  function replaceAll(search, replacement, str)
  {
    return str.split(search).join(replacement);
  };

  function get_url_param( name, url )
	{
    if (!url) url = location.href;
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? null : results[1];
	}


function isPageProduct()
{
  if (typeof __st != 'undefined')
  {
    return ('product' == __st.p);
  }
  else
  {
    return false;
  }
}

function isPageCart()
{
  if (typeof __st != 'undefined')
  {
    if (__st.pageurl && __st.pageurl.indexOf('/cart') != -1)
    {
      return true;
    }
  }

  return false;
}

function prepend(a, v)
{
  var res = [];

  res.push(v);

  for(var j=0; j < a.length; j++)
  {
    res.push(a[j]);
  }

  return res;
}

function inArrayKv(a, k, v)
{
  for(var j=0; j < a.length; j++)
  {
    if (a[j][k] == v)
    {
      return true;
    }
  }

  return false;
}

function fixHiddenAttributesInCart()
{
  console.log('fixHiddenAttributesInCart');

  $('[data-cart-item-property-name]').each(function(k, el)
  {
    var $el = $(el);

    var t = $el.text();

    //console.log('t', "`"+t+"`");

    var s = t.substring(0,1);

    if (s == '_')
    {
      //console.log('hide-attr');
      var $p = $el.closest('[data-cart-item-property]');
      //console.log('p', $p);
      $p.hide();
    }
  });

};
  
function pageflyLayoutIsDetected()
{
  var $pf_atc = $('[data-pf-type=ProductATC]');

  if ($pf_atc.length)
  {
    return true;
  }
  else
  {
    return false;
  }
}

function pageflyQuantityField()
{
  var $qty = $('[data-pf-type=QuantityField]');
  return $qty;
}

function pageflyLayoutIsFinishLoading()
{
  var $qty = pageflyQuantityField();
  var $form = $qty.closest('form');

  if (0 == $form.length)
  {
    return true;
  }
  else
  {
    return false;
  }
}

function pageflyLayoutRebuildForm()
{
  console.log('pageflyLayoutRebuildForm4');

  var $qty = pageflyQuantityField();
  var $col = $qty.closest('[data-pf-type=Column]');

  var $btn = $col.find('button[data-product-id]');
  var btn_html = $btn[0].outerHTML;

  var $qty_box = $col.find('[data-pf-type=ProductQuantity]');
  var qty_box_html = $qty_box[0].outerHTML;


  var $form = $('<form/>');
  $btn.before($form);
  $btn.remove();
  $qty_box.remove();

  var $ext_opts_cont = $('<div/>');
  $ext_opts_cont.attr('id', 'ext-opts-container');
  $form.append($ext_opts_cont);

  var $btn_new = $('<div/>');
  $btn_new.attr('class', 'pf-btn-wrapper');
  $btn_new.attr('style', 'position: relative');
  $btn_new.append(btn_html);

  var $cover = $('<div/>');
  $cover.attr('class', 'pf-btn-cover');
  $cover.attr('style', 'position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 9999;cursor: pointer;');
  $btn_new.append($cover);

  var can_submit = false;

  $(document).on('click', '.pf-btn-wrapper, .pf-btn-cover', function(e)
  {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (can_submit)
    {
      console.log('can submit3, exit');
      return;
    }

    console.log('pf-btn-wrapper3 - click');

    can_submit = false;
    if (runValidate(e))
    {
      can_submit = true;
      console.log('send click');

      //$form.find('button[data-product-id]').click();
      $form.submit();
    }

    /*e.preventDefault();
    */
  });

  $form.append($btn_new);
  //$form.append(btn_html);

  $form.append(qty_box_html);

  $form.find('button').attr('type', 'submit');

  $form.attr('method', 'post');
  $form.attr('action', '/cart/add');
  $form.attr('accept-charset', 'UTF-8');
  $form.attr('enctype', 'multipart/form-data');

  var $inp = $('<input/>');
  $inp.attr('type', 'hidden');
  $inp.attr('name', 'form_type');
  $inp.attr('value', 'product');
  $inp.attr('utf8', '✓');
  $form.append($inp);

  var $inp = $('<input/>');
  $inp.attr('type', 'hidden');
  $inp.attr('name', 'utf8');
  $inp.attr('value', '✓');
  $form.append($inp);

  var pv_id = window.ShopifyAnalytics.meta['product']['variants'][0]['id'];
  var $inp = $('<input/>');
  $inp.attr('type', 'hidden');
  $inp.attr('name', 'id');
  $inp.attr('value', pv_id);
  $form.append($inp);

  /*$(document).on('click', '[data-adding]', function()
  {
    var $t = $(this);
    console.log('t', $t);
    var lbl = $t.attr('data-adding');
    console.log('lbl', lbl);

    var $span = $t.find('span');
    console.log('span', $span);

    if ($span.length > 0)
    {
      $span.text(lbl);
    }
    else
    {
      $t.text(lbl);
    }

  });*/

}

function pageflySubmitEffect($form)
{
  console.log("pageflySubmitEffect");

  var $adding = $form.find('[data-adding]');

  if (0 == $adding.length)
  {
    return;
  }

  var $t =  $adding
  console.log('t', $t);
  var lbl = $t.attr('data-adding');
  console.log('lbl', lbl);

  var $span = $t.find('span');
  console.log('span', $span);

  if ($span.length > 0)
  {
    $span.text(lbl);
  }
  else
  {
    $t.text(lbl);
  }
};







  //
  if (1*params.test_page)
  {

  }
  else if (params.test_with_param)
  {
    var url = location.href;
    var test_param = 'ext_opts_test';

    if (-1 == url.indexOf(test_param))
    {
      console.log("EXT OPTS App is working in the test mode, but parameter `" + test_param + "` was not provided, exit");
      console.log('params', params);
      return;
    }
  }


  var params = getExtOptsStorefrontParams();
console.log("ExtOpts JS ver: ", params.ver, params.ver_name, params.file_time);

if (window["ext_opts_params"])
{
  for(var k in window["ext_opts_params"])
  {
    if (!window["ext_opts_params"].hasOwnProperty(k))
    {
      continue;
    }
  }

  params[k] = window["ext_opts_params"][k];
}


if (params.SNAPSHOT == 'active')
{
  console.log("Use snapshot #" + params.SNAPSHOT_ID);

  if (params.SNAPSHOT_TIME)
  {
    console.log("JS was generated at: " + params.SNAPSHOT_TIME);
  }

}
else
{
  console.log("No snapshot / use fresh data");
}

if (!params.enabled)
{
  console.log("ext-opts disabled, exit");
  return;
}

var ext_opts_disable = 1*get_url_param('ext_opts_disable');
if (ext_opts_disable)
{
  if (!params.force_enable)
  {
    console.log('ext-opts - disabled by param, exit', params);
    return;
  }
}



if (!isPageProduct())
{
  console.log("ext-opts - no product page, exit");
  return;
}

var dbg = params.debug;

if (!window.ShopifyAnalytics.meta['product'])
{
  console.log("No ShopifyAnalytics data for product, exit");
  return;
}

// get sku
var sku;
var sku_main;

var product_shopify_id = window.ShopifyAnalytics.meta['product']['id'];
var product_shopify_id_with_prefix = 'id_' + product_shopify_id;

/*if (params.product_shopify_id_to_sku[product_shopify_id_with_prefix])
{
  sku = params.product_shopify_id_to_sku[product_shopify_id_with_prefix];
  console.log('sku detection - use product_shopify_id_to_sku', product_shopify_id_with_prefix, ' => ', sku);
}
else
{
*/

  sku = window.ShopifyAnalytics.meta['product']['variants'][0]['sku'];
  console.log('sku detection - use variant sku');
//}

sku_main = sku;

if (!sku)
{
  console.log("SKU is not filled, exit");
  return;
}


if (pageflyLayoutIsDetected())
{
  if (pageflyLayoutIsFinishLoading())
  {
    console.log('[pf]: pageflyLayoutDetected, loaded, rebuild form');
    pageflyLayoutRebuildForm();
  }
  else
  {
    console.log('[pf]: pageflyLayoutDetected, but not loaded yet, wait 0.1s and retry');
    setTimeout(function()
    {
      extOptsMain($);
    }, 100);

    return;
  }
}

var inputs_sequence = {};
var inputs_before = {};

var api_data = params.api_data;
var save_array_data = params.save_array_data;
var main_item = api_data[sku];

//if (params.test_page)
//{
  console.log("Data for SKU `" + sku + "`");
  console.log('position1');
  console.log(main_item);
//}

if (!api_data[sku])
{
  console.log("Data for SKU `" + sku + "` is not available in API data, exit");
  return;
}

var main_item_chk_attrs = api_data[sku]
if (!main_item_chk_attrs.attributes || (0 == main_item_chk_attrs.attributes.length))
{
  addExtOptsJsError("Data for SKU `" + sku + "` has no attributes in API data, exit");
  return;
}

var attrs = api_data[sku].attributes;
var is_kit_item = main_item.kit_item_status;


var css = params.css;
var $css_tag = "<style>" + css + "</style>";
$('head').append($css_tag);

  var $box = $('<div/>');
  $box.attr('data-ext-opts-box', '');

  $box.addClass('ext-opts-well');
  $box.addClass('ext-opts-well-base');
  $box.attr('data-sku', sku);


  if (params.show_name)
  {
    $box.prepend('<p><b>SKU: ' + sku + '</b></p>');
  }

  var $cont = $('#ext-opts-container');
  //console.log('ci- ', $cont);

  var $form;

  function extOptsExtendForm()
  {

  if (1 == $cont.length)
  {
    //console.log('ci- append existing');
    $cont.append($box);

    $form = $cont.closest('form');
  }
  else
  {
    //if (Shopify && Shopify.theme && Shopify.theme.name
      //&& "Mavon" == Shopify.theme.name)
    if ($('.product__add__cart__button').length)
    {
      console.log("Mavon detected");
      var $buy_btn = $('.product__add__cart__button:first');
      console.log('$buy_btn', $buy_btn);
      $form = $buy_btn.closest('form');
      console.log('$form', $form);
      $buy_btn.prepend($box);
    }
    else
    {
      $form = $('form[method=post][action*=cart][action*=add]:visible');

      var $select = $form.find('select:visible,.select:visible');
      var $variants = $form.find('.variants');

      if ($form.find('.js-qty.quantity-selector').length > 0)
      {
        console.log('eo- box: .js-qty.quantity-selector');
        var $qs = $form.find('.js-qty.quantity-selector');
        $qs.after($box);
      }
      else if ($form.find('#bcpo').length > 0)
      {
        console.log('eo- box: bcpo-fix prepend');
        $form.prepend($box);
        $form.find('#bcpo').hide();
      }
      else if ($select.length > 0)
      {
        console.log('eo- box: add after select');
        $select.last().after($box);
      }
      else if ($variants.length > 0)
      {
        console.log('eo- box: add after variants');
        $variants.after($box);
      }
      else
      {

        var $submit = $form.find('[type=submit], button[class*=addtocart]');

        if ($submit.length > 0)
        {
          console.log('eo- box: add before submit');
          $submit.before($box);
        }
        else
        {
          //$form.prepend($box);
          var msg = "can't find form for add properties";
          console.log('eo- ' + msg);
          addExtOptsJsError(msg);
          return;
        }

      }
    }

    }
  }
  extOptsExtendForm();



  var attr_checks = {};;


    if (get_url_param("notification_quantity"))
    {
      console.log('get_url_param("notification_quantity")', get_url_param("notification_quantity"));

      main_item.allow_notification = true;
      main_item.notification_quantity = get_url_param("notification_quantity");
      main_item.notification_on_screen = "The item is not available";

      main_item.allow_warning = true;
      main_item.warning_on_screen = "low stock";
      main_item.warning_quantity = main_item.notification_quantity/2;
    }

    if (get_url_param("warning_quantity"))
    {
      console.log('get_url_param("warning_quantity")', get_url_param("warning_quantity"));

      main_item.warning_quantity = get_url_param("warning_quantity");
    }


  runForAllItem(main_item, function(el)
  {
    console.log('rs- ', el);

    if (!el.synced)
    {
      var el_sku = el.sku;

      if (!el_sku)
      {
        el_sku = el.SKU;
      }

      if (api_data[el_sku])
      {
        var api_el = api_data[el_sku];

        el.attributes = api_el.attributes;
        el.allow_backorder = api_el.allow_backorder;
        el.force_allow_backorder = api_el.force_allow_backorder;

        if (!(1*api_el.allow_notification))
        {
          el.force_allow_backorder = true;
        }
      }
      else
      {
        console.log('dp- ', "can't find attributes");
        el.attributes = [];
        el.allow_backorder = false;
        el.force_allow_backorder = false;
      }

      el.sku = el_sku;
      el.synced = true;
    }

  });

  console.log('main_item', main_item);

    var css = main_item.custom_css;
    if (css)
    {
      var $css_tag = "<style>" + css + "</style>";
      console.log('flex-css', css);
      $('head').append($css_tag);
    }


  if (1 == combinationsCount(main_item))
  {
    main_item.comb_data = main_item.active_combinations[0];
  }

  

var last_price = null;

function vpDisplayPrice(p)
{

  if (!p)
  {
    //console.log("no price provided", p);
    p = getShopifyPrice();
    //debugger;
    //console.log("use getShopifyPrice", p);

    if (!p)
    {
      //console.log("invalid getShopifyPrice, exit");
      return;
    }
  }

  last_price = p;

  var sel = '.price-item, .product__price';
  var product_id = getShopifyProductId();

  //console.log('chk ext-opts-price2');

  var $p = $('.product-single__meta .product__price, [data-ext-opts-price], .product__title__wrapper [data-price-wrapper], [data-product-price], .price--large .price-item--regular');

  //console.log('p_init', $p, 'p_len', $p.length);

  if ($p.length == 0)
  {
    $p = $form.find(sel);
  }


  var sel_uniq = '';

  if (product_id)
  {

    sel_uniq += "[data-product-type=price][data-product-id='" + product_id + "']";
    //sel_uniq += ", [data-product-id='" + product_id + "'] form .price-item";
    sel_uniq += ", [data-ext-opts-product-type=price][data-ext-opts-product-id='" + product_id + "']";
    sel_uniq += ", #ProductPrice-" + product_id;
    sel_uniq += ", [id=product-price]";
    //sel_uniq += ", #product-" + product_id + "  .price-item";

    var $p2 = $(sel_uniq);

    if ($p2.length > 0)
    {
      //console.log('use_uniq: yes');
      $p = $p2;
      //$p.add(sel_uniq);
    }
    else
    {
      //console.log('use_uniq: no');
    }
  }
  else
  {
    //console.log('no_product_id')
  }

  //console.log('product_selector', sel,' ***', sel_uniq, $p, 'p_len', $p.length);

  if ($p.length == 0)
  {
    $p = $("<p/>");

    $p.attr('class', 'price-item product__price');
    //$p.attr('data-product-type', 'price');
    $p.attr('data-ext-opts-product-type', 'price');

    if (product_id)
    {
      //$p.attr('id', 'ProductPrice-' + product_id);
      //$p.attr('data-product-id', product_id);
      $p.attr('data-ext-opts-product-id', product_id);
    }

    $form.prepend($p);
    //console.log('price_fix_prepended', $form);
  }
  else
  {
    if ($p.length > 1)
    {
      var $p_non_sticky = $p.not('[id=product-price]').not('.ext-opts-price');

      // check diff forms
      if ($p_non_sticky.length > 1)
      {
        //console.log('price_fix_remove', $p_non_sticky);
        $p_non_sticky.last().remove();
      }
    }
  }

  var $p_old = $p.not('.ext-opts-price');

  $p_old.removeAttr('data-product-type');
  $p_old.removeAttr('data-product-id');
  $p_old.removeAttr('data-price');


  //$p.removeAttr('id');
  //$p.removeClass('product__price');

  var qty = getQuantity();

  p *= 1;

  if (qty)
  {
    p *= qty;
  }

  var price_fmt = "$" + p;
  if (p.toFixed)
  {
    price_fmt = "$" + p.toFixed(2);
  }

  //console.log('price_fmt', price_fmt, $p);
  $p.html(price_fmt);

  // update
  var $sticky_cart = $('#sticky-cart #current-option-1');

  if ($sticky_cart.length > 0)
  {
    var details_html = $("[name='properties[_Details_html]']").val();

    $sticky_cart.html(details_html);
    //console.log('sticky_cart - set details_html', details_html);

    //<div id="current-option-1" class="current-option">
    //<p class="option-label">Size</p>
    //<p class="option-selected">1.7 fl oz</p>
    //</div>

    //$sticky_cart.find('.option-selected')


  }

  $('.ext-opts-well-base').attr('data-price-fmt', price_fmt);

  $(document).trigger('ext-opts-form-update-price');

}

function getQuantity()
{
  var v = $form.find('[name=quantity]').val();

  if (!v)
  {
    v = 1;
  }

  //console.log('getQuantity()', v);

  return v;
}

$(document).on("change", '[name=quantity]', function(e)
{
  console.log("change", '[name=quantity]');

  vpDisplayPrice(last_price);

});

$(document).on("click", 'button, .select-popout__option', function(e)
{
  function updatePrice()
  {
    console.log("click", '.select-popout__option');
    vpDisplayPrice(last_price);
  }

  updatePrice();
  setTimeout(updatePrice, 1000);

});

function getShopifyPrice()
{
  return main_item.price*1;

  var pd = getShopifyProductData();

  if (pd)
  {
    return pd.variants[0].price/100;
  }
  else
  {
    return null;
  }

}

function getShopifyVariantMatchingOption()
{
  // get dropdown names
  //console.log('mo-  get dropdown names');

  //var shopify_dropdown_names = [];
  var shopify_option_to_name = {};

  var pd_base = getShopifyProductData();
  console.log('mo- pd_base', pd_base);

  var json_el_id = 'ProductJson-' + pd_base.id;
  console.log('mo- json_el_id', json_el_id)
  var json_el = document.getElementById(json_el_id);
  console.log('mo- json_el', json_el)

  if (!json_el)
  {
    console.log('mo- no product json');
    return false;
  }

  var productData = JSON.parse(json_el.textContent);

  var pd = productData;
  console.log('mo- pd', pd);
  //for(var j=0; pd.options.length; j++)


  /*for(let opt of pd.options)
  {
    console.log('mo- opt', opt);
    //shopify_dropdown_names.push(opt.name);
    shopify_option_to_name["option" + opt.position] = "p_" + opt.name.toLowerCase();
  } */

  for(var idx=0; idx < pd.options.length; idx++)
  {
    var opt_name = pd.options[idx];
    var position = idx + 1;
    console.log('mo- opt_name', opt_name);
    console.log('mo- position', position);

    //shopify_dropdown_names.push(opt.name);
    shopify_option_to_name["option" + position] = "p_" + opt_name.toLowerCase();
  }

  //console.log('mo- shopify_dropdown_names', shopify_dropdown_names);
  console.log('mo- shopify_option_to_name', shopify_option_to_name);

  console.log('mo- main_item', main_item);

  var item_attr_to_val = {};

  for(let attr of main_item.attributes)
  {
    if (!attr.value_text)
    {
      // can't match variant
      return false;
    }

    var n = "p_" + attr.name.toLowerCase();

    item_attr_to_val[n] = attr.value_text.toLowerCase();
  }

  //console.log('mo- item_attr_to_val', item_attr_to_val);

  for(let v of pd.variants)
  {
    var v_opts = [];

    var var_matching = true;
    for(var j=1; j<=3; j++)
    {
      var key = 'option' + j;

      var v_key = shopify_option_to_name[key];

      if (v[key])
      {
        var v_val = v[key].toLowerCase();

        v_opts[v_key] = v_val;

        if (item_attr_to_val[v_key] && item_attr_to_val[v_key] != v_val)
        {
          var_matching = false;
        }

      }

    }

    if (var_matching)
    {
      console.log('mo- match - v_opts', v_opts, v);
      console.log('mo- match - v_id', v.id);
      return v.id;
    }
    else
    {
      //console.log('mo- non-match - v_opts', v_opts, v);
    }




    //shopify_dropdown_names.push(opt.name);
    //shopify_option_to_name["option" + opt.position] = opt.name.toLowerCase();
  }


  console.log('mo- item_attr_to_val', item_attr_to_val);
  return false;

}

function getShopifyVariantId()
{
  console.log('getShopifyVariantId()');

  var pd = getShopifyProductData();

  if (!main_item.kit_item_status)
  {
    if (pd.variants.length > 0)
    {
      var var_id = getShopifyVariantMatchingOption();

      if (var_id)
      {
        return var_id;
      }

    }
  }

  if (pd)
  {
    return pd.variants[0].id;
  }
  else
  {
    return null;
  }
}

function getShopifyProductId()
{
  var pd = getShopifyProductData();

  if (pd)
  {
    return pd.id;
  }
  else
  {
    return null;
  }
}

function getShopifyProductData()
{
  if (window.ShopifyAnalytics)
  {
    if (window.ShopifyAnalytics.meta)
    {
      if (window.ShopifyAnalytics.meta.product)
      {
        return window.ShopifyAnalytics.meta.product;
      }
    }
  }

  return null;
}

function vpCanSubmitForm()
{
  //console.log('vpCanSubmitForm');

  //var c_data = vpCustomVariantData();

  //if (!c_data.price_diff)
  if (!vpDiffPriceForCurrentCombination())
  {
    vpSetFormProductVariantId(getShopifyVariantId(), 'default');
    return true;
  }

  var c_data = vpCustomVariantData();

  var sel = "[data-var-key='" + c_data.variant_key + "']";
  var $dvk = $(sel);

  if ($dvk.length > 0)
  {
    vpSetFormProductVariantId($dvk.val(), c_data.variant_key);
    return true;
  }
  else
  {

    if (!c_data.product_id)
    {
      alert('This product is not loaded to Shopify yet');
      return false;
    }

    runRequestForCustomVariant(c_data)
    return false;
  }

}

function vpSetFormProductVariantId(id, key)
{
  if (typeof key == "undefined")
  {
    key = '';
  }

  var $inp = $('<input/>');
  $inp.attr('type', 'hidden');
  $inp.attr('name', 'id');
  $inp.attr('data-var-key', key);
  $inp.val(id);

  $form.append("\n");
  $form.append($inp);
  $form.append("\n");
}

$(document).on('dblclick',
  // '.refresh_main_item',
  function(e)
{
  e.preventDefault();

  /*
  var $el = $(this);

  $el.css('color', 'red');

  $("#json").JSONView(main_item, { collapsed: true, nl2br: true, recursive_collapser: true });

  $el.css('color', 'blue');
  */

  console.log('main_item', main_item);

});

function vpCustomVariantData()
{
  // addtional_price_per_char": null,
  var $inp = $("[name='properties[_ext_opts_serialize]']");

  var json_attrs = $inp.val();

  var ser;

  if (json_attrs)
  {
    ser = JSON.parse(json_attrs);
  }
  //console.log('dp- ', ser, $inp);

  if (ser)
  {
    setValsToItem(main_item, ser);
  }

  //console.log('dp- ', main_item);


  //debugger;

  updatePriceChanges(main_item);

  var $comb_area = $('[data-comb-test]');

  if ($comb_area.length > 0 && main_item.comb_data)
  {
    $comb_area.html("<b>Comb:</b> " + JSON.stringify(main_item.comb_data, null, 4));
  }


  //console.log('upc-');

  var c_data = {};
  c_data.variant_price = 1*main_item.price;

  //console.log('upc- main_item.price_change_combination', main_item.price_change_combination);
  if (main_item.price_change_combination)
  {
    c_data.variant_price += 1*main_item.price_change_combination;
  }
  if (main_item.price_change_characters)
  {
    c_data.variant_price += 1*main_item.price_change_characters;
  }

  c_data.price_diff = false;
  if (c_data.variant_price > 1*main_item.price)
  {
    c_data.price_diff = true;
  }
  c_data.shop_host = params.shop_host;
  c_data.product_id = getShopifyProductId();
  c_data.sku_main = main_item.sku;
  c_data.variant_price = c_data.variant_price.toFixed(2);

  //c_data.variant_key = main_item.sku + "_" + comb_key + "_" + c_data.variant_price;
  var var_data = getVariantNameCustomPrice(main_item);
  var_data.key = main_item.sku + '_' + var_data.key;

  //console.log('upc- var_data.name', var_data.name);
  //console.log('upc- var_data.key', var_data.key);

  c_data.variant_name = var_data.name;
  c_data.variant_key = var_data.key;
  c_data.variant_key_json = json_attrs;

  c_data.dyn_pricing = 1;

  c_data.stock = 1;
  if (main_item.comb_data)
  {
    c_data.stock = main_item.comb_data.stock
  }

  //console.log('upc- c_data', c_data);


  return c_data;
}

function getVariantNameCustomPrice(item, depth)
{
  if (!depth)
  {
    depth = 0;
  }

  var names = [];
  var keys = [];

  $(item.attributes).each(function(k, a)
  {
    //console.log('vncp- ', a.type, a.name, a);

    switch(a.type)
    {
      case 'text':
        if (a.ext_characters)
        {
          names.push(a.name + ": "  + a.ext_characters + ' extra chars');
          keys.push(a.id + '#'+a.ext_characters);
        }

        break;

      case 'radio':
      case 'list':
        if (a.options.length <= 1)
        {
          break;
        }

        keys.push(a.id + '_' + a.value);

        if (0 == depth)
        {
          names.push(a.name + ": " + a.value_text);
        }
        else
        {
          names.push(a.value_text);
        }
        break;

      case 'item':

        //console.log('ni- a', a);

        if (a.value == a.id_non_skip)
        {
          for(var j=0; j<a.options.length; j++)
          {
            var opt = a.options[j];
            //console.log('ni- opt', opt)

            if (opt.id == a.value && opt.item)
            {
              //console.log('ni- opt find', opt);

              var nested_data = getVariantNameCustomPrice(opt.item, depth + 1);

              var name = a.name;

              if (nested_data.name)
              {
                name += " (";
                name += nested_data.name;
                name += ")";
              }

              var key = opt.id;

              if (nested_data.key)
              {
                key += "(";
                key += nested_data.key;
                key += ")";
              }

              keys.push(key);
              names.push(name);
            }
          }
        }
        else
        {
          //console.log('ni- a - skip', a);
        }

        break;
    }
  });

  var name = names.join(", ");
  var key = keys.join(",");

  var res = {};
  res.name = name;
  res.key = key;

  return res;
}

function updatePriceChanges(item)
{
  item.price_change_combination = 0;

  if (item.comb_data)
  {
    //debugger;
  }

  var total_price_change_combination = 0;

  runForAllItem(item, function(el)
  {
    el.price_change_combination = 0;
    el.price_change_characters = 0;

    //console.log('upc- runForAllItem - updatePriceChanges - el', 'item', 'el', el);
    //var k = getCurrentCombKey();
    //var k2c = getKey2Comb();
    //var comb = k2c[k];
    //console.log('dp- comb', comb);

    el.price_change_combination = 0;

    //console.log('upc- el', el);

    if (el.comb_data)
    {
      //console.log('upc-summ1 item.price_change_combination', item.price_change_combination, '+', el.price_change_combination,
        //      'comb_data', el.comb_data, 'el.comb_data.price_change', el.comb_data.price_change);

      el.price_change_combination = 1*el.comb_data.price_change;
      total_price_change_combination += 1*el.price_change_combination;

      //console.log('upc-summ2 item.price_change_combination', item.price_change_combination, '+', el.price_change_combination,
        //      'comb_data', el.comb_data, 'el.comb_data.price_change', el.comb_data.price_change);

    };


    $(el.attributes).each(function(k, a)
    {
      //console.log('updatePriceChanges', a.name);
      a.price_change_characters = 0;

      if ('text' != a.type)
      {
        //console.log('updatePriceChanges - non-text');
        return;
      }

      if (!a.validation || !a.validation.addtional_price_per_char)
      {
        //console.log('updatePriceChanges - no addtional_price_per_char');
        return;
      }

      if (!a.value)
      {
        //console.log('updatePriceChanges - no value');
        return;
      }

      var len = a.value.length;
      //console.log('pcc- len', len);
      //console.log('pcc- a.addtional_price_per_char', a.validation.addtional_price_per_char);

      if (len > a.validation.free_chars)
      {
        var ext_len = len - a.validation.free_chars;
        //console.log('pcc- ext_len', ext_len);
        a.price_change_characters = ext_len * a.validation.addtional_price_per_char;
        a.ext_characters = ext_len;
        //console.log('pcc- a.price_change_characters', a.price_change_characters);

        el.price_change_characters += 1*a.price_change_characters;

      }
    });

    item.price_change_characters += el.price_change_characters;

  });

  item.price_change_combination = total_price_change_combination;
}

function runForAllItem(item, callback, parent)
{
  if (!parent)
  {
    parent = null;
  }

  //console.log('runForAllItem', item.sku, 'parent', parent);

  callback(item);

  var attrs = [];

  if (item.attributes)
  {
    attrs = item.attributes;
  }

  for(var position=0; position<attrs.length; position++)
  {
    var attr = attrs[position];

    //console.log('runForAllItem', 'attr', attr);

    if (attr.type == 'item')
    {
      var nested_options = attr.options;
      var nested_idx;

      for(nested_idx=0; nested_idx<nested_options.length; nested_idx++)
      {
        var nested_option = nested_options[nested_idx];

        if (nested_option.item)
        {
          runForAllItem(nested_option.item, callback, item);
        }
      }
    }
  }
}


function setValsToItem(item, data, path)
{
  //console.log('svl- setValsToItem', item, data, path);

  if (typeof path == "undefined")
  {
    path = '';
  }

  //if (!item.attributes)
  //if (!item.synced)
  if (!item.attributes)
  {
    if (api_data[item.sku])
    {
      item.attributes = api_data[item.sku].attributes;
      //item.allow_backorder = api_data[item.sku].allow_backorder;
    }
    else
    {
      console.log('dp- ', "can't find attributes");
      item.attributes = [];
      //item.allow_backorder = false;
    }

    //item.synced = true;
  }

  if (!item.active_combinations)
  {
    if (api_data[item.sku])
    {
      item.active_combinations = api_data[item.sku].active_combinations;
    }
    else
    {
      console.log('dp- ', "can't find active_combinations");
      item.active_combinations = [];
    }
  }


  var attrs = item.attributes;

  var return_obj = {};
  return_obj.text_value_set = false;

  for(var position=0; position<attrs.length; position++)
  {
    var attr = attrs[position];

    if (attr.type == 'item')
    {
      var nested_options = attr.options;
      var nested_idx;

      attr.has_text_values = false;

      for(nested_idx=0; nested_idx<nested_options.length; nested_idx++)
      {

        var nested_option = nested_options[nested_idx];

        if (nested_option.skip)
        {
          attr.id_skip = nested_option.id;
        }
        else
        {
          attr.id_non_skip = nested_option.id;
        }

        if (!nested_option.item)
        {
          continue;
        }

        var nested_sku = nested_option.item.SKU;
        var nested_item_id = nested_option.item.id;

        if (!nested_sku)
        {
          console.log('Attribute has type = item, but SKU was not provided');
          console.log(nested_option);
          continue;
        }

        var nested_item = api_data[nested_sku];


        if (!nested_item)
        {
          console.log('Attribute has type = item, but there are no data for this SKU: `' + nested_sku + '`');
          continue;
        }

        var path_new = path;
        if (path_new.trim() != '')
        {
          path_new += '.';
        }

        path_new += attr.id;
        path_new += '-' + nested_option.id;
        path_new += '-' + nested_item_id;

        nested_option.item.sku = nested_sku;

        var set_vals_res = setValsToItem(nested_option.item, data, path_new);

        if (set_vals_res.text_value_set)
        {
          attr.has_text_values = true;
        }
        else
        {

        }

        if (set_vals_res.list_value_set)
        {
          attr.has_list_values = true;
        }

      }

      //if (1 == nested_options.length)
      //{
      attr.value = nested_options[0].id;
      //}

      if (2 == nested_options.length)
      {
        //if (attr.has_text_values || attr.has_list_values)
        if (attr.skip)
        {
          attr.value = attr.id_skip;
          //attr.skip = false;
        }
        else
        {
          attr.value = attr.id_non_skip;
          //attr.skip = true;
        }

      }
    }
    else
    {
      var path_new = path;
      if (path_new.trim() != '')
      {
        path_new += '.';
      }
      path_new += attr.id;

      var val = data[path_new];

      if (val)
      {
        if (val.indexOf('*') == -1)
        {
          attr.value = val;
          attr.value_text = val;
        }
        else
        {
          var val_arr = val.split('*');
          attr.value = val_arr[0];
          attr.value_detailed = val;
          attr.value_text = val_arr[1];
        }

        if ('text' == attr.type)
        {
          return_obj.text_value_set = true;
        }

        if ('list' == attr.type)
        {
          //console.log('svl- path_new, ' + path_new + 'set val to list, attr: ', attr, ' val: ', val)

          var $inp = getInputByPath(path_new);
          //$inp.css('color', 'red');

          var $box = $inp.closest('[data-path-box]');
          //$box.css('color', 'blue');

          //console.log('svl- $inp', $inp, ' box ', $box);

          //if ($inp.is(":visible"))
          {
            if (val)
            {
              //console.log('svl- hasval - non-skip');
              $box.removeAttr('data-skip');
              attr.skip = false;
            }
            else
            {
              $box.attr('data-skip', 1);
              //console.log('svl- hasval - skip');
              attr.skip = true;
            }
          }
          return_obj.list_value_set = true;
        }

      }
      else
      {
        attr.value = null;
      }

      attr.path = path_new;
    }
  }

  //console.log('dp- getCurrentCombKey', getCombKey(main_item));
  item.comb_key = getCombKey(item);
  var map = mapKeyToComb(item);
  item.comb_data = map[item.comb_key];


  return return_obj;


}

function getInputByPath(path)
{
  var sel = '[data-ext-opts-path="' + path + '"]';
  //console.log('svl- getInputByPath(path) ', path, ' sel ', sel);
  var $el = $(sel);

  return $el;
}

function vpCustomVariantDataOld()
{
  var k2c = getKey2Comb();
  var c_data = {};
  var comb_key = getCurrentCombKey();

  if (k2c[comb_key])
  {
    var c = k2c[comb_key];

    c_data.shop_host = params.shop_host;
    c_data.product_id = getShopifyProductId();

    c_data.variant_price = 1*main_item.price + 1*c.price_change;
    c_data.sku_main = main_item.sku;
    c_data.variant_price = c_data.variant_price.toFixed(2);
    c_data.variant_name = $("[name='properties[Details]']").val();

    c_data.variant_key = main_item.sku + "_" + comb_key + "_" + c_data.variant_price;
    c_data.variant_key_json = $("[name='properties[_ext_opts_serialize]']").val();
    c_data.stock = c.stock;

    //console.log('cv-', c_data, params.custom_variant_url);

    return c_data;
  }
  else
  {
    //console.log("can't find", comb_key, k2c);
    return null;
  }
}

function runRequestForCustomVariant(c_data)
{
  var ajax_cfg = {};
  ajax_cfg.method = "GET";
  ajax_cfg.url = params.custom_variant_url;
  ajax_cfg.data = c_data;
  ajax_cfg.cache = false;

  ajax_cfg.beforeSend = function (jqXHR, settings)
  {
    var url = settings.url + "?" + settings.data;
    console.log('url-custom', url);
  };

  ajax_cfg.error = function (xhr, status, error)
  {
    console.log('error', error, xhr);
    alert('error');
  };

  ajax_cfg.success = function (data, status, xhr)
  {
    console.log('complete, custom variant id', data, this.url);

    if (!data.id)
    {
      alert("Error on loading data for custom variant");
      return;
    }

    vpSetFormProductVariantId(data.id, c_data.variant_key);

    //var action = $form.attr('action');

    $form.submit();
    return;

    //////////////////
    // check variant is available on JS API

    checkVariantAdded(data.id, function()
    {
      $form.submit();
    });



function getCanonicalUrl()
{
  return $('[rel=canonical]').attr('href');
}

function getProductAjaxUrl()
{
  var url = getCanonicalUrl();
  url += ".js";

  return url;
}

//getProductAjaxUrl();


function checkVariantAdded(variant_id, callback)
{
  console.log('checkVariantAdded- ' + variant_id);

  var ajax_cfg = {};
  ajax_cfg.method = "GET";
  //ajax_cfg.url = getProductAjaxUrl();
  ajax_cfg.url = getCanonicalUrl();
  ajax_cfg.cache = false;

  ajax_cfg.error = function (xhr, status, error)
  {
    console.log('error', error, xhr);
    alert('error: ' + error);
  };

  ajax_cfg.success = function (data, status, xhr)
  {
    console.log('checkVariantAdded - AJAX complete, product data', data);

    if (data.indexOf(variant_id) != -1)
    {
      console.log('checkVariantAdded- Cart JS API updated, new variant is available, run cart submit');
      callback();
      return;
    }
    else
    {
      console.log('checkVariantAdded- Cart JS API was not updated yet, try check again');
      checkVariantAdded(variant_id, callback);
      return;
    }

/*    var vars = data.variants;

    for(var j=0; j<vars.lenght; j++)
    {
      var v = vars[j];

      if (v.id == variant_id)
      {
        console.log('checkVariantAdded- Cart JS API updated, new variant is available, run cart submit');
        callback();
        return;
      }
    }

    console.log('checkVariantAdded- Cart JS API was not updated yet, try check again');
    checkVariantAdded(variant_id, callback);    */

  };

  console.log("ajax_cfg", ajax_cfg);
  $.ajax(ajax_cfg);
  return "Ok";

}
  };

  console.log("ajax_cfg", ajax_cfg);
  $.ajax(ajax_cfg);
}

$(document).on('ext-opts-form-serialized', function(e)
{
  //console.log('ext-opts-form-serialized', e);
  //debugger;

  if (vpDiffPriceForCurrentCombination())
  {
    var c_data = vpCustomVariantData();
    vpDisplayPrice(c_data.variant_price);
    return;
  }
  else
  {
    //var c_data = vpCustomVariantData();
    //console.log('display_base_price');
    vpDisplayPrice('');


    vpSetFormProductVariantId(getShopifyVariantId());
  }

  // reset
  var p = 1*getShopifyPrice();

  if (p)
  {
    vpDisplayPrice(p);
  }
  else
  {
    vpDisplayPrice('');
  }

});


function vpDiffPriceForCurrentCombination()
{
  var c_data = vpCustomVariantData();
  console.log('vpDiffPriceForCurrentCombination', c_data);

  return c_data.price_diff;

  /*
  return true;
  console.log('vpDiffPriceForCurrentCombination');

  var k = getCurrentCombKey();
  //console.log('getCurrentCombKey', k);

  var k2c = getKey2Comb();
  //console.log('getKey2Comb', k2c);

  if (!k2c[k])
  {
    return;
  }
  var c = k2c[k];
  //console.log('active comb', c);
  var p = c.price_change;
  p *= 1;

  //console.log('price_change-p', p);

  var $inp_custom_price = $('input[name="properties[_item_custom_price]"]');


  if (p != 0)
  {
    $inp_custom_price.val(1);
    return true;
  }
  else
  {
    $inp_custom_price.val('');
    return false;
  }    */

}

function mapKeyToComb(item)
{
  //debugger;

  var comb_key2obj = {};

  var active_combinations = item.active_combinations;

  for(var j in active_combinations)
  {
    if (!active_combinations.hasOwnProperty(j))
    {
      continue;
    }

    var cs = active_combinations[j];

    var cfg = {};
    //var cfg_name = {};

    for(var i=0; i < cs.combination.length; i++)
    {
      var c = cs.combination[i];

      if (c.attribute_option_id)
      {
        cfg[c.attribute_id] = c.attribute_option_id;
      }
    }

    //console.log('cfg', cfg);

    var comb_key = encodeKey(cfg);

    //console.log('comb_key', comb_key);

    comb_key2obj[comb_key] = cs;

  }

  return comb_key2obj;
}

function encodeKey(obj)
{
  //console.log('encodeKey', obj);

  obj = sortKeys(obj);
  var keys = Object.keys(obj)

  var opts = [];

  for (var i = 0; i < keys.length; i++)
  {
    var k = keys[i];
    var v = obj[k];
    var opt_txt = k + "-" + v;
    opts.push(opt_txt);
  }

  var var_key = opts.join(".");

  //console.log('var_key', var_key);

  return var_key;
}


function getCombKey(item)
{
  var cfg = {};

  $(item.attributes).each(function(k, el)
  {
    //console.log('cfg- ', el);

    switch(el.type)
    {
      case 'item':
      case 'radio':
      case 'list':
        if (!el.value)
        {
          cfg[el.id] = null;
        }
        else
        {
          cfg[el.id] = el.value;
        }
    }
  });

  //console.log('cfg- ', cfg);

  var comb_key = encodeKey(cfg);

  return comb_key;
}


function sortKeys(obj_1)
{
  var key = Object.keys(obj_1)
    .sort(function order(key1, key2) {
      if (key1 < key2) return -1;
      else if (key1 > key2) return +1;
      else return 0;
  });

  // Taking the object in 'temp' object
  // and deleting the original object.
  var temp = {};

  for (var i = 0; i < key.length; i++)
  {
    temp[key[i]] = obj_1[key[i]];
    delete obj_1[key[i]];
  }

  // Copying the object from 'temp' to
  // 'original object'.
  for (var i = 0; i < key.length; i++)
  {
    obj_1[key[i]] = temp[key[i]];
  }

  return obj_1;
}

$(document).on('ext-opts-form-init', function()
{
  console.log('ext-opts-form-init');

  /*var hfs = ['shop_host', 'variant_key', 'variant_name', 'variant_price', 'product_id'];

  $(hfs).each(function(k, input_name)
  {
    var $inp = $('<input/>');
    $inp.attr('type', 'hidden');
    $inp.attr('name', input_name);

    if ('shop_host' == input_name)
    {
      $inp.val(params.shop_host);
    }

    $form.append("\n");
    $form.append($inp);
    $form.append("\n");
  });

  var product_id = getShopifyProductId();
  $form.find('input[name=product_id]').val(product_id);
  */
});

    /*var acs = el.active_combinations;


    for(var k=0; k<acs.length; k++)
    {
      var match = true;

      var ac = acs[k];
      var comb = ac.combination;

      for(var j=0; j<comb.length; j++)
      {
        if (comb.attribute_option_id != val[comb.attribute_id])
        {
          match = false;
          continue;
        }
      }
    }

    if (match)
    {

    }    */
;

  //if (main_item.is_kit_item)
  //console.log('getCurrentCombKey - fix');

  if (false)
  {
    //console.log('getCurrentCombKey - is_kit_item');

    var getCurrentCombKeyOld = getCurrentCombKey;

    var getCurrentCombKey = function()
    {

      //console.log('getCurrentCombKey - mi', main_item);
      //debugger;

      if (!main_item.kit_item_status)
      {

        //console.log('getCurrentCombKey - NON is_kit_item');
        return getCurrentCombKeyOld();
      }

      /*
      if (!params.hide_options_for_skippable_items)
      {
        return getCurrentCombKeyOld();
      }
      */

      //console.log('getCurrentCombKey - is_kit_item');

      var cfg = {};

      for(var j=0; j < main_item.attributes.length; j++)
      {
        var attr = main_item.attributes[j];
        //console.log('comb_attr', attr);

        if (attr.options.length == 1)
        {
          cfg[attr.id] = attr.options[0].id;
          continue;
        }

        if (attr.options.length == 2)
        {
          var filled_to_val = {};


          for(var k=0; k < attr.options.length; k++)
          {
            var opt = attr.options[k];
            filled_to_val[1-opt.skip*1] = opt.id;
          }

          var selector_text_input =
            '[type=text][data-ext-opts-path^="' + attr.id + '-"], [type=text][data-ext-opts-path-tmp^="' + attr.id + '-"]'
              // +
              //', select[data-ext-opts-path^="' + attr.id + '-"], select[data-ext-opts-path-tmp^="' + attr.id + '-"]';
              ;


          var $inp = $(selector_text_input);
          //console.log('flex- selector_text_input', selector_text_input);

          //console.log('flex- $inp', $inp);

          if ($inp.length == 0)
          {
            //console.log("flex- can't find flex input");
          }

          var v = $inp.val();
          //console.log('getCurrentCombKey - attr', attr, 'filled_to_val', filled_to_val, 'v', v);

          if ($inp.length == 0)
          {
            v = '';
          }

          if (v || $inp.length == 0)
          {
            v = v.trim();
            restorePathAttr($inp);
          }
          else
          {
            hidePathAttr($inp);
          }

          var ext_fields_selector = 'select[data-ext-opts-path-tmp^="' + attr.id + '-"], select[data-ext-opts-path^="' + attr.id + '-"], [for^="' + attr.id + '-"]';
          //console.log('flex2 ext_fields_selector', ext_fields_selector);

          //console.log('flex2 v', v);

          if (v || $inp.length == 0)
          {
            cfg[attr.id] = filled_to_val[1];

            // show ext fields
            $(ext_fields_selector).show();

            $(ext_fields_selector).each(function(k, el)
            {
              var $el = $(el);
              restorePathAttr($el);
            });

          }
          else
          {
            cfg[attr.id] = filled_to_val[0];

            // hide ext fields
            $(ext_fields_selector).each(function(k, el)
            {
              var $el = $(el);
              var a_for = $el.attr('for');

              hidePathAttr($el);

              if (a_for)
              {
                var inp_sel = '[id="' + a_for + '"]';

                var $inp = $(inp_sel);

                //console.log('inp_sel', inp_sel, $inp);


                if ($inp.attr('type'))
                {
                  return;
                }
              }

              if (params.hide_options_for_skippable_items)
              {
                $el.hide();
              }

              //.is(':input').prop('disabled', true);


              //[data-ext-opts-path]

            });
            //hide();

          }

          //console.log('flex-attr', 'cfg[', attr.id, '] = ', cfg[attr.id]);
        }

      }

      var comb_key = encodeKey(cfg);

      //console.log('getCurrentCombKey - comb_key', comb_key);
      return comb_key;
    };

    function restorePathAttr($el)
    {
      //console.log('flex2 restorePathAttr', $el.attr('id'), $el);

      var a_main = 'data-ext-opts-path';
      var a_tmp = 'data-ext-opts-path-tmp';
      var v = $el.attr(a_tmp);

      if (v)
      {
        $el.attr(a_main, v);
        $el.removeAttr(a_tmp);
      }
    }

    function hidePathAttr($el)
    {
      //console.log('flex2 hidePathAttr', $el.attr('id'), $el);

      var a_main = 'data-ext-opts-path';
      var a_tmp = 'data-ext-opts-path-tmp';
      var v = $el.attr(a_main);

      if (v)
      {
        $el.attr(a_tmp, v);
        $el.removeAttr(a_main);
      }

    }


  }

  

function toggleSkipStatusByPath(box_path, skip_status, item)
{
  //console.log('tss- box_path', box_path, ' skip_status ', skip_status);

  if (typeof item === "undefined")
  {
    item = main_item;
  }

  //console.log('tss' + box_path, ' skip_status ', skip_status);

  //main_item

  attrs = item.attributes;
  for(var position=0; position<attrs.length; position++)
  {
    var attr = attrs[position];

    //console.log('runForAllItem', 'attr', attr);

    if (attr.type == 'item')
    {
      if (attr.id == box_path)
      {
        attr.skip = skip_status;
      }
      else
      {

      }
    }
  }

  //console.log('tss- res', main_item);
  window.main_item = main_item;
}

function toggleBoxInputs($box, names_old_to_names)
{
  var attr_old = 'data-name-old';
  var attr = 'name';

  var path_box_level = $box.attr('data-path-box-attr-level');

  console.log('tbi-'+path_box_level, names_old_to_names);

  $box.find('[name], [data-name-old]').not('[type=hidden]').each(function(k, input)
  {
    var $input = $(input);

    if (names_old_to_names)
    {

      var name_old = $input.attr(attr_old);
      if (name_old)
      {
        console.log('tbi-'+path_box_level, ' $input.attr', $input, attr, name_old);
        $input.attr(attr, name_old);
      }

    }
    else
    {

      var name = $input.attr(attr);
      if (name)
      {
        $input.attr(attr_old, name);
        $input.removeAttr(attr);
      }

    }

  });
}

function serializeData()
{

  var data = {};

  var $inputs = $('[data-ext-opts-path]');

  //console.log('srs', $inputs);

  // update skip status

  //var path_to_skip_status = {};

  var path_to_skip = {};
  var path_to_non_skip = {};

  $inputs.each(function(k, input)
  {
    var $input = $(input);
    var v = getInputValueForSerialize($input);

    var $box = $input.closest('[data-path-box]');
    if (!$box.attr('data-skippable'))
    {
      return;
    }

    var path_box_attr_level = $box.attr('data-path-box-attr-level');



    if ($input.is(':visible'))
    {
      //console.log('tss' + path_box_attr_level);

      if (v)
      {
        //if ($input.attr('type'))
        //console.log('uss-', v, $input);
        //$box.removeAttr('data-skip');
        //toggleSkipStatusByPath(path_box_attr_level, false);

        //path_to_skip_status[path_box_attr_level]
        path_to_non_skip[path_box_attr_level] = $box;
      }
      else
      {
        //$box.attr('data-skip', 1);
        //toggleSkipStatusByPath(path_box_attr_level, true);

        path_to_skip[path_box_attr_level] = $box;
      }
    }

  });

  console.log('path_to_skip', path_to_skip);
  console.log('path_to_non_skip', path_to_non_skip);
  var names_old_to_names;

  for(var xpath in path_to_skip)
  {
    var $box = path_to_skip[xpath];

    if (!path_to_non_skip[xpath])
    {
      var path_box_attr_level = $box.attr('data-path-box-attr-level');
      toggleSkipStatusByPath(path_box_attr_level, true);
      $box.attr('data-skip', 1);
    }

    toggleBoxInputs($box, names_old_to_names = false);
  }

  for(var xpath in path_to_non_skip)
  {
    var $box = path_to_non_skip[xpath];
    var path_box_attr_level = $box.attr('data-path-box-attr-level');
    toggleSkipStatusByPath(path_box_attr_level, false);
    $box.removeAttr('data-skip');
    toggleBoxInputs($box, names_old_to_names = true);
  }

  $inputs.each(function(k, input)
  {
    var $input = $(input);

    if ($input.closest('[data-skip]').length > 0)
    {
      return;
    }

    //debugger;
    var p = $input.attr('data-ext-opts-path');
    var v = getInputValueForSerialize($input);

    data[p] = v;


    /* var $box = $input.closest('[data-path-box]');

    if (!$box.attr('data-skippable'))
    {
      data[p] = v;
    }
    else
    {
      if (v && $input[0].tagName == 'input')
      {
        $box.removeAttr('data-skip');
        data[p] = v;
      }
      else
      {
        $box.attr('data-skip', 1);
      }


    }*/

    //console.log('srs-p,v', p, v);

  });

  var json = JSON.stringify(data);
  //console.log('srs-json', json);

  $inp_summary['_ext_opts_serialize'].val(json);

  updateDetails();

  return json;
};


  function combinationsCount(item)
  {
    if (!item.active_combinations)
    {
      return 0;
    }

    var n = 0;
    for(var c in item.active_combinations)
    {
      if (!item.active_combinations.hasOwnProperty(c))
      {
        continue;
      }

      n++;
    }

    return n;

  }

  function itemCountOfCombinations(item)
  {
    var n_combs = 0;
    for(var c in item.active_combinations)
    {
      if (!item.active_combinations.hasOwnProperty(c))
      {
        continue;
      }

      n_combs++;
    }

    return n_combs;
  }

  function isItemHasAvailableComb(item)
  {
    if (item.kit_item_status)
    {
      return true;
    }


    var n_combs = 0;
    for(var c in item.active_combinations)
    {
      if (!item.active_combinations.hasOwnProperty(c))
      {
        continue;
      }

      n_combs++;

      var comb = item.active_combinations[c];

      //console.log('nav- comb', comb);
      if (comb.stock || comb.allow_backorder)
      {
        return true;
      }
    }

    //if (item.kit_item_status && 1 == n_combs)
    //{
      //return true;
    //}

    console.log("nav - can't find");
    return false;
  }

  var is_item_has_available_comb = isItemHasAvailableComb(main_item);
  //console.log('nav- is_item_has_available_comb', is_item_has_available_comb);

  if (!is_item_has_available_comb)
  {
    //console.log('nav- main_item no comb');
    main_item.attributes = [];
    main_item.force_out_of_stock = true;
  }

  if (main_item.kit_item_status)
  {
    // check nested items has stock or allow back orders
    var is_kit_has_all_single_items_available = isKitHasAllSingleItemsAvailable(main_item);
    //console.log('isKitHasAllSingleItemsAvailable -res', is_kit_has_all_single_items_available);

    if (!is_kit_has_all_single_items_available)
    {
      main_item.attributes = [];
      main_item.force_out_of_stock = true;
    }
  }

  function isKitHasAllSingleItemsAvailable(item)
  {
    var attrs = [];

    console.log('isKitHasAllSingleItemsAvailable', item);

    if (item.attributes)
    {
      attrs = item.attributes;
    }

    for(var position=0; position<attrs.length; position++)
    {
      var attr = attrs[position];

      //console.log('runForAllItem', 'attr', attr);

      if (attr.type != 'item')
      {
        continue;
      }

      var nested_options = attr.options;
      var nested_idx;

      for(nested_idx=0; nested_idx<nested_options.length; nested_idx++)
      {
        var nested_option = nested_options[nested_idx];

        if (nested_option.item)
        {
          var nested_item_sku = nested_option.item.SKU;

          if (!nested_item_sku)
          {
            continue;
          }

          var nested_item = api_data[nested_item_sku];

          if (!nested_item)
          {
            console.log('err- can find nested item with sku: ' + nested_item_sku);
          }

          if (nested_option.item.kit_item_status)
          {
            if (!isKitHasAllSingleItemsAvailable(nested_option.item))
            {
              return false;
            }
          }
          else
          {
            var n_combs = 0;

            var has_available = false;

            console.log('combs', nested_item.active_combinations);

            for(var c in nested_item.active_combinations)
            {
              if (!nested_item.active_combinations.hasOwnProperty(c))
              {
                continue;
              }

              n_combs++;

              var comb = nested_item.active_combinations[c];

              //console.log('nav- comb', comb);
              if (comb.allow_backorder || comb.stock)
              {
                has_available = true;

                //return false;
                break;
              }
            }

            if (n_combs > 0 && !has_available)
            {
              console.log('navi- no comb for item ', nested_item);
              return false;
            }
          }
        }
      }
    }

    return true;

  }

  


  var add_attrs_cfg = {};

  add_attrs_cfg.sku = sku;
  add_attrs_cfg.path = '';
  add_attrs_cfg.box = $box;
  add_attrs_cfg.prefix = '';
  add_attrs_cfg.prefix_id = '';
  $box.attr('data-path-box', add_attrs_cfg.path);

  var last_attr_related_to_input_with_options = {};

  addAttributes(add_attrs_cfg);


  $('input[data-ext-opts-path], select[data-ext-opts-path]').each(function(k, el)
  {
    var $el = $(el);

    $box = $el.closest('[data-ext-opts-box]');

    if (0 == $box.find('.ext-opts-visible').length)
    {
      $box.hide();
    }

  });

  $('[data-header]').each(function(k, el)
  {
    var $el = $(el);
    var $box = $el.closest('[data-ext-opts-box]');

    if ($box.children('.ext-opts-visible').length)
    {
      $el.show();
    }
  });



  //if (0 == $box.find('.ext-opts-visible').length)

  $(document).on("change", "[data-ext-opts-box] select[ext-opts][data-top-level]", function(e)
  {
    var $input = $(this);
    console.log($input);

    var a_id_f = 'data-attribute-id';
    var a_id = $input.attr(a_id_f);

    var sel = "[" + a_id_f + "=" + a_id + "]:not([data-top-level])";

    //console.log("switch nested items", sel, $input);

    $input.closest('[data-ext-opts-box]').find(sel).val($input.val());

    //$(sel).not('[data-top-level]').val($input.val());

  });

  function getNestedOption(opts)
  {
    var nested_option = null;

    $(opts).each(function(k, opt)
    {
      if (opt.item)
      {
        nested_option = opt;
        return false;
      }
    });

    return nested_option;
  }

  function getNestedItemSkuFromOptions(opts)
  {
    var nested_option = getNestedOption(opts);

    if (nested_option)
    {
      return nested_option.item.SKU;
    }

    return null;
  }

  function getNestedItemIdFromOptions(opts)
  {
    var nested_option = getNestedOption(opts);

    if (item)
    {
      return nested_option.item.id;
    }

    return null;

  }

  var global_css_added = {};

  function addErpData(main_item) {
    var link = document.createElement('input');
    link.id='product_erp_unique'
    link.setAttribute('data-id',main_item.erp_id);
    for(let i=0;i<main_item.attributes.length;i++){
      let object=main_item.attributes[i];
      if(object.name=="CustomFont"){
        link.setAttribute('data-options',JSON.stringify(object.options));
      }
    }
    link.style.display = 'none';
    document.body.appendChild(link);
  }

  function addAttributes(add_attrs_cfg)
  {
    //console.log('aa-', 'addAttributes', add_attrs_cfg);

    var sku = add_attrs_cfg.sku;
    var parent_sku = null;

    if (add_attrs_cfg.parent_sku)
    {
      parent_sku = add_attrs_cfg.parent_sku;
    }

    var path = add_attrs_cfg.path;
    var prefix = add_attrs_cfg.prefix;
    var prefix_id = add_attrs_cfg.prefix_id;
    var $box = add_attrs_cfg.box;

    var main_item = api_data[sku];

    addErpData(main_item);


    var add_attrs_cfg_init = add_attrs_cfg;

    if (!add_attrs_cfg.attrs)
    {

      var $box_new = null;

      if (api_data[sku].top_level && api_data[sku].top_level.attributes && api_data[sku].top_level.attributes.length)
      {
        console.log(sku, 'top_level');

        add_attrs_cfg = add_attrs_cfg_init;
        add_attrs_cfg.sku = sku;
        //add_attrs_cfg.skippable = add_attrs_cfg_init.skippable;
        add_attrs_cfg.prefix = prefix;
        add_attrs_cfg.prefix_id = prefix_id;

        add_attrs_cfg.attrs = main_item.top_level.attributes;
        add_attrs_cfg.attributes_top_level = 1;
        add_attrs_cfg.path = path + '!top_level';
        add_attrs_cfg.parent_sku = parent_sku;

        $box_new = $('<div/>');
        $box_new.append("<p style='font-size: 130%; margin-top: 10px; display: none;' data-header><b>Item Options</b></p>");
        $box_new.attr('data-ext-opts-box', true);
        $box_new.attr('data-allow-backorder', main_item.allow_backorder ? 1 : 0);
        $box_new.attr('data-sku', main_item.sku);
        $box_new.addClass('ext-opts-well');
        $box_new.attr('data-path-box', add_attrs_cfg.path);
        $box_new.attr('data_level', 'top_level');
        // $box_new.attr('data-shape-preview', JSON.stringify(main_item.shape));

        $box.append($box_new);

        add_attrs_cfg.box = $box_new;

        addAttributes(add_attrs_cfg);
      }

      //console.log(sku, 'own');

      add_attrs_cfg = add_attrs_cfg_init;
      add_attrs_cfg.sku = sku;
      add_attrs_cfg.prefix = prefix;
      //add_attrs_cfg.skippable = add_attrs_cfg_init.skippable;
      add_attrs_cfg.prefix_id = prefix_id;
      add_attrs_cfg.box = $box;
      if ($box_new)
      {
        add_attrs_cfg.box = $box_new;
      }

      add_attrs_cfg.parent_sku = parent_sku;
      add_attrs_cfg.path = path;
      //$box.attr('data-path-box', add_attrs_cfg.path);

      //add_attrs_cfg.attrs = main_item.attributes;
      add_attrs_cfg.attrs = JSON.parse(JSON.stringify(main_item.attributes));

      addAttributes(add_attrs_cfg);

      return;
    }

    var attrs = add_attrs_cfg.attrs;
    var prefix = add_attrs_cfg.prefix;
    var prefix_id = add_attrs_cfg.prefix_id;
    var $box = add_attrs_cfg.box;
    var current_sku = add_attrs_cfg.sku;

    for(var position=0; position<attrs.length; position++)
    {
      var attr = attrs[position];

      //console.log('eo-', 'addAttributes-attr', attr);

      if (attr.type == 'item')
      {
        var nested_options = attr.options;
        var nested_idx;

        var multiple_nested_items = false;

        if (nested_options.length > 1)
        {
          multiple_nested_items = true;
          //alert("dd me");
          var $input = $("<select/>");
          $input.attr('ext-opts', 1);

          for(nested_idx=0; nested_idx<nested_options.length; nested_idx++)
          {
            var nested_option = nested_options[nested_idx];

            if (!nested_option.item)
            {
              continue;
            }

            var $opt = $("<option/>");
            $opt.text(nested_option.name)
            $opt.attr('value', nested_option.id);

            $input.append($opt);
          }

          var path_new = add_attrs_cfg.path;
          if (path_new.trim() != '')
          {
            path_new += '.';
          }
          path_new += attr.id;

          attr.ext = {};
          attr.ext.path = path_new;
          path_to_attr[attr.ext.path] = attr;


          var id = '_' + attr.id + '*' + attr.name;
          var input_id = attr.id;

          var input_name = 'properties'+ '[' + prefix + id + ']';

          $input.attr('data-attribute-id', attr.id);
          $input.attr('data-ext-opts-path', attr.ext.path);
          $input.attr('data-input-type', attr.type);
          $input.attr('name', input_name);

          $input.attr('data-select-one-of-nested', 1);

          var $label = $('<label/>');
          $label.attr('for', input_id);
          $label.text(attr.name);


          var $div = $('<div/>');

          var $header_div = $("<div/>");
          $header_div.text(attr.name);
          $header_div.css('font-size', '120%');
          $header_div.css('margin-top', '10px');
          $header_div.css('font-weight', 'bold');


          //$div.append($label);
          //$div.append("<p style='font-size: 120%; margin-top: 10px;'><b>" + attr.name + "</b></p>");
          $div.append($header_div);
          $div.append($input);
          $div.addClass('ext-opts-visible');

          //$div.addClass('ext-opts-form-group');
          $input.addClass('ext-opts-form-control');

          add_attrs_cfg.box.append($div);
          //if ($validation_message)
          {
            //$div.append($validation_message);
          }
        }

        for(nested_idx=0; nested_idx<nested_options.length; nested_idx++)
        {
          var nested_option = nested_options[nested_idx];


          if (!nested_option.item)
          {
            continue;
          }

          //console.log('nested_option', nested_option);
          var nested_sku = nested_option.item.SKU;

          var nested_item_id = nested_option.item.id;

          if (!nested_sku)
          {
            console.log('Attribute has type = item, but SKU was not provided');
            console.log(nested_option);
            continue;
          }


          //console.log('nested_sku', nested_sku);
          var nested_item = api_data[nested_sku];
          //console.log('nested_item', nested_item);


          if (!nested_item)
          {
            console.log('Attribute has type = item, but there are no data for this SKU: `' + nested_sku + '`');
            continue;
          }

          var nested_item_css = nested_item.custom_css;
          if (nested_item_css && !nested_item.custom_css_added)//!global_css_added[nested_item_css])
          {
            console.log('flex-css', nested_item_css);
            var $css_tag = "<style> " + nested_item_css + " </style>";
            $('head').append($css_tag);
            nested_item.custom_css_added = 1;
          }


          var prefix_current = prefix;

          if (save_array_data)
          {
             prefix_current += "[";
          }
          else
          {
            if (prefix_current)
            {
              prefix_current += " | ";
            }
          }

          prefix_current += "_SKU_" + nested_sku;

          prefix_current += "," + attr.id;
          prefix_current += "," + nested_option.id;

          //console.log("prefix_current", prefix_current);

          prefix_current += "*";
          //prefix_current += attr.name;

          if (save_array_data)
          {
            prefix_current += "]";
          }

          var $box_new = $('<div/>');
          $box_new.attr('data-ext-opts-box', true);
          $box_new.attr('data-allow-backorder', nested_item.allow_backorder ? 1 : 0);
          $box_new.attr('data-sku', nested_item.sku);

          $box_new.addClass('ext-opts-well');

          //$box_new.append("<p style='font-size: 120%; margin-top: 10px;'><b>" + attr.name + "</b></p>");
          //$box_new.append("<p style='font-size: 120%; margin-top: 10px;'><b>" + nested_item.name + "</b></p>");

          var header_name = '';

          //header_name += attr.name;
          header_name += nested_item.name;

          if (params.test_page)
          {
            header_name += " [Attr" + attr.id + " Option" + nested_option.id + "]";
          }

          //$box_new.append("<p style='font-size: 120%; margin-top: 10px;'><b>" + header_name + "</b></p>");

          var $header_div = $("<div/>");
          $header_div.css('font-weight', 'bold');
          $header_div.text(header_name);

          if (multiple_nested_items)
          {

          }
          else
          {
            $header_div.css('margin-top', '10px');
            $header_div.css('font-size', '120%');
            //$header_div.css('font-weight', 'bold');
          }
          $box_new.append($header_div);

          $box.append($box_new);

          if (!nested_item)
          {
            console.log("Can't find nested item with SKU: " + nested_sku);
          }
          else
          {
            var nested_attrs = nested_item.attributes;

            //console.log('nested_attrs');
            //console.log(nested_attrs);

            var nested_add_attrs_cfg = {};
            //nested_add_attrs_cfg.attrs = nested_attrs;
            nested_add_attrs_cfg.sku = nested_sku;
            nested_add_attrs_cfg.prefix = prefix_current;
            nested_add_attrs_cfg.prefix_id = prefix_id + nested_sku + '_';
            nested_add_attrs_cfg.box = $box_new;

            nested_add_attrs_cfg.parent_sku = sku;
            nested_add_attrs_cfg.skippable = attr.skippable;

            if (nested_add_attrs_cfg.skippable)
            {
              $box_new.attr('data-skip', 1);
              $box_new.attr('data-skippable', 1);
            }

            var path_new = add_attrs_cfg.path;
            //var path_new = add_attrs_cfg.path;
            if (path_new)
            {
              path_new += '.';
            }
            path_new += attr.id;
            var path_box_attr_level = path_new;
            path_new += '-' + nested_option.id;
            path_new += '-' + nested_item_id;

            //attr.path = path_new;

            nested_add_attrs_cfg.path = path_new;
            $box_new.attr('data-path-box', nested_add_attrs_cfg.path);
            $box_new.attr('data-path-box-attr-level', path_box_attr_level);

            nested_add_attrs_cfg.prefix = prefix_current;
            nested_add_attrs_cfg.prefix_id = prefix_id + nested_sku + '_';

            nested_add_attrs_cfg.nested_option_item = nested_option.item;
            nested_add_attrs_cfg.nested_option = nested_option;
            nested_add_attrs_cfg.nested_option_item.attributes = [];

            //console.log('al- nested_add_attrs_cfg', nested_add_attrs_cfg);

            addAttributes(nested_add_attrs_cfg);

          }
        }

      }
      else
      {
        var id = '_' + attr.id + '*' + attr.name;

        var input_id = attr.id;

        if (params.test_page || save_array_data)
        {
          var input_name = 'properties'+ '[' + prefix + id + ']';

          if (save_array_data)
          {
            input_name = 'properties' + prefix + '[' + id + ']';
          }
        }

        var $input;
        var $validation_message = null;
        var $hint_message = null;

        if (add_attrs_cfg.nested_option_item)
        {
          add_attrs_cfg.nested_option_item.attributes.push(attr);
        }


        attr.ext = {};
        attr.ext.id = id;

        attr.ext.id_uniq = prefix_id + attr.id;

        attr.ext.sku = current_sku;
        attr.ext.parent_sku = parent_sku;
        attr.ext.attribute_id = attr.id;
        attr.ext.position = position;
        attr.ext.input_id = input_id;
        attr.ext.input_name = input_name;

        if (main_item)
        {
          attr.ext.allow_backorder = main_item.allow_backorder;
        }

        var path_new = add_attrs_cfg.path;
        if (path_new.trim() != '')
        {
          path_new += '.';
        }
        path_new += attr.id;

        attr.ext.path = path_new;
        path_to_attr[attr.ext.path] = attr;

        attr.ext.path_box = add_attrs_cfg.path;

        input_id = attr.ext.path;
        attr.ext.input_id = input_id;

        //console.log('attr', attr.ext, attr);

        //var last_attr_related_to_input_with_options = null;

        switch (attr.type)
        {
          case 'list':

            //console.log('al- add_attrs_cfg ', add_attrs_cfg, ' attr ', attr);

            if (!add_attrs_cfg.skippable)
            {
              attr.validation = {};
              attr.validation.required = true;
              attr.validation.name = attr.name;
              attr.validation.list = true;
            }
            else
            {
              //attr.validation = false;
            }

            attr.nested_option = {};//add_attrs_cfg.nested_option;

            if (add_attrs_cfg.nested_option)
            {
              if (add_attrs_cfg.nested_option.item_option_combinations)
              {
                attr.nested_option.item_option_combinations = add_attrs_cfg.nested_option.item_option_combinations;
              }
            }

            $input = addInputList(attr, id);

            if ($input.find('option').length > 1)
            {
              last_attr_related_to_input_with_options[attr.ext.sku] = attr;
            }
            //console.log('list added', attr.ext.path);

            if (!add_attrs_cfg.skippable)
            {
              $validation_message = $("<div/>");
              $validation_message.addClass('ext-opts-validation-message');
              $validation_message.hide();
            }
            else
            {
              //$validation_message = null
            }
            
            break;

          case 'text':
            $input = addInputText(attr, id, input_id);

            if (!add_attrs_cfg.skippable)
            {
              console.log('ns- non skippable', attr);
              //attr.validation = {};



              //attr.validation.name = attr.name;
              //attr.validation.list = true;
              $validation_message = $("<div/>");
              $validation_message.addClass('ext-opts-validation-message');
              $validation_message.hide();
            }
            else
            {
              //attr.validation = false;

              //if (attr.validation)
              //{
                attr.validation.required = false;
              //}
              console.log('ns- skippable', attr);
            }




            if (attr.validation && !main_item.fields_rules_hide)
            {
              var hint = valueHint(attr);

              if (hint)
              {
                $hint_message = $("<div/>");
                $hint_message.css('font-style', 'italic');
                $hint_message.html(hint);
              }

              if (attr.validation.max_chars)
              {
                $input.attr('maxlength', attr.validation.max_chars);
              }


            }


            break;

          case 'radio':
            $input = addInputRadio(attr);
            break;

          case 'color':
            $input = addInputColor(attr);
            break;

          case 'image':
            $input = addInputImageSelect(attr);
            break;

          default:
            console.log('Attribute has type `' + attr.type + '` - this is not supported yet, skipping');
            continue;
        }

        $input.attr('id', input_id);

        $input.attr('data-attribute-id', attr.id);
        $input.attr('data-ext-opts-path', attr.ext.path);
        $input.attr('data-input-type', attr.type);

        //$input.css('margin-bottom', '16px');
        $input.attr('name', input_name);

        if (attr.top_level)
        {
          $input.attr('data-top-level', 1);
        }

        var $label = $('<label/>');
        $label.attr('for', input_id);
        $label.text(attr.name);

        var $div = $('<div/>');
        $div.append($label);
        $div.append($input);
        $div.addClass('ext-opts-visible');

        if ($validation_message)
        {
          $div.append($validation_message);
        }

        if ($hint_message)
        {
          $div.append($hint_message);
        }

        if (attr.description)
        {
          var $description_box = $("<div/>");
          $description_box.css('font-style', 'italic');
          $description_box.html(attr.description);

          $div.append($description_box);
        }

        if (params.test_page || params.format_input)
        {
        }

        $div.addClass('ext-opts-form-group');
        $input.addClass('ext-opts-form-control');

        if ($input.attr('data-hide'))
        {
          /*if (attr.ext.path.indexOf('.') != -1 && attrs.length == 1 && attr.ext.path.indexOf('top_level') == -1)
          {
            console.log('nested has hide mark / unhide', attr.ext.path, attr.name);
            $input.removeAttr('data-hide');
          }
          else
          {*/
            $div.hide();
            $div.removeClass('ext-opts-visible');
          //}
        }

        if (!attr.top_level)
        {
          //console.log('is not top level');

          if (add_attrs_cfg.parent_sku)
          {

            //console.log('has parent sku', add_attrs_cfg.parent_sku);

            var parent_item = api_data[add_attrs_cfg.parent_sku];

            if (parent_item.top_level && parent_item.top_level.attributes_nested_skip_ids)
            {
              //console.log('parent_item has top level / attributes_nested_skip_ids');

              //console.log(parent_item.top_level.attributes_nested_skip_ids);

              if (parent_item.top_level.attributes_nested_skip_ids[attr.id])
              {
                //console.log('attributes_nested_skip_ids matches, hide');

                // find top attr
                var $tls = $box.closest('[data_level=top_level]').find('select[data-top-level]');
                attr.depends_on_top_level = true;
                //console.log(attr);
                //console.log($tls.html());
                //console.log($div.html());

                $div.hide();

                if ($tls.attr('data-hide'))
                {
                  $div.find('select').attr('data-hide', true);
                }

                $div.removeClass('ext-opts-visible');
              }
            }
            else
            {
              //console.log("parent_item has no top_level", parent_item);
            }
          }
          else
          {

          }
        }


        //console.log('eo- append attr', $div.html());

        add_attrs_cfg.box.append($div);
        //add_attrs_cfg.box.css('border', '2px solid red');

        //console.log('eo- append attr - new box', add_attrs_cfg.box.html());

      }
    }

    //console.log('last_attr_related_to_input_with_options', last_attr_related_to_input_with_options);

    //if (last_attr_related_to_input_with_options)
    //{
      //last_attr_related_to_input_with_options.last = true;
    //}

    /*if ($box.find('.ext-opts-visible').length >0)
    {
      $box.find('[data-header]').show();
    } */

    if (0 == $box.find('.ext-opts-visible').length)
    {
      //$box.append("<p>There are no attributes for configure</p>");
      $box.hide();
      //console.log("hd- can't find .ext-opts-visible attributes, hide box", $box);
    }
    else
    {
      $box.show();
      //console.log("hd- found .ext-opts-visible attributes, show box", $box);
    }
  }

  function getBox(box_id)
  {
    var sel = '[data-path-box="' + box_id + '"]';
    var $res = $(sel);
    return $res;
  }


  function addInputRadio(attr)
  {
    var box_id = attr.ext.path_box;
    console.log('air- box_id', box_id);

    if (attr.top_level)
    {
      //console.log('box_id', box_id);
    }

    if (!inputs_sequence[box_id])
    {
      inputs_sequence[box_id] = [];
    }

    if (!inputs_before[box_id])
    {
      inputs_before[box_id] = {};
    }

    inputs_before[box_id][attr.id] = $.extend(true, [], inputs_sequence[box_id]);
    inputs_sequence[box_id].push(attr);

    var picks = [];

    var opts = getAvailableOptions(attr);
    //console.log('radio-opts', 'attr', attr, 'opts', opts);

    //for(var j=0; j < attr.options.length; j++)
    for(var j=0; j < opts.length; j++)
    {

      //var opt_data = attr.options[j];
      var opt_data = opts[j];

      //var $color = $("<span/>");
      //$color.css('background-color', opt_data.color_code);
      //$color.addClass('color-sample');

      var $name = $("<div/>");
      //$name.append($color);
      $name.append(opt_data.name);

      var pick = {};
      pick.attribute_id = attr.id;
      pick.attribute_id_uniq = attr.ext.id_uniq;
      pick.option_id = opt_data.id;

      pick.id = opt_data.id + '*' + opt_data.name;
      pick.name = $name[0].outerHTML;
      pick.label_class = "color";

      if (opt_data.disabled)
      {
        continue;
      }

      picks.push(pick);


    }

    return renderPicker(picks, attr);
  }
;
  
function getBoxByPath(path)
{
  var sel = '[data-path-box="' + path + '"]';
  var $el = $(sel);
  return $el;
}


var summary_fields = [];
summary_fields.push('Details');
summary_fields.push('_item_custom_price');
summary_fields.push('_ext_opts_serialize');

//if (get_url_param("details_v2"))
if (true)
{
  //summary_fields.push('_Details_old');
  summary_fields.push('_Details_html');
  //summary_fields.push('_Details_text_full');
  summary_fields.push('_Details_markup');
}


var $inp_summary = [];

for(var j=0; j<summary_fields.length; j++)
{
  var k = summary_fields[j];
  var input_name = 'properties'+ '[' + k + ']';

  $inp_summary[k] = $('<input/>');
  $inp_summary[k].attr('type', 'hidden');
  $inp_summary[k].attr('name', input_name);
  $form.append($inp_summary[k]);

  //console.log('dp- $form', $form, 'dp append', k);
}


function getInputValueForDetails(box_id, attr)
{
  //debugger;
  //var $input = $('[data-attribute-id-uniq="' + attr.ext.id_uniq +'"]');
  //var sel = '[data-path-box="' + box_id + '"] [data-ext-opts-path="' + attr.ext.path +'"]';

  var sel = '[data-path-box="' + box_id + '"] [data-attribute-id="' + attr.id +'"]';
  var $input = $(sel);

  if (0 == $input.length)
  {
    console.log("Can't find input by selector: " + sel);
    return '';
  }

  if ($input.attr('data-ext-opts-path-tmp'))
  {
    console.log("flex-exclude: " + sel);
    return '';
  }

  ////console.log('getInputValueForDetails', sel, $input);


  var val = null;

  //console.log('getInputValueForDetails', 'attr', attr);

  switch (attr.type)
  {
    case 'list':

      if ($input.attr('data-hide'))
      {
        return '';
      }

      var $opt = $input.find('option:selected');
      val = $opt.text();
      var dn = $opt.attr('data-name');
      if (dn)
      {
        val = dn;
      }

      break;

    case 'text':
      val = $input.val();
      break;

    case 'radio':
    case 'color':
    case 'image':
      var $opt = $input.find('option:checked,input:checked');
      //console.log('getInputValueForDetails', 'opt', $opt);

      if ($opt.length == 0)
      {
        return '';
      }
      val = $opt.attr('data-label-text');
      break;
  }

  return val.trim();
}

function prepareNames(attrs, naming_cfg, level, base_path_box)
{

  if (typeof base_path_box == "undefined")
  {
    base_path_box = '';
  }

  if (typeof level == "undefined")
  {
    level = 1;
  }

  var nested_initial = naming_cfg.nested;

  //console.log('naming_cfg');
  //console.log(naming_cfg);

  var res = [];

  var fmt = {};

  fmt.item_name_prefix = "\n";
  fmt.item_name_suffix = "";
  fmt.item_name_attrs_separator = " ";

  fmt.item_attrs_prefix = "";
  fmt.item_attrs_suffix = "";

  fmt.attr_row_prefix = "";
  fmt.attr_row_suffix = "";

  fmt.attr_name_prefix = "";
  if (naming_cfg.nested)
  {
    fmt.attr_name_prefix = "- ";
  }
  fmt.attr_name_suffix = "";

  fmt.attr_value_prefix = "";
  fmt.attr_value_suffix = "";

  fmt.lines_separator = ", ";

  if (naming_cfg.mode_markup)
  {
    fmt.item_name_prefix = "\n'";
    fmt.item_name_suffix = "'";
    fmt.item_name_attrs_separator = ":\n";
    fmt.lines_separator = ", ";
  }

  if (naming_cfg.mode_html)
  {
    fmt.item_name_prefix = '<br><b>';
    fmt.item_name_suffix = ':</b>';

    fmt.item_name_attrs_separator = "<br>";

    fmt.attr_name_prefix = '<b>' + fmt.attr_name_prefix;

    fmt.attr_name_suffix = fmt.attr_name_suffix + '</b>';

    fmt.lines_separator = '<br>' + "\n";
  }

  if (naming_cfg.mode_nested_short)
  {
    fmt.item_attrs_prefix = "(";
    fmt.item_attrs_suffix = ")";

    if (naming_cfg.nested)
    {
      fmt.lines_separator = ", ";
    }
  }

  if (naming_cfg.mode_text_full || naming_cfg.mode_markup)
  {
    fmt.lines_separator = "\n";
  }

  if (naming_cfg.fmt)
  {
    fmt = $.extend(true, fmt, naming_cfg.fmt);
  }

  if (naming_cfg.nested && naming_cfg.fmt_nested)
  {
    fmt = $.extend(true, fmt, naming_cfg.fmt_nested);
  }

  for(var position=0; position<attrs.length; position++)
  {
    var attr = attrs[position];

    if (attr.type == 'item')
    {

      if (attr.skippable && attr.skip)
      {
        continue;
      }

      var nested_options = attr.options;
      var nested_idx;

      for(nested_idx=0; nested_idx<nested_options.length; nested_idx++)
      {
        var nested_option = nested_options[nested_idx];

        if (!nested_option.item)
        {
          continue;
        }

        //var nested_option = getNestedOption(attr.options);
        var nested_sku = nested_option.item.SKU;

        if (!nested_sku)
        {
          console.log('Attribute has type = item, but SKU was not provided');
          console.log(nested_option);
          continue;
        }


        var nested_item = api_data[nested_sku];

        //res.push(fmt_item_name_prefix + attr.name + fmt_item_name_suffix);

        if (nested_item)
        {
          naming_cfg.nested = true;

          var path_new = base_path_box;
          if (path_new)
          {
            path_new += '.';
          }
          path_new += attr.id;
          path_new += '-' + nested_option.id;
          path_new += '-' + nested_option.item.id;

          var $box = getBoxByPath(path_new);
          //console.log('db- ', $box);

          if ($box.attr('data-skip'))
          {
            //console.log('db- skip');
            continue;
          }
          else
          {
            //console.log('db- NO skip');
          }

          //naming_cfg.path_box = path_new;

          var nested_names = prepareNames(nested_item.attributes, naming_cfg, level+1, path_new);
          nested_names = nested_names.trim();
          var line = fmt.item_attrs_prefix + nested_names + fmt.item_attrs_suffix;

          //console.log('nested_names `' + nested_names + '`');

          if ('' == nested_names)
          {
            line = '';
          }

          var line_full = fmt.item_name_prefix + attr.name + fmt.item_name_suffix;

          if (line)
          {
            line_full += fmt.item_name_attrs_separator + line;
          }

          if (nested_names)
          {
            res.push(line_full);
          }
        }
        else
        {
          console.log('Attribute has type = item, but there are no data for this SKU: `' + nested_sku + '`');
          continue;
        }
      }
    }
    else
    {
      var name = attr.name;
      var line = "";
      var val = getInputValueForDetails(base_path_box, attr);

      if (naming_cfg.nested && naming_cfg.mode_nested_short)
      {
        line = val;
      }
      else
      {

        line += fmt.attr_row_prefix;

        line += fmt.attr_name_prefix;
        line += name;
        line += fmt.attr_name_suffix;

        line += ": ";

        line += fmt.attr_value_prefix;
        line += val;
        line += fmt.attr_value_suffix;

        line += fmt.attr_row_suffix;
      }

      if (val)
      {
        res.push(line);
      }

    }

  }

  res = res.join(fmt.lines_separator);

  naming_cfg.level = level;

  if (get_url_param("details_cfg"))
  {
    res = "<br><b>" + JSON.stringify(naming_cfg) + "</b><br> " + JSON.stringify(fmt) + "<br><div data-item-details-test class='card card-body bg-light' style='margin: 10px 0px; display: block'>" + res + "</div>";
  }

  return res;

}



function getInputValueForSerialize($input)
{
  var path = $input.attr('data-path');
  var type = $input.attr('data-input-type');

  var val;

  switch(type)
  {
    case 'list':
      val = $input.find('option:selected').val();
      break;

    case 'text':
      val = $input.val();
      val = replaceAll('*', '&ast;', val);
    break;

    case 'color':
    case 'image':
      //..val = $input.find('option:checked').attr('data-label-text');
      //val = replaceAll('*', '&ast;', val);
      //break;

    case 'radio':
      val = $input.find(':checked').val();
      break;
  }

  return val;
}


function fixAttributesForCart()
{
  /*
  $.getJSON('/cart.js', function(cart)
  {
    $('.cart__row').each(function(k, el)
    {
      if (!cart.items[j])
      {
        return;
      }

      var item = cart.items[j];

      var $row = $(this);

      var $d = $row.find('[data-property-handle=details]');

      if ($d.length > 0)
      {
        if (item.properties._Details_html)
        {
          $row.html(item.properties._Details_html);
        }
      }

    });

  });
  */
}

function updateDetails()
{
  var naming_cfg = {};
  var n = '';

  //if (!get_url_param("details_v2"))
  if (false)
  {
    naming_cfg.fmt = {};
    naming_cfg.fmt.item_name_attrs_separator = " - ";
    naming_cfg.fmt_nested = {};
    naming_cfg.fmt_nested.attr_name_prefix = "";
    n = prepareNames(attrs, naming_cfg);
    $inp_summary["Details"].val(n);
  }
  else
  {
    /*if (params.test_page)
    {
      naming_cfg.fmt = {};
      naming_cfg.fmt.lines_separator = ", ";
      naming_cfg.fmt.item_name_attrs_separator = ":\n";
      naming_cfg.fmt_nested = {};
      naming_cfg.fmt_nested.attr_name_prefix = "";

      //var n = prepareNames(attrs, naming_cfg);
      //$inp_summary["_Details_old"].val(n);
    } */

    naming_cfg.fmt = null;
    naming_cfg.fmt_nested = null;

    naming_cfg.mode_nested_short = true;
    n = prepareNames(attrs, naming_cfg);
    $inp_summary["Details"].val(n);

    naming_cfg.mode_html = true;
    naming_cfg.mode_nested_short = false;
    n = prepareNames(attrs, naming_cfg);
    $inp_summary["_Details_html"].val(n);

    var markup = n;
    markup = replaceAll("<br>", "[br]\n", markup);
    markup = replaceAll("<b>", "[b]", markup);
    markup = replaceAll("</b>", "[/b]", markup);

    /*naming_cfg.mode_html = false;
    naming_cfg.mode_markup = true;
    naming_cfg.mode_nested_short = false;
    n = prepareNames(attrs, naming_cfg);
    n = "<pre>" + n + "</pre>";*/

    $inp_summary["_Details_markup"].val(markup);

    /*naming_cfg.mode_html = false;
    naming_cfg.mode_markup = false;
    naming_cfg.mode_nested_short = false;
    naming_cfg.mode_text_full = true;
    n = prepareNames(attrs, naming_cfg);
    n = "<pre>" + n + "</pre>";
    $inp_summary["_Details_text_full"].val(n); */

  }

  var $test_area = $('[data-item-details-test]');

  //console.log('$test_area');
  //console.log($test_area);

  if ($test_area.length > 0)
  {
    var test_data = "";

    //if (window.main_item)
    //{
      //test_data += "<br><b>Comb:</b> " + JSON.stringify(main_item.comb_data, null, 4);
    //}

    for(k in $inp_summary)
    {
      if (!$inp_summary.hasOwnProperty(k))
      {
        continue;
      }

      var $inp = $inp_summary[k];

      test_data += "<br><b>";
      test_data += $inp.attr('name');
      test_data += ":</b><br>";
      test_data += $inp.val();
      test_data += "<br>";
    }

    //console.log('test_data');
    //console.log(test_data);

    $test_area.html(test_data);

  }

}

;


  try
  {
    fetch("/cart/update.js",
    {
      method:"POST",
      body: new URLSearchParams("attributes[route_toggle_state]=1")
    });
  }
  catch(e)
  {
    console.log('route err', e);
  }

  var final_html = $box.html();


  $(document).on('ext-opts-form-init', function()
  {

  });

  $(document).trigger('ext-opts-form-init');





  
$(document).on('submit', 'form[method=post][action*=cart]', function(e)
{
  e.stopPropagation();
  //runValidate(e);

  if (!runValidate(e))
  {
    event.preventDefault();

    var $box = $('[data-ext-opts-box]:first');
    $box[0].scrollIntoView();
    console.log('scroll');

    return false;
  }

});

 $(document).on("keydown", "form[method=post][action*=cart] input, form[method=post][action*=cart] select", function(e)
 {
  e.stopPropagation();

  if(event.keyCode == 13)
  {
    if (!runValidate(e))
    {
      event.preventDefault();
      return false;
    }
  }
});

/*$(document).on('click', 'form[method=post][action*=cart] button', function(e)
{
  e.stopPropagation();
  runValidate(e);
});*/

$(document).on('mouseover', '.ext-opts-handle-click-wrapper', function(e)
{
  var $el = $(this);
  $el.addClass('hover');
});

$(document).on('mouseout', '.ext-opts-handle-click-wrapper', function(e)
{
  var $el = $(this);
  $el.removeClass('hover');
});


/*$(document).on('ext-opts-form-serialized', function()
{

  $form.find('button, [type=submit]').not('[data-ext-opts-btn-submit]').off('click');
  $form.off('submit');
  $form.submit(function(e)
  {
    runValidate(e);
  });
});*/


/*$(document).on('submit', 'form[method=post][action*=cart]', function(e)
{
  runValidate(e);
});

/*
  $(document).on('submit', 'form[method=post][action*=cart]', function(e)
  {
    runValidate(e);
  });

  $(document).on('click', 'form[method=post][action*=cart] [type=submit]', function(e)
  {
    runValidate(e);
  });

});  */


/*var $buy_btn_new = $("<button/>");
//$buy_btn_new.addClass('ext-opts-submit');
$buy_btn_new.addClass('btn product__submit__add');
$buy_btn_new.attr('data-ext-opts-btn-submit');
$buy_btn_new.html("<span data-add-to-cart-text>Add to Cart</span>");

$(document).on('click', '[data-ext-opts-btn-submit]', function(evt)
{
  console.log('fbb- data-ext-opts-btn-submit - click');

  evt.preventDefault();

  $form.off('submit');

  $form.submit(function(e)
  {
    runValidate(e);
  });

  //$buy_btn_new.closest('form').submit();
  $form.submit();
});


var $buy_btn_old = $form.find('button')
$buy_btn_old.after($buy_btn_new);
$buy_btn_old.remove();   */


flexFixBuyBtn2();

var fix_buy_btn_counter = 0;

function fixSticky()
{
  //console.log('fs- fixSticky');

  var $sticky_cont = $('.product__sticky_add__form');

  //console.log('fs- $sticky_cont', $sticky_cont);
  if (0 == $sticky_cont.length)
  {
    //console.log('fs- 0 == $sticky_cont.length');
    return;
  }

  var $btn = $sticky_cont.find('.product__add__cart__button').find('button');
  //console.log('fs- $btn', $btn);

  if (0 == $btn.length)
  {
    //console.log('fs- 0 == $btn.length');
    return;
  }

  $btn.wrap("<div class='ext-opts-handle-click-wrapper' style='position: relative;'></div>" );
  var $wrap = $btn.closest('.ext-opts-handle-click-wrapper');

  var $div = $('<div/>');
  //$div.addClass('ext-opts-handle-click');
  $div.addClass('ext-opts-handle-click-redirect-to-main');

  var style = 'position: absolute !important; width: 100% !important; left: 0px !important; top: 0px !important; z-index: 999999 !important; height: 100%  !important; cursor: pointer;';
  if (params.localhost)
  {
    style += "; border: 1px solid red; ";
  }

  $div.attr('style', style);

  $wrap.append($div);
  $btn.addClass('popover-fixed');

  //console.log('fs- OK');
}

function flexFixBuyBtn2ChkPopover()
{
  var buy_button_dbg = false;
  if (get_url_param('buy_button_dbg'))
  {
    buy_button_dbg = true;
  }


  fixSticky();

  fix_buy_btn_counter++;
  var run_id = fix_buy_btn_counter;


  //var sel = 'div.shopify-payment-button__button, button.shopify-payment-button__more-options, .product__submit__add';
  var sel = '.add-to-cart[type=submit], .product__submit__add, [data-shopify=payment-button], .addtocart-js, [data-add-to-cart], .product-form__submit, [data-ext-opts-test-submit-btn]';
  //form[method=post][action*=cart] button';

  //var $btn = $(sel);//.filter(':visible').not('.popover-fixed').not('.popover-submitting');
  var $btn = $(sel).not('.popover-fixed');//.not('.popover-submitting');

  if (buy_button_dbg)
  {
    console.log('flexFixBuyBtn2ChkPopover-' + run_id, ' -start', $btn);
  }

  if (0 == $btn.length)
  {
    setTimeout(flexFixBuyBtn2ChkPopover, 1000);
    return;
  }

  var is_payment_btn = false;

  if ($btn.hasClass('shopify-payment-button__button'))
  {
    //is_payment_btn = true;
  }

  if (buy_button_dbg)
  {
    console.log('chk_popover-' + run_id, ' -start', $btn);
  }


  //console.log('fix popover');
  //console.log($btn);
  //console.log($btn.html());

  if (is_payment_btn)
  {
    $btn.css('position', 'relative');
  }
  else
  {
    $btn.wrap("<div class='ext-opts-handle-click-wrapper' style='position: relative;'></div>" );
    var $wrap = $btn.closest('.ext-opts-handle-click-wrapper');
  }

  var $div = $('<div/>');
  $div.addClass('ext-opts-handle-click');

  if (is_payment_btn)
  {
    $div.addClass('ext-opts-handle-click-payment');
  }
  else
  {
    $div.addClass('ext-opts-handle-click-add-to-cart');
  }

  var style = 'position: absolute !important; width: 100% !important; left: 0px !important; top: 0px !important; z-index: 999999 !important; height: 100%  !important; cursor: pointer;';

  if (params.localhost)
  {
    style += "; border: 1px solid red; ";
  }

  $div.attr('style', style);

  if (is_payment_btn)
  {
    $btn.append($div);
  }
  else
  {
    $wrap.append($div);
  }

  $btn.addClass('popover-fixed');

  console.log('flexFixBuyBtn2ChkPopover-' + run_id, ' -end');
  setTimeout(flexFixBuyBtn2ChkPopover, 1000);
}

function flexFixBuyBtn2()
{
  if (get_url_param('no_fix_buy_now_button'))
  {
    return;
  }

  if (params.no_fix_buy_btn)
  {
    return;
  }

  flexFixBuyBtn2ChkPopover();
}

$(document).on("click", '.ext-opts-handle-click-redirect-to-main', function(e)
{
  e.preventDefault();
  //alert('ext-opts-handle-click-redirect-to-main');

  var $btn = $('.ext-opts-handle-click:first');
  $btn.click();

  //var $box = $('[data-ext-opts-box]:first');
  //$box[0].scrollIntoView();
});

$(document).on("click", '.ext-opts-handle-click', function(e)
{
  var $el = $(this);
  console.log("ev2- click on popover fix");

  //console.log(e);
  //console.log('e.data');
  //console.log(e.data);
  if ($el.hasClass('event-passed'))
  {
    console.log('ev2- has class event-passed');
    return;
  }

  var $t = $(this);

  $form.submit();
  /*
  if (runValidate(e))
  {
    $form.submit();
  }
  else
  {
    var $box = $('[data-ext-opts-box]:first');
    $box[0].scrollIntoView();
    console.log('scroll');
  } */


});;
  function runValidate(e)
{
  console.log('vld - runValidate');

  serializeData();

  //alert('submit');

  if (params.validate_not_submit)
  {
    //e.preventDefault(); // for testing
  }

  if (!validateForm($form))
  {
    console.log('vld - form non-valid');
    e.preventDefault();
    return false;
  }
  else
  {
    console.log('vld - form VALID');

    if (params.validate_not_submit)
    {
      //alert('fields were validated and ready for submit');
      //e.preventDefault();
      //alert("validated [local]");
    }
  }

  var details = $('input[name="properties[Details]"]').val();

  //console.log('details', details);
  if (details.indexOf('select option') != -1)
  {
    alert("Please select all options");
    e.preventDefault();
    return false;
  }


  pageflySubmitEffect($form);

  return true;
}
;



  
if (get_url_param('mobile_emulation'))
{
  console.log('mobile_emulation_mode');

  if (!window.webkit)
  {
    window.webkit = {};
  }

  if (!window.webkit.messageHandlers)
  {
    window.webkit.messageHandlers = {};
  }

  if (!window.webkit.messageHandlers.addLineItemProperty)
  {
    window.webkit.messageHandlers.addLineItemProperty = {};
    window.webkit.messageHandlers.addLineItemProperty.postMessage = function() {};
  }
  if (!window.webkit.messageHandlers.removeLineItemProperty)
  {
    window.webkit.messageHandlers.removeLineItemProperty = {};
    window.webkit.messageHandlers.removeLineItemProperty.postMessage = function() {};
  }

  if (!window.webkit.messageHandlers.isMobileApp)
  {
    window.webkit.messageHandlers.isMobileApp = function() { return true};
  }
}


  function extOptsMobileAppFunctionCheck(f)
  {
    if (!window['PlobalBridge'])
    {
      console.log('extOptsMobileAppFunctionCheck', 'No PlobalBridge');
      return;
    }

    var pb = window['PlobalBridge'];

    if (!pb[f])
    {
      console.log('extOptsMobileAppFunctionCheck', 'No `' + f + '` in PlobalBridge');
      return false;
    }

    if (typeof pb[f] !== 'function')
    {
      console.log('extOptsMobileAppFunctionCheck', '`' + f + '` in PlobalBridge exists, but is not function');
      return false;
    }

    return true;
  }

  function extOptsMobileAppSetLineItemProperties(props)
  {

    if (!extOptsMobileAppFunctionCheck('addLineItemProperty'))
    {
      return;
    }

    if (!extOptsMobileAppFunctionCheck('removeLineItemProperty'))
    {
      return;
    }

    for(var key in props)
    {
      if (!props.hasOwnProperty(key))
      {
        continue;
      }

      var value = props[key];

      var obj = {};
      obj[key] = value;

       //Do mobile handling here
       //window.PlobalBridge.addLineItemProperty({"Color":"red"}) ;
       //window.PlobalBridge.addLineItemProperty({"Letter":"A"}) ;
       //we can add all rest required properties like this individually

      var pb = window['PlobalBridge'];
      pb.removeLineItemProperty(key);
      pb.addLineItemProperty(obj);

    }

  }

  function extOptsMobileAppIsActive()
  {

    if (!extOptsMobileAppFunctionCheck('isMobileApp'))
    {
      return false;
    }

    var pb = window['PlobalBridge'];
    var f = pb.isMobileApp;
    return f();

  }

  function extOptsMobileAppBeforeSubmitForm($form)
  {
    var $inputs = $form.find("[name*=properties][type=hidden]");
    var props = {};

    $inputs.each(function(k, el)
    {
      var $el = $(el);
      //console.log($el);

      var v = $el.val();

      var name_full = $el.attr('name');
      var name_parts = name_full.split('[');
      var name = name_parts[1].slice(0, -1);

      props[name] = v;
    });

    var hide_from_display = JSON.stringify(['_ext_opts_serialize', '_Details_html', '_Details_markup',
          '__ext_opts_js_loaded']);
    props['hide_from_display'] = hide_from_display;

    extOptsMobileAppSetLineItemProperties(props);

  }
;

    function getBuyButton()
  {
    var $el = $('form[method=post][action*=cart] button, .ext-opts-handle-click, .ext-opts-handle-click-wrapper');

    return $el;
  }

  setTimeout(function()
  {
    if ($('.notification-active').length > 0)
    {
      $('.ext-opts-handle-click-wrapper').hide();

    }

  }, 100);


  function getKey2CombForSku(sku)
  {
    //debugger;

    var comb_key2obj = {};

    var active_combinations = params.api_data[sku].active_combinations;

    for(var j in active_combinations)
    {
      if (!active_combinations.hasOwnProperty(j))
      {
        continue;
      }

      var cs = active_combinations[j];

      var cfg = {};
      //var cfg_name = {};

      for(var i=0; i < cs.combination.length; i++)
      {
        var c = cs.combination[i];

        if (c.attribute_option_id)
        {
          cfg[c.attribute_id] = c.attribute_option_id;
        }
      }

      //console.log('cfg', cfg);

      var comb_key = encodeKey(cfg);

      //console.log('comb_key', comb_key);

      comb_key2obj[comb_key] = cs;
    }

    return comb_key2obj;
  }


  function getItemCombinationKey($box)
  {
    /*var vals = {}

    $box.find('[data-attribute-id]').each(function(k, el)
    {
      var $el = $(el);
      var a_id = $el.attr('data-attribute-id');
      var ap_id = getInputValueForSerialize($el);

      vals[a_id] = ap_id;

    });

    return vals;  */

    var cfg = {};

    var $selects = $box.find("select[ext-opts]");
    $selects.each(function(k,el)
    {
      var $sel = $(el);

      var opt_id = $sel.attr('data-attribute-id');
      var opt_val_id = $sel.find("option:selected").attr('data-option-id');

      cfg[opt_id] = opt_val_id;

    });

    var $radio_input = $box.find("input[type=radio][ext-opts]:checked");
    $radio_input.each(function(k,el)
    {
      var $el = $(el);

      var opt_id = $el.attr('data-attribute-id');
      var opt_val_id = $el.attr('data-option-id');

      cfg[opt_id] = opt_val_id;
    });


    var comb_key = encodeKey(cfg);

    return comb_key;
  }

  $(document).on('change', '[data-attribute-id]', function(e)
  {
    var $el = $(this);
    var $box = $el.closest('[data-ext-opts-box]');

    checkNotificationsForBox($box);
  });

  function checkNotificationsForBox($box)
  {
    var sku = $box.attr('data-sku');

    console.log('nts- selection was changed for item: ' + sku);//, $box, $el);

    var comb_key = getItemCombinationKey($box);

    //console.log('nts- comb_key: ', comb_key);//, $box, $el);

    var k2c = getKey2CombForSku(sku);

    var comb = k2c[comb_key];

    console.log('nts- sku: ', sku, 'comb: ', comb);//, $box, $el);

    if (!comb)
    {
      return;
    }

    // chk all visible select have values

    var all_filled = true;
    $('select[data-ext-opts-path]:visible').each(function(k, el)
    {
      var $el = $(el);

      if (!$el.val())
      {
        console.log('nts- nf- ', $el);
        all_filled = false;
      }
    });

    if (!all_filled)
    {
      console.log('nts- not all filled')
      return;
    }

    var stock = comb.stock;

    var $buy_btn = getBuyButton();

    $('[' + stockAttr() + '=' + sku + ']').hide().removeClass('.notification-active');

    var notification_form_displayed = false;

    //if (!main_item.allow_backorder && stock <= main_item.notification_quantity)

    var item_by_sku = params.api_data[sku];

    console.log('nts- stock <= item_by_sku.notification_quantity',
        sku,
        item_by_sku,
        stock, item_by_sku.notification_quantity);

        //debugger;
    if (1*stock <= 1*item_by_sku.notification_quantity)
    {

      if (item_by_sku.allow_notification)
      {
        //var msg = "Notify Me";
      }

      //if (main_item.allow_notification && item_by_sku.allow_notification)
      console.log('nts- item_by_sku.allow_notification', item_by_sku.allow_notification);

      if (item_by_sku.allow_notification)
      {
        var $n_box = initNotificationsBox($box, $form);
        $n_box.show();
        $n_box.addClass('notification-active');
        notification_form_displayed = true;

        //$buy_btn.hide();
        //console.log('buy_btn- hide');
      }
    }


    if (!notification_form_displayed)
    {
      if ($("select[ext-opts]:visible").length == 0)
      {
        //console.log('nts- no selects');

        if (stock <= item_by_sku.warning_quantity)
        {
          //console.log('nts- stock <= item_by_sku.warning_quantity');

          if (item_by_sku.allow_warning)
          {

            //var msg = "Low Stock (less than " + item_by_sku.warning_quantity + " available)";
            //var msg = sku + ": " + item_by_sku.warning_on_screen;
            var msg = item_by_sku.warning_on_screen;
            var $stock_warning = initStockWarning($form, msg, $box);

            //console.log('nts- initStockWarning', $stock_warning);
            $stock_warning.show();
          }
        }
      }
    }
  }


  //console.log('nno- check all boxes');
  $('[data-ext-opts-box]').each(function(k, box)
  {
    var $box = $(box);

    //console.log('nno- box', $box);
    checkNotificationsForBox($box);
    
  });
  //$(document).on('ext-opts-form-init', function(e)
  //{

  //});



  $(document).on('e1xt-opts-form-serialized', function(e)
  {
    extOptsBeforeSubmitForm($form);



    var curent_comb = vpCustomVariantData();
    console.log('n- current comb', curent_comb);

    if (!curent_comb)
    {
      return;
    }

    var stock = curent_comb.stock;
    //alert('stock: ' + stock);
    console.log('n- stock: ' + stock);
    //console.log('n- main_item', main_item);





  });

  function stockAttr()
  {
    return 'ext-opts-stock';
  }

  function initStockWarning($form, msg, $box)
  {
    var sku = $box.attr('data-sku');
    var attr = 'ext-opts-stock-warning';

    var sel = '[' + attr + '=' + sku +']';
    //console.log('nts- initStockWarning, sel', sel);

    var $stock_warning = $();

    if ($stock_warning.length > 0)
    {
      return $stock_warning;
    }

    $stock_warning = $('<div/>');
    $stock_warning.attr(attr, sku);
    $stock_warning.attr(stockAttr(), sku);
    $stock_warning.addClass('alert alert-danger');

    $stock_warning.append('<p>' + msg + '</p>');

    //console.log('nts- $form.before', $form, $stock_warning);

    $form.before($stock_warning);

    return $stock_warning;
  }

  /*$(document).on('change', 'input[name=agree_check]', function(e)
  {
    console.log('change agree_check');
    var $el = $(this);
    var $btn = $el.closest('[ext-opts-notifications-box]').find('.ext-opts-btn');

    var checked = $el.prop("checked");

    $btn.toggleClass('ext-opts-btn-danger', checked);
    $btn.toggleClass('ext-opts-btn-secondary', !checked);
    $btn.toggleClass('ext-opts-btn-disabled', !checked);
  });

  /*
  $(document).on('click', 'label[for=agree_check]', function(e)
  {
    var $el = $(this);
    var $chk = $el.find('input[type=checkbox]')
    $chk.prop("checked", !$chk.prop("checked"));
  });
  */

  function initNotificationsBox($box, $form)
  {
    var notification_on_screen = main_item.notification_on_screen;

    if (!notification_on_screen)
    {
      notification_on_screen = "Notify Me";
    }

    var attr = 'ext-opts-notifications-box';

    var sku = $box.attr('data-sku');

    var $n_box = $box.find('[' + attr + '=' + sku + ']');

    if ($n_box.length > 0)
    {
      return $n_box;
    }


    var item_by_sku = params.api_data[sku];

    //var $n_box = $('<form/>');
    var $n_box = $('<div/>');
    $n_box.attr(attr, sku);
    $n_box.attr(stockAttr(), sku);

    $n_box.addClass('alert alert-danger');

    //$n_box.append("<p><b>" + notification_on_screen + " (less than " + item_by_sku.notification_quantity + " available)</b></p>");
    //$n_box.append("<p><b>" + notification_on_screen + "<br>Less than " + item_by_sku.notification_quantity + " available</b></p>");
    //$n_box.append("<p><b>" + sku + ": " + item_by_sku.notification_on_screen + "</b></p>");

    var box_title = '';
    if (params.local)
    {
      box_title = "SKU: " + sku + " - ";
    }
    box_title += item_by_sku.notification_on_screen;

    $n_box.append("<p><b>" + box_title + "</b></p>");

    //var $name = $('<div class=form-group><label for=notification_name>Name</label><input type=text id=notification_name class=form-control></div>');
    var $name = $('<div class=form-group><label>Name</label><input type=text class="notification_name form-control"></div>');
    $n_box.append($name);

    //var $phone = $('<div class=form-group><label for=notification_phone>Phone</label><input type=text id=notification_phone class=form-control></div>');
    var $phone = $('<div class=form-group><label>Phone</label><input type=text class="notification_phone form-control"></div>');

    $n_box.append($phone);

    /*<div class="form-check">
        <input type="checkbox" class="form-check-input" id="exampleCheck1" name="show_data_on_submit">
        <label class="form-check-label" for="exampleCheck1">Show data on submit</label>
      </div>*/

    var $check_div = $("<div/>");
    $check_div.addClass('ext-opts-form-check');

    var $check_inp = $("<input/>");
    $check_inp.addClass('ext-opts-form-check-input');
    $check_inp.attr('style', 'width: auto !important');
    $check_inp.attr('type', 'checkbox');

    var check_id = 'agree_check';
    $check_inp.attr('id', check_id);
    $check_inp.attr('name', check_id);
    //$check_div.append($check_inp);

    var $check_label = $("<label/>");
    $check_label.addClass('ext-opts-form-check-label');
    //$check_label.attr('for', check_id);
    $check_label.append($check_inp);
    $check_label.append(params.subscribe_checkbox_text);

    /*$check_label.append(" By checking this box you agree to receive text messages from VibeSzn. You can reply stop to opt-out at any time."+
          " This is our privacy policy ");


    var privacy_url = 'https://vibeszn.com/policies/privacy-policy';
    var $privacy_a = $('<a/>');
    $privacy_a.text(privacy_url);
    $privacy_a.attr('href', privacy_url);
    $privacy_a.attr('target', '_blank');
    $check_label.append($privacy_a);*/

    $check_div.append($check_label);

    $n_box.append($check_div);

    //var $btn = $('<a ext-opts-notification-submit class="ext-opts-btn ext-opts-btn-danger">Subscribe</a>');
    //var $btn = $('<a ext-opts-notification-submit class="ext-opts-btn ext-opts-btn-secondary ext-opts-btn-disabled">Subscribe</a>');
    var $btn = $('<a ext-opts-notification-submit class="ext-opts-btn ext-opts-btn-danger">Subscribe</a>');

    //var $btn = $('<button type=submit ext-opts-notification-submit class="ext-opts-btn ext-opts-btn-danger">Subscribe</button>');
    $n_box.append($btn);

    //$form.before($n_box);
    $('[data-ext-opts-box]:first').before($n_box);
    //$box.prepend($n_box);

    //debugger;
    return $n_box;
  }



  function alertNotificationResponse(msg)
  {
    var $alert = $("<div/>");
    $alert.html(msg);
    $alert.addClass('alert alert-danger');
    $alert.css('background-color', 'white');
    $alert.css('border-color', 'darkred');
    $alert.attr('ext-opts-notifications-box-response', 1);

    $('[ext-opts-notifications-box]').prepend($alert);
  }

  $(document).on('click', '[ext-opts-notification-submit]', function(e)
  {
    e.preventDefault();

    $('[ext-opts-notifications-box-response]').remove();

    var $el = $(this);
    //var $box = $el.closest('[data-ext-opts-box]');
    var $box = $el.closest('[ext-opts-notifications-box]');
    var sku = $box.attr('ext-opts-notifications-box');


    var ajax_cfg = {};

    ajax_cfg.method = "POST";
    ajax_cfg.url = params.stock_alert_subscribe_url;
    ajax_cfg.url = replaceAll('__sku__', sku, ajax_cfg.url);

    ajax_cfg.data = {};
    ajax_cfg.data.properties = {};

    ajax_cfg.data.properties.Details = getExtOptsFormField('Details');
    ajax_cfg.data.properties._ext_opts_serialize = getExtOptsFormField('_ext_opts_serialize');

    var $agree_check = $box.find('[name=agree_check]');
    if (!$agree_check.is(':checked') && params.subscribe_checkbox_required)
    {
      alert("Please check the box to agree to receive text messages");
      return;
    }

    var $name = $box.find('.notification_name');

    ajax_cfg.data.StockAlertSubscribeForm = {};
    ajax_cfg.data.StockAlertSubscribeForm.name = $name.val().trim();

    ajax_cfg.data.StockAlertSubscribeForm.agree_to_receive_text_messages = 0;
    if ($agree_check.is(':checked'))
    {
      ajax_cfg.data.StockAlertSubscribeForm.agree_to_receive_text_messages = 1;
    }

    if (!ajax_cfg.data.StockAlertSubscribeForm.name)
    {
      console.log('provided name', ajax_cfg.data.StockAlertSubscribeForm.name, $name, $name.val());
      alert("Please provide name");
      return;
    }

    var $phone = $box.find('.notification_phone');

    ajax_cfg.data.StockAlertSubscribeForm.phone = $phone.val().trim();

    if (!ajax_cfg.data.StockAlertSubscribeForm.phone)
    {
      alert("Please provide phone");
      return;
    }

    ajax_cfg.cache = false;

    $el.html("<div class=ext_opts_loader></div> Subscribe ...");

    ajax_cfg.error = function (xhr, status, error)
    {
      //$el.text("Subscribe");
      console.log('error', error, xhr);
      alert('error: ' + error + "\n" + xhr.responseText);
    };

    ajax_cfg.success = function (data, status, xhr)
    {
      $el.text("Subscribe");

      console.log('success', data);
      //console.log('success', typeof data);

      if (typeof data == "object")
      {

        if (data.result_array.message)
        {
          //alert(data.result_array.message);
          alertNotificationResponse(data.result_array.message);
          return;
        }


        if (data.result == 'success')
        {
          //alert("Thank you! The subscription was saved");
          alertNotificationResponse("Thank you! The subscription was saved");
        }
        else
        {
          var data_str = JSON.stringify(data);
          //alert(data_str);
          alertNotificationResponse(data_str);
        }
      }
      else
      {
        //alert(data);
        alertNotificationResponse(data);
      }
    }

    console.log('prepare to send ajax', ajax_cfg);
    $.ajax(ajax_cfg);

  });;

  function getExtOptsFormField(f)
  {
    var sel = '[name="properties[' + f + ']"]';
    //console.log('getExtOptsFormField sel', sel);

    var $f = $(sel);
    //console.log('$f', $f, $f.val());

    return $f.val();
  }

  function getMainSku()
  {
    var sel = '[data-path-box][data-sku]';
    var $el = $(sel);

    return $el.attr('data-sku');
  }


  function extOptsBeforeSubmitForm($form)
  {
    var mobile_app_mode = extOptsMobileAppIsActive();
    //console.log('mobile_app_mode', mobile_app_mode);

    if (mobile_app_mode)
    {
//      console.log('Mobile app active');
      extOptsMobileAppBeforeSubmitForm($form)
    }
    else
    {
      //console.log('Mobile app inactive');
    }
  }


    function validateForm($form)
    {

      var kx;
      for(kx in attr_checks)
      {
        if (!attr_checks.hasOwnProperty(kx))
        {
          continue;
        }

        var chk = attr_checks[kx];
        console.log('chk- ', chk);

        //var sel = '#' + chk.input_id;
        var sel = '[data-ext-opts-path="' + chk.path + '"]';

        var $input = $(sel);

        if ($input.length == 0)
        {
          //console.log('can not find sel', sel);
          //console.log($input);
        }

        var f = chk.func;
        f($input, chk.rules);
      }


      var $inp_errs = $form.find('input[data-error], select[data-error]');
      console.log('vld- inp_errs', $inp_errs);

      if (params.local)
      {
        $inp_errs.each(function(k, el)
        {
          var $el = $(el);
          $el.closest('.form-group').show();
        });
      }

      if ($inp_errs.length == 0)
      {
        $(document).trigger('ext-opts-form-validated');

        if (typeof vpCanSubmitForm != "undefined")
        {
          if (!vpCanSubmitForm())
          {
            return false;
          }
        }

        if (typeof extOptsBeforeSubmitForm != "undefined")
        {
          extOptsBeforeSubmitForm($form);
        }
      }
      else
      {
        return false;
      }

      //console.log("vld- Run form validation");
      //console.log('vld- attr_checks', attr_checks);


      //$(attr_checks).each(function(k, chk)
      //console.log('validateForm- main_item', main_item);
      //debugger;

      if (main_item.kit_item_status)
      {
        // check all nested items availability
        var not_available_item_exists = false;
        var not_available_item_name = '';

        runForAllItem(main_item, function(el)
        {
          console.log('cav- sku:', el.sku, el);

          if (!el.comb_data)
          {
            return;
          }

          //console.log('cav- el.comb_data', el.comb_data);

          if (!(el.force_allow_backorder*1) && !(el.comb_data.stock))
          {

            var all_attributes_set = true;

            for(var j=0; j < el.attributes.length; j++)
            {
              var attr = el.attributes[j];
              if (!attr.value_text)
              {
                all_attributes_set = false;
              }
            }

            if (all_attributes_set)
            {

              //alert("Not available" + JSON.stringify(el));
              not_available_item_name = el.name;
              not_available_item_exists = true;

              var a_vals = [];

              for(var j=0; j < el.attributes.length; j++)
              {
                var attr = el.attributes[j];

                //if (attr.value_text)
                //{
                  var a_val = attr.name + ": " + attr.value_text;
                  a_vals.push(a_val);
                //}
              }

              if (a_vals.length)
              {
                not_available_item_name += " (";
                not_available_item_name += a_vals.join(", ");
                not_available_item_name += ")";
              }
            }
          }

        });

        if (not_available_item_exists)
        {
          alert(not_available_item_name + " is not available");
          return false;
        }
      }

      if (!main_item.kit_item_status)
      {


        if (!isItemHasAvailableComb(main_item)
          || main_item.force_out_of_stock)
        {
          alert("This item is out of stock");
          return false;
        }

        if (main_item.comb_data)
        {
          console.log('vs- chk main_item.comb_data', main_item.comb_data);

          //if (!main_item.comb_data.allow_backorder*1)

          if (!main_item.force_allow_backorder*1)
          {
            console.log('vs- backorder: no');
            if (!main_item.comb_data.stock)
            {
              console.log('vs- stock: no');
              var n_combs = itemCountOfCombinations(main_item);

              if (n_combs > 1 || !main_item.kit_item_status)
              {
                alert("This item is out of stock");
                return false;
              }
            }
            else
            {
              console.log('vs- stock: yes');
            }
          }
          else
          {
            console.log('vs- force_allow_backorder: allowed');
          }
        }
      }

      return true;
    }

  //console.log('getCurrentCombKey - test', getCurrentCombKey());

  $("[data-ext-opts-box] select[ext-opts], fieldset input[type=radio]").on("change", function()
  {


    var $input = $(this);
    //console.log("oc- option changed", $input);

    var changed_attribute_id = $input.attr('data-attribute-id');

    //console.log("ddchg- attribute_id changed", changed_attribute_id);

    var box_id = $input.closest('[data-path-box]').attr('data-path-box');
    //console.log("ddchg- box_id", box_id);
    //console.log('box_id', box_id);

    //var sku = $input.closest('[data-sku]').attr('data-sku');
    //console.log('sku', sku);

    //debugger;
    // don't update 1st select
    if (!inputs_sequence[box_id])
    {
      return;
    }

    //console.log('ddchg- inputs_sequence', inputs_sequence[box_id]);

    var count_inputs = inputs_sequence[box_id].length;

    //console.log('last- ', inputs_sequence);

    /*if (count_inputs > 0)
    {
      inputs_sequence[box_id][count_inputs-1].last = true;
    } */

    // find last list with options
    for(var j = inputs_sequence[box_id].length - 1; j>=0; j--)
    {
      var inp = inputs_sequence[box_id][j];
      if (inp.options.length > 1)
      {
        inputs_sequence[box_id][j].last = true;
        //console.log('last- set', inputs_sequence[box_id][j]);
        break;
      }
    }


    var changed_attribute_passed = false;
    for(var j=0; j<inputs_sequence[box_id].length; j++)
    {
      var attr = inputs_sequence[box_id][j];

      if (changed_attribute_id == attr.id)
      {
        //console.log('au- attr', attr);

        attr.updated_by_user = true;

        //console.log('au- path_to_attr[attr.path]', path_to_attr[attr.path]);

        changed_attribute_passed = true;
        continue;
      }
      else if (!changed_attribute_passed)
      {
        continue;
      }

      refreshOpts(box_id, inputs_sequence[box_id][j]);
    }

  }).change();

  //
  //var last_box_id = var box_id = $input.closest('[data-path-box]:').attr('data-path-box');

  if (last_attr_related_to_input_with_options)
  {
    for(var current_sku in last_attr_related_to_input_with_options)
    {
      if (!last_attr_related_to_input_with_options.hasOwnProperty(current_sku))
      {
        continue;
      }

      var attr = last_attr_related_to_input_with_options[current_sku];

      var last_box_id = attr.ext.path_box;
      //console.log('last_box_id', last_box_id);
      refreshOpts(last_box_id, attr);
    }
  }

  console.log('last_attr_related_to_input_with_options', last_attr_related_to_input_with_options);


  $(document).on("change keyup", '[data-attribute-id]', function()
  {
    if (!isItemHasAvailableComb(main_item))
    {
      return;
    }

    serializeData();

    var ext_opts_serialize = $('input[name=_ext_opts_serialize]').val();
    //console.log('ext_opts_serialize', ext_opts_serialize);


    //$(document).trigger('ext-opts-form-changed');
    $(document).trigger('ext-opts-form-serialized');

  });

  //$(document).on('ext-opts-form-serialized', function()
  //{
    //var ser_evt = vpCustomVariantData();
    //console.log('ser_evt', ser_evt);
  //});

  $(document).trigger('ext-opts-form-serialized');

  if (isItemHasAvailableComb(main_item))
  {
    serializeData();
  }
  //var cvd = vpCustomVariantData();
  //console.log('cvd', ser_evt);

  return;

  ////////////////////////////////
  ////////////////////////////////
  ////////////////////////////////



  function valueError(v, rules)
  {
    if (!rules)
    {
      return '';
    }

    if (v)
    {
      v = v.trim();
    }

    if (rules.required)
    {
      if (!v)
      {

        if (rules.name)
        {
          var err = "Please select " + rules.name;
          return err;
        }

        var err = "Please specify some value";
        return err;
      }
    }

    if (rules.list)
    {
      return;
    }

    if ("only_numbers" == rules.type || "numbers_only" == rules.type)
    {
      if (rules.special_chars)
      {
        return;
      }

      var isnum = /^\d+$/.test(v);

      if (!isnum)
      {
        var err = "Please use only numbers";
        return err;
      }
    }

    if ("only_text" == rules.type || "text_only" == rules.type)
    {
      var reg_exp = /^[a-zA-Z]+$/;
      var no_other_chars = (reg_exp.test(v));

      if (!no_other_chars)
      {
        var err = "Please use only a-z, A-Z letters";
        return err;
      }

    }

    if (v.indexOf('"') != -1)
    {
      var err = "Please don't use quotes (\")" ;
      return err;
    }

    if (v.indexOf("'") != -1)
    {
      var err = "Please don't use quotes (')" ;
      return err;
    }


    if ("alphanumeric" == rules.type && !rules.special_chars)
    {
      var reg_exp = /^[0-9a-zA-Z]+$/;
      var no_special_chars = (reg_exp.test(v));

      if (!no_special_chars)
      {
        var err = "Please use only alphanumeric symbols";
        return err;
      }

    }

    if (rules.min_chars && rules.max_chars && rules.min_chars == rules.max_chars)
    {
      if (v.length != rules.min_chars)
      {
        var err = "Please specify " + rules.min_chars + " symbol";

        if (rules.min_chars > 1)
        {
          err += "s";
        }
        return err;
      }
    }
    else
    {

      if (rules.min_chars)
      {
        if (v.length && v.length < rules.min_chars)
        {
          var err = "Please use " + rules.min_chars + " symbols or more";
          return err;
        }
      }

      if (rules.max_chars)
      {
        if (v.length > rules.max_chars)
        {
          var err = "Please use " + rules.max_chars + " symbols or less";
          return err;
        }
      }
    }

    if (!rules.emojis)
    {
      //console.log('chk emojis', v);

      //var reg_exp = /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g;
      var reg_exp = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;


      if ((reg_exp.test(v)))
      {
        var err = "Please don't use emoji";
        return err;
      }
    }

    if (!rules.special_chars)
    {
      //console.log('chk special_chars', v);

      var reg_exp = /^[0-9a-zA-Z]+$/;
      var no_special_chars = (reg_exp.test(v));

      if (!no_special_chars)
      {
        var err = "Please use only alphanumeric symbols";
        return err;
      }
    }


    return null;

  }


  function valueHint(attr)
  {

    var rules = attr.validation
    var hints = [];

    if (rules.required)
    {
      hints.push("required");
    }

    if ('text' == attr.type)
    {
      var letter_type = "symbols";
      if ("only_text" == rules.type || "text_only" == rules.type)
      {
        letter_type = "alpha letters";
      }

      if (rules.min_chars && rules.min_chars > 1)
      {
        hints.push(rules.min_chars + " " + letter_type + " minimum");
      }

      if (rules.max_chars)
      {
        hints.push(rules.max_chars + " " + letter_type + " maximum");
      }

      if ("only_text" == rules.type || "text_only" == rules.type)
      {
        hints.push("only a-z, A-Z letters are allowed");
      }
      else if ("numbers_only" == rules.type || "only_numbers" == rules.type)
      {
        if (rules.special_chars)
        {
          hints.push("numbers and special symbols are allowed");
        }
        else
        {
          hints.push("only numbers are allowed");
        }
      }
      else if (!rules.special_chars && 'alphanumeric' == rules.type)
      {
        hints.push("only alphanumeric symbols are allowed");
      }
      else
      {
        if (attr.type == 'text')
        {

          if (!rules.emojis)
          {
            hints.push("alphanumeric and special symbols are allowed (except emojis)");
          }
          else
          {
            hints.push("alphanumeric, special symbols, emojis are allowed");
          }

        }
      }
    }

    //console.log("hints", hints);

    var hint = '';
    if (hints.length > 0)
    {
      hint = "<ul><li>" + hints.join('</li><li>') + "</li></ul>";
    }

    return hint;
  }

  function addInputText(attr, id, input_id)
  {
    var $input = $('<input/>');
    $input.attr('type', 'text');

    addValidationCode($input, attr);

    return $input;
  }


  function addValidationCode($input, attr)
  {

    if (!attr.validation)
    {
      return;
    }

    console.log('avc- ', $input, attr);

    var id = attr.ext.path;

    attr_checks[id] = {};

    attr_checks[id]['path'] = attr.ext.path;
    //attr_checks[id]['input'] = $input;
    //attr_checks[id]['input_id'] = input_id;
    attr_checks[id]['rules'] = attr.validation;

    attr_checks[id]['func'] = function($el, rules)
    {

      console.log('oi- checking', attr, $input);

      var path = $el.attr('data-ext-opts-path');
      //console.log('eo-v- path', path);

      if (!$el.attr('data-ext-opts-path'))
      {
        return;
      }

      $el.removeAttr('data-error');
      var $div = $el.closest('div');
      $div.removeClass('ext-opts-error');

      var $msg = $div.find('.ext-opts-validation-message');
      $msg.hide();

      //console.log("Validate input", $el);

      if ($el.length == 0)
      {
        //debugger;
        console.log("can't get val for input");
        console.log($el);
      }

      var v = $el.val();



      if (v)
      {
        v = v.trim();
      }

      var err = valueError(v, rules);

      if (err)
      {
        //console.log(err);
        $msg.text(err);
        $msg.show();
        $div.addClass('ext-opts-error');
        $el.attr('data-error', true);
      }
    }
  }

  function filterOptionsForKit(attr, prev_selected)
  {

  }

  function getKitOptionsFilter2(item_option_combinations)
  {
    var filter_item_option_combinations = [];

    for(var j=0; j<item_option_combinations.length; j++)
    {
      var item_option_combination = item_option_combinations[j];

      var filter = {};

      for(var k=0; k<item_option_combination.length; k++)
      {
        var pair = item_option_combination[k];
        filter[pair.attribute_id] = pair.attribute_option_id;
      }

      filter_item_option_combinations.push(filter);
    }

    return filter_item_option_combinations;
  }

  function getKitOptionsFilter(kit_item_sku)
  {
    for(var position=0; position < main_item.attributes.length; position++)
    {
      var attr = main_item.attributes[position];

      //console.log('eo-', 'addAttributes-attr', attr);

      if (attr.type == 'item')
      {

        var nested_option = getNestedOption(attr.options);
        if (!nested_option)
        {
          continue;
        }

        //console.log('nested_option', nested_option);
        var nested_sku = nested_option.item.SKU;

        if (nested_sku == kit_item_sku)
        {
          //console.log('filter - find SKU', nested_sku, nested_option);

          var item_option_combinations = nested_option.item_option_combinations;
          var filter_item_option_combinations = [];

          for(var j=0; j<item_option_combinations.length; j++)
          {
            var item_option_combination = item_option_combinations[j];

            var filter = {};

            for(var k=0; k<item_option_combination.length; k++)
            {
              var pair = item_option_combination[k];
              filter[pair.attribute_id] = pair.attribute_option_id;
            }

            filter_item_option_combinations.push(filter);
          }

          return filter_item_option_combinations;
          /*var filter_match = false;
          for(var ck=0; ck < cs.length; ck++)
          {
            var c = cs[ck];

            if (prev_selected[c.attribute_id]
                  && prev_selected[c.attribute_id] != c.attribute_option_id)
            {
              prev_selected_match = false;
              break;
            }
          } */

        }
      }
    }

    return [];
  }

  function getAvailableOptions(attr, prev_selected)
  {
    console.log('ao- getAvailableOptions - attr', attr.ext.sku, attr.name, attr);
    //console.log('ao- prev_selected', prev_selected);

    //debugger;

    //console.log('ao- nested_option', attr.nested_option);

    var item = api_data[attr.ext.sku];
    //console.log('ao- item', item);

    if (attr.top_level)
    {
      //debugger;
      //return attr.options;
    }

    if (!item.active_combinations)// || !item.comb_data)
    {
      return attr.options;
    }

    var active_combinations = item.active_combinations;

    if (attr.top_level)
    {
      active_combinations = item.top_level.active_combinations
    }

    //console.log('ao- active_combinations', active_combinations);

    //var filter_item_option_combinations = getKitOptionsFilter(item.sku);
    var filter_item_option_combinations = [];


    if (attr.nested_option && attr.nested_option.item_option_combinations)
    {
      filter_item_option_combinations = getKitOptionsFilter2(
        attr.nested_option.item_option_combinations);
      if (filter_item_option_combinations)
      {
        //console.log('filter', active_combinations, 'by', filter_item_option_combinations);
      }
    }

    if (filter_item_option_combinations.length > 0)
    {
      var active_combinations_filtered = [];
      for(var ack in active_combinations)
      {
        if (!active_combinations.hasOwnProperty(ack))
        {
          continue;
        }

        var ac = active_combinations[ack];

        for(var fk = 0; fk<filter_item_option_combinations.length; fk++)
        {
          var filter = filter_item_option_combinations[fk];



          var cs = active_combinations[ack].combination;

          //console.log('chk filter', filter, cs);

          var filter_match = true;
          for(var ck=0; ck < cs.length; ck++)
          {
            var c = cs[ck];

            if (filter[c.attribute_id] && (filter[c.attribute_id] != c.attribute_option_id))
            {
              //console.log('not match', filter, c);
              //console.log('not match', c.attribute_id, filter[c.attribute_id], c.attribute_option_id);

              filter_match = false;
            }
          }

          if (filter_match)
          {
            //console.log('match');
            active_combinations_filtered.push(ac);
          }

        }


      }

      //console.log('filter - active_combinations_filtered', active_combinations_filtered);

      active_combinations = active_combinations_filtered;
    }


    console.log('ao- active_combinations_filtered', attr.ext.sku, attr.name,
          active_combinations);



    //attr.ext.allow_backorder = false;

    /*if (is_kit_item)
    {
      return attr.options;
    } */

    var opt_id2name = {};
    for(var j=0; j<attr.options.length; j++)
    {
      var opt = attr.options[j];
      opt_id2name[opt.id] = opt.name;
    }


    if ('undefined' == typeof prev_selected)
    {
      prev_selected = {};
    }

    var prev_selected_all = true;
    for(var prev_sel_id in prev_selected)
    {
      if (!prev_selected.hasOwnProperty(prev_sel_id))
      {
        continue;
      }

      if (!prev_selected[prev_sel_id])
      {
        prev_selected_all = false;
      }
    }

    //console.log(attr.id + 'a-prev_selected', prev_selected, 'prev_selected_all', prev_selected_all, 'attr', attr, 'last', attr.last);

    var opts = {};


    var back_order_warning = false;//item.back_order_warning;
    var current_sku = attr.ext.sku;
    var current_item = params.api_data[current_sku];;

    //console.log(attr.id + 'a-back_order_warning- sku', current_sku, 'back_order_warning - before check overloading', back_order_warning);

    var parent_sku = attr.ext.parent_sku;
    //console.log('back_order_warning- attr.ext.parent_sku', attr.ext.parent_sku);

    if (parent_sku)
    {
      var parent_item = api_data[parent_sku];

      //console.log('back_order_warning- parent_item.kit_items_back_order_warning_overload', parent_item.kit_items_back_order_warning_overload);
      //console.log('back_order_warning- parent_item.kit_items_back_order_warning_overload[current_sku]', parent_item.kit_items_back_order_warning_overload[current_sku]);

      if (parent_item.kit_items_back_order_warning_overload[current_sku])
      {
        var val = parent_item.kit_items_back_order_warning_overload[current_sku];

        if (val*1 > 0)
        {
          //back_order_warning = true;
        }

        if (val*1 < 0)
        {
          //back_order_warning = false;
        }
      }
    }

    //console.log(attr.id + 'a-back_order_warning- sku', current_sku, 'back_order_warning - after check overloading', back_order_warning);


    var current_sku = attr.ext.sku;

    for(var ack in active_combinations)
    {
      if (!active_combinations.hasOwnProperty(ack))
      {
        continue;
      }

      var ac = active_combinations[ack];

      //if (!attr.ext.allow_backorder)
      if (!ac.allow_backorder)
      {
        //if (!item.back_order_warning && !(1*ac.stock))
        if (//!back_order_warning &&
              !(1*ac.stock)
              //&& !main_item.allow_warning && !main_item.allow_notification)
              && !current_item.allow_warning && !current_item.allow_notification)
        {
          console.log('ao- !main_icurrent_itemtem.allow_warning && !current_item.allow_notification - skip',
                attr.ext.sku, attr.name, ac);
          continue;
        }
      }

      var cs = active_combinations[ack].combination;

      // check match prev selected
      var prev_selected_match = true;
      for(var ck=0; ck < cs.length; ck++)
      {
        var c = cs[ck];

        if (prev_selected[c.attribute_id]
              && prev_selected[c.attribute_id] != c.attribute_option_id)
        {
          prev_selected_match = false;
          break;
        }
      }

      if (!prev_selected_match)
      {
        //console.log(attr.id + 'a-prev_selected_match-no');
          console.log('ao- a-prev_selected_match-no',
                attr.ext.sku, attr.name, ac);

        continue;
      }

      //console.log(attr.id + 'a-cs-prev_selected_match', cs);

      for(var ck=0; ck < cs.length; ck++)
      {
        var c = cs[ck];

        if (c.attribute_id != attr.id)
        {
          continue;
        }

        var opt = {};
        opt.id = c.attribute_option_id;
        opt.name = opt_id2name[opt.id];
        opt.name_initial = opt.name;

        //debugger;
        var append_to_opt = '';


        var current_sku = attr.ext.sku;

        //console.log('la- chk', current_sku, last_attr_related_to_input_with_options, attr);

        if (last_attr_related_to_input_with_options[current_sku]
              && attr.id == last_attr_related_to_input_with_options[current_sku].id)
        {
          //console.log('la- in');

          var current_item = params.api_data[current_sku];;

          if (current_item.allow_warning)
          {
            if (ac.stock <= current_item.warning_quantity)
            {
              append_to_opt = current_item.warning_on_screen;
              console.log(attr.id + 'a-append_to_opt-warning_on_screen', append_to_opt);
            }
          }

          if (current_item.allow_notification)
          {
            if (ac.stock <= current_item.notification_quantity)
            {
              append_to_opt = current_item.notification_on_screen;

              console.log(attr.id + 'a-append_to_opt-notification_on_screen', append_to_opt, attr);
            }
          }

        }

        if (prev_selected_all)
        {
          if (append_to_opt)
          {
            opt.name += " - " + append_to_opt;
          }
        }


        if (!append_to_opt && prev_selected_all && attr.last)
        {

          if (!(1*ac.stock))
          {

            if (opts[opt.id])
            {
              continue;
            }

            if (1*back_order_warning)
            {
              opt.name += " - " + params.back_order_warning_message;
            }

            //if (!attr.ext.allow_backorder)

            if (!ac.allow_backorder)
            {
              opt.disabled = true;
            }

            opts[opt.id] = opt;
            //console.log(attr.id + 'a-opt-add1', opt);
            continue;
          }


        }

        opt.disabled = false;
        //console.log(attr.id + 'a-opt-add2-', opt);
        opts[opt.id] = opt;

      }
    }

    console.log('ao -opts', attr.ext.sku, attr.name, opts);

    var kx;
    //var opts_res = [];

    var opts_on = {};

    for(kx in opts)
    {
      if (!opts.hasOwnProperty(kx))
      {
        continue;
      }

      //opts_res.push(opts[kx]);

      opts_on[opts[kx].id] = opts[kx];
    }

    //console.log('attr-av-opts', attr);
    //console.log(opts_res);

    //console.log('opts_on'); console.log(opts_on);

    var opts_res2 = [];

    for(var j=0;j<attr.options.length; j++)
    {
      var opt = attr.options[j];
      var opt_on = opts_on[opt.id];

      if (opt_on)
      {
        if (params.test_page)
        {
          opt_on.name += " [" + opt_on.id + "]";
        }

        opts_res2.push(opt_on);
      }
    }

    console.log('ao- getAvailableOptions-result', opts_res2);

    return opts_res2;
  }


  function getAttr(box_id, attr)
  {
    //var sel_exp = "[data-sku="+attr.ext.sku+"] select[data-attribute-id="+attr.id+"]";
    var sel_exp = "select[data-attribute-id="+attr.id+"]";
    //var $select = $(sel_exp);

    var $select = getBox(box_id).find(sel_exp);

    if ($select.length > 0)
    {
      return $select;
    }
    else
    {
      console.log("can't find sel_exp", sel_exp);
    }

    return null;
  }

  function getAttrRadio(box_id, attr)
  {
    //var sel_exp = "[data-sku="+attr.ext.sku+"] select[data-attribute-id="+attr.id+"]";
    var sel_exp = "[type=radio][data-attribute-id="+attr.id+"]";
    //var $select = $(sel_exp);

    var $radio = getBox(box_id).find(sel_exp);

    if ($radio.length > 0)
    {
      return $radio;
    }
    else
    {
      console.log("can't find sel_exp", sel_exp);
    }

    return null;
  }

  function getAttrVal(box_id, attr)
  {
    //console.log('getAttrVal-', box_id, attr);

    if ('radio' == attr.type)
    {
      var $radio = getAttrRadio(box_id, attr);
//      console.log('getAttrVal- $radio', $radio);

      var val = $radio.filter(':checked').attr('data-option-id');
      //console.log('getAttrVal- $radio-val', val);

      return val;
    }

    var $select = getAttr(box_id, attr);

    if ($select)
    {
      return $select.find(':selected').attr('data-option-id');
    }

    /*var attr_exp = "[data-attribute-id=" + id + "]";
    var radio_exp = "input[type=radio]" + attr_exp + ":checked";
    var $radio = $(radio_exp);
    if ($radio.length > 0)
    {
      return $radio.attr('data-option-id');
    } */

    return null;

  }


  function refreshOpts(box_id, attr)
  {
    if (attr.depends_on_top_level)
    {
      return;
    }

    console.log('ro- ', box_id, attr);


    var sku_current = attr.ext.sku;
    var prev_ids = inputs_before[box_id][attr.id];
    var prev_selected = {};
    var item_current = api_data[sku_current];

    var id2attr = {};

    var attrs_all = item_current.attributes;
    if (attr.top_level)
    {
      attrs_all = item_current.top_level.attributes;
    }

    for(var j=0; j< attrs_all.length; j++)
    {
      var a = attrs_all[j];
      id2attr[a.id] = a;
    }

    for(var i=0; i<prev_ids.length; i++)
    {
      var prev_attr_id = prev_ids[i].id;

      if (!id2attr[prev_attr_id])
      {
        console.log("Can't find attr by ID: " + prev_attr_id + ", box_id: " + box_id, sku_current);
        console.log(attr);
      }

      prev_selected[prev_attr_id] = getAttrVal(box_id, id2attr[prev_attr_id]);
    }

    var opts = getAvailableOptions(attr, prev_selected);
    //console.log('sl- getAvailableOptions', 'main_item', main_item, 'attr', attr, 'opts', opts);

    var $input;

    if ('radio' == attr.type)
    {
      $input = getAttrRadio(box_id, attr);
    }
    else
    {
      $input = getAttr(box_id, attr);
    }

    if (!$input)
    {
      console.log("can't find input", box_id, attr);
      return;
    }

    console.log('ro- updating attr - $input', $input);

    if ('radio' == attr.type)
    {
      addOptsToRadio(attr, $input, opts);
    }
    else
    {
      addOptsToSelect($input, opts, attr);
    }
  }


  function addOptsToRadio(attr, $input, opts)
  {
    console.log('addOptsToRadio', $input, opts);

    var $fieldset = $input.closest("fieldset");

    $fieldset.html('');

    var first_selected = false;

    for (var j=0; j<opts.length; j++)
    {
      var opt_data = opts[j];
      if (opt_data.disabled)
      {
        continue;
      }

      var $name = $("<div/>");
      //$name.append($color);
      $name.append(opt_data.name);

      var pick = {};
      pick.attribute_id = attr.id;
      pick.attribute_id_uniq = attr.ext.id_uniq;
      pick.option_id = opt_data.id;

      pick.id = opt_data.id + '*' + opt_data.name;
      pick.name = $name[0].outerHTML;
      pick.label_class = "color";

      var $el = $("<div/>");
      $el.addClass('ext-opts-picker-input');
      //$el.attr('data-index');
      //$el.attr('data-value');

      var control_id = attr.ext.input_name + '_' + j;

      var $control = $('<input/>');
      $control.attr('type', 'radio');
      $control.attr('value', pick.id);

      $control.attr('data-attribute-id', pick.attribute_id);
      //$control.attr('data-attribute-id-uniq', pick.attribute_id_uniq);
      $control.attr('data-option-id', pick.option_id);

      var html = pick.name;
      var div = document.createElement("div");
      div.innerHTML = html;
      var pick_name_text = div.textContent || div.innerText || "";


      $control.attr('data-label-text',pick_name_text);

      $control.attr('id', control_id);
      $control.attr('name', attr.ext.input_name);
      $control.attr('ext-opts', true);
      //$control.attr('data-index');


      if (!first_selected)
      {
        $control.prop('checked', true);
        first_selected = true;
      }

      var $label = $('<label/>');
      $label.attr('for', control_id);
      $label.html(pick.name);

      if (pick.label_class)
      {
        $label.addClass(pick.label_class);
      }

      $el.append($control);
      $el.append($label);

      $fieldset.append($el);
    }

    return $fieldset;


  }

  function addOptsToSelect($input, opts, attr)
  {

    var blank = {};
    blank.id = '';
    blank.name = 'select option';


    if (1 == opts.length)
    {
      if (!attr.show_with_one_option)
      {
        $input.attr('data-hide', 1);
        //console.log('data-hide- add', $input, opts);
      }
    }
    else
    {
      $input.removeAttr('data-hide');
    }

    if (!$input.attr('data-hide'))
    {
      if (opts.length > 1 && 'first' != params.default_option_behavior)
      {
        opts = prepend(opts, blank);
      }
    }

    //console.log(opts);


    if ($input.attr('data-top-level'))
    {
      //debugger;
    }
    //console.log('opts', opts);

    var $opts = $input.find('option');

    /*$opts.each(function(k, opt)
    {
      var $opt = $(opt);
      var opt_id = $opt.attr('data-option-id');

      if (!inArrayKv(opts, 'id', opt_id))
      {
        //console.log('remove', $input.attr('name'), opt_id, $opt.text());
        $opt.remove();
      }
    })   */

    $input.html('');

    attr.last_opts = opts;

    for(var j=0; j < opts.length; j++)
    {
      var opt_data = opts[j];
      var opt_name = opt_data.name;

      /*var $opt_existing = $input.find("[data-option-id='" + opt_data.id + "']");

      if ($opt_existing.length > 0)
      {
        //$opt_existing.remove();

        if (opt_data.disabled)
        {
          $opt_existing.attr('disabled', 1);

          if ($opt_existing.prop('selected'))
          {
            $input.val('');
          }
        }
        else
        {
          $opt_existing.removeAttr('disabled');
        }

        $opt_existing.attr('data-name', opt_data.name_initial);
        $opt_existing.text(opt_name);

        continue;
      }   */


      var $opt = $('<option/>');
      $opt.text(opt_name);

      //if (params.test_page)
      //{
        //$opt.text(opt_name + " [" + opt_data.id + "]");
      //}

      $opt.attr('data-name', opt_data.name_initial);

      var opt_id = opt_data.id + '*' + opt_data.name_initial;

      if (!opt_data.id)
      {
        opt_id = '';
      }

      $opt.attr('value', opt_id);
      $opt.attr('data-option-id', opt_data.id);

      // $input.attr('name'),
      //console.log('add', opt_id, opt_data.name);
      if (opt_data.disabled)
      {
        $opt.attr('disabled', 1);
      }

      $input.append($opt);
    }

    if ($input.attr('data-top-level'))
    {
      //$input.change();
    }

    if (opts.length == 1 || (opts.length == 2 && 'first' == params.default_option_behavior))
    {
      //var $div = $input.closest('div');

      //console.log('opts-count-hide', $input.attr('data-attribute-id'), opts);
      //$input.hide();
      //$input.closest('div').find('label').hide();
      //$input.attr('data-hide', 1);
    }
    else
    {
      //var $div = $input.closest('div');
      //console.log('opts-count-show', $input.attr('data-attribute-id'), opts);
      //$input.show();
      //$input.closest('div').find('label').show();
      //$input.removeAttr('data-hide');
    }

  }


  function addInputList(attr)
  {
    //console.log('addInputList', attr.name);
    //console.log(attr);

    var $input = $('<select/>');
    $input.attr('ext-opts', true);
    $input.attr('data-attribute-id', attr.id);
    //$input.attr('data-attribute-id-uniq', attr.ext.id_uniq);

    //var sku_current = attr.ext.sku;
    var box_id = attr.ext.path_box;

    if (attr.top_level)
    {
      //console.log('box_id', box_id);
    }

    if (!inputs_sequence[box_id])
    {
      inputs_sequence[box_id] = [];
    }

    if (!inputs_before[box_id])
    {
      inputs_before[box_id] = {};
    }

    inputs_before[box_id][attr.id] = $.extend(true, [], inputs_sequence[box_id]);
    inputs_sequence[box_id].push(attr);

    //console.log('inputs_before');    console.log(inputs_before);

    var opts = getAvailableOptions(attr);

    if (params.test_page)
    {
      //console.log('getAvailableOptions'); console.log(opts);
    }

    addOptsToSelect($input, opts, attr);



    addValidationCode($input, attr);

    return $input;
  }

  function renderPicker(picks, attr)
  {
    //console.log('picks', picks);

    var $input = $("<fieldset/>");

    $input.addClass('ext-opts-picker-input-wrap');
    //$input.attr('name');
    //$input.attr('data-index');
    //$input.attr('id');

    for (var j=0; j<picks.length; j++)
    {
      var pick = picks[j];

      var $el = $("<div/>");
      $el.addClass('ext-opts-picker-input');
      //$el.attr('data-index');
      //$el.attr('data-value');

      var control_id = attr.ext.input_name + '_' + j;

      var $control = $('<input/>');
      $control.attr('type', 'radio');
      $control.attr('value', pick.id);

      $control.attr('data-attribute-id', pick.attribute_id);
      //$control.attr('data-attribute-id-uniq', pick.attribute_id_uniq);
      $control.attr('data-option-id', pick.option_id);

      var html = pick.name;
      var div = document.createElement("div");
      div.innerHTML = html;
      var pick_name_text = div.textContent || div.innerText || "";


      $control.attr('data-label-text',pick_name_text);

      $control.attr('id', control_id);
      $control.attr('name', attr.ext.input_name);
      $control.attr('ext-opts', true);
      //$control.attr('data-index');


      if (0 == j)
      {
        $control.prop('checked', true);
      }

      var $label = $('<label/>');
      $label.attr('for', control_id);
      $label.html(pick.name);

      if (pick.label_class)
      {
        $label.addClass(pick.label_class);
      }

      $el.append($control);
      $el.append($label);

      $input.append($el);
    }

    return $input;

  }


  function addInputColor(attr)
  {
    var picks = [];

    for(var j=0; j < attr.options.length; j++)
    {

      var opt_data = attr.options[j];

      var $color = $("<span/>");
      $color.css('background-color', opt_data.color_code);
      $color.addClass('color-sample');

      var $name = $("<div/>");
      $name.append($color);
      $name.append(opt_data.name);

      var pick = {};
      pick.attribute_id = attr.id;
      pick.attribute_id_uniq = attr.ext.id_uniq;
      pick.option_id = opt_data.id;

      pick.id = opt_data.id + '*' + opt_data.name;
      pick.name = $name[0].outerHTML;
      pick.label_class = "color";

      picks.push(pick);

    }

    return renderPicker(picks, attr);
  }

  function addInputImageSelect(attr)
  {
    var picks = [];

    for(var j=0; j < attr.options.length; j++)
    {
      var opt_data = attr.options[j];

      var $name = $("<div/>");

      var $title = $("<p/>");
      $title.append(opt_data.name);

      var $img = $("<img/>");
      $img.attr('src', opt_data.image_path);

      var $img_p = $("<p/>");
      $img_p.append($img);

      $name.append($title);
      $name.append($img_p);

      var pick = {};
      pick.attribute_id = attr.id;
      pick.attribute_id_uniq = attr.ext.id_uniq;
      pick.option_id = opt_data.id;

      pick.id = opt_data.id + '*' + opt_data.name;
      pick.name = $name[0].outerHTML;
      pick.label_class = 'image-select';

      picks.push(pick);
    }

    return renderPicker(picks, attr);

  };

};


function getExtOptsStorefrontParams()
{
  return /*PARAMS_START*/{"cart_add_url":"https:\/\/shopify.aioboportal.com\/storefront\/proxy\/cart-add","stock_alert_subscribe_url":"https:\/\/shopify.aioboportal.com\/storefront\/stock-alert\/subscribe?host=aiobo.myshopify.com&sku=__sku__&ajax=1","custom_variant_url":"https:\/\/shopify.aioboportal.com\/storefront\/proxy\/custom-variant","validate_not_submit":0,"format_input":0,"no_fix_buy_btn":false,"app_name":"Ext Opts","ver":"43_connect_to_variant","ver_name":"43. Previous (42) + Connect to variants","snippets":[],"error_track_url":"https:\/\/shopify.aioboportal.com\/storefront\/error\/js-track?shop_id=1&sku=__sku__&text=__text__&url=__url__&ver=__ver__","track_page_url":"https:\/\/shopify.aioboportal.com\/storefront\/track\/url?shop_id=1&cart_token=__cart_token__&note=__note__&url=__url__&ref_url=__ref_url__","note_last_url":"https:\/\/shopify.aioboportal.com\/storefront\/track\/note-last?cart_token=__cart_token__","ext":{"ver":"43_connect_to_variant"},"shop_host":"aiobo.myshopify.com","subscribe_checkbox_required":0,"subscribe_checkbox_text":"By checking this box you agree to receive text messages from VibeSzn. You can reply stop to opt-out at any time. This is our privacy policy <a href='https:\/\/vibeszn.com\/policies\/privacy-policy' target = '_blank'>https:\/\/vibeszn.com\/policies\/privacy-policy<\/a>","back_order_warning":1,"back_order_warning_message":"Out of Stock","default_option_behavior":"","test_with_param":0,"save_array_data":1,"debug":false,"local":false,"enabled":1,"css":"select:not([ext-opts]),\n.select:not([ext-opts]),\n.selector-wrapper,\n.variant-input-wrap,\n.variant-wrapper,\n.variant-wrapper--button,\n.product_form .variants,\n[pf-variant-select]\n{\n  display: none !important;\n}\n\nselect[ext-opts]\n{\n  float: none !important;\n  background-image: none !important;\n  -webkit-appearance: auto !important;\n  -moz-appearance: auto !important;\n  appearance: auto !important;\n}\n\n\n#ext-opts-container ul\n{\n  list-style: disc;\n  margin: 0px;\n}\n\n.ext-opts-form-check {\n    position: relative;\n    display: block;\n    padding-left: 1.25rem;\n}\n\n.ext-opts-form-check-label {\n    margin-bottom: 0;\n}\n\n.ext-opts-form-check-input {\n    position: absolute;\n    margin-top: 7px;\n    margin-left: -1.25rem;\n}\n\n\n.ext-opts-btn {\n    display: inline-block;\n    font-weight: 400;\n    color: #212529;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    text-decoration: none !important;\n}\n\n.ext-opts-btn-secondary.ext-opts-btn-disabled\n{\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.ext-opts-btn.ext-opts-btn-disabled\n{\n    opacity: 0.65;\n}\n.ext-opts-btn {\n    margin-right: 5px;\n    margin-bottom: 5px;\n}\n.ext-opts-btn-secondary {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\n\n\nelement.style {\n}\n.btn:not(:disabled):not(.disabled) {\n    cursor: pointer;\n}\n.ext-opts-btn-secondary.ext-opts-btn-disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n.ext-opts-btn-secondary.ext-opts-btn-disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n.ext-opts-btn-secondary {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n..ext-opts-btn {\n    margin-right: 5px;\n    margin-bottom: 5px;\n}\n.ext-opts-btn-secondary {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\nvariant-selects\n{\n  display: none !important;\n}\n\n\n.ext-opts-form-control\n{\n  display: block;\n  width: 100%  !important;\n  \/*height: calc(3rem + 5px) !important;*\/\n  height: 35px !important;\n  padding: 0.375rem 0.75rem  !important;\n  font-size: 18px  !important;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.ext-opts-validation-message\n{\n  color: red !important;\n}\n\n\n.product-variant-inventory\n{\n  display: none;\n}\n\n\n.ext-opts-form-group\n{\n    margin-bottom: 1rem;\n}\n\n[ext-opts-notifications-box]\n{\n  min-height: 10px;\n  padding: 5px;\n  background-color: #f5f5f5;\n  border: 2px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n  margin-bottom: 10px;\n\n}\n\n\n.ext-opts-btn-danger,\n.ext-opts-btn-danger:hover\n{\n    color: #fff !important;\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n}\n\n\n\/*.ext_opts_loader {\n  border: 6px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 6px solid blue;\n  border-bottom: 6px solid blue;\n  width: 12px;\n  height: 12px;\n  -webkit-animation: ext_opts_spin 2s linear infinite;\n  animation: ext_opts_spin 2s linear infinite;\n}\n\n@-webkit-keyframes ext_opts_spin {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes ext_opts_spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n  *\/\n\n\/* HTML: <div class=\"loader\"><\/div> *\/\n.ext_opts_loader\n{\n  width: 12px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  border: 4px solid lightgray;\n  border-right-color: white;\n  animation: ext_opts_spin 2s infinite linear;\n  float: left;\n  margin: 6px;\n}\n@keyframes ext_opts_spin {to{transform: rotate(1turn)}}\n\n\n\n.ext-opts-btn-primary,\n.ext-opts-btn-primary:hover\n{\n    color: #fff !important;\n    background-color: #007bff !important;\n    border-color: #007bff !important;\n}\n\n\n\nselect:not([ext-opts]),\n.select:not([ext-opts]),\n.selector-wrapper,\n.variant-input-wrap,\n.variant-wrapper,\n.variant-wrapper--button,\n.product_form .variants,\n[pf-variant-select]\n{\n  display: none !important;\n}\n\nselect[ext-opts]\n{\n  float: none !important;\n  background-image: none !important;\n  -webkit-appearance: auto !important;\n  -moz-appearance: auto !important;\n  appearance: auto !important;\n}\n\n\n#ext-opts-container ul\n{\n  list-style: disc;\n  margin: 0px;\n}\n\n.ext-opts-form-check {\n    position: relative;\n    display: block;\n    padding-left: 1.25rem;\n}\n\n.ext-opts-form-check-label {\n    margin-bottom: 0;\n}\n\n.ext-opts-form-check-input {\n    position: absolute;\n    margin-top: 7px;\n    margin-left: -1.25rem;\n}\n\n\n.ext-opts-btn {\n    display: inline-block;\n    font-weight: 400;\n    color: #212529;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    text-decoration: none !important;\n}\n\n.ext-opts-btn-secondary.ext-opts-btn-disabled\n{\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.ext-opts-btn.ext-opts-btn-disabled\n{\n    opacity: 0.65;\n}\n.ext-opts-btn {\n    margin-right: 5px;\n    margin-bottom: 5px;\n}\n.ext-opts-btn-secondary {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\n\n\nelement.style {\n}\n.btn:not(:disabled):not(.disabled) {\n    cursor: pointer;\n}\n.ext-opts-btn-secondary.ext-opts-btn-disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n.ext-opts-btn-secondary.ext-opts-btn-disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n.ext-opts-btn-secondary {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n..ext-opts-btn {\n    margin-right: 5px;\n    margin-bottom: 5px;\n}\n.ext-opts-btn-secondary {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\nvariant-selects\n{\n  display: none !important;\n}\n\n\n.ext-opts-form-control\n{\n  display: block;\n  width: 100%  !important;\n  \/*height: calc(3rem + 5px) !important;*\/\n  height: 35px !important;\n  padding: 0.375rem 0.75rem  !important;\n  font-size: 18px  !important;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.ext-opts-validation-message\n{\n  color: red !important;\n}\n\n\n.product-variant-inventory\n{\n  display: none;\n}\n\n\n.ext-opts-form-group\n{\n    margin-bottom: 1rem;\n}\n\n[ext-opts-notifications-box]\n{\n  min-height: 10px;\n  padding: 5px;\n  background-color: #f5f5f5;\n  border: 2px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n  margin-bottom: 10px;\n\n}\n\n\n.ext-opts-btn-danger,\n.ext-opts-btn-danger:hover\n{\n    color: #fff !important;\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n}\n\n\n\/*.ext_opts_loader {\n  border: 6px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 6px solid blue;\n  border-bottom: 6px solid blue;\n  width: 12px;\n  height: 12px;\n  -webkit-animation: ext_opts_spin 2s linear infinite;\n  animation: ext_opts_spin 2s linear infinite;\n}\n\n@-webkit-keyframes ext_opts_spin {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes ext_opts_spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n  *\/\n\n\/* HTML: <div class=\"loader\"><\/div> *\/\n.ext_opts_loader\n{\n  width: 12px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  border: 4px solid lightgray;\n  border-right-color: white;\n  animation: ext_opts_spin 2s infinite linear;\n  float: left;\n  margin: 6px;\n}\n@keyframes ext_opts_spin {to{transform: rotate(1turn)}}\n\n\n\n.ext-opts-btn-primary,\n.ext-opts-btn-primary:hover\n{\n    color: #fff !important;\n    background-color: #007bff !important;\n    border-color: #007bff !important;\n}\n\n","api_data":{"4itemalt":{"id":3738,"details_loaded_time":"2025-07-20 07:05:38","sku":"4itemalt","price":"30.00","name":"4 item Mysterybox Alternate Silver","allow_backorder":0,"erp_id":1867,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3738,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[],"active_combinations":[],"tags":["new","set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"5itemmystery":{"id":3739,"details_loaded_time":"2025-07-20 07:05:33","sku":"5itemmystery","price":"49.00","name":"5 Item Mystery Box Gold","allow_backorder":1,"erp_id":1868,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3739,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153}],"allow_backorder":true}],"tags":["new","set","topsell","custom-set","non-custom","top seller","don't notify","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ABAND":{"id":3515,"details_loaded_time":"2025-07-20 07:28:16","sku":"ABAND","price":"55.00","name":"Amalfi Band","allow_backorder":1,"erp_id":1742,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3515,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ABC":{"id":3639,"details_loaded_time":"2025-07-20 07:16:33","sku":"ABC","price":"18.00","name":"Angel Baby Charm","allow_backorder":1,"erp_id":1810,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3639,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ABP":{"id":3,"details_loaded_time":"2025-07-20 06:46:18","sku":"ABP","price":"58.00","name":"Angel Baby Pendant","allow_backorder":1,"erp_id":291,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"ABPpen":"ABPpen","REC":"REC"}}],"skus":{"ABPpen":"ABPpen","REC":"REC"},"top_level":true}],"grouped_attributes_ids":[11],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":{"11":11}},"attributes":[{"id":121,"name":"Angel Baby Pendant","quantity":1,"description":null,"type":"item","options":[{"id":449,"name":"Angel Baby Pendant","skip":false,"item":{"id":521,"name":"Angel Baby Pendant -- Pendant","SKU":"ABPpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"List","options":[{"id":248,"name":"1.8 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":121,"attribute_option_id":449},{"attribute_id":496,"attribute_option_id":1505}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":60,"attribute_option_id":278},{"attribute_id":121,"attribute_option_id":449},{"attribute_id":496,"attribute_option_id":1505}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":60,"attribute_option_id":278},{"attribute_id":121,"attribute_option_id":449},{"attribute_id":496,"attribute_option_id":1505}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":60,"attribute_option_id":278},{"attribute_id":121,"attribute_option_id":449},{"attribute_id":496,"attribute_option_id":1505}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","guadalupe","gold diamond virgin mary necklace","mother mary","our lady of guadalupe","heaven sent","saint mary","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ABPpen":{"id":816,"details_loaded_time":"2025-07-20 08:44:09","sku":"ABPpen","price":"9.80","name":"Angel Baby Pendant -- Pendant","allow_backorder":1,"erp_id":521,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":816,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon! When its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"list","options":[{"id":248,"name":"1.8 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["sale","non-custom","ws","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ACC":{"id":933,"details_loaded_time":"2023-02-24 15:01:23","sku":"ACC","price":"16.80","name":"Acrylic Clip","allow_backorder":0,"erp_id":618,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":933,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":490,"name":"Acrylic","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":490}],"allow_backorder":false}],"tags":["non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ACN":{"id":5,"details_loaded_time":"2025-07-20 08:57:22","sku":"ACN","price":"80.00","name":"Area Code Necklace","allow_backorder":true,"erp_id":294,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":5,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":40,"name":"Area Code","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":8,"required":true,"type":"only_numbers","free_chars":8,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","yankee","yankees","new york","brooklyn love","808","314","112124","ny necklace","727","nyc","items_mobile_app","los angeles"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ACR":{"id":926,"details_loaded_time":"2022-09-15 12:45:29","sku":"ACR","price":"28.35","name":"Acrylic Ring","allow_backorder":0,"erp_id":602,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":926,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["topsell","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ADVENT":{"id":2873,"details_loaded_time":"2023-02-07 21:07:08","sku":"ADVENT","price":"199.00","name":"Advent Box","allow_backorder":1,"erp_id":1343,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":2873,"force_allow_backorder":false,"attributes":[],"active_combinations":[],"tags":["new","topsell","top seller","holiday box","holiday calendar","calendar","advent calendar","advent box","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ADVENTBOX2":{"id":3428,"details_loaded_time":"2024-02-07 18:22:20","sku":"ADVENTBOX2","price":"125.00","name":"Advent Box","allow_backorder":1,"erp_id":1650,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3428,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will receive  an SMS text message !","attributes":[],"active_combinations":[],"tags":["new","topsell","top seller","holiday box","holiday calendar","calendar","advent calendar","advent box","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AES":{"id":907,"details_loaded_time":"2025-07-20 08:34:23","sku":"AES","price":"40.00","name":"Angel Energy Studs","allow_backorder":0,"erp_id":576,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":907,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","to my soulmate","heaven sent","saint benedict coin","mini mar","mini virgen","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AGEMNECK":{"id":3526,"details_loaded_time":"2025-06-25 17:11:31","sku":"AGEMNECK","price":"65.00","name":"Aperol Gem Necklace","allow_backorder":0,"erp_id":1756,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3526,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":799,"name":"Pink","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":799},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","sale","non-custom","ws","endless summer campaign","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AHE":{"id":1515,"details_loaded_time":"2025-07-20 08:10:10","sku":"AHE","price":"40.00","name":"Angel Hoop Earrings","allow_backorder":0,"erp_id":1016,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1515,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","angel numbers","1111","angel number","111","222","333","444","555","666","777","888","999","say my name","say my name collection","111717","summer collection","fall","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AHEAR":{"id":3489,"details_loaded_time":"2025-07-20 07:32:30","sku":"AHEAR","price":"60.00","name":"After Hours Earrings","allow_backorder":1,"erp_id":1714,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3489,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","sale","non-custom","ws","items_mobile_app","working woman campaign","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AIRNN":{"id":2,"details_loaded_time":"2025-07-20 06:46:24","sku":"AIRNN","price":"80.00","name":"Airbrush Nameplate Necklace","allow_backorder":true,"erp_id":289,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":227,"name":"Airbrush","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":227},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","15 inch sterling silver name necklace","multi name nameplate","delores name necklace","waterproof","18k gold platedwith your nameneckless alex","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AMN":{"id":153,"details_loaded_time":"2025-07-20 08:54:35","sku":"AMN","price":"32.00","name":"Amore Necklace","allow_backorder":0,"erp_id":448,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":153,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AMORC":{"id":3647,"details_loaded_time":"2025-07-20 07:14:43","sku":"AMORC","price":"18.00","name":"Amore Charm","allow_backorder":1,"erp_id":1818,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3647,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANGN":{"id":1172,"details_loaded_time":"2021-09-03 17:49:18","sku":"ANGN","price":"52.00","name":"Angel Numbers Necklace","allow_backorder":true,"erp_id":771,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1172,"force_allow_backorder":true,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":31,"name":"Font","type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":137,"name":"Custom Text","type":"text","validation":{"min_chars":3,"max_chars":3,"required":true,"type":"only_numbers","free_chars":3,"addtional_price_per_char":null,"special_chars":false,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true}],"tags":["necklace","new","custom","topsell"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANGN2":{"id":1197,"details_loaded_time":"2025-07-20 08:15:15","sku":"ANGN2","price":"55.00","name":"Angel Numbers Necklace","allow_backorder":1,"erp_id":801,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1197,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"18":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":true},"19":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":true},"20":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":true},"21":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":true},"22":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":true},"23":{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":true},"24":{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":true},"25":{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":true},"26":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":true},"27":{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":true},"28":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":true},"29":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":true},"30":{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":true},"31":{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":true},"32":{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":true},"33":{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":true},"34":{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":true},"35":{"image":null,"stock":86,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":true}},"tags":["necklace","topsell","non-custom","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","angel number necklace","best sellers","heaven sent","111717","top seller","best seller","bikini","swimwear","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","anngel numbers","onyx angel number","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANGNN":{"id":4,"details_loaded_time":"2025-07-20 06:46:10","sku":"ANGNN","price":"60.00","name":"Angel Nameplate Necklace","allow_backorder":1,"erp_id":292,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":4,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","angel","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","heaven sent","saint christopher","saint benedict coin","mini mar","mini virgen","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANGNNUM":{"id":1996,"details_loaded_time":"2024-04-04 20:34:22","sku":"ANGNNUM","price":null,"name":"Angel Numbers service item","allow_backorder":1,"erp_id":1171,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1996,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":140,"name":"Choose your numbers","description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":true}],"tags":["workorder","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANGR":{"id":1193,"details_loaded_time":"2025-07-20 08:15:28","sku":"ANGR","price":"55.00","name":"Angel Numbers Ring","allow_backorder":0,"erp_id":796,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1193,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":131,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":173,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":151,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":178,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false}],"tags":["ring","non-custom","silver","angel numbers","angle numbers","silver","1111","angle number","angel number","11 11","rings for men silver","111","222","333","444","555","666","777","888","999","ring for women","heaven sent","111717","sliver","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","anngel numbers","onyx angel number","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANGWINC":{"id":3645,"details_loaded_time":"2025-07-20 07:16:09","sku":"ANGWINC","price":"18.00","name":"Angel Wing Charm","allow_backorder":1,"erp_id":1816,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3645,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANN":{"id":315,"details_loaded_time":"2025-07-20 08:54:14","sku":"ANN","price":"80.00","name":"Arabic Nameplate Necklace","allow_backorder":true,"erp_id":293,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":315,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":39,"name":"Translation text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"alphanumeric","free_chars":15,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":105,"name":"Arabic Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"alphanumeric","free_chars":15,"addtional_price_per_char":"0.00","special_chars":true,"emojis":false}}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["necklace","custom","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ANR":{"id":1168,"details_loaded_time":"2021-09-03 21:57:14","sku":"ANR","price":"29.40","name":"Angel Numbers Ring","allow_backorder":true,"erp_id":770,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1168,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":137,"name":"Custom Text","type":"text","validation":{"min_chars":3,"max_chars":3,"required":true,"type":"only_numbers","free_chars":3,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AOHC":{"id":3749,"details_loaded_time":"2025-07-20 07:03:39","sku":"AOHC","price":"18.00","name":"Ace of Hearts Charm","allow_backorder":1,"erp_id":1878,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3749,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"AOSC":{"id":3750,"details_loaded_time":"2025-07-20 07:03:35","sku":"AOSC","price":"18.00","name":"Ace of Spades Charm","allow_backorder":1,"erp_id":1879,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3750,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ASE":{"id":1516,"details_loaded_time":"2025-07-20 08:10:05","sku":"ASE","price":"60.00","name":"Angel Stud Earrings","allow_backorder":0,"erp_id":1051,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1516,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false}],"tags":["earrings","non-custom","angel","angel numbers","angel number","say my name","heaven sent","say my name collection","summer collection","saint benedict coin","mini mar","mini virgen","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ASIFB":{"id":1509,"details_loaded_time":"2025-07-20 08:10:33","sku":"ASIFB","price":"55.00","name":"As If Bracelet","allow_backorder":1,"erp_id":1058,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1509,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":76,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","topsell","non-custom","tennis chain","tennis necklace","brackets","say my name","say my name collection","summer collection","bracelet for guys","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app","vintage edit","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ASTARR":{"id":3890,"details_loaded_time":"2025-07-20 06:49:31","sku":"ASTARR","price":"60.00","name":"All Star Ring","allow_backorder":1,"erp_id":1945,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3890,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","ring for women","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ATHDEP":{"id":3885,"details_loaded_time":"2025-07-20 06:51:13","sku":"ATHDEP","price":"35.00","name":"The AD Hat","allow_backorder":1,"erp_id":1940,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3885,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Low Stock Order Soon!","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":2381,"name":"0231 Red\/Nat","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2381}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BACB":{"id":3625,"details_loaded_time":"2025-07-20 07:20:15","sku":"BACB","price":"50.00","name":"Basket Chain Bracelet","allow_backorder":1,"erp_id":1794,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3625,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BADN":{"id":3017,"details_loaded_time":"2025-07-20 07:58:29","sku":"BADN","price":"35.00","name":"Baddie Necklace","allow_backorder":1,"erp_id":1406,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3017,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"list","options":[{"id":1314,"name":"Herringbone","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":228,"name":"Classic Nameplate","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":228},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":228},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","gg x vs","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BAGHUG":{"id":3714,"details_loaded_time":"2025-07-20 08:55:01","sku":"BAGHUG","price":"70.00","name":"Baguette Huggies","allow_backorder":1,"erp_id":1849,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3714,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BALLCANK":{"id":3539,"details_loaded_time":"2025-07-20 07:24:04","sku":"BALLCANK","price":"50.00","name":"Ball Chain Anklet","allow_backorder":1,"erp_id":1768,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3539,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":919,"name":"7\"","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":919},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","non-custom","ankle bracelet","toe rings","ank","sanklets","anklet bracelets","anklet clasps","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","endless summer campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BALRNG":{"id":3325,"details_loaded_time":"2025-07-20 07:43:06","sku":"BALRNG","price":"50.00","name":"Balloon Ring","allow_backorder":1,"erp_id":1627,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3325,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","topsell","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BANH":{"id":1300,"details_loaded_time":"2024-02-12 19:10:37","sku":"BANH","price":"89.00","name":"Bone Angel Number Hoodie RETAIL","allow_backorder":1,"erp_id":860,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1300,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will receive  an SMS text message !","attributes":[{"id":143,"name":"Size:","description":null,"type":"list","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":140,"name":"Choose your numbers","description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true}],"tags":["items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BANHCI":{"id":2000,"details_loaded_time":"2023-03-01 16:39:11","sku":"BANHCI","price":"10.00","name":"Bone Angel Number hoodie child item","allow_backorder":1,"erp_id":1100,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":2000,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":143,"name":"Size:","type":"list","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true}],"tags":["items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BANHCOLLAB":{"id":2001,"details_loaded_time":"2024-04-04 18:48:23","sku":"BANHCOLLAB","price":"89.00","name":"Bone Angel Number Hoodie x Heitmat","allow_backorder":1,"erp_id":1170,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":true,"db_id":2001,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":144,"name":"Angel Numbers Necklace","description":null,"type":"item","options":[{"id":534,"name":"ANGN2","skip":false,"item":{"id":801,"name":"Angel Numbers Necklace","SKU":"ANGN2"},"attributes_per_every_item":[{"id":14,"name":"Length","description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":31,"name":"Font","description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":140,"name":"Choose your numbers","description":null,"type":"List","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null},{"id":501,"name":"222","skip":false,"parent_attribute":null},{"id":502,"name":"333","skip":false,"parent_attribute":null},{"id":503,"name":"444","skip":false,"parent_attribute":null},{"id":504,"name":"555","skip":false,"parent_attribute":null},{"id":509,"name":"666","skip":false,"parent_attribute":null},{"id":505,"name":"777","skip":false,"parent_attribute":null},{"id":506,"name":"888","skip":false,"parent_attribute":null},{"id":507,"name":"999","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}]],"active_combinations":{"18":{"image":null,"stock":10,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}]},"19":{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}]},"20":{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}]},"21":{"image":null,"stock":42,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}]},"22":{"image":null,"stock":12,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}]},"23":{"image":null,"stock":84,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}]},"24":{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}]},"25":{"image":null,"stock":164,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}]},"26":{"image":null,"stock":16,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}]},"27":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}]},"28":{"image":null,"stock":16,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}]},"29":{"image":null,"stock":9,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}]},"30":{"image":null,"stock":15,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}]},"31":{"image":null,"stock":57,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}]},"32":{"image":null,"stock":59,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}]},"33":{"image":null,"stock":113,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}]},"34":{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}]},"35":{"image":null,"stock":82,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":272,"name":"Bone Hoodie","description":null,"type":"item","options":[{"id":954,"name":"White Hoodie","skip":false,"item":{"id":1123,"name":"Bone Hoodie","SKU":"WHOOD"},"attributes_per_every_item":[{"id":143,"name":"Size:","description":null,"type":"List","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":602,"name":"3XL","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":143,"attribute_option_id":602}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":528}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":529}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":530}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":531}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":532}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":602}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":333,"name":"Angel Numbers","description":null,"type":"item","options":[{"id":1101,"name":"Pick your 3 numbers","skip":false,"item":{"id":1171,"name":"Angel Numbers service item","SKU":"ANGNNUM"},"attributes_per_every_item":[{"id":140,"name":"Choose your numbers","description":null,"type":"List","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null},{"id":501,"name":"222","skip":false,"parent_attribute":null},{"id":502,"name":"333","skip":false,"parent_attribute":null},{"id":503,"name":"444","skip":false,"parent_attribute":null},{"id":504,"name":"555","skip":false,"parent_attribute":null},{"id":509,"name":"666","skip":false,"parent_attribute":null},{"id":505,"name":"777","skip":false,"parent_attribute":null},{"id":506,"name":"888","skip":false,"parent_attribute":null},{"id":507,"name":"999","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":140,"attribute_option_id":507}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":144,"attribute_option_id":534},{"attribute_id":272,"attribute_option_id":954},{"attribute_id":333,"attribute_option_id":1101}],"allow_backorder":true}],"tags":["collab","hoodie","angel","best seller","tops","items_mobile_app","nodiscount"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":{"ANGN2":"0","WHOOD":"-1","ANGNNUM":"0"}},"BANHH":{"id":1298,"details_loaded_time":"2022-08-09 01:27:29","sku":"BANHH","price":"89.00","name":"Bone Angel Number Hoodie x Heitmat","allow_backorder":1,"erp_id":862,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":1298,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":144,"name":"Angel Numbers Necklace","type":"item","options":[{"id":534,"name":"ANGN2","skip":false,"item":{"id":801,"name":"Angel Numbers Necklace","SKU":"ANGN2"},"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":146,"name":"Bone Hoodie","type":"item","options":[{"id":538,"name":"Bone Hoodie","skip":false,"item":{"id":860,"name":"Bone Angel Number Hoodie","SKU":"BANH"},"item_option_combinations":[[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":532}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":144,"attribute_option_id":534},{"attribute_id":146,"attribute_option_id":538}],"allow_backorder":true}],"tags":["collab","angel"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BARGRILL":{"id":3240,"details_loaded_time":"2025-06-04 18:41:22","sku":"BARGRILL","price":"40.00","name":"Bar Grill","allow_backorder":1,"erp_id":1560,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3240,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":519,"name":"VibeSzn Grill Impression Mold","quantity":1,"description":null,"type":"item","options":[{"id":1562,"name":"VibeSzn Grill Impression Mold","skip":false,"item":{"id":1508,"name":"VibeSzn Grill Impression Mold","SKU":"VGIM"},"attributes_per_every_item":[],"item_option_combinations":[],"active_combinations":[],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":527,"name":"VibeSzn Grill Bar","quantity":1,"description":null,"type":"item","options":[{"id":1682,"name":"VibeSzn Grill Bar","skip":false,"item":{"id":1559,"name":"VibeSzn Grill Bar","SKU":"VSGRILLBAR"},"attributes_per_every_item":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"List","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}]},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"List","options":[{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}]],"active_combinations":[{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":519,"attribute_option_id":1562},{"attribute_id":527,"attribute_option_id":1682}],"allow_backorder":true}],"tags":["don't notify","grill","grills","grillz","no discounts allowed","tooth gem"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BBNN":{"id":12,"details_loaded_time":"2025-07-20 07:18:11","sku":"BBNN","price":"80.00","name":"Outline Nameplate Necklace","allow_backorder":true,"erp_id":302,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":12,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":118,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_text","free_chars":13,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BBST":{"id":8,"details_loaded_time":"2020-05-22 21:00:02","sku":"BBST","price":"75.00","name":"Best Buds Set","allow_backorder":1,"erp_id":297,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":8,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Metal Color","type":"list","options":[{"id":19,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","mayfair"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCHSN":{"id":11,"details_loaded_time":"2025-07-20 08:57:26","sku":"BCHSN","price":"85.00","name":"Box Chain Hanging Script Nameplate","allow_backorder":true,"erp_id":300,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":11,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","15 inch sterling silver name necklace","nameplate essential necklace","waterproof","18k gold platedwith your nameneckless alex","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCMEN3":{"id":3108,"details_loaded_time":"2025-07-20 07:48:38","sku":"BCMEN3","price":"100.00","name":"3 mm Basket Chain","allow_backorder":1,"erp_id":1456,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3108,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCMEN5":{"id":3106,"details_loaded_time":"2025-07-20 07:50:04","sku":"BCMEN5","price":"110.00","name":"5 mm Basket Chain","allow_backorder":1,"erp_id":1457,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3106,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCN":{"id":3073,"details_loaded_time":"2025-07-20 07:54:28","sku":"BCN","price":"58.00","name":"Beaded Cross Necklace","allow_backorder":1,"erp_id":1443,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3073,"force_allow_backorder":false,"warning_quantity":15,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","best sellers","best seller","vintage edit","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCOEBN":{"id":694,"details_loaded_time":"2025-07-20 08:48:29","sku":"BCOEBN","price":"32.00","name":"Box Chain Old English Birthdate Necklace","allow_backorder":0,"erp_id":301,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":694,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null,"weight":170},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":133,"name":"Year","quantity":1,"description":null,"type":"list","options":[{"id":472,"name":"Skip","skip":true,"parent_attribute":null},{"id":473,"name":"1987","skip":false,"parent_attribute":null},{"id":474,"name":"1988","skip":false,"parent_attribute":null},{"id":475,"name":"1989","skip":false,"parent_attribute":null},{"id":476,"name":"1990","skip":false,"parent_attribute":null},{"id":477,"name":"1991","skip":false,"parent_attribute":null},{"id":478,"name":"1992","skip":false,"parent_attribute":null},{"id":479,"name":"1993","skip":false,"parent_attribute":null},{"id":480,"name":"1994","skip":false,"parent_attribute":null},{"id":481,"name":"1995","skip":false,"parent_attribute":null},{"id":482,"name":"1996","skip":false,"parent_attribute":null},{"id":483,"name":"1997","skip":false,"parent_attribute":null},{"id":484,"name":"1998","skip":false,"parent_attribute":null},{"id":485,"name":"1999","skip":false,"parent_attribute":null},{"id":486,"name":"2000","skip":false,"parent_attribute":null},{"id":487,"name":"2001","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"4":{"image":null,"stock":153,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"5":{"image":null,"stock":269,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"6":{"image":null,"stock":179,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"7":{"image":null,"stock":226,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"8":{"image":null,"stock":153,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"9":{"image":null,"stock":206,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"10":{"image":null,"stock":159,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"11":{"image":null,"stock":196,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"12":{"image":null,"stock":164,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"13":{"image":null,"stock":215,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"14":{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"15":{"image":null,"stock":214,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"16":{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"17":{"image":null,"stock":238,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"18":{"image":null,"stock":177,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"19":{"image":null,"stock":223,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"20":{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"21":{"image":null,"stock":145,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"22":{"image":null,"stock":121,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"23":{"image":null,"stock":187,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"24":{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"25":{"image":null,"stock":101,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"26":{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"27":{"image":null,"stock":212,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"28":{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"29":{"image":null,"stock":121,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"30":{"image":null,"stock":148,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"31":{"image":null,"stock":199,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"32":{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"33":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"34":{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"35":{"image":null,"stock":211,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"36":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"37":{"image":null,"stock":69,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"38":{"image":null,"stock":120,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"39":{"image":null,"stock":202,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"40":{"image":null,"stock":98,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"41":{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"42":{"image":null,"stock":130,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"43":{"image":null,"stock":214,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"44":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"45":{"image":null,"stock":58,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"46":{"image":null,"stock":121,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"47":{"image":null,"stock":222,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"48":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"49":{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"50":{"image":null,"stock":146,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"51":{"image":null,"stock":232,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"52":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"53":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"54":{"image":null,"stock":177,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"55":{"image":null,"stock":183,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"56":{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"57":{"image":null,"stock":149,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"58":{"image":null,"stock":156,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"59":{"image":null,"stock":189,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"60":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false},"61":{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false},"62":{"image":null,"stock":112,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false},"63":{"image":null,"stock":143,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false},"68":{"image":null,"stock":156,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"69":{"image":null,"stock":188,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"70":{"image":null,"stock":120,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"71":{"image":null,"stock":119,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":473}],"allow_backorder":false},"72":{"image":null,"stock":186,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"73":{"image":null,"stock":191,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"74":{"image":null,"stock":112,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"75":{"image":null,"stock":125,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":474}],"allow_backorder":false},"76":{"image":null,"stock":190,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"77":{"image":null,"stock":187,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"78":{"image":null,"stock":101,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"79":{"image":null,"stock":146,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":475}],"allow_backorder":false},"80":{"image":null,"stock":169,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"81":{"image":null,"stock":204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"82":{"image":null,"stock":149,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"83":{"image":null,"stock":134,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":476}],"allow_backorder":false},"84":{"image":null,"stock":142,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"85":{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"86":{"image":null,"stock":125,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"87":{"image":null,"stock":132,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":477}],"allow_backorder":false},"88":{"image":null,"stock":185,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"89":{"image":null,"stock":182,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"90":{"image":null,"stock":139,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"91":{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":478}],"allow_backorder":false},"92":{"image":null,"stock":165,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"93":{"image":null,"stock":215,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"94":{"image":null,"stock":131,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"95":{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":479}],"allow_backorder":false},"96":{"image":null,"stock":209,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"97":{"image":null,"stock":183,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"98":{"image":null,"stock":134,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"99":{"image":null,"stock":135,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":480}],"allow_backorder":false},"100":{"image":null,"stock":175,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"101":{"image":null,"stock":172,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"102":{"image":null,"stock":126,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"103":{"image":null,"stock":149,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":481}],"allow_backorder":false},"104":{"image":null,"stock":145,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"105":{"image":null,"stock":193,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"106":{"image":null,"stock":128,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"107":{"image":null,"stock":119,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":482}],"allow_backorder":false},"108":{"image":null,"stock":165,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"109":{"image":null,"stock":177,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"110":{"image":null,"stock":127,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"111":{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":483}],"allow_backorder":false},"112":{"image":null,"stock":158,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"113":{"image":null,"stock":171,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"114":{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"115":{"image":null,"stock":133,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":484}],"allow_backorder":false},"116":{"image":null,"stock":183,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"117":{"image":null,"stock":138,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"118":{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"119":{"image":null,"stock":131,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":485}],"allow_backorder":false},"120":{"image":null,"stock":152,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"121":{"image":null,"stock":158,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"122":{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"123":{"image":null,"stock":127,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":486}],"allow_backorder":false},"124":{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false},"125":{"image":null,"stock":83,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false},"126":{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false},"127":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":36},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":133,"attribute_option_id":487}],"allow_backorder":false}},"tags":["necklace","custom","sale","ws","1992","1999","1997","1996","1990","birth year","birthyear","2003","2004","1995","1988","2000","1986","2008","2008","1995 necklace","2002","1998 necklace","1987","1989","1991","1993","1994","1996","1997","1998","1999","1999","2001","2005","2006","2007","birthday charms","90 necklace","waterproof","fiagro","tarnish free","tarnishfree","tarnish-free","water proof","1984","1981","items_mobile_app","don't notify","last chance page","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCR":{"id":1108,"details_loaded_time":"2024-05-09 19:20:09","sku":"BCR","price":"28.35","name":"Brown Chunky Ring","allow_backorder":0,"erp_id":627,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1108,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCR1":{"id":1118,"details_loaded_time":"2024-05-09 20:24:21","sku":"BCR1","price":null,"name":"Blue Chunky Ring","allow_backorder":0,"erp_id":635,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1118,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BCROSSN":{"id":3313,"details_loaded_time":"2025-07-20 07:44:12","sku":"BCROSSN","price":"58.00","name":"Ball & Chain Cross Necklace","allow_backorder":1,"erp_id":1611,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3313,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","non-custom","cross necklace","edge cross necklace","big cross","double cross necklace","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BDCHARM":{"id":3747,"details_loaded_time":"2025-07-20 07:05:05","sku":"BDCHARM","price":"18.00","name":"Balloon Dog Charm","allow_backorder":1,"erp_id":1876,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3747,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BEADCANK":{"id":3538,"details_loaded_time":"2025-07-20 07:24:07","sku":"BEADCANK","price":"50.00","name":"Beads Chain Anklet","allow_backorder":1,"erp_id":1767,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3538,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":919,"name":"7\"","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":919},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","non-custom","ankle bracelet","toe rings","ank","sanklets","anklet bracelets","anklet clasps","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","endless summer campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BEBRACE":{"id":3496,"details_loaded_time":"2025-07-20 08:55:06","sku":"BEBRACE","price":"55.00","name":"Business Expense","allow_backorder":1,"erp_id":1724,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3496,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","non-custom","top seller","working woman campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BEHB":{"id":1292,"details_loaded_time":"2021-11-29 14:48:36","sku":"BEHB","price":"35.00","name":"Be Happy Bracelet","allow_backorder":0,"erp_id":815,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1292,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["bracelet","new","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BEPN":{"id":13,"details_loaded_time":"2025-01-17 20:37:01","sku":"BEPN","price":null,"name":"Butterfly Effect Pendant Necklace","allow_backorder":0,"erp_id":303,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":13,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","charm","charms","bejeweled pendant","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BEPNpen":{"id":859,"details_loaded_time":"2025-03-12 18:52:16","sku":"BEPNpen","price":"21.70","name":"Butterfly Effect Pendant Necklace--Pendant","allow_backorder":0,"erp_id":546,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":859,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BEZBAND":{"id":3891,"details_loaded_time":"2025-07-20 06:50:05","sku":"BEZBAND","price":"68.00","name":"Bezzel Band","allow_backorder":1,"erp_id":1946,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3891,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BFLYH":{"id":1508,"details_loaded_time":"2023-09-01 17:04:37","sku":"BFLYH","price":"58.00","name":"Butterfly Huggies","allow_backorder":0,"erp_id":1057,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1508,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["new","earrings","sale","non-custom","ws","say my name","say my name collection","summer collection","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BFR":{"id":1175,"details_loaded_time":"2024-05-09 20:46:45","sku":"BFR","price":null,"name":"Blue Flame Ring","allow_backorder":0,"erp_id":777,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1175,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ring for women","woman blue ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BGNN":{"id":6,"details_loaded_time":"2025-07-20 06:44:41","sku":"BGNN","price":"28.00","name":"Babygirl Nameplate Necklace","allow_backorder":0,"erp_id":295,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":6,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","female","woman","baby girl","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BGR":{"id":920,"details_loaded_time":"2022-12-06 08:57:18","sku":"BGR","price":"28.35","name":"Blue Galaxy Ring","allow_backorder":0,"erp_id":606,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":920,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BHB":{"id":1169,"details_loaded_time":"2023-03-10 19:17:04","sku":"BHB","price":"55.00","name":"Be Happy Band","allow_backorder":0,"erp_id":755,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1169,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":35,"name":"Ring Size","type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":false}],"tags":["ring","new","sale","non-custom","ws","ring for women","woman","iced smiley","woman blue ring","stay smiling","joy","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BHE":{"id":1150,"details_loaded_time":"2025-04-02 11:57:22","sku":"BHE","price":"50.00","name":"Bamboo Hoop Earrings","allow_backorder":0,"erp_id":745,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1150,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item! Only 3 left!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","fine thin hoops","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BHN":{"id":1160,"details_loaded_time":"2021-11-16 20:38:56","sku":"BHN","price":"22.40","name":"Brown Heart Necklace","allow_backorder":0,"erp_id":757,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1160,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BINSTDS":{"id":3697,"details_loaded_time":"2025-07-20 07:11:29","sku":"BINSTDS","price":"55.00","name":"Bubble Initial Studs","allow_backorder":1,"erp_id":1840,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3697,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BJPN":{"id":7,"details_loaded_time":"2025-03-03 19:48:06","sku":"BJPN","price":"40.00","name":"Bejeweled Pendant Necklace","allow_backorder":1,"erp_id":296,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":7,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null},{"id":125,"name":"Ruby Red","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}},"tags":["necklace","sale","non-custom","ws","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLESSC":{"id":3646,"details_loaded_time":"2025-07-20 07:16:05","sku":"BLESSC","price":"18.00","name":"Blessed Charm","allow_backorder":1,"erp_id":1817,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3646,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLGR":{"id":1127,"details_loaded_time":"2024-05-09 20:27:00","sku":"BLGR","price":"32.00","name":"Blue Gem Ring","allow_backorder":0,"erp_id":642,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1127,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLHR":{"id":1310,"details_loaded_time":"2025-07-20 08:12:34","sku":"BLHR","price":"36.00","name":"Black Heart Ring","allow_backorder":1,"erp_id":872,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1310,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","sale","non-custom","ws","heart shape diamond ring","ring for women","blue heart ring","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLKCR":{"id":3631,"details_loaded_time":"2024-10-14 15:11:15","sku":"BLKCR","price":"110.00","name":"Block Custom Ring","allow_backorder":true,"erp_id":1825,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3631,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","custom","topsell","birth year","birthyear","ring for women","14k gold","delores name charm","l ring","items_mobile_app","the casual edit campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLKHEIT":{"id":2223,"details_loaded_time":"2025-07-20 08:07:05","sku":"BLKHEIT","price":"40.00","name":"Onyx Hoodie","allow_backorder":0,"erp_id":1080,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":2223,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":143,"name":"Size:","quantity":1,"description":null,"type":"list","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null},{"id":602,"name":"3XL","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":false}],"tags":["custom","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLKLN":{"id":9,"details_loaded_time":"2025-07-20 06:44:21","sku":"BLKLN","price":"58.00","name":"Block Letter Necklace","allow_backorder":1,"erp_id":298,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":9,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":53,"name":"Skip","skip":true,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","silver","charm","charms","silver","m necklace","j necklace","e necklaces","initial necklace","initial","s necklace","j pendant","b necklace","initial j","c necklace","v initial","k necklace","b initial necklace","t letter chain","j chain","gold n necklace","letter j necklace","initial charm","w necklace","letter d necklace","best sellers","15 inch sterling silver name necklace","sterling silver necklaces","best seller","r necklace","sliver necklaces","sliver","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","leo season","cursive name necklace","name neclace","items_mobile_app","varsity letter"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLKLNpen":{"id":858,"details_loaded_time":"2025-07-20 08:57:02","sku":"BLKLNpen","price":"58.00","name":"Block Letter Necklace--Pendant","allow_backorder":1,"erp_id":545,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":858,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["necklace","non-custom","m necklace","j necklace","initial necklace","k necklace","t letter chain","letter j necklace","letter d necklace","l necklace","waterproof","tarnish free","tarnishfree","tarnish-free","water proof"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLNKIT":{"id":3315,"details_loaded_time":"2025-07-20 07:44:06","sku":"BLNKIT","price":"58.00","name":"Block Letter Pendant Necklace","allow_backorder":1,"erp_id":1635,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3315,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"BLKLNpen":"BLKLNpen","REC":"REC"}},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null,"skus":{"BLKLNpen":"BLKLNpen","REC":"REC"}}],"skus":{"BLKLNpen":"BLKLNpen","REC":"REC"},"top_level":true}],"grouped_attributes_ids":[11],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":{"11":11}},"attributes":[{"id":584,"name":"Block Letter Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1882,"name":"Block Letter Necklace--Pendant","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","SKU":"BLKLNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":584,"attribute_option_id":1882},{"attribute_id":585,"attribute_option_id":1884}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","silver","charm","charms","silver","m necklace","j necklace","e necklaces","initial necklace","initial","s necklace","j pendant","b necklace","initial j","c necklace","v initial","k necklace","b initial necklace","t letter chain","j chain","gold n necklace","letter j necklace","initial charm","w necklace","letter d necklace","best sellers","15 inch sterling silver name necklace","sterling silver necklaces","best seller","r necklace","sliver necklaces","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","water proof","leo season","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLR":{"id":1111,"details_loaded_time":"2023-10-20 13:22:04","sku":"BLR","price":"28.35","name":"Blue Link Ring","allow_backorder":0,"erp_id":631,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1111,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLS":{"id":930,"details_loaded_time":"2024-05-09 19:22:04","sku":"BLS","price":"17.50","name":"Black Leather Scrunchie","allow_backorder":0,"erp_id":613,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":930,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":489,"name":"Leather","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":489}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BLSR":{"id":1307,"details_loaded_time":"2025-07-20 08:13:07","sku":"BLSR","price":"60.00","name":"Black Stone Ring","allow_backorder":1,"erp_id":871,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1307,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","non-custom","ring for women","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BMN":{"id":1981,"details_loaded_time":"2025-07-20 08:06:24","sku":"BMN","price":"60.00","name":"Bridesmaid Necklace","allow_backorder":0,"erp_id":993,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1981,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","giftcol","items_mobile_app","bridal sets","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BNN":{"id":14,"details_loaded_time":"2025-07-20 06:42:34","sku":"BNN","price":"80.00","name":"Butterfly Nameplate Necklace","allow_backorder":true,"erp_id":304,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":14,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"15":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"24":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"25":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"26":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"27":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"28":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"29":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"30":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"31":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"32":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"33":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"34":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"35":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"36":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"37":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"38":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"39":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"40":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"41":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"42":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"43":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"44":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"45":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"46":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"47":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"48":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"49":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"50":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"51":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"52":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"53":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"54":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"55":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"56":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"57":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"58":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"59":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"60":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"61":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"62":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"63":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"64":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"65":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"66":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"67":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"68":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"69":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"70":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"71":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"72":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"73":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"74":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"75":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"76":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"77":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"78":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"79":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"80":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"81":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"82":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"83":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"84":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"85":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"86":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"87":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"88":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"89":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"90":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"91":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"92":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"93":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"94":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"95":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["necklace","custom","15 inch sterling silver name necklace","waterproof","18k gold platedwith your nameneckless alex","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BNPN":{"id":2667,"details_loaded_time":"2025-07-20 08:00:09","sku":"BNPN","price":"80.00","name":"Bubble Nameplate Necklace","allow_backorder":true,"erp_id":1330,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2667,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"list","options":[{"id":1316,"name":"Curb Chain","skip":false,"parent_attribute":null},{"id":1313,"name":"Figaro","skip":false,"parent_attribute":null},{"id":1314,"name":"Herringbone","skip":false,"parent_attribute":null},{"id":1315,"name":"Regular Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":1318,"name":"SoapBubbles","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":118,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_text","free_chars":13,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"15":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"32":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"33":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"34":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"35":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"36":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"37":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"38":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"39":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"40":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"41":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"42":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"43":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"44":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"45":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"46":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"47":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1318},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true}},"tags":["necklace","custom","silver","silver","15 inch sterling silver name necklace","bubble pendant","nameplate essential necklace","curbchain nameplate","18k gold platedwith your nameneckless alex","cursive name necklace","name neclace","winter","winter collection","off duty","off duty collection","future","futuristic","gold"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BNPNECK":{"id":3762,"details_loaded_time":"2025-07-20 07:01:41","sku":"BNPNECK","price":"80.00","name":"Custom Block Nameplate Necklace","allow_backorder":true,"erp_id":1743,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3762,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","waterproof","water proof"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BOHE":{"id":830,"details_loaded_time":"2025-07-20 08:42:30","sku":"BOHE","price":"55.00","name":"Bamboo Open Hoop Earrings","allow_backorder":0,"erp_id":525,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":830,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","non-custom","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BOLNN":{"id":10,"details_loaded_time":"2021-02-23 16:56:34","sku":"BOLNN","price":"69.00","name":"Bolt Nameplate Necklace","allow_backorder":true,"erp_id":299,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":10,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BOX1WED":{"id":1486,"details_loaded_time":"2022-12-22 10:26:06","sku":"BOX1WED","price":"60.00","name":"Box 1","allow_backorder":1,"erp_id":1002,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":1486,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":56,"name":"Iced Ring","type":"item","options":[{"id":270,"name":"Iced Ring","skip":false,"item":{"id":368,"name":"Iced Ring","SKU":"IDR"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":80,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":68,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":39,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":51,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":95,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":88,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":169,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":92,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":135,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":115,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":84,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":57,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":122,"name":"Old English Lock Necklace","type":"item","options":[{"id":452,"name":"Old English Lock Necklace","skip":false,"item":{"id":463,"name":"Old English Lock Necklace","SKU":"OELN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153}]],"active_combinations":[{"image":null,"stock":35,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":117,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":38,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":61,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":64,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":59,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":49,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":367,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":50,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":44,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":214,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":29,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153}]},{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":28,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":128,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":17,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":37,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":40,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":56,"attribute_option_id":270},{"attribute_id":122,"attribute_option_id":452}],"allow_backorder":true}],"tags":["wedding","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BOX2WED":{"id":1487,"details_loaded_time":"2022-12-22 10:22:46","sku":"BOX2WED","price":"75.00","name":"Box 2","allow_backorder":1,"erp_id":1003,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":1487,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":56,"name":"Iced Ring","type":"item","options":[{"id":270,"name":"Iced Ring","skip":false,"item":{"id":368,"name":"Iced Ring","SKU":"IDR"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":80,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":68,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":39,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":51,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":95,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":88,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":169,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":92,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":135,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":115,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":84,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":57,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":122,"name":"Old English Lock Necklace","type":"item","options":[{"id":452,"name":"Old English Lock Necklace","skip":false,"item":{"id":463,"name":"Old English Lock Necklace","SKU":"OELN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153}]],"active_combinations":[{"image":null,"stock":35,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":117,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":38,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":61,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":64,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":59,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":49,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":367,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":50,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":44,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":214,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":29,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153}]},{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":28,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":128,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":17,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":37,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":40,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":235,"name":"Mini Pearl Hoops","type":"item","options":[{"id":786,"name":"Mini Pearl Hoops","skip":false,"item":{"id":385,"name":"Mini Pearl Hoops","SKU":"MPH"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":64,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":14,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":56,"attribute_option_id":270},{"attribute_id":122,"attribute_option_id":452},{"attribute_id":235,"attribute_option_id":786}],"allow_backorder":true}],"tags":["wedding","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BOX3WED":{"id":1488,"details_loaded_time":"2022-12-22 10:22:38","sku":"BOX3WED","price":"90.00","name":"Box 3","allow_backorder":1,"erp_id":1004,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":1488,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":56,"name":"Iced Ring","type":"item","options":[{"id":270,"name":"Iced Ring","skip":false,"item":{"id":368,"name":"Iced Ring","SKU":"IDR"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":80,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":68,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":39,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":51,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":95,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":88,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":169,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":92,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":135,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":115,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":84,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":57,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":122,"name":"Old English Lock Necklace","type":"item","options":[{"id":452,"name":"Old English Lock Necklace","skip":false,"item":{"id":463,"name":"Old English Lock Necklace","SKU":"OELN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153}]],"active_combinations":[{"image":null,"stock":35,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":117,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":38,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":61,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":64,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":59,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":49,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":367,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":50,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":44,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":214,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":29,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153}]},{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":28,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":128,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":17,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":37,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":40,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":235,"name":"Mini Pearl Hoops","type":"item","options":[{"id":786,"name":"Mini Pearl Hoops","skip":false,"item":{"id":385,"name":"Mini Pearl Hoops","SKU":"MPH"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":64,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":14,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":66,"name":"Script Nameplate Necklace","type":"item","options":[{"id":292,"name":"Script Nameplate Necklace","skip":false,"item":{"id":405,"name":"Script Nameplate Necklace","SKU":"SNN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":56,"attribute_option_id":270},{"attribute_id":66,"attribute_option_id":292},{"attribute_id":122,"attribute_option_id":452},{"attribute_id":235,"attribute_option_id":786}],"allow_backorder":true}],"tags":["wedding","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BOXCANK":{"id":3536,"details_loaded_time":"2025-07-20 07:24:14","sku":"BOXCANK","price":"50.00","name":"Box Chain Anklet","allow_backorder":1,"erp_id":1765,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3536,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":919,"name":"7\"","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":919},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","non-custom","ankle bracelet","toe rings","ank","sanklets","anklet bracelets","anklet clasps","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","endless summer campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BPBC":{"id":936,"details_loaded_time":"2022-07-20 11:51:32","sku":"BPBC","price":"16.80","name":"Baby Pink Bubble Clip","allow_backorder":0,"erp_id":617,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":936,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":490,"name":"Acrylic","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":490}],"allow_backorder":false}],"tags":["sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BPNpen":{"id":857,"details_loaded_time":"2022-06-29 14:00:19","sku":"BPNpen","price":"42.00","name":"Bejeweled Pendant Necklace--Pendant","allow_backorder":0,"erp_id":544,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":857,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","type":"list","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null},{"id":125,"name":"Ruby Red","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BR":{"id":1110,"details_loaded_time":"2024-05-09 20:33:47","sku":"BR","price":null,"name":"Braided Ring","allow_backorder":0,"erp_id":625,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1110,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BREMN":{"id":2188,"details_loaded_time":"2025-01-17 20:39:01","sku":"BREMN","price":"65.00","name":"Braided Emerald Necklace","allow_backorder":1,"erp_id":1256,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2188,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","emerald stone necklace","bejeweled pendant","necklace with a gem","baby chain","emerald gold necklace","tarnish free","fall","girls night","girls night collection","girls night out","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BRRR":{"id":1113,"details_loaded_time":"2024-05-09 20:04:15","sku":"BRRR","price":"22.00","name":"Bamboo Ring","allow_backorder":0,"erp_id":626,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1113,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BRSAN":{"id":2189,"details_loaded_time":"2024-02-07 18:54:23","sku":"BRSAN","price":"52.00","name":"Braided Sapphire Necklace","allow_backorder":0,"erp_id":1257,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2189,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Sold Out!","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["sale","non-custom","ws","emerald stone necklace","necklace with a gem","fall","girls night","girls night collection","girls night out","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BSAPHN":{"id":1121,"details_loaded_time":"2021-05-31 19:25:48","sku":"BSAPHN","price":"31.67","name":"Blue Sapphire Necklace","allow_backorder":0,"erp_id":639,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1121,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BSR":{"id":1126,"details_loaded_time":"2024-05-09 20:31:24","sku":"BSR","price":null,"name":"Blue Square Ring","allow_backorder":0,"erp_id":643,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1126,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BSRI":{"id":1286,"details_loaded_time":"2023-09-01 17:17:31","sku":"BSRI","price":"55.00","name":"Black Smiley Ring","allow_backorder":0,"erp_id":809,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1286,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":35,"name":"Ring Size","type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["ring","new","sale","non-custom","ws","ring for women","iced smiley","stay smiling","joy","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BTC":{"id":2665,"details_loaded_time":"2025-07-20 08:00:18","sku":"BTC","price":"80.00","name":"Box Tennis Chain","allow_backorder":0,"erp_id":1328,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2665,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":false}],"tags":["necklace","non-custom","silver","silver","gold n necklace","tennis chain","tennis necklace","sterling silver necklaces","14k gold","sliver","rhinestone","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold","tennis","sofia richie","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BTCB":{"id":2666,"details_loaded_time":"2025-07-20 08:00:14","sku":"BTCB","price":"65.00","name":"Box Tennis Chain Bracelet","allow_backorder":1,"erp_id":1329,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2666,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":true}],"tags":["bracelet","topsell","non-custom","silver","silver","tennis chain","braceletbracelet","top seller","14k gold","sliver","sliver chin","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold","tennis","sofia richie","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BUBBLEINECK":{"id":3521,"details_loaded_time":"2025-07-20 07:26:32","sku":"BUBBLEINECK","price":"60.00","name":"Bubble Initial Necklace","allow_backorder":1,"erp_id":1749,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3521,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BUCHARM":{"id":3744,"details_loaded_time":"2025-07-20 07:05:15","sku":"BUCHARM","price":"18.00","name":"Butterfly Charm","allow_backorder":1,"erp_id":1873,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3744,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"BYYN":{"id":1161,"details_loaded_time":"2022-09-15 17:44:41","sku":"BYYN","price":"22.40","name":"Blue Yin Yang Necklace","allow_backorder":0,"erp_id":756,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1161,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CACS":{"id":30,"details_loaded_time":"2025-07-20 06:38:16","sku":"CACS","price":"70.00","name":"Custom Area Code Studs","allow_backorder":true,"erp_id":321,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":30,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":132,"name":"Numbers","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"only_numbers","free_chars":15,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","earrings","earrings men","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CALLYOURSHOT":{"id":3888,"details_loaded_time":"2025-07-20 06:49:40","sku":"CALLYOURSHOT","price":"35.00","name":"CALL YOUR SHOT","allow_backorder":1,"erp_id":1942,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3888,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":1490,"name":"0431 Nvy\/Natrl","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":1490}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CAMOHAT":{"id":3855,"details_loaded_time":"2025-07-20 06:55:21","sku":"CAMOHAT","price":"4.45","name":"Camo blank hat","allow_backorder":1,"erp_id":1336,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3855,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":428,"name":"Camo hat color","quantity":1,"description":null,"type":"list","options":[{"id":1326,"name":"Camo","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":428,"attribute_option_id":1326}],"allow_backorder":true}],"tags":["non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CANG":{"id":1294,"details_loaded_time":"2025-07-20 08:14:07","sku":"CANG","price":"36.00","name":"Classic Angel Necklace","allow_backorder":0,"erp_id":816,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1294,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","angel","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CARANECK":{"id":3634,"details_loaded_time":"2025-07-20 07:18:24","sku":"CARANECK","price":"55.00","name":"Carabiner Chain Type","allow_backorder":1,"erp_id":1802,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3634,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":692,"name":"Carabiner Chain","quantity":1,"description":null,"type":"list","options":[{"id":2246,"name":"Dainty Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2247,"name":"Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2248,"name":"Dainty Curb Carabiner Chain","skip":false,"parent_attribute":null},{"id":2249,"name":"Curb Carabiner Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2246}],"allow_backorder":true},{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2247}],"allow_backorder":true},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2248}],"allow_backorder":true},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2249}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CASHSET":{"id":3699,"details_loaded_time":"2025-07-20 07:11:21","sku":"CASHSET","price":"150.00","name":"Cashmere Set","allow_backorder":1,"erp_id":1859,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3699,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":700,"name":"The Hardware Chain","quantity":1,"description":null,"type":"item","options":[{"id":2277,"name":"The Hardware Chain","skip":false,"item":{"id":1853,"name":"The Hardware Chain","SKU":"THC"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":701,"name":"The Oliver Band","quantity":1,"description":null,"type":"item","options":[{"id":2278,"name":"The Oliver Band","skip":false,"item":{"id":1852,"name":"The Oliver Band","SKU":"TOB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":702,"name":"The Margot","quantity":1,"description":null,"type":"item","options":[{"id":2279,"name":"The Margot","skip":false,"item":{"id":1848,"name":"The Margot","SKU":"THEMARG"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":700,"attribute_option_id":2277},{"attribute_id":701,"attribute_option_id":2278},{"attribute_id":702,"attribute_option_id":2279}],"allow_backorder":true}],"tags":["new","set","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CBAMBOOH":{"id":3528,"details_loaded_time":"2025-07-20 07:26:04","sku":"CBAMBOOH","price":"70.00","name":"Custom Bamboo Hoops","allow_backorder":true,"erp_id":1758,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3528,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":41,"name":"Size","quantity":1,"description":null,"type":"list","options":[{"id":171,"name":"Small","skip":false,"parent_attribute":null},{"id":172,"name":"Medium","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","custom","earrings","topsell","items_mobile_app","don't notify","endless summer campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CBC":{"id":3194,"details_loaded_time":"2025-07-20 07:48:13","sku":"CBC","price":"85.00","name":"Custom Belly Chain","allow_backorder":true,"erp_id":1514,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3194,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":507,"name":"Belly Chain Length","quantity":1,"description":null,"type":"list","options":[{"id":1531,"name":"60 cm + 20 cm extender","skip":false,"parent_attribute":null},{"id":1532,"name":"70 cm + 20 cm extender","skip":false,"parent_attribute":null},{"id":1533,"name":"80 cm + 20 cm extender","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true}],"tags":["custom","accessories"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CBKS":{"id":3703,"details_loaded_time":"2025-07-20 07:11:04","sku":"CBKS","price":"150.00","name":"CBK Set","allow_backorder":1,"erp_id":1860,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3703,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":703,"name":"Suede Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2283,"name":"Suede Pendant Necklace","skip":false,"item":{"id":1854,"name":"Suede Pendant Necklace","SKU":"SPENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":704,"name":"The Sloane","quantity":1,"description":null,"type":"item","options":[{"id":2284,"name":"The Sloane","skip":false,"item":{"id":1855,"name":"The Sloane","SKU":"TSE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":705,"name":"Teddy Ring","quantity":1,"description":null,"type":"item","options":[{"id":2285,"name":"Teddy Ring","skip":false,"item":{"id":1843,"name":"Teddy Ring","SKU":"TEDRING"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":703,"attribute_option_id":2283},{"attribute_id":704,"attribute_option_id":2284},{"attribute_id":705,"attribute_option_id":2285}],"allow_backorder":true}],"tags":["new","set","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CBLCFR":{"id":3416,"details_loaded_time":"2024-11-06 20:20:28","sku":"CBLCFR","price":null,"name":"Cable Cuff Ring","allow_backorder":1,"erp_id":1629,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3416,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","topsell","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CBN":{"id":3527,"details_loaded_time":"2025-07-20 07:26:09","sku":"CBN","price":"55.00","name":"Coastal Beaded Necklace","allow_backorder":1,"erp_id":1757,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3527,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null,"weight":170}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":2080,"name":"Stainless Steel\/Beaded","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":2080}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","endless summer campaign","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CBR":{"id":1174,"details_loaded_time":"2024-05-09 20:51:23","sku":"CBR","price":null,"name":"Cherry Bomb Ring","allow_backorder":0,"erp_id":778,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1174,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":498,"name":"Brass","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":498}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":498}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":498}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ring for women","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCAN":{"id":1282,"details_loaded_time":"2025-07-20 08:14:40","sku":"CCAN","price":"50.00","name":"Curb Chain Anklet","allow_backorder":0,"erp_id":807,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1282,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":221,"name":"7.3\"","skip":false,"parent_attribute":null,"weight":73}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":221},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["anklet","non-custom","ankle bracelet","toe rings","ank","sanklets","anklet bracelets","anklet clasps","cuban anklet","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCANK":{"id":2183,"details_loaded_time":"2025-07-20 08:04:38","sku":"CCANK","price":"75.00","name":"Custom Curb Chain Anklet","allow_backorder":0,"erp_id":1017,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2183,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["anklet","new","custom","ankle bracelet","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCANNN":{"id":1520,"details_loaded_time":"2025-07-20 08:06:42","sku":"CCANNN","price":"60.00","name":"Curb Chain Angel Numbers Necklace","allow_backorder":0,"erp_id":1005,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1520,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false}],"tags":["necklace","angel","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","angel number necklace","summer 2022","best sellers","heaven sent","111717","top seller","curb link angel number","best seller","curb chain angel numbers necklace","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCAP":{"id":27,"details_loaded_time":"2020-07-10 20:19:15","sku":"CCAP","price":"25.00","name":"Curb Chain Allah Pendant","allow_backorder":1,"erp_id":318,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":27,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":249,"name":"17.7\"","skip":false,"parent_attribute":null,"weight":177}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","type":"list","options":[{"id":247,"name":"3.2 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":249},{"attribute_id":52,"attribute_option_id":247},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["necklace","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCBFF":{"id":1521,"details_loaded_time":"2025-07-20 08:06:38","sku":"CCBFF","price":"44.00","name":"Curb Chain BFF Bracelet","allow_backorder":0,"erp_id":1014,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1521,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":375,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["bracelet","sale","non-custom","ws","bestfriend","curb chain bff bracelet","brackets","bff","curb chain bff","friendship","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","best friennds","bestie","items_mobile_app","no-reorder","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCCHARM":{"id":3742,"details_loaded_time":"2025-07-20 07:05:23","sku":"CCCHARM","price":"18.00","name":"Crystal Cross Charm","allow_backorder":1,"erp_id":1871,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3742,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCHA":{"id":26,"details_loaded_time":"2025-07-20 06:38:39","sku":"CCHA","price":"55.00","name":"Curb Chain","allow_backorder":0,"erp_id":317,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":26,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":36,"name":"Style","quantity":1,"description":null,"type":"list","options":[{"id":163,"name":"Style 1","skip":false,"parent_attribute":null},{"id":164,"name":"Style 2","skip":false,"parent_attribute":null},{"id":165,"name":"Style 3","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":164},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":165},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","non-custom","figaro c","cuban mariner","curbchain nameplate","link choker","waterproof","fiagro","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCR":{"id":17,"details_loaded_time":"2025-07-20 07:39:08","sku":"CCR","price":"45.00","name":"Classic Crystal Ring","allow_backorder":1,"erp_id":307,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":17,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":430,"name":"Orange","skip":false,"parent_attribute":null},{"id":431,"name":"Purple","skip":false,"parent_attribute":null},{"id":432,"name":"Pink","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true}],"tags":["ring","sale","non-custom","ws","ring for women","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCSN":{"id":28,"details_loaded_time":"2025-07-20 06:38:28","sku":"CCSN","price":"85.00","name":"Curb Chain Nameplate","allow_backorder":true,"erp_id":319,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":28,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","daniel","gabriel neckless","nathan","alessandra","15 inch sterling silver name necklace","dominique","addison","nameplate essential necklace","delores name necklace","delores name charm","yasmine","malena","bikini","cayden","savannah","andrew","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","18k gold plated neckless alex","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","chunky charm necklace","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CCUFFB":{"id":3324,"details_loaded_time":"2025-07-20 07:43:03","sku":"CCUFFB","price":"50.00","name":"Classic Cuff Bracelet","allow_backorder":1,"erp_id":1628,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3324,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","topsell","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CDC":{"id":3740,"details_loaded_time":"2025-07-20 07:05:30","sku":"CDC","price":"18.00","name":"Crystal Dice Charm","allow_backorder":1,"erp_id":1869,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3740,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CDHC":{"id":3746,"details_loaded_time":"2025-07-20 07:05:08","sku":"CDHC","price":"18.00","name":"Crystal Dripping Heart Charm","allow_backorder":1,"erp_id":1875,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3746,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CDN":{"id":18,"details_loaded_time":"2025-07-20 07:18:07","sku":"CDN","price":"80.00","name":"Classic Date Necklace","allow_backorder":true,"erp_id":308,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":18,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":32,"name":"Numbers","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"only_numbers","free_chars":15,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","gold n necklace","birthday charms","14k gold","90 necklace","sports","swimwear","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","chiefs","number18","baseball","33 necklace","1981","1944 necklace","89 necklace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CEC":{"id":3865,"details_loaded_time":"2025-07-20 06:53:27","sku":"CEC","price":"60.00","name":"Crystal Ear Cuff","allow_backorder":1,"erp_id":1923,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3865,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CECUFF":{"id":3488,"details_loaded_time":"2025-02-27 12:57:26","sku":"CECUFF","price":"52.00","name":"Crystal Ear Cuff","allow_backorder":0,"erp_id":1713,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3488,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":485,"name":"Stone Color","quantity":1,"description":null,"type":"list","options":[{"id":1470,"name":"Crystal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":485,"attribute_option_id":1470}],"allow_backorder":false}],"tags":["accessories","earrings","sale","non-custom","ws","items_mobile_app","ear cuff","working woman campaign","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CFA":{"id":479,"details_loaded_time":"2025-07-20 08:52:41","sku":"CFA","price":"75.00","name":"Custom Figaro Anklet","allow_backorder":true,"erp_id":461,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":479,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":375,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["anklet","custom","topsell","ankle bracelet","toe rings","ank","ryan anklets","sanklets","anklet bracelets","anklet clasps","cuban anklet","waterproof","fiagro","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CFB":{"id":480,"details_loaded_time":"2025-07-20 08:52:35","sku":"CFB","price":"75.00","name":"Custom Figaro Bracelet","allow_backorder":true,"erp_id":462,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":480,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":375,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","custom","personalize","figaro c","brackets","personalised","personalised","bracelet for guys","c initial brackets","personalized bracelets for men","waterproof","fiagro","tarnish free","tarnishfree","tarnish-free","water proof","custom used bracelet","customize bracelet cubana","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CFFN":{"id":661,"details_loaded_time":"2025-07-20 08:50:37","sku":"CFFN","price":"38.00","name":"Cuffed Necklace","allow_backorder":0,"erp_id":469,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":661,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","handcuff","handcuffs","handcuff necklace","cuffs","playboy","two circles","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CFN":{"id":478,"details_loaded_time":"2025-07-20 08:54:04","sku":"CFN","price":"85.00","name":"Custom Figaro Necklace","allow_backorder":true,"erp_id":460,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":478,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":471,"name":"Figaro","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":375,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":471},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","topsell","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CGHE":{"id":3054,"details_loaded_time":"2024-05-14 14:31:12","sku":"CGHE","price":"58.00","name":"Crystal Gem Huggie","allow_backorder":0,"erp_id":1424,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3054,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":485,"name":"Stone Color","quantity":1,"description":null,"type":"list","options":[{"id":1470,"name":"Crystal","skip":false,"parent_attribute":null},{"id":1471,"name":"Emerald","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":485,"attribute_option_id":1470}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":485,"attribute_option_id":1471}],"allow_backorder":false}],"tags":["new","earrings","sale","non-custom","ws","birthstone","vintage edit","birth stone","do not reorder"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHAMP":{"id":3881,"details_loaded_time":"2025-07-20 06:51:30","sku":"CHAMP","price":"68.00","name":"Champion Ring","allow_backorder":1,"erp_id":1936,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3881,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHARM1":{"id":3650,"details_loaded_time":"2025-07-20 07:18:35","sku":"CHARM1","price":"17.00","name":"Charm 1","allow_backorder":1,"erp_id":1831,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3650,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":678,"name":"Select Charm","quantity":1,"description":null,"type":"list","options":[{"id":2140,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2136,"name":"Angel Baby charm","skip":false,"parent_attribute":null},{"id":2144,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2141,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2133,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2143,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2139,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2135,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2132,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2134,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2138,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2142,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2145,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2131,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2137,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2329,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2330,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2331,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2332,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2333,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2334,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2335,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2336,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2337,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2338,"name":"Ace Of Hearts Charm","skip":false,"parent_attribute":null},{"id":2339,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2340,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2341,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2342,"name":"Match Charm","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2140}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2136}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2144}],"allow_backorder":true},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2141}],"allow_backorder":true},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2133}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2143}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2139}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2135}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2132}],"allow_backorder":true},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2134}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2138}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2142}],"allow_backorder":true},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2145}],"allow_backorder":true},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2131}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2137}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2329}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2330}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2331}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2332}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2333}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2334}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2335}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2336}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2337}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2338}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2339}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2340}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2341}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2342}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHARM2":{"id":3652,"details_loaded_time":"2025-07-20 07:18:38","sku":"CHARM2","price":"17.00","name":"Charm 2","allow_backorder":1,"erp_id":1832,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3652,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":688,"name":"Select Charm","quantity":1,"description":null,"type":"list","options":[{"id":2204,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2200,"name":"Angel Baby Charm","skip":false,"parent_attribute":null},{"id":2208,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2205,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2197,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2195,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2196,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2207,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2203,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2199,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2198,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2202,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2206,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2209,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2201,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2210,"name":"Initial Charm","skip":false,"parent_attribute":null},{"id":2343,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2344,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2345,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2346,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2347,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2348,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2349,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2350,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2351,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2352,"name":"Ace of Hearts Charm","skip":false,"parent_attribute":null},{"id":2353,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2354,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2355,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2356,"name":"Match Charm","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2195}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2196}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2197}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2198}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2199}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2200}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2201}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2202}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2203}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2204}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2205}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2206}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2207}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2208}],"allow_backorder":true},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2209}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2210}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2343}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2344}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2345}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2346}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2347}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2348}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2349}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2350}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2351}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2352}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2353}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2354}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2355}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2356}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHARMLETTERS":{"id":3626,"details_loaded_time":"2025-07-20 07:20:10","sku":"CHARMLETTERS","price":"18.00","name":"Charm Letters","allow_backorder":1,"erp_id":1830,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3626,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":690,"name":"Charm Letters","quantity":1,"description":null,"type":"list","options":[{"id":2214,"name":"A","skip":false,"parent_attribute":null},{"id":2215,"name":"B","skip":false,"parent_attribute":null},{"id":2216,"name":"C","skip":false,"parent_attribute":null},{"id":2217,"name":"D","skip":false,"parent_attribute":null},{"id":2218,"name":"E","skip":false,"parent_attribute":null},{"id":2219,"name":"F","skip":false,"parent_attribute":null},{"id":2220,"name":"G","skip":false,"parent_attribute":null},{"id":2221,"name":"H","skip":false,"parent_attribute":null},{"id":2222,"name":"I","skip":false,"parent_attribute":null},{"id":2223,"name":"J","skip":false,"parent_attribute":null},{"id":2224,"name":"K","skip":false,"parent_attribute":null},{"id":2225,"name":"L","skip":false,"parent_attribute":null},{"id":2226,"name":"M","skip":false,"parent_attribute":null},{"id":2227,"name":"N","skip":false,"parent_attribute":null},{"id":2228,"name":"O","skip":false,"parent_attribute":null},{"id":2229,"name":"P","skip":false,"parent_attribute":null},{"id":2230,"name":"Q","skip":false,"parent_attribute":null},{"id":2231,"name":"R","skip":false,"parent_attribute":null},{"id":2232,"name":"S","skip":false,"parent_attribute":null},{"id":2233,"name":"T","skip":false,"parent_attribute":null},{"id":2234,"name":"U","skip":false,"parent_attribute":null},{"id":2235,"name":"V","skip":false,"parent_attribute":null},{"id":2236,"name":"W","skip":false,"parent_attribute":null},{"id":2237,"name":"X","skip":false,"parent_attribute":null},{"id":2238,"name":"Y","skip":false,"parent_attribute":null},{"id":2239,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}],"allow_backorder":true},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}],"allow_backorder":true},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}],"allow_backorder":true},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}],"allow_backorder":true},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}],"allow_backorder":true}],"tags":["non-custom","charms","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHATPIN":{"id":3694,"details_loaded_time":"2025-07-20 07:14:07","sku":"CHATPIN","price":"60.00","name":"Custom Hat Pins","allow_backorder":true,"erp_id":1834,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3694,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","custom","accessories","hat","don't notify"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHBB":{"id":3056,"details_loaded_time":"2025-07-20 07:56:33","sku":"CHBB","price":"60.00","name":"Crystal Herringbone Bracelet","allow_backorder":1,"erp_id":1426,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3056,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":485,"name":"Stone Color","quantity":1,"description":null,"type":"list","options":[{"id":1470,"name":"Crystal","skip":false,"parent_attribute":null},{"id":1471,"name":"Emerald","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1470}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1471}],"allow_backorder":true}],"tags":["bracelet","sale","non-custom","ws","vintage edit","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHBELLYC":{"id":3529,"details_loaded_time":"2025-07-20 07:24:42","sku":"CHBELLYC","price":"85.00","name":"Custom Herringbone Belly Chain","allow_backorder":true,"erp_id":1759,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3529,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":507,"name":"Belly Chain Length","quantity":1,"description":null,"type":"list","options":[{"id":1531,"name":"60 cm + 20 cm extender","skip":false,"parent_attribute":null},{"id":1532,"name":"70 cm + 20 cm extender","skip":false,"parent_attribute":null},{"id":1533,"name":"80 cm + 20 cm extender","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":2087,"name":"Herringbone Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":2087},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true}],"tags":["new","custom","accessories","endless summer campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHBN":{"id":3055,"details_loaded_time":"2025-07-20 07:56:37","sku":"CHBN","price":"65.00","name":"Crystal Herringbone Necklace","allow_backorder":0,"erp_id":1425,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3055,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":485,"name":"Stone Color","quantity":1,"description":null,"type":"list","options":[{"id":1470,"name":"Crystal","skip":false,"parent_attribute":null},{"id":1471,"name":"Emerald","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1470}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1471}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","vintage edit","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHC":{"id":31,"details_loaded_time":"2020-05-28 19:14:30","sku":"CHC","price":"65.00","name":"Custom Hair Clips","allow_backorder":true,"erp_id":322,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":31,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"Gold","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"alphanumeric","free_chars":15,"addtional_price_per_char":"0.10","special_chars":true,"emojis":true}},{"id":31,"name":"Font","type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","accessories"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHE":{"id":32,"details_loaded_time":"2025-07-20 06:38:04","sku":"CHE","price":"70.00","name":"Custom Hoop Earrings","allow_backorder":true,"erp_id":323,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":32,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":41,"name":"Size","quantity":1,"description":null,"type":"list","options":[{"id":171,"name":"Small","skip":false,"parent_attribute":null},{"id":172,"name":"Medium","skip":false,"parent_attribute":null},{"id":173,"name":"Large","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","earrings","topsell","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHERGANK":{"id":3530,"details_loaded_time":"2025-07-20 07:24:38","sku":"CHERGANK","price":"75.00","name":"Custom Herringbone Anklet","allow_backorder":true,"erp_id":1760,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3530,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":571,"name":"Pick Your Anklet","quantity":1,"description":null,"type":"list","options":[{"id":1852,"name":"Herringbone Anklet","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}],"allow_backorder":true}],"tags":["anklet","new","custom","topsell","ankle bracelet","ank","ryan anklets","sanklets","anklet bracelets","anklet clasps","cuban anklet","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","don't notify","the players club campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHERNG":{"id":656,"details_loaded_time":"2025-07-20 08:52:09","sku":"CHERNG","price":"36.00","name":"Chained Earrings","allow_backorder":0,"erp_id":466,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":656,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","earrings men","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHH":{"id":24,"details_loaded_time":"2025-03-03 19:42:11","sku":"CHH","price":"36.00","name":"Crystal Heart Huggies","allow_backorder":1,"erp_id":314,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":24,"force_allow_backorder":false,"warning_quantity":1,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true}],"tags":["earrings","sale","non-custom","ws","heart shape diamond ring","earrings sterling","playboy","swimwear","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","opal","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHHR":{"id":1296,"details_loaded_time":"2024-05-10 12:47:48","sku":"CHHR","price":null,"name":"Checkered Heart Ring","allow_backorder":0,"erp_id":821,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1296,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","heart shape diamond ring","ring for women","blue heart ring","waterproof","red black","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHKEYCHAIN":{"id":3847,"details_loaded_time":"2025-07-20 06:57:04","sku":"CHKEYCHAIN","price":"60.00","name":"Custom Heart Keychain","allow_backorder":true,"erp_id":1913,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3847,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","custom","accessories"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHN2":{"id":749,"details_loaded_time":"2024-02-22 19:58:19","sku":"CHN2","price":null,"name":"Crystal Heart Necklace","allow_backorder":0,"erp_id":315,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":749,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","heart lock","necklace with a gem","items_mobile_app","opal"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHN2KIT":{"id":3483,"details_loaded_time":"2025-07-20 07:34:19","sku":"CHN2KIT","price":"45.00","name":"Crystal Heart Pendant Necklace","allow_backorder":1,"erp_id":1706,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3483,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":639,"name":"Crystal Heart Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2015,"name":"Crystal Heart Necklace--Pendant","skip":false,"item":{"id":548,"name":"Crystal Heart Necklace--Pendant","SKU":"CHN2pen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":639,"attribute_option_id":2015}],"allow_backorder":true}],"tags":["sale","non-custom","ws","heart lock","necklace with a gem","items_mobile_app","opal","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHN2pen":{"id":861,"details_loaded_time":"2025-07-20 08:57:14","sku":"CHN2pen","price":"45.00","name":"Crystal Heart Necklace--Pendant","allow_backorder":1,"erp_id":548,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":861,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["non-custom","heart lock","necklace with a gem"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHNECKLACE":{"id":3848,"details_loaded_time":"2025-07-20 06:55:41","sku":"CHNECKLACE","price":"75.00","name":"Custom Heart Necklace","allow_backorder":true,"erp_id":1914,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3848,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","custom","top seller","vibeszn market campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHOOSEBRACE":{"id":3838,"details_loaded_time":"2025-07-20 06:58:06","sku":"CHOOSEBRACE","price":"55.00","name":"Choose Your Bracelet","allow_backorder":1,"erp_id":1907,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3838,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":732,"name":"Choose Your Bracelet","quantity":1,"description":null,"type":"list","options":[{"id":2370,"name":"Elevated Chain Bracelet","skip":false,"parent_attribute":null},{"id":2371,"name":"Paperclip Chain Bracelet","skip":false,"parent_attribute":null},{"id":2372,"name":"Rolo Chain Bracelet","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":919,"name":"7\"","skip":false,"parent_attribute":null},{"id":920,"name":"8\"","skip":false,"parent_attribute":null},{"id":241,"name":"6\"","skip":false,"parent_attribute":null,"weight":60}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2370}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2370}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2370}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2371}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2371}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2371}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2372}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2372}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2372}],"allow_backorder":true}],"tags":["non-custom","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHR":{"id":1278,"details_loaded_time":"2024-05-10 14:38:37","sku":"CHR","price":"45.00","name":"Checkered Ring","allow_backorder":0,"erp_id":774,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1278,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Item Discontinued","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ring for women","waterproof","red black","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHRBN":{"id":657,"details_loaded_time":"2025-07-20 08:52:04","sku":"CHRBN","price":"58.00","name":"Cherub Necklace","allow_backorder":0,"erp_id":467,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":657,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","silver","charm","charms","coin necklace","heaven sent","sliver necklaces","sliver","saint benedict coin","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","vintage edit","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHRS":{"id":909,"details_loaded_time":"2025-07-20 08:34:10","sku":"CHRS","price":"160.00","name":"Chain Reaction Set","allow_backorder":0,"erp_id":580,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":909,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":123,"name":"Linked Bar Necklace","quantity":1,"description":null,"type":"item","options":[{"id":454,"name":"Linked Bar Necklace","skip":false,"item":{"id":540,"name":"Linked Bar Necklace","SKU":"LBN"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":124,"name":"Iced Ruby Necklace","quantity":1,"description":null,"type":"item","options":[{"id":456,"name":"Iced Ruby Necklace","skip":false,"item":{"id":539,"name":"Iced Ruby Necklace","SKU":"IRN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":78,"name":"Chain Link Ring","quantity":1,"description":null,"type":"item","options":[{"id":316,"name":"Chain Link Ring","skip":false,"item":{"id":305,"name":"Chain Link Ring","SKU":"CLR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":155,"name":"Black","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":78,"attribute_option_id":316},{"attribute_id":123,"attribute_option_id":454},{"attribute_id":124,"attribute_option_id":456}],"allow_backorder":false}],"tags":["set","sale","non-custom","ws","red ruby","ruby","bejeweled","items_mobile_app","nodiscount","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHRTR":{"id":1514,"details_loaded_time":"2024-11-06 18:59:36","sku":"CHRTR","price":"42.00","name":"Crystal Heart Ring","allow_backorder":0,"erp_id":1065,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1514,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":807,"name":"Clear","skip":false,"parent_attribute":null},{"id":808,"name":"Green","skip":false,"parent_attribute":null},{"id":799,"name":"Pink","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":807},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":807},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"3":{"image":null,"stock":10,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":808},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"6":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":799},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"7":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":799},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}},"tags":["ring","sale","non-custom","ws","heart shape diamond ring","say my name","ring for women","say my name collection","summer collection","green marbled","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app","don't notify"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CHTN":{"id":1303,"details_loaded_time":"2024-05-10 12:31:07","sku":"CHTN","price":"40.00","name":"Checkered Tag Necklace","allow_backorder":0,"erp_id":865,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1303,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","14k gold","cross tag necklace","waterproof","red black","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CIAOBEAR":{"id":3517,"details_loaded_time":"2025-07-20 07:28:07","sku":"CIAOBEAR","price":"65.00","name":"Ciao Bella Earrings","allow_backorder":1,"erp_id":1745,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3517,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","non-custom","items_mobile_app","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CIS":{"id":33,"details_loaded_time":"2025-07-20 06:36:48","sku":"CIS","price":"32.00","name":"Initial Stud Combo","allow_backorder":0,"erp_id":324,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":33,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":448,"name":"First initial","quantity":1,"description":null,"type":"item","options":[{"id":1376,"name":"First initial","skip":false,"item":{"id":503,"name":"Initial Studs","SKU":"INTSTD"},"attributes_per_every_item":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":34,"attribute_option_id":153}]],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":132,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":124,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":164,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":63,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":119,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":146,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":140,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":156,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":157,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":152,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":150,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":162,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":148,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":147,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":449,"name":"Second Initial","quantity":1,"description":null,"type":"item","options":[{"id":1378,"name":"Second Initial","skip":false,"item":{"id":503,"name":"Initial Studs","SKU":"INTSTD"},"attributes_per_every_item":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":34,"attribute_option_id":153}]],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":132,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":124,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":164,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":63,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":119,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":146,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":140,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":156,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":157,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":152,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":150,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":162,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":148,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":147,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":175},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":176},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":177},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":178},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":179},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":180},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":181},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":182},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":183},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":184},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":185},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":186},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":187},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":188},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":189},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":190},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":191},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":192},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":193},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":194},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":195},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":196},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":197},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":198},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":199},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":42,"attribute_option_id":200},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":448,"attribute_option_id":1376},{"attribute_id":449,"attribute_option_id":1378}],"allow_backorder":false}],"tags":["earrings","sale","ws","e earring","initial","initial j","v initial","initial charm","earrings men","intial","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","s earring","letter earrings"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CJP":{"id":19,"details_loaded_time":"2025-07-20 06:40:42","sku":"CJP","price":"58.00","name":"Classic Jesus Piece","allow_backorder":0,"erp_id":309,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":19,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":1,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":53,"name":"Skip","skip":true,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":{"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":false},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":false},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":false}},"tags":["necklace","sale","non-custom","ws","charm","charms","cross ne","cross necklace","iced cross pearl choker","saint christopher","cross men","st augustine cross necklace","saint mary","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CJPKIT":{"id":3486,"details_loaded_time":"2025-07-20 08:59:56","sku":"CJPKIT","price":"58.00","name":"Classic Jesus Piece Necklace","allow_backorder":1,"erp_id":1711,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3486,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":647,"name":"Classic Jesus Piece--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2031,"name":"Classic Jesus Piece--Pendant","skip":false,"item":{"id":1712,"name":"Classic Jesus Piece--Pendant","SKU":"CJPpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]],"active_combinations":[{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":647,"attribute_option_id":2031}],"allow_backorder":true}],"tags":["non-custom","charm","charms","cross ne","cross necklace","iced cross pearl choker","saint christopher","cross men","st augustine cross necklace","saint mary","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CJPpen":{"id":3487,"details_loaded_time":"2025-01-15 13:39:01","sku":"CJPpen","price":null,"name":"Classic Jesus Piece--Pendant","allow_backorder":1,"erp_id":1712,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3487,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":54,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":94,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":54,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":true},{"image":null,"stock":110,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":true},{"image":null,"stock":61,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true}],"tags":["necklace","non-custom","charm","charms","cross ne","cross necklace","iced cross pearl choker","saint christopher","cross men","st augustine cross necklace","saint mary","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CKEYCHAIN":{"id":3845,"details_loaded_time":"2025-07-20 06:57:13","sku":"CKEYCHAIN","price":"60.00","name":"Custom Key Chain","allow_backorder":true,"erp_id":1911,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3845,"force_allow_backorder":true,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","custom","accessories","vibeszn market campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLA":{"id":841,"details_loaded_time":"2025-07-20 08:40:30","sku":"CLA","price":"50.00","name":"Chain Link Anklet","allow_backorder":1,"erp_id":536,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":841,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","non-custom","ankle bracelet","toe rings","ank","sanklets","anklet bracelets","anklet clasps","cuban anklet","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLB":{"id":156,"details_loaded_time":"2025-07-20 08:54:23","sku":"CLB","price":"50.00","name":"Chain Link Bracelet","allow_backorder":0,"erp_id":455,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":156,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":53,"name":"Skip","skip":true,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":119,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":167,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["bracelet","topsell","non-custom","men s","brackets","braceletbracelet","bracelet for guys","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLBMEN":{"id":3100,"details_loaded_time":"2025-07-20 07:50:32","sku":"CLBMEN","price":"115.00","name":"Cuban Link Bracelet","allow_backorder":0,"erp_id":1470,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3100,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! ITEM","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLC":{"id":934,"details_loaded_time":"2022-11-22 08:30:41","sku":"CLC","price":"16.80","name":"Clay Clip","allow_backorder":0,"erp_id":619,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":934,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":490,"name":"Acrylic","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":490}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLCMEN":{"id":3101,"details_loaded_time":"2025-07-20 07:50:27","sku":"CLCMEN","price":"149.00","name":"Cuban Link Chain","allow_backorder":1,"erp_id":1463,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3101,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLN":{"id":660,"details_loaded_time":"2025-07-20 08:50:41","sku":"CLN","price":"55.00","name":"Chunky Link Necklace","allow_backorder":0,"erp_id":468,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":660,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null,"weight":170}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","silver","men","mens","men s","men chains","men necklace","mens chains","mens necklace","mens chain","for men","men jewelry","mens gold chains","mens jewelry","necklace for him","gold plated chain mens","gold chain men","chains for men","chain gold men","mans necklace","sliver necklaces","sliver","link choker","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","chunky charm necklace","items_mobile_app","men s chains","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLR":{"id":15,"details_loaded_time":"2025-07-20 08:57:07","sku":"CLR","price":"55.00","name":"Chain Link Ring","allow_backorder":0,"erp_id":305,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":15,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":155,"name":"Black","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","topsell","non-custom","silver","men","mens","men s","men chains","mens rings","men necklace","mens chains","mens necklace","mens chain","men chain","men rings","for men","men jewelry","men ring","mens gold chains","mens jewelry","necklace for him","gold plated chain mens","gold chain men","chains for men","chain gold men","rings for men silver","mans necklace","ring for women","tumb rings","thumb rings","sliver necklaces","sliver","diamond link ring","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","items_mobile_app","men s rings","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CLS":{"id":931,"details_loaded_time":"2024-05-09 19:20:43","sku":"CLS","price":"17.50","name":"Camel Leather Scrunchie","allow_backorder":0,"erp_id":614,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":931,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":489,"name":"Leather","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":489}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CMR":{"id":1289,"details_loaded_time":"2024-05-10 12:39:34","sku":"CMR","price":"42.00","name":"Checkmate Ring","allow_backorder":0,"erp_id":812,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1289,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Item Discontinued","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ring for women","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CNAN":{"id":16,"details_loaded_time":"2020-06-17 20:39:36","sku":"CNAN","price":"69.00","name":"Chella Nameplate Necklace","allow_backorder":true,"erp_id":306,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":16,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"alphanumeric","free_chars":15,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CNB":{"id":35,"details_loaded_time":"2025-07-20 06:36:24","sku":"CNB","price":"70.00","name":"Custom Name Bracelet","allow_backorder":true,"erp_id":326,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":35,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":241,"name":"6\"","skip":false,"parent_attribute":null,"weight":60}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"15":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":2},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"20":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"21":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"22":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"23":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":2,"attribute_option_id":3},{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":241},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["bracelet","custom","brackets","braceletbracelet","bracelet for guys","c initial brackets","curbchain nameplate","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","custom used bracelet","customize bracelet cubana","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CNE":{"id":36,"details_loaded_time":"2025-07-20 06:36:19","sku":"CNE","price":"70.00","name":"Custom Name Earrings","allow_backorder":true,"erp_id":327,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":36,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","earrings","e earring","earrings men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","s earring","letter earrings","nameplate hoops","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CNH2":{"id":482,"details_loaded_time":"2025-07-20 08:52:21","sku":"CNH2","price":"70.00","name":"Custom Name Hoops","allow_backorder":true,"erp_id":464,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":482,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":375,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":41,"name":"Size","quantity":1,"description":null,"type":"list","options":[{"id":171,"name":"Small","skip":false,"parent_attribute":null},{"id":172,"name":"Medium","skip":false,"parent_attribute":null},{"id":173,"name":"Large","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":375},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","earrings","multi name nameplate","delores name charm","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","nameplate hoops","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CNN":{"id":34,"details_loaded_time":"2025-07-20 06:36:30","sku":"CNN","price":"80.00","name":"Custom Language Nameplate","allow_backorder":true,"erp_id":325,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":34,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":39,"name":"Translation text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"alphanumeric","free_chars":15,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":43,"name":"Language","quantity":1,"description":null,"type":"list","options":[{"id":202,"name":"Armenian","skip":false,"parent_attribute":null},{"id":203,"name":"Arabic","skip":false,"parent_attribute":null},{"id":204,"name":"Bengali","skip":false,"parent_attribute":null},{"id":205,"name":"Chinese","skip":false,"parent_attribute":null},{"id":206,"name":"Greek","skip":false,"parent_attribute":null},{"id":207,"name":"Hebrew","skip":false,"parent_attribute":null},{"id":208,"name":"Hindi","skip":false,"parent_attribute":null},{"id":450,"name":"Japanese","skip":false,"parent_attribute":null},{"id":209,"name":"Korean","skip":false,"parent_attribute":null},{"id":210,"name":"Russian","skip":false,"parent_attribute":null},{"id":211,"name":"Other","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"15":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"20":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"21":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"22":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"23":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"24":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"25":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"26":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"27":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"28":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"29":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"30":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"31":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"32":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"33":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"34":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"35":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"36":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"37":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"38":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"39":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"40":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"41":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"42":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"43":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"44":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"45":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"46":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"47":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"48":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"49":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"50":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"51":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"52":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"53":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"54":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"55":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"56":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"57":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"58":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"59":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"60":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"61":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"62":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"63":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"64":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"65":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"66":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"67":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"68":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"69":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"70":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":202},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"71":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":203},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"72":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":204},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"73":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":205},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"74":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":206},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"75":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":207},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"76":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":208},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"77":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":209},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"78":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":210},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"79":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":211},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"120":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"121":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"122":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"123":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"124":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"125":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"126":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"127":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":43,"attribute_option_id":450},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["necklace","custom","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CNN2":{"id":20,"details_loaded_time":"2025-07-20 06:40:32","sku":"CNN2","price":"80.00","name":"Classic Nameplate Necklace","allow_backorder":true,"erp_id":310,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":20,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","gucci","daniel","gabriel neckless","nathan","alessandra","15 inch sterling silver name necklace","dominique","addison","nameplate essential necklace","delores name necklace","delores name charm","sports","yasmine","malena","bikini","swimwear","cayden","andrew","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","18k gold plated neckless alex","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","chiefs","number18","baseball","33 necklace","1981","1944 necklace","nike chain","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"COCONECK":{"id":3837,"details_loaded_time":"2025-07-20 06:57:42","sku":"COCONECK","price":"58.00","name":"The Coco Beaded Necklace","allow_backorder":1,"erp_id":1906,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3837,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":2080,"name":"Stainless Steel\/Beaded","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":2080}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"COENN":{"id":21,"details_loaded_time":"2025-07-20 09:01:41","sku":"COENN","price":"80.00","name":"Classic Old English Nameplate Necklace","allow_backorder":true,"erp_id":311,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":21,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["necklace","custom","topsell","silver","dior","dior necklace","chanel","euphoria","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","gucci","astrology","gemini necklace","aries necklace","leo necklace","capricorn af","horoscope pendant necklace","horroscope pendant necklace","pisceszodiac","gemini moon","aquarius necklace","taurus necklace","cancer necklace","virgo necklace","libra necklace","scorpio necklace","sagittarius necklace","capricorn necklace","pisces necklace","wedding","daniel","best sellers","gabriel neckless","old english nameplate mary","nathan","alessandra","15 inch sterling silver name necklace","dominique","addison","top seller","nameplate essential necklace","best seller","delores name necklace","delores name charm","sliver","yasmine","malena","bikini","swimwear","cayden","savannah","andrew","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","18k gold plated neckless alex","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","chiefs","leo season","cursive name necklace","nike chain","name neclace","items_mobile_app","los angeles","missouri tigers","don't notify"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CONSTUD":{"id":3418,"details_loaded_time":"2024-05-01 16:13:36","sku":"CONSTUD","price":"50.00","name":"Constellation Stud","allow_backorder":0,"erp_id":1632,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3418,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["new","earrings","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CPN":{"id":22,"details_loaded_time":"2020-12-21 04:34:27","sku":"CPN","price":"29.00","name":"Coin Pendant Necklace","allow_backorder":0,"erp_id":312,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":22,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":false},{"image":null,"stock":1,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":false}],"tags":["necklace","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CPNMEN":{"id":3093,"details_loaded_time":"2025-07-20 07:52:23","sku":"CPNMEN","price":"110.00","name":"Cross Pendant Necklace","allow_backorder":0,"erp_id":1404,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3093,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220},{"id":250,"name":"24\"","skip":false,"parent_attribute":null,"weight":240}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"9.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":250},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"9.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":250},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CRCHARM":{"id":3741,"details_loaded_time":"2025-07-20 07:05:26","sku":"CRCHARM","price":"18.00","name":"Crystal Rainbow Charm","allow_backorder":1,"erp_id":1870,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3741,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CREARSET":{"id":3433,"details_loaded_time":"2024-05-14 14:33:57","sku":"CREARSET","price":"125.00","name":"Crystal Earring Set","allow_backorder":1,"erp_id":1654,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3433,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":620,"name":"Crystal Heart Huggies","quantity":1,"description":null,"type":"item","options":[{"id":1954,"name":"Crystal Heart Huggies","skip":false,"item":{"id":314,"name":"Crystal Heart Huggies","SKU":"CHH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":607,"name":"Crystal Gem Huggie","quantity":1,"description":null,"type":"item","options":[{"id":1925,"name":"Crystal Gem Huggie","skip":false,"item":{"id":1424,"name":"Crystal Gem Huggie","SKU":"CGHE"},"attributes_per_every_item":[{"id":485,"name":"Stone Color","quantity":1,"description":null,"type":"List","options":[{"id":1470,"name":"Crystal","skip":false,"parent_attribute":null},{"id":1471,"name":"Emerald","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":485,"attribute_option_id":1470}],[{"attribute_id":485,"attribute_option_id":1471}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":485,"attribute_option_id":1470}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":485,"attribute_option_id":1471}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":112,"name":"Simple Stack Huggies","quantity":1,"description":null,"type":"item","options":[{"id":436,"name":"Simple Stack Huggies","skip":false,"item":{"id":507,"name":"Simple Stack Huggies","SKU":"SSH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":112,"attribute_option_id":436},{"attribute_id":607,"attribute_option_id":1925},{"attribute_id":620,"attribute_option_id":1954}],"allow_backorder":true}],"tags":["new","earrings","set","sale","non-custom","ws","giftcol"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CRING":{"id":3522,"details_loaded_time":"2025-07-20 07:26:28","sku":"CRING","price":"60.00","name":"Cecilia Ring","allow_backorder":1,"erp_id":1750,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3522,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","mens","mens rings","men rings","men ring","top seller","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","men s rings","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CRMT":{"id":3023,"details_loaded_time":"2025-07-20 07:58:07","sku":"CRMT","price":"18.00","name":"Chained Rose medium tray","allow_backorder":0,"erp_id":1411,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3023,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":1456,"name":"Pink with chains and roses","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1456}],"allow_backorder":false}],"tags":["non-custom","gg x vs","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CRPARC":{"id":2191,"details_loaded_time":"2025-03-03 15:37:25","sku":"CRPARC","price":"65.00","name":"Crystal Paris Chain","allow_backorder":0,"erp_id":1259,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2191,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","necklace with a gem","tarnish free","fall","paris","girls night","girls night collection","girls night out","items_mobile_app","paris choker","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CRR":{"id":37,"details_loaded_time":"2025-07-20 06:36:14","sku":"CRR","price":"82.00","name":"Custom Ring","allow_backorder":true,"erp_id":328,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":37,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"15":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"24":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"25":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"26":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"27":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["ring","custom","topsell","birth year","birthyear","ring for women","14k gold","delores name charm","l ring","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CRSR":{"id":25,"details_loaded_time":"2025-07-20 06:40:07","sku":"CRSR","price":"48.00","name":"Crystal Ring","allow_backorder":0,"erp_id":316,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":25,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}},"tags":["sale","non-custom","ws","pink planet","waterproof","baby pink bubble clip","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CRYHANDC":{"id":3835,"details_loaded_time":"2025-07-20 06:59:08","sku":"CRYHANDC","price":"60.00","name":"Crystal Hand Chain","allow_backorder":1,"erp_id":1904,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3835,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CSN":{"id":155,"details_loaded_time":"2025-07-20 08:54:28","sku":"CSN","price":"60.00","name":"Custom Shoe Nameplates","allow_backorder":true,"erp_id":454,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":155,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":109,"name":"word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":8,"required":true,"type":"alphanumeric","free_chars":8,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":110,"name":"Word2","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":8,"required":true,"type":"alphanumeric","free_chars":8,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","accessories","nike","nike shorts","air force","cross tag necklace","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","shoe tagger","nike chain","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CSRING":{"id":3889,"details_loaded_time":"2025-07-20 06:49:35","sku":"CSRING","price":"72.00","name":"Curved Stacking Ring Set","allow_backorder":1,"erp_id":1944,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3889,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":true}],"tags":["ring","new","set","topsell","non-custom","silver","silver","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CSRMEN":{"id":3094,"details_loaded_time":"2025-07-20 07:52:17","sku":"CSRMEN","price":"70.00","name":"Classic Signet Ring","allow_backorder":1,"erp_id":1468,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3094,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":155,"name":"Black","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null},{"id":792,"name":"11","skip":false,"parent_attribute":null},{"id":793,"name":"12","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":792},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":793},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":792},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":793},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":792},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":793},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","non-custom","mens rings","mens jewelry","rings for men silver","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CSSET":{"id":3502,"details_loaded_time":"2025-07-20 07:30:22","sku":"CSSET","price":"140.00","name":"C Suite Set","allow_backorder":1,"erp_id":1731,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3502,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":653,"name":"Sculpted Earrings","quantity":1,"description":null,"type":"item","options":[{"id":2044,"name":"Sculpted Earrings","skip":false,"item":{"id":1721,"name":"Sculpted Earrings","SKU":"SEAR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":654,"name":"The Bone Chain","quantity":1,"description":null,"type":"item","options":[{"id":2046,"name":"The Bone Chain","skip":false,"item":{"id":1723,"name":"The Bone Chain","SKU":"TBCNECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":655,"name":"Business Expense","quantity":1,"description":null,"type":"item","options":[{"id":2048,"name":"Business Expense","skip":false,"item":{"id":1724,"name":"Business Expense","SKU":"BEBRACE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":653,"attribute_option_id":2044},{"attribute_id":654,"attribute_option_id":2046},{"attribute_id":655,"attribute_option_id":2048}],"allow_backorder":true}],"tags":["new","set","non-custom","working woman campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CSTA":{"id":38,"details_loaded_time":"2025-07-20 06:36:05","sku":"CSTA","price":"60.00","name":"Custom Shoe Tags","allow_backorder":true,"erp_id":329,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":38,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":155,"name":"Black","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null},{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":31,"attribute_option_id":213},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["custom","accessories","nike","nike shorts","air force","cross tag necklace","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","shoe tagger","nike chain","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CTCN":{"id":2659,"details_loaded_time":"2025-07-20 08:02:05","sku":"CTCN","price":"75.00","name":"Classic Tennis Chain Necklace","allow_backorder":0,"erp_id":1322,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2659,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","silver","silver","tennis chain","tennis necklace","mens diamond chain","iced curban","14k gold","sliver necklaces","sliver","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","rhinestone","winter","winter collection","off duty","offduty","off duty collection","gold","tennis","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CTN":{"id":23,"details_loaded_time":"2022-09-15 15:58:37","sku":"CTN","price":"30.24","name":"Cross Tag Necklace","allow_backorder":0,"erp_id":313,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":23,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null,"weight":170},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CTNpen":{"id":860,"details_loaded_time":"2021-04-09 12:30:32","sku":"CTNpen","price":"26.00","name":"Cross Tag Necklace--Pendant","allow_backorder":1,"erp_id":547,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":860,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CULR":{"id":1143,"details_loaded_time":"2025-07-20 08:24:36","sku":"CULR","price":"55.00","name":"Cuban Link Ring","allow_backorder":0,"erp_id":737,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1143,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","topsell","non-custom","ring for women","best sellers","cuban mariner","top seller","diamond link ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CUPC":{"id":3743,"details_loaded_time":"2025-07-20 07:05:19","sku":"CUPC","price":"18.00","name":"Cupid Charm","allow_backorder":1,"erp_id":1872,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3743,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CUSTOMBLOCKBRACE":{"id":3842,"details_loaded_time":"2025-07-20 06:57:22","sku":"CUSTOMBLOCKBRACE","price":"70.00","name":"Custom Block Name Bracelet","allow_backorder":true,"erp_id":1909,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3842,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":734,"name":"Capital Letters Only Max 10","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":10,"required":true,"type":"only_text","free_chars":10,"addtional_price_per_char":null,"special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","custom","don't notify","vibeszn market campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CUSTOMCHARMBRACE":{"id":3839,"details_loaded_time":"2025-07-20 06:57:32","sku":"CUSTOMCHARMBRACE","price":"99.00","name":"Custom Charm Bracelet","allow_backorder":1,"erp_id":1908,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3839,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2370}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":731,"name":"Choose Your Bracelet Chain","quantity":1,"description":null,"type":"item","options":[{"id":2368,"name":"Choose Your Bracelet","skip":false,"item":{"id":1907,"name":"Choose Your Bracelet","SKU":"CHOOSEBRACE"},"attributes_per_every_item":[{"id":732,"name":"Choose Your Bracelet","quantity":1,"description":null,"type":"List","options":[{"id":2370,"name":"Elevated Chain Bracelet","skip":false,"parent_attribute":null},{"id":2371,"name":"Paperclip Chain Bracelet","skip":false,"parent_attribute":null},{"id":2372,"name":"Rolo Chain Bracelet","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":241,"name":"6\"","skip":false,"parent_attribute":null},{"id":919,"name":"7\"","skip":false,"parent_attribute":null},{"id":920,"name":"8\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2370}],[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2370}],[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2370}],[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2371}],[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2371}],[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2371}],[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2372}],[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2372}],[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2372}]],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2370}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2370}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2370}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2371}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2371}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2371}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":241},{"attribute_id":732,"attribute_option_id":2372}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":919},{"attribute_id":732,"attribute_option_id":2372}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":920},{"attribute_id":732,"attribute_option_id":2372}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":681,"name":"Gem Charm","quantity":1,"description":null,"type":"item","options":[{"id":2164,"name":"Gem Charm","skip":false,"item":{"id":1811,"name":"Gem Charm","SKU":"GEMC"},"attributes_per_every_item":[{"id":680,"name":"Gem Charm","quantity":1,"description":null,"type":"List","options":[{"id":2151,"name":"Garnet","skip":false,"parent_attribute":null},{"id":2152,"name":"Amethyst","skip":false,"parent_attribute":null},{"id":2153,"name":"Blue","skip":false,"parent_attribute":null},{"id":2154,"name":"Crystal","skip":false,"parent_attribute":null},{"id":2155,"name":"Emerald","skip":false,"parent_attribute":null},{"id":2156,"name":"Lavender","skip":false,"parent_attribute":null},{"id":2157,"name":"Ruby","skip":false,"parent_attribute":null},{"id":2158,"name":"Green","skip":false,"parent_attribute":null},{"id":2159,"name":"Cobalt","skip":false,"parent_attribute":null},{"id":2160,"name":"Pink","skip":false,"parent_attribute":null},{"id":2161,"name":"Champagne","skip":false,"parent_attribute":null},{"id":2162,"name":"Sky","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":680,"attribute_option_id":2151}],[{"attribute_id":680,"attribute_option_id":2152}],[{"attribute_id":680,"attribute_option_id":2153}],[{"attribute_id":680,"attribute_option_id":2154}],[{"attribute_id":680,"attribute_option_id":2155}],[{"attribute_id":680,"attribute_option_id":2156}],[{"attribute_id":680,"attribute_option_id":2157}],[{"attribute_id":680,"attribute_option_id":2158}],[{"attribute_id":680,"attribute_option_id":2159}],[{"attribute_id":680,"attribute_option_id":2160}],[{"attribute_id":680,"attribute_option_id":2161}],[{"attribute_id":680,"attribute_option_id":2162}]],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2151}]},{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2152}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2153}]},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2154}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2155}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2156}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2157}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2158}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2159}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2160}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2161}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2162}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":689,"name":"Initial Charm","quantity":1,"description":null,"type":"item","options":[{"id":2212,"name":"Initial Charm","skip":false,"item":{"id":1830,"name":"Charm Letters","SKU":"CHARMLETTERS"},"attributes_per_every_item":[{"id":690,"name":"Charm Letters","quantity":1,"description":null,"type":"List","options":[{"id":2214,"name":"A","skip":false,"parent_attribute":null},{"id":2215,"name":"B","skip":false,"parent_attribute":null},{"id":2216,"name":"C","skip":false,"parent_attribute":null},{"id":2217,"name":"D","skip":false,"parent_attribute":null},{"id":2218,"name":"E","skip":false,"parent_attribute":null},{"id":2219,"name":"F","skip":false,"parent_attribute":null},{"id":2220,"name":"G","skip":false,"parent_attribute":null},{"id":2221,"name":"H","skip":false,"parent_attribute":null},{"id":2222,"name":"I","skip":false,"parent_attribute":null},{"id":2223,"name":"J","skip":false,"parent_attribute":null},{"id":2224,"name":"K","skip":false,"parent_attribute":null},{"id":2225,"name":"L","skip":false,"parent_attribute":null},{"id":2226,"name":"M","skip":false,"parent_attribute":null},{"id":2227,"name":"N","skip":false,"parent_attribute":null},{"id":2228,"name":"O","skip":false,"parent_attribute":null},{"id":2229,"name":"P","skip":false,"parent_attribute":null},{"id":2230,"name":"Q","skip":false,"parent_attribute":null},{"id":2231,"name":"R","skip":false,"parent_attribute":null},{"id":2232,"name":"S","skip":false,"parent_attribute":null},{"id":2233,"name":"T","skip":false,"parent_attribute":null},{"id":2234,"name":"U","skip":false,"parent_attribute":null},{"id":2235,"name":"V","skip":false,"parent_attribute":null},{"id":2236,"name":"W","skip":false,"parent_attribute":null},{"id":2237,"name":"X","skip":false,"parent_attribute":null},{"id":2238,"name":"Y","skip":false,"parent_attribute":null},{"id":2239,"name":"Z","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}]],"active_combinations":[{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":694,"name":"Select Charm 1","quantity":1,"description":null,"type":"item","options":[{"id":2257,"name":"Select Charm","skip":false,"item":{"id":1831,"name":"Charm 1","SKU":"CHARM1"},"attributes_per_every_item":[{"id":678,"name":"Select Charm","quantity":1,"description":null,"type":"List","options":[{"id":2140,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2136,"name":"Angel Baby charm","skip":false,"parent_attribute":null},{"id":2144,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2141,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2133,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2143,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2139,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2135,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2132,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2134,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2138,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2142,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2145,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2131,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2137,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2329,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2330,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2331,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2332,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2333,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2334,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2335,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2336,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2337,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2338,"name":"Ace Of Hearts Charm","skip":false,"parent_attribute":null},{"id":2339,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2340,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2341,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2342,"name":"Match Charm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":678,"attribute_option_id":2140}],[{"attribute_id":678,"attribute_option_id":2136}],[{"attribute_id":678,"attribute_option_id":2144}],[{"attribute_id":678,"attribute_option_id":2141}],[{"attribute_id":678,"attribute_option_id":2133}],[{"attribute_id":678,"attribute_option_id":2143}],[{"attribute_id":678,"attribute_option_id":2139}],[{"attribute_id":678,"attribute_option_id":2135}],[{"attribute_id":678,"attribute_option_id":2132}],[{"attribute_id":678,"attribute_option_id":2134}],[{"attribute_id":678,"attribute_option_id":2138}],[{"attribute_id":678,"attribute_option_id":2142}],[{"attribute_id":678,"attribute_option_id":2145}],[{"attribute_id":678,"attribute_option_id":2131}],[{"attribute_id":678,"attribute_option_id":2137}],[{"attribute_id":678,"attribute_option_id":2329}],[{"attribute_id":678,"attribute_option_id":2330}],[{"attribute_id":678,"attribute_option_id":2331}],[{"attribute_id":678,"attribute_option_id":2332}],[{"attribute_id":678,"attribute_option_id":2333}],[{"attribute_id":678,"attribute_option_id":2334}],[{"attribute_id":678,"attribute_option_id":2335}],[{"attribute_id":678,"attribute_option_id":2336}],[{"attribute_id":678,"attribute_option_id":2337}],[{"attribute_id":678,"attribute_option_id":2338}],[{"attribute_id":678,"attribute_option_id":2339}],[{"attribute_id":678,"attribute_option_id":2340}],[{"attribute_id":678,"attribute_option_id":2341}],[{"attribute_id":678,"attribute_option_id":2342}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2140}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2136}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2144}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2141}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2133}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2143}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2139}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2135}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2132}]},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2134}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2138}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2142}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2145}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2131}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2137}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2329}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2330}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2331}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2332}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2333}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2334}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2335}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2336}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2337}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2338}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2339}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2340}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2341}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2342}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":695,"name":"Select Charm 2","quantity":1,"description":null,"type":"item","options":[{"id":2259,"name":"Select Charm","skip":false,"item":{"id":1832,"name":"Charm 2","SKU":"CHARM2"},"attributes_per_every_item":[{"id":688,"name":"Select Charm","quantity":1,"description":null,"type":"List","options":[{"id":2204,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2200,"name":"Angel Baby Charm","skip":false,"parent_attribute":null},{"id":2208,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2205,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2197,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2195,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2196,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2207,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2203,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2199,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2198,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2202,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2206,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2209,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2201,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2210,"name":"Initial Charm","skip":false,"parent_attribute":null},{"id":2343,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2344,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2345,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2346,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2347,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2348,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2349,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2350,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2351,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2352,"name":"Ace of Hearts Charm","skip":false,"parent_attribute":null},{"id":2353,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2354,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2355,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2356,"name":"Match Charm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":688,"attribute_option_id":2195}],[{"attribute_id":688,"attribute_option_id":2196}],[{"attribute_id":688,"attribute_option_id":2197}],[{"attribute_id":688,"attribute_option_id":2198}],[{"attribute_id":688,"attribute_option_id":2199}],[{"attribute_id":688,"attribute_option_id":2200}],[{"attribute_id":688,"attribute_option_id":2201}],[{"attribute_id":688,"attribute_option_id":2202}],[{"attribute_id":688,"attribute_option_id":2203}],[{"attribute_id":688,"attribute_option_id":2204}],[{"attribute_id":688,"attribute_option_id":2205}],[{"attribute_id":688,"attribute_option_id":2206}],[{"attribute_id":688,"attribute_option_id":2207}],[{"attribute_id":688,"attribute_option_id":2208}],[{"attribute_id":688,"attribute_option_id":2209}],[{"attribute_id":688,"attribute_option_id":2343}],[{"attribute_id":688,"attribute_option_id":2344}],[{"attribute_id":688,"attribute_option_id":2345}],[{"attribute_id":688,"attribute_option_id":2346}],[{"attribute_id":688,"attribute_option_id":2347}],[{"attribute_id":688,"attribute_option_id":2348}],[{"attribute_id":688,"attribute_option_id":2349}],[{"attribute_id":688,"attribute_option_id":2350}],[{"attribute_id":688,"attribute_option_id":2351}],[{"attribute_id":688,"attribute_option_id":2352}],[{"attribute_id":688,"attribute_option_id":2353}],[{"attribute_id":688,"attribute_option_id":2354}],[{"attribute_id":688,"attribute_option_id":2355}],[{"attribute_id":688,"attribute_option_id":2356}]],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2195}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2196}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2197}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2198}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2199}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2200}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2201}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2202}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2203}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2204}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2205}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2206}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2207}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2208}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2209}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2210}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2343}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2344}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2345}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2346}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2347}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2348}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2349}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2350}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2351}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2352}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2353}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2354}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2355}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2356}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":733,"name":"Select Charm 3","quantity":1,"description":null,"type":"item","options":[{"id":2374,"name":"Select Charm","skip":false,"item":{"id":1831,"name":"Charm 1","SKU":"CHARM1"},"attributes_per_every_item":[{"id":678,"name":"Select Charm","quantity":1,"description":null,"type":"List","options":[{"id":2140,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2136,"name":"Angel Baby charm","skip":false,"parent_attribute":null},{"id":2144,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2141,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2133,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2143,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2139,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2135,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2132,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2134,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2138,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2142,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2145,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2131,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2137,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2329,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2330,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2331,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2332,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2333,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2334,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2335,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2336,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2337,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2338,"name":"Ace Of Hearts Charm","skip":false,"parent_attribute":null},{"id":2339,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2340,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2341,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2342,"name":"Match Charm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":678,"attribute_option_id":2140}],[{"attribute_id":678,"attribute_option_id":2136}],[{"attribute_id":678,"attribute_option_id":2144}],[{"attribute_id":678,"attribute_option_id":2141}],[{"attribute_id":678,"attribute_option_id":2133}],[{"attribute_id":678,"attribute_option_id":2143}],[{"attribute_id":678,"attribute_option_id":2139}],[{"attribute_id":678,"attribute_option_id":2135}],[{"attribute_id":678,"attribute_option_id":2132}],[{"attribute_id":678,"attribute_option_id":2134}],[{"attribute_id":678,"attribute_option_id":2138}],[{"attribute_id":678,"attribute_option_id":2142}],[{"attribute_id":678,"attribute_option_id":2145}],[{"attribute_id":678,"attribute_option_id":2131}],[{"attribute_id":678,"attribute_option_id":2137}],[{"attribute_id":678,"attribute_option_id":2329}],[{"attribute_id":678,"attribute_option_id":2330}],[{"attribute_id":678,"attribute_option_id":2331}],[{"attribute_id":678,"attribute_option_id":2332}],[{"attribute_id":678,"attribute_option_id":2333}],[{"attribute_id":678,"attribute_option_id":2334}],[{"attribute_id":678,"attribute_option_id":2335}],[{"attribute_id":678,"attribute_option_id":2336}],[{"attribute_id":678,"attribute_option_id":2337}],[{"attribute_id":678,"attribute_option_id":2338}],[{"attribute_id":678,"attribute_option_id":2339}],[{"attribute_id":678,"attribute_option_id":2340}],[{"attribute_id":678,"attribute_option_id":2341}],[{"attribute_id":678,"attribute_option_id":2342}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2140}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2136}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2144}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2141}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2133}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2143}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2139}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2135}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2132}]},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2134}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2138}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2142}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2145}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2131}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2137}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2329}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2330}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2331}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2332}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2333}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2334}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2335}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2336}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2337}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2338}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2339}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2340}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2341}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2342}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":681,"attribute_option_id":2164},{"attribute_id":689,"attribute_option_id":2212},{"attribute_id":694,"attribute_option_id":2257},{"attribute_id":695,"attribute_option_id":2259},{"attribute_id":731,"attribute_option_id":2368},{"attribute_id":733,"attribute_option_id":2374}],"allow_backorder":true}],"tags":["bracelet","new","custom","non-custom","top seller","vibeszn market campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"CUSTOMMULTIBLOCKNAME":{"id":3843,"details_loaded_time":"2025-07-20 06:57:18","sku":"CUSTOMMULTIBLOCKNAME","price":"75.00","name":"Custom Multi-Block Name Bracelet","allow_backorder":true,"erp_id":1910,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3843,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":734,"name":"Capital Letters Only Max 10","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":10,"required":true,"type":"only_text","free_chars":10,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":735,"name":"Capital Letters Only Max 10","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":10,"required":true,"type":"only_text","free_chars":10,"addtional_price_per_char":null,"special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","custom","don't notify","vibeszn market campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DBIBRACE":{"id":3853,"details_loaded_time":"2025-07-20 06:55:28","sku":"DBIBRACE","price":"62.00","name":"Dainty Bubble Initial Bracelet","allow_backorder":1,"erp_id":1918,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3853,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DBINECK":{"id":3854,"details_loaded_time":"2025-07-20 06:55:24","sku":"DBINECK","price":"65.00","name":"Dainty Bubble Initial Necklace","allow_backorder":1,"erp_id":1917,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3854,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DBLPN":{"id":3442,"details_loaded_time":"2025-07-20 07:36:12","sku":"DBLPN","price":"65.00","name":"Double Block Letter Necklace","allow_backorder":1,"erp_id":1699,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3442,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":630,"name":"Block Letter Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1997,"name":"Block Letter Pendant","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","SKU":"BLKLNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":631,"name":"Block Letter Pendant 2","quantity":1,"description":null,"type":"item","options":[{"id":2001,"name":"Block Letter Pendant 2","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","SKU":"BLKLNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":585,"attribute_option_id":1884},{"attribute_id":630,"attribute_option_id":1997},{"attribute_id":631,"attribute_option_id":2001}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","silver","charm","charms","silver","m necklace","j necklace","e necklaces","initial necklace","initial","s necklace","j pendant","b necklace","initial j","c necklace","v initial","k necklace","b initial necklace","t letter chain","j chain","gold n necklace","letter j necklace","initial charm","w necklace","letter d necklace","best sellers","15 inch sterling silver name necklace","sterling silver necklaces","best seller","r necklace","sliver necklaces","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","water proof","leo season","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DCCB":{"id":3630,"details_loaded_time":"2025-07-20 07:18:32","sku":"DCCB","price":"50.00","name":"Dainty Curb Chain Bracelet","allow_backorder":1,"erp_id":1798,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3630,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DCGRILLS":{"id":3242,"details_loaded_time":"2025-06-04 18:41:12","sku":"DCGRILLS","price":"40.00","name":"Diamond Cut","allow_backorder":1,"erp_id":1555,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3242,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":519,"name":"VibeSzn Grill Impression Mold","quantity":1,"description":null,"type":"item","options":[{"id":1562,"name":"VibeSzn Grill Impression Mold","skip":false,"item":{"id":1508,"name":"VibeSzn Grill Impression Mold","SKU":"VGIM"},"attributes_per_every_item":[],"item_option_combinations":[],"active_combinations":[],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":528,"name":"VibeSzn Diamond Cut Grill","quantity":1,"description":null,"type":"item","options":[{"id":1683,"name":"VibeSzn Diamond Cut Grill","skip":false,"item":{"id":1561,"name":"VibeSzn Diamond Cut Grill","SKU":"VSDCGRILL"},"attributes_per_every_item":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"List","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}]},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"List","options":[{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}]],"active_combinations":[{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":519,"attribute_option_id":1562},{"attribute_id":528,"attribute_option_id":1683}],"allow_backorder":true}],"tags":["don't notify","grill","grills","grillz","no discounts allowed"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DDH":{"id":3620,"details_loaded_time":"2025-07-20 07:20:35","sku":"DDH","price":"55.00","name":"Double Down Huggies","allow_backorder":1,"erp_id":1790,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3620,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DFIGAROC":{"id":3698,"details_loaded_time":"2025-07-20 07:11:25","sku":"DFIGAROC","price":"60.00","name":"Dainty Figaro Chain","allow_backorder":1,"erp_id":1858,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3698,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true}],"tags":["non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DHE":{"id":2653,"details_loaded_time":"2025-07-20 08:02:29","sku":"DHE","price":"55.00","name":"Drop Hoops","allow_backorder":0,"erp_id":1316,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2653,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","non-custom","silver","silver","fine thin hoops","earrings sterling","14k gold","sliver","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","winter","winter collection","off duty","offduty","off duty collection","chunky hoops","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DHERCH":{"id":3439,"details_loaded_time":"2025-07-20 07:37:09","sku":"DHERCH","price":"55.00","name":"Dainty Herringbone Chain","allow_backorder":1,"erp_id":1696,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3439,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","best sellers","top seller","best seller","herrington bone chain","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DINE":{"id":1122,"details_loaded_time":"2021-05-31 19:25:47","sku":"DINE","price":"31.67","name":"Dice Necklace","allow_backorder":0,"erp_id":638,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1122,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DLR":{"id":39,"details_loaded_time":"2022-09-15 15:46:27","sku":"DLR","price":"34.30","name":"Diamond Link Ring","allow_backorder":0,"erp_id":331,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":39,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["ring","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DNHN":{"id":40,"details_loaded_time":"2021-02-23 17:44:27","sku":"DNHN","price":"70.00","name":"Double Name Heart Necklace","allow_backorder":true,"erp_id":332,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":40,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":31,"name":"Font","type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":37,"name":"Name","type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":44,"name":"2nd Name","type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DNPN":{"id":2668,"details_loaded_time":"2025-07-20 08:00:04","sku":"DNPN","price":"80.00","name":"Drip Nameplate Necklace","allow_backorder":true,"erp_id":1331,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2668,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"list","options":[{"id":1316,"name":"Curb Chain","skip":false,"parent_attribute":null},{"id":1313,"name":"Figaro","skip":false,"parent_attribute":null},{"id":1314,"name":"Herringbone","skip":false,"parent_attribute":null},{"id":1315,"name":"Regular Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":1317,"name":"HappyOk","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":118,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_text","free_chars":13,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"15":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"32":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"33":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"34":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"35":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"36":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"37":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"38":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"39":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"40":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"41":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"42":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"43":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"44":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"45":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"46":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"47":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1317},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true}},"tags":["necklace","custom","silver","silver","15 inch sterling silver name necklace","14k gold","sliver","curbchain nameplate","name neclace","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DPCE":{"id":1148,"details_loaded_time":"2024-05-07 15:33:09","sku":"DPCE","price":"45.00","name":"Double Pierced Chain Earrings","allow_backorder":0,"erp_id":735,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1148,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DRCN":{"id":834,"details_loaded_time":"2025-07-20 08:42:17","sku":"DRCN","price":"50.00","name":"Delicate Rope Chain Necklace","allow_backorder":0,"erp_id":529,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":834,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","baby chain","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DRIPGRILL":{"id":3238,"details_loaded_time":"2025-06-04 18:41:33","sku":"DRIPGRILL","price":"40.00","name":"Drip Grill","allow_backorder":1,"erp_id":1558,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3238,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":519,"name":"VibeSzn Grill Impression Mold","quantity":1,"description":null,"type":"item","options":[{"id":1562,"name":"VibeSzn Grill Impression Mold","skip":false,"item":{"id":1508,"name":"VibeSzn Grill Impression Mold","SKU":"VGIM"},"attributes_per_every_item":[],"item_option_combinations":[],"active_combinations":[],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":526,"name":"VibeSzn Grill Drip","quantity":1,"description":null,"type":"item","options":[{"id":1681,"name":"VibeSzn Grill Drip and Bar","skip":false,"item":{"id":1556,"name":"VibeSzn Grill Drip","SKU":"VSGRILLDRIP"},"attributes_per_every_item":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"List","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}]},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"List","options":[{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}]],"active_combinations":[{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":519,"attribute_option_id":1562},{"attribute_id":526,"attribute_option_id":1681}],"allow_backorder":true}],"tags":["don't notify","grill","grills","grillz","no discounts allowed","tooth gem"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DSE":{"id":3200,"details_loaded_time":"2025-07-20 07:48:05","sku":"DSE","price":"55.00","name":"Drip Stud Earrings","allow_backorder":1,"erp_id":1486,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3200,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","topsell","non-custom","drip stud","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DSNHC":{"id":2187,"details_loaded_time":"2024-08-05 18:59:53","sku":"DSNHC","price":"55.00","name":"Double Snake Herringbone Chain","allow_backorder":0,"erp_id":1255,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2187,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","men herringbone gold chain","herrington bone chain","tarnish free","fall","girls night","girls night collection","girls night out","items_mobile_app","don't notify"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"DTN":{"id":41,"details_loaded_time":"2020-08-21 22:36:27","sku":"DTN","price":"32.00","name":"Dragon Tag Necklace","allow_backorder":0,"erp_id":333,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":41,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":250,"name":"24\"","skip":false,"parent_attribute":null,"weight":240}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[]}],"active_combinations":[{"image":null,"stock":"1","price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":250}],"allow_backorder":false}],"tags":["necklace","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EBR":{"id":1138,"details_loaded_time":"2025-07-20 08:26:17","sku":"EBR","price":"55.00","name":"Essential Band Ring","allow_backorder":0,"erp_id":716,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1138,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","non-custom","wedding","ring for women","tumb rings","thumb rings","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EBRR":{"id":1139,"details_loaded_time":"2025-07-20 08:26:13","sku":"EBRR","price":"55.00","name":"Essential Braided Ring","allow_backorder":0,"erp_id":717,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1139,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","non-custom","ring for women","tumb rings","thumb rings","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EBRV":{"id":2661,"details_loaded_time":"2025-07-20 08:00:35","sku":"EBRV","price":"60.00","name":"Elevated Band","allow_backorder":0,"erp_id":1324,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2661,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","non-custom","silver","silver","rings for men silver","ring for women","thumb rings","14k gold","diamond link ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","rhinestone","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ECN":{"id":1145,"details_loaded_time":"2025-07-20 08:24:28","sku":"ECN","price":"58.00","name":"Edgy Cross Necklace","allow_backorder":1,"erp_id":732,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1145,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","euphoria","charm","charms","cross ne","cross necklace","silver cross","best sellers","golden diamond cross","cross men","st augustine cross necklace","bikini","crucifix","swimwear","saint benedict coin","waterproof","iced croix pearl necklace","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","big cross","vintage edit","double cross necklace","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ECR":{"id":1308,"details_loaded_time":"2025-07-20 08:12:43","sku":"ECR","price":"40.00","name":"Essential Chain Ring","allow_backorder":0,"erp_id":870,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1308,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK! Discontinued","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"2":{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}},"tags":["ring","sale","non-custom","ws","ring for women","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EDBB":{"id":3075,"details_loaded_time":"2025-07-20 07:54:19","sku":"EDBB","price":"50.00","name":"Everyday Bangle","allow_backorder":1,"erp_id":1445,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3075,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true}],"tags":["bracelet","topsell","non-custom","vintage edit","bangle","bangles","sofia richie","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EDBC":{"id":1943,"details_loaded_time":"2025-07-20 08:55:12","sku":"EDBC","price":"55.00","name":"Everyday Belly Chain","allow_backorder":0,"erp_id":1093,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1943,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":false}],"tags":["accessories","non-custom","bikini","swimwear","gold belly button studs","waist","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","body chain","bellychain","items_mobile_app","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EDBSTACK":{"id":3498,"details_loaded_time":"2025-07-20 07:30:34","sku":"EDBSTACK","price":"120.00","name":"Everyday Bangle Stack","allow_backorder":1,"erp_id":1729,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3498,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":649,"name":"Bangle Stack","quantity":3,"description":null,"type":"item","options":[{"id":2036,"name":"Bangle Stack","skip":false,"item":{"id":1445,"name":"Everyday Bangle","SKU":"EDBB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":649,"attribute_option_id":2036}],"allow_backorder":true}],"tags":["bracelet","non-custom","items_mobile_app","working woman campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EDCHAINGOLD":{"id":3533,"details_loaded_time":"2025-07-20 07:24:27","sku":"EDCHAINGOLD","price":"20.00","name":"Everyday Chain 18K Gold-plated","allow_backorder":0,"erp_id":1707,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3533,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":false}],"tags":["non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EEPN":{"id":42,"details_loaded_time":"2025-07-20 06:34:31","sku":"EEPN","price":"45.00","name":"Evil Eye Pendant Necklace","allow_backorder":0,"erp_id":334,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":42,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false}],"tags":["necklace","topsell","sale","non-custom","ws","bejeweled pendant necklace","bejeweled","bejeweled pendant","eviil","eveil eye","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","evil eye braclets","evil eye bracelet","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EH":{"id":3716,"details_loaded_time":"2025-07-20 07:07:36","sku":"EH","price":"70.00","name":"Empire Hoops","allow_backorder":1,"erp_id":1856,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3716,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":true}],"tags":["new","earrings","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EHEN":{"id":1293,"details_loaded_time":"2023-09-01 17:14:42","sku":"EHEN","price":"58.00","name":"Cocoa Heart Necklace","allow_backorder":0,"erp_id":818,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1293,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","sale","non-custom","ws","coaca heart","cocoa heart","horroscope pendant necklace","cocoa heart neckalce","chocolate","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EHR":{"id":1135,"details_loaded_time":"2025-07-20 08:26:31","sku":"EHR","price":"55.00","name":"Essential Heart Ring","allow_backorder":0,"erp_id":713,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1135,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","non-custom","heart shape diamond ring","ring for women","blue heart ring","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EICLR":{"id":1136,"details_loaded_time":"2025-07-20 08:26:26","sku":"EICLR","price":"48.00","name":"Essential Iced Chain Link Ring","allow_backorder":0,"erp_id":714,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1136,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","non-custom","ws","bejeweled","ring for women","top seller","best seller","bikini","swimwear","diamond link ring","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","crown rings","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ELCH":{"id":3510,"details_loaded_time":"2025-07-20 07:28:38","sku":"ELCH","price":"27.00","name":"Everyday Love Club Hat","allow_backorder":0,"erp_id":1735,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3510,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":1490,"name":"0431 Nvy\/Natrl","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":1490}],"allow_backorder":false}],"tags":["new","accessories","topsell","non-custom","hat","trucker","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ELYH":{"id":3695,"details_loaded_time":"2025-07-20 07:11:40","sku":"ELYH","price":"25.00","name":"Elevated Lucky You Hat","allow_backorder":1,"erp_id":1835,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3695,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":1474,"name":"0311 Blk\/Natl","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":213,"name":"Block","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":150,"name":"Thread Color:","quantity":1,"description":null,"type":"list","options":[{"id":558,"name":"Black","skip":false,"parent_attribute":null},{"id":2266,"name":"Cream","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":31,"attribute_option_id":213},{"attribute_id":150,"attribute_option_id":558},{"attribute_id":486,"attribute_option_id":1474}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":31,"attribute_option_id":213},{"attribute_id":150,"attribute_option_id":2266},{"attribute_id":486,"attribute_option_id":1474}],"allow_backorder":true}],"tags":["new","accessories","hat","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EMSN":{"id":1309,"details_loaded_time":"2025-07-20 08:12:38","sku":"EMSN","price":"58.00","name":"Emerald Stone Necklace","allow_backorder":1,"erp_id":869,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1309,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","non-custom","charm","charms","emerald stone necklace","necklace with a gem","amethyst","emerald gold necklace","green marbled","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","birth stone","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ENDSUMSET":{"id":3534,"details_loaded_time":"2025-07-20 07:24:23","sku":"ENDSUMSET","price":"140.00","name":"Endless Summer Set","allow_backorder":1,"erp_id":1763,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3534,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":669,"name":"Santorini Cross Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2095,"name":"Santorini Cross Pendant","skip":false,"item":{"id":1751,"name":"Santorini Cross Pendant","SKU":"SCP"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":665,"name":"Positano Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2086,"name":"Positano Pendant Necklace","skip":false,"item":{"id":1752,"name":"Positano Pendant","SKU":"POSPENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":670,"name":"Nonna's Earrings","quantity":1,"description":null,"type":"item","options":[{"id":2097,"name":"Nonna's Earrings","skip":false,"item":{"id":1747,"name":"Nonna's Earrings","SKU":"NEAR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":665,"attribute_option_id":2086},{"attribute_id":669,"attribute_option_id":2095},{"attribute_id":670,"attribute_option_id":2097}],"allow_backorder":true}],"tags":["new","set","non-custom","endless summer campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EPB":{"id":3880,"details_loaded_time":"2025-07-20 06:51:35","sku":"EPB","price":"65.00","name":"Elevated Pearl Bracelet","allow_backorder":1,"erp_id":1935,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3880,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1322,"name":"Stainless Steel\/Pearl","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":1322}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ERR":{"id":1137,"details_loaded_time":"2025-07-20 08:26:22","sku":"ERR","price":"55.00","name":"Essential Rope Ring","allow_backorder":0,"erp_id":715,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1137,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","non-custom","ring for women","tumb rings","thumb rings","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ESRNGSET":{"id":3434,"details_loaded_time":"2025-07-20 07:38:11","sku":"ESRNGSET","price":"140.00","name":"Essential Ring Set","allow_backorder":1,"erp_id":1655,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3434,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":621,"name":"Essential Band Ring","quantity":1,"description":null,"type":"item","options":[{"id":1956,"name":"Essential Band Ring","skip":false,"item":{"id":716,"name":"Essential Band Ring","SKU":"EBR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":544,"name":"Essential Rope Ring","quantity":1,"description":null,"type":"item","options":[{"id":1786,"name":"Essential Rope Ring","skip":false,"item":{"id":715,"name":"Essential Rope Ring","SKU":"ERR"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":622,"name":"Simple Stacked Ring","quantity":1,"description":null,"type":"item","options":[{"id":1957,"name":"Simple Stacked Ring","skip":false,"item":{"id":408,"name":"Simple Stacked Ring","SKU":"SSR"},"attributes_per_every_item":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":254,"name":"Sterling Silver","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":254}],[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":254}],[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":254}],[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":254}],[{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":254}],[{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":254}]],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":254}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":254}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":254}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":254}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":254}]},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":254}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":544,"attribute_option_id":1786},{"attribute_id":621,"attribute_option_id":1956},{"attribute_id":622,"attribute_option_id":1957}],"allow_backorder":true}],"tags":["ring","set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"EXEST":{"id":3490,"details_loaded_time":"2025-07-20 07:32:26","sku":"EXEST","price":"60.00","name":"Executive Studs","allow_backorder":1,"erp_id":1715,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3490,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","sale","non-custom","items_mobile_app","working woman campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FAV":{"id":3717,"details_loaded_time":"2025-07-20 07:07:32","sku":"FAV","price":"75.00","name":"5th Avenue Hoops","allow_backorder":1,"erp_id":1857,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3717,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":true}],"tags":["new","earrings","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FBMEN":{"id":3104,"details_loaded_time":"2025-07-20 07:50:13","sku":"FBMEN","price":"89.00","name":"Figaro Bracelet","allow_backorder":1,"erp_id":1462,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3104,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FCHN":{"id":766,"details_loaded_time":"2025-07-20 08:46:07","sku":"FCHN","price":"85.00","name":"Figaro Chain Hanging Nameplate","allow_backorder":true,"erp_id":506,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":766,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true}],"tags":["necklace","custom","topsell","delores name necklace","delores name charm","yasmine","malena","swimwear","cayden","andrew","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","fiagro","18k gold plated neckless alex","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","chunky charm necklace","items_mobile_app","don't notify"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FCHON":{"id":835,"details_loaded_time":"2025-07-20 08:42:13","sku":"FCHON","price":"30.00","name":"Figaro Choker Necklace","allow_backorder":0,"erp_id":530,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":835,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","figaro c","chocked","baby chain","link choker","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FCN":{"id":46,"details_loaded_time":"2024-02-02 14:33:36","sku":"FCN","price":"55.00","name":"Figaro Chain Necklace","allow_backorder":0,"erp_id":338,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":46,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":36,"name":"Style","description":null,"type":"list","options":[{"id":163,"name":"Style 1","skip":false,"parent_attribute":null},{"id":164,"name":"Style 2","skip":false,"parent_attribute":null},{"id":165,"name":"Style 3","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":164},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":165},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","silver","men","mens","men chains","men necklace","mens chains","mens necklace","mens chain","men chain","for men","men jewelry","mens gold chains","mens jewelry","necklace for him","gold plated chain mens","gold chain men","chains for men","chain gold men","mans necklace","mens mini chain","figaro c","best sellers","top seller","best seller","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","items_mobile_app","men s chains"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FCNECK":{"id":3632,"details_loaded_time":"2025-07-20 07:18:22","sku":"FCNECK","price":"95.00","name":"4 Charm Necklace","allow_backorder":1,"erp_id":1828,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3632,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2246}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":683,"name":"Carabiner Chain Type","quantity":1,"description":null,"type":"item","options":[{"id":2171,"name":"Choose Your Carabiner Chain","skip":false,"item":{"id":1802,"name":"Carabiner Chain Type","SKU":"CARANECK"},"attributes_per_every_item":[{"id":692,"name":"Carabiner Chain","quantity":1,"description":null,"type":"List","options":[{"id":2246,"name":"Dainty Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2247,"name":"Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2248,"name":"Dainty Curb Carabiner Chain","skip":false,"parent_attribute":null},{"id":2249,"name":"Curb Carabiner Chain","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":692,"attribute_option_id":2246}],[{"attribute_id":692,"attribute_option_id":2247}],[{"attribute_id":692,"attribute_option_id":2248}],[{"attribute_id":692,"attribute_option_id":2249}]],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2246}]},{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2247}]},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2248}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2249}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":689,"name":"Initial Charm","quantity":1,"description":null,"type":"item","options":[{"id":2212,"name":"Initial Charm","skip":false,"item":{"id":1830,"name":"Charm Letters","SKU":"CHARMLETTERS"},"attributes_per_every_item":[{"id":690,"name":"Charm Letters","quantity":1,"description":null,"type":"List","options":[{"id":2214,"name":"A","skip":false,"parent_attribute":null},{"id":2215,"name":"B","skip":false,"parent_attribute":null},{"id":2216,"name":"C","skip":false,"parent_attribute":null},{"id":2217,"name":"D","skip":false,"parent_attribute":null},{"id":2218,"name":"E","skip":false,"parent_attribute":null},{"id":2219,"name":"F","skip":false,"parent_attribute":null},{"id":2220,"name":"G","skip":false,"parent_attribute":null},{"id":2221,"name":"H","skip":false,"parent_attribute":null},{"id":2222,"name":"I","skip":false,"parent_attribute":null},{"id":2223,"name":"J","skip":false,"parent_attribute":null},{"id":2224,"name":"K","skip":false,"parent_attribute":null},{"id":2225,"name":"L","skip":false,"parent_attribute":null},{"id":2226,"name":"M","skip":false,"parent_attribute":null},{"id":2227,"name":"N","skip":false,"parent_attribute":null},{"id":2228,"name":"O","skip":false,"parent_attribute":null},{"id":2229,"name":"P","skip":false,"parent_attribute":null},{"id":2230,"name":"Q","skip":false,"parent_attribute":null},{"id":2231,"name":"R","skip":false,"parent_attribute":null},{"id":2232,"name":"S","skip":false,"parent_attribute":null},{"id":2233,"name":"T","skip":false,"parent_attribute":null},{"id":2234,"name":"U","skip":false,"parent_attribute":null},{"id":2235,"name":"V","skip":false,"parent_attribute":null},{"id":2236,"name":"W","skip":false,"parent_attribute":null},{"id":2237,"name":"X","skip":false,"parent_attribute":null},{"id":2238,"name":"Y","skip":false,"parent_attribute":null},{"id":2239,"name":"Z","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}]],"active_combinations":[{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":694,"name":"Select Charm 1","quantity":1,"description":null,"type":"item","options":[{"id":2257,"name":"Select Charm","skip":false,"item":{"id":1831,"name":"Charm 1","SKU":"CHARM1"},"attributes_per_every_item":[{"id":678,"name":"Select Charm","quantity":1,"description":null,"type":"List","options":[{"id":2140,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2136,"name":"Angel Baby charm","skip":false,"parent_attribute":null},{"id":2144,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2141,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2133,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2143,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2139,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2135,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2132,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2134,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2138,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2142,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2145,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2131,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2137,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2329,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2330,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2331,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2332,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2333,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2334,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2335,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2336,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2337,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2338,"name":"Ace Of Hearts Charm","skip":false,"parent_attribute":null},{"id":2339,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2340,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2341,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2342,"name":"Match Charm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":678,"attribute_option_id":2140}],[{"attribute_id":678,"attribute_option_id":2136}],[{"attribute_id":678,"attribute_option_id":2144}],[{"attribute_id":678,"attribute_option_id":2141}],[{"attribute_id":678,"attribute_option_id":2133}],[{"attribute_id":678,"attribute_option_id":2143}],[{"attribute_id":678,"attribute_option_id":2139}],[{"attribute_id":678,"attribute_option_id":2135}],[{"attribute_id":678,"attribute_option_id":2132}],[{"attribute_id":678,"attribute_option_id":2134}],[{"attribute_id":678,"attribute_option_id":2138}],[{"attribute_id":678,"attribute_option_id":2142}],[{"attribute_id":678,"attribute_option_id":2145}],[{"attribute_id":678,"attribute_option_id":2131}],[{"attribute_id":678,"attribute_option_id":2137}],[{"attribute_id":678,"attribute_option_id":2329}],[{"attribute_id":678,"attribute_option_id":2330}],[{"attribute_id":678,"attribute_option_id":2331}],[{"attribute_id":678,"attribute_option_id":2332}],[{"attribute_id":678,"attribute_option_id":2333}],[{"attribute_id":678,"attribute_option_id":2334}],[{"attribute_id":678,"attribute_option_id":2335}],[{"attribute_id":678,"attribute_option_id":2336}],[{"attribute_id":678,"attribute_option_id":2337}],[{"attribute_id":678,"attribute_option_id":2338}],[{"attribute_id":678,"attribute_option_id":2339}],[{"attribute_id":678,"attribute_option_id":2340}],[{"attribute_id":678,"attribute_option_id":2341}],[{"attribute_id":678,"attribute_option_id":2342}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2140}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2136}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2144}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2141}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2133}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2143}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2139}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2135}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2132}]},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2134}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2138}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2142}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2145}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2131}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2137}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2329}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2330}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2331}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2332}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2333}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2334}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2335}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2336}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2337}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2338}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2339}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2340}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2341}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2342}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":681,"name":"Gem Charm","quantity":1,"description":null,"type":"item","options":[{"id":2164,"name":"Gem Charm","skip":false,"item":{"id":1811,"name":"Gem Charm","SKU":"GEMC"},"attributes_per_every_item":[{"id":680,"name":"Gem Charm","quantity":1,"description":null,"type":"List","options":[{"id":2151,"name":"Garnet","skip":false,"parent_attribute":null},{"id":2152,"name":"Amethyst","skip":false,"parent_attribute":null},{"id":2153,"name":"Blue","skip":false,"parent_attribute":null},{"id":2154,"name":"Crystal","skip":false,"parent_attribute":null},{"id":2155,"name":"Emerald","skip":false,"parent_attribute":null},{"id":2156,"name":"Lavender","skip":false,"parent_attribute":null},{"id":2157,"name":"Ruby","skip":false,"parent_attribute":null},{"id":2158,"name":"Green","skip":false,"parent_attribute":null},{"id":2159,"name":"Cobalt","skip":false,"parent_attribute":null},{"id":2160,"name":"Pink","skip":false,"parent_attribute":null},{"id":2161,"name":"Champagne","skip":false,"parent_attribute":null},{"id":2162,"name":"Sky","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":680,"attribute_option_id":2151}],[{"attribute_id":680,"attribute_option_id":2152}],[{"attribute_id":680,"attribute_option_id":2153}],[{"attribute_id":680,"attribute_option_id":2154}],[{"attribute_id":680,"attribute_option_id":2155}],[{"attribute_id":680,"attribute_option_id":2156}],[{"attribute_id":680,"attribute_option_id":2157}],[{"attribute_id":680,"attribute_option_id":2158}],[{"attribute_id":680,"attribute_option_id":2159}],[{"attribute_id":680,"attribute_option_id":2160}],[{"attribute_id":680,"attribute_option_id":2161}],[{"attribute_id":680,"attribute_option_id":2162}]],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2151}]},{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2152}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2153}]},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2154}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2155}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2156}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2157}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2158}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2159}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2160}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2161}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2162}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":695,"name":"Select Charm 2","quantity":1,"description":null,"type":"item","options":[{"id":2259,"name":"Select Charm","skip":false,"item":{"id":1832,"name":"Charm 2","SKU":"CHARM2"},"attributes_per_every_item":[{"id":688,"name":"Select Charm","quantity":1,"description":null,"type":"List","options":[{"id":2204,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2200,"name":"Angel Baby Charm","skip":false,"parent_attribute":null},{"id":2208,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2205,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2197,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2195,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2196,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2207,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2203,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2199,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2198,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2202,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2206,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2209,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2201,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2210,"name":"Initial Charm","skip":false,"parent_attribute":null},{"id":2343,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2344,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2345,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2346,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2347,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2348,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2349,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2350,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2351,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2352,"name":"Ace of Hearts Charm","skip":false,"parent_attribute":null},{"id":2353,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2354,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2355,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2356,"name":"Match Charm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":688,"attribute_option_id":2195}],[{"attribute_id":688,"attribute_option_id":2196}],[{"attribute_id":688,"attribute_option_id":2197}],[{"attribute_id":688,"attribute_option_id":2198}],[{"attribute_id":688,"attribute_option_id":2199}],[{"attribute_id":688,"attribute_option_id":2200}],[{"attribute_id":688,"attribute_option_id":2201}],[{"attribute_id":688,"attribute_option_id":2202}],[{"attribute_id":688,"attribute_option_id":2203}],[{"attribute_id":688,"attribute_option_id":2204}],[{"attribute_id":688,"attribute_option_id":2205}],[{"attribute_id":688,"attribute_option_id":2206}],[{"attribute_id":688,"attribute_option_id":2207}],[{"attribute_id":688,"attribute_option_id":2208}],[{"attribute_id":688,"attribute_option_id":2209}],[{"attribute_id":688,"attribute_option_id":2343}],[{"attribute_id":688,"attribute_option_id":2344}],[{"attribute_id":688,"attribute_option_id":2345}],[{"attribute_id":688,"attribute_option_id":2346}],[{"attribute_id":688,"attribute_option_id":2347}],[{"attribute_id":688,"attribute_option_id":2348}],[{"attribute_id":688,"attribute_option_id":2349}],[{"attribute_id":688,"attribute_option_id":2350}],[{"attribute_id":688,"attribute_option_id":2351}],[{"attribute_id":688,"attribute_option_id":2352}],[{"attribute_id":688,"attribute_option_id":2353}],[{"attribute_id":688,"attribute_option_id":2354}],[{"attribute_id":688,"attribute_option_id":2355}],[{"attribute_id":688,"attribute_option_id":2356}]],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2195}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2196}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2197}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2198}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2199}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2200}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2201}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2202}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2203}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2204}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2205}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2206}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2207}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2208}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2209}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2210}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2343}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2344}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2345}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2346}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2347}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2348}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2349}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2350}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2351}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2352}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2353}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2354}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2355}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":688,"attribute_option_id":2356}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":681,"attribute_option_id":2164},{"attribute_id":683,"attribute_option_id":2171},{"attribute_id":689,"attribute_option_id":2212},{"attribute_id":694,"attribute_option_id":2257},{"attribute_id":695,"attribute_option_id":2259}],"allow_backorder":true}],"tags":["necklace","new","custom","topsell","non-custom","the casual edit campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FCOEIN":{"id":47,"details_loaded_time":"2025-07-20 06:34:09","sku":"FCOEIN","price":"85.00","name":"Figaro Chain Old English Initial Necklace","allow_backorder":true,"erp_id":339,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":47,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":45,"name":"Letter","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":1,"required":true,"type":"only_text","free_chars":1,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","men","mens","men s","men chains","men necklace","mens chains","mens necklace","mens chain","men chain","for men","men jewelry","initial necklace","initial","mens gold chains","mens jewelry","initial j","necklace for him","v initial","b initial necklace","gold plated chain mens","gold chain men","chains for men","chain gold men","mans necklace","initial charm","figaro c","letter d necklace","mens collection","r necklace","swimwear","intial","pindens","l necklace","j leclace","boyfriend","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","men s initial","g necklace","items_mobile_app","men s chains"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FEN":{"id":3737,"details_loaded_time":"2025-07-20 07:05:41","sku":"FEN","price":"35.00","name":"Foreva Eva Necklace","allow_backorder":1,"erp_id":794,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3737,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","giftcol"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FEN2":{"id":1190,"details_loaded_time":"2025-07-20 08:16:28","sku":"FEN2","price":"60.00","name":"Forever Necklace","allow_backorder":0,"erp_id":795,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1190,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","giftcol","silver","silver","bestfriend","wedding","15 inch sterling silver name necklace","sterling silver necklaces","sliver necklaces","sliver","friendship","got it on lock","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FIGBLPN":{"id":3443,"details_loaded_time":"2025-07-20 07:36:05","sku":"FIGBLPN","price":"60.00","name":"Figaro Block Letter Pendant Necklace","allow_backorder":1,"erp_id":1700,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3443,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":630,"name":"Block Letter Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1997,"name":"Block Letter Pendant","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","SKU":"BLKLNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":632,"name":"Figaro Chain","quantity":1,"description":null,"type":"item","options":[{"id":2002,"name":"Figaro Chain","skip":false,"item":{"id":1697,"name":"Figaro Chain","SKU":"FIGCH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}]},"5":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},"6":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":630,"attribute_option_id":1997},{"attribute_id":632,"attribute_option_id":2002}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","silver","charm","charms","silver","m necklace","j necklace","e necklaces","initial necklace","initial","s necklace","j pendant","b necklace","initial j","c necklace","v initial","k necklace","b initial necklace","t letter chain","j chain","gold n necklace","letter j necklace","initial charm","w necklace","letter d necklace","best sellers","15 inch sterling silver name necklace","sterling silver necklaces","top seller","best seller","r necklace","sliver necklaces","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","water proof","leo season","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FIGC":{"id":1154,"details_loaded_time":"2025-07-20 08:24:04","sku":"FIGC","price":"65.00","name":"Figaro Cross Necklace","allow_backorder":0,"erp_id":754,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1154,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","cross necklace","silver cross","golden diamond cross","cross men","pink planet","crucifix","saint benedict coin","mini virgen","st jude","waterproof","fiagro","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","big cross","vintage edit","double cross necklace","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FIGCH":{"id":3440,"details_loaded_time":"2025-07-20 07:37:04","sku":"FIGCH","price":"55.00","name":"Figaro Chain","allow_backorder":1,"erp_id":1697,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3440,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"5":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["necklace","topsell","non-custom","figaro c","fig layering","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FIVEITEMMYSTERYSILVER":{"id":3809,"details_loaded_time":"2025-07-20 07:01:36","sku":"FIVEITEMMYSTERYSILVER","price":"49.00","name":"5 item Mystery Box Silver","allow_backorder":1,"erp_id":1889,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3809,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true}],"tags":["new","set","custom-set","non-custom","don't notify","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FKNN":{"id":1304,"details_loaded_time":"2024-10-30 18:41:22","sku":"FKNN","price":"42.00","name":"F*ck It Necklace","allow_backorder":0,"erp_id":864,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1304,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FMEH":{"id":44,"details_loaded_time":"2020-05-28 19:12:19","sku":"FMEH","price":"55.00","name":"Femme Hoops","allow_backorder":1,"erp_id":336,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":44,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"Gold","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":41,"name":"Size(list)","type":"list","options":[{"id":172,"name":"Medium","skip":false,"parent_attribute":null},{"id":173,"name":"Large","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["mayfair","earrings"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FMEN":{"id":45,"details_loaded_time":"2025-07-20 06:34:19","sku":"FMEN","price":"28.00","name":"Femme Necklace","allow_backorder":0,"erp_id":337,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":45,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}},"tags":["necklace","mayfair","sale","non-custom","ws","female","woman","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FPN":{"id":1128,"details_loaded_time":"2023-12-08 18:30:35","sku":"FPN","price":"65.00","name":"Free Palestine Necklace","allow_backorder":1,"erp_id":646,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1128,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true}],"tags":["necklace","new","non-custom","items_mobile_app","palestine"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FPR":{"id":1284,"details_loaded_time":"2024-05-10 12:45:17","sku":"FPR","price":null,"name":"Flower Power Ring","allow_backorder":0,"erp_id":820,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1284,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ring for women","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FPWRN":{"id":1505,"details_loaded_time":"2024-05-10 12:42:16","sku":"FPWRN","price":"42.00","name":"Flower Power Necklace","allow_backorder":0,"erp_id":1054,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1505,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","sale","non-custom","ws","say my name","say my name collection","summer collection","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FROSTSET":{"id":3719,"details_loaded_time":"2025-07-20 07:07:23","sku":"FROSTSET","price":"158.00","name":"Frosted Set","allow_backorder":1,"erp_id":1863,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3719,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":711,"name":"Gem Cross Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2297,"name":"Gem Cross Pendant","skip":false,"item":{"id":1850,"name":"Gem Cross Pendant","SKU":"GEMCPEN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":944,"name":"Emerald","skip":false,"parent_attribute":null}]},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"List","options":[{"id":2271,"name":"Dainty Figaro Chain","skip":false,"parent_attribute":null},{"id":2272,"name":"Dainty Herringbone Chain","skip":false,"parent_attribute":null},{"id":2273,"name":"Delicate Rope Chain","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":712,"name":"Baguette Huggies","quantity":1,"description":null,"type":"item","options":[{"id":2300,"name":"Baguette Huggies","skip":false,"item":{"id":1849,"name":"Baguette Huggies","SKU":"BAGHUG"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":261}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":261}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":713,"name":"The Genevieve Band","quantity":1,"description":null,"type":"item","options":[{"id":2301,"name":"The Genevieve Band","skip":false,"item":{"id":1844,"name":"The Genevieve Band","SKU":"TGENBAND"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":944,"name":"Emerald","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":711,"attribute_option_id":2297},{"attribute_id":712,"attribute_option_id":2300},{"attribute_id":713,"attribute_option_id":2301}],"allow_backorder":true}],"tags":["new","set","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FSE":{"id":722,"details_loaded_time":"2025-07-20 08:46:30","sku":"FSE","price":"36.00","name":"Figaro Studs","allow_backorder":0,"erp_id":489,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":722,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":419,"name":"Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":false},"2":{"image":null,"stock":187,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":419}],"allow_backorder":false}},"tags":["earrings","sale","non-custom","ws","figaro c","earrings men","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FTRG":{"id":48,"details_loaded_time":"2025-07-20 06:34:04","sku":"FTRG","price":"55.00","name":"Fu*k That Ring","allow_backorder":0,"erp_id":340,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":48,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","mayfair","topsell","non-custom","ring for women","f that ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"FUSS":{"id":43,"details_loaded_time":"2020-10-20 20:35:37","sku":"FUSS","price":"45.00","name":"F U Stud Sets","allow_backorder":1,"erp_id":335,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":43,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":"79","price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["earrings"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GAR":{"id":1114,"details_loaded_time":"2022-09-15 18:12:18","sku":"GAR","price":"28.35","name":"Gold Asymmetrical Ring","allow_backorder":0,"erp_id":624,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1114,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GBCHARM":{"id":3752,"details_loaded_time":"2025-07-20 07:03:28","sku":"GBCHARM","price":"18.00","name":"Gummy Bear Charm","allow_backorder":1,"erp_id":1881,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3752,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GBR":{"id":925,"details_loaded_time":"2022-09-15 18:19:36","sku":"GBR","price":"15.75","name":"Gold Bubble Ring","allow_backorder":0,"erp_id":611,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":925,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GBR1":{"id":1119,"details_loaded_time":"2022-09-15 18:08:31","sku":"GBR1","price":"28.35","name":"Green Bubble Ring","allow_backorder":0,"erp_id":636,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1119,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GCPKIT":{"id":3851,"details_loaded_time":"2025-06-27 16:46:08","sku":"GCPKIT","price":"65.00","name":"Gem Cross Pendant Necklace","allow_backorder":1,"erp_id":1916,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3851,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":711,"name":"Gem Cross Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2297,"name":"Gem Cross Pendant","skip":false,"item":{"id":1850,"name":"Gem Cross Pendant","SKU":"GEMCPEN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":944,"name":"Emerald","skip":false,"parent_attribute":null}]},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"List","options":[{"id":2271,"name":"Dainty Figaro Chain","skip":false,"parent_attribute":null},{"id":2272,"name":"Dainty Herringbone Chain","skip":false,"parent_attribute":null},{"id":2273,"name":"Delicate Rope Chain","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":711,"attribute_option_id":2297}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GEMBR":{"id":3312,"details_loaded_time":"2025-07-20 07:44:16","sku":"GEMBR","price":"60.00","name":"Gemstone Bracelet","allow_backorder":1,"erp_id":1624,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3312,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":1838,"name":"Multicolor","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":1838},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","topsell","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GEMC":{"id":3640,"details_loaded_time":"2025-07-20 07:18:30","sku":"GEMC","price":"18.00","name":"Gem Charm","allow_backorder":1,"erp_id":1811,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3640,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":680,"name":"Gem Charm","quantity":1,"description":null,"type":"list","options":[{"id":2151,"name":"Garnet","skip":false,"parent_attribute":null},{"id":2152,"name":"Amethyst","skip":false,"parent_attribute":null},{"id":2153,"name":"Blue","skip":false,"parent_attribute":null},{"id":2154,"name":"Crystal","skip":false,"parent_attribute":null},{"id":2155,"name":"Emerald","skip":false,"parent_attribute":null},{"id":2156,"name":"Lavender","skip":false,"parent_attribute":null},{"id":2157,"name":"Ruby","skip":false,"parent_attribute":null},{"id":2158,"name":"Green","skip":false,"parent_attribute":null},{"id":2159,"name":"Cobalt","skip":false,"parent_attribute":null},{"id":2160,"name":"Pink","skip":false,"parent_attribute":null},{"id":2161,"name":"Champagne","skip":false,"parent_attribute":null},{"id":2162,"name":"Sky","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2151}],"allow_backorder":true},{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2152}],"allow_backorder":true},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2153}],"allow_backorder":true},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2154}],"allow_backorder":true},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2155}],"allow_backorder":true},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2156}],"allow_backorder":true},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2157}],"allow_backorder":true},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2158}],"allow_backorder":true},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2159}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2160}],"allow_backorder":true},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2161}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2162}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GEMCPEN":{"id":3715,"details_loaded_time":"2025-07-20 07:07:42","sku":"GEMCPEN","price":"65.00","name":"Gem Cross Pendant","allow_backorder":1,"erp_id":1850,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3715,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":944,"name":"Emerald","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"list","options":[{"id":2271,"name":"Dainty Figaro Chain","skip":false,"parent_attribute":null},{"id":2272,"name":"Dainty Herringbone Chain","skip":false,"parent_attribute":null},{"id":2273,"name":"Delicate Rope Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GFA":{"id":49,"details_loaded_time":"2025-07-20 06:32:43","sku":"GFA","price":"50.00","name":"Gold Figaro Anklet","allow_backorder":1,"erp_id":341,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":49,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":221,"name":"7.3\"","skip":false,"parent_attribute":null,"weight":73}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":221},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["anklet","topsell","non-custom","ankle bracelet","toe rings","ank","ryan anklets","sanklets","anklet bracelets","anklet clasps","cuban anklet","waterproof","fiagro","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GFB":{"id":3623,"details_loaded_time":"2025-07-20 07:20:24","sku":"GFB","price":"50.00","name":"Good Fortune Bracelet","allow_backorder":1,"erp_id":1792,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3623,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GGHR":{"id":1291,"details_loaded_time":"2024-05-10 12:51:39","sku":"GGHR","price":null,"name":"Green Gem Heart Ring","allow_backorder":0,"erp_id":814,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1291,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","sale","non-custom","emerald stone necklace","heart shape diamond ring","ring for women","blue heart ring","emerald gold necklace","green marbled","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GGR":{"id":1125,"details_loaded_time":"2024-05-09 20:12:49","sku":"GGR","price":"32.00","name":"Green Gem Ring","allow_backorder":0,"erp_id":644,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1125,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[],"active_combinations":[],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GHE":{"id":50,"details_loaded_time":"2025-07-20 07:39:29","sku":"GHE","price":"55.00","name":"Gold Huggie Earrings","allow_backorder":1,"erp_id":342,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":50,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["earrings","topsell","non-custom","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GHN":{"id":1159,"details_loaded_time":"2022-09-15 17:48:10","sku":"GHN","price":"22.40","name":"Green Heart Necklace","allow_backorder":0,"erp_id":758,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1159,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GICLN":{"id":662,"details_loaded_time":"2020-05-29 12:42:09","sku":"GICLN","price":"75.00","name":"Gold Iced Cuban Link Necklace","allow_backorder":1,"erp_id":470,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":662,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GIGIN":{"id":1178,"details_loaded_time":"2025-07-20 08:20:12","sku":"GIGIN","price":"60.00","name":"Gigi Necklace","allow_backorder":0,"erp_id":791,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1178,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","mama chains","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GIOAURA":{"id":1196,"details_loaded_time":"2022-09-15 17:22:38","sku":"GIOAURA","price":"30.00","name":"Got It On Lock Necklace","allow_backorder":0,"erp_id":799,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1196,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":418,"name":"Gold","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false}],"tags":["necklace","new","sale","ws","aura"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GIPB":{"id":51,"details_loaded_time":"2025-07-20 06:32:33","sku":"GIPB","price":"32.00","name":"Gold Initial Pendant Bracelet","allow_backorder":0,"erp_id":343,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":51,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":243,"name":"8.7\"","skip":false,"parent_attribute":null,"weight":87}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":127,"name":"Skip","skip":true,"parent_attribute":null},{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":false},"2":{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":false},"3":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":false},"4":{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":false},"5":{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":132}],"allow_backorder":false},"6":{"image":null,"stock":139,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":133}],"allow_backorder":false},"7":{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":134}],"allow_backorder":false},"8":{"image":null,"stock":112,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":135}],"allow_backorder":false},"9":{"image":null,"stock":143,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":136}],"allow_backorder":false},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":137}],"allow_backorder":false},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":138}],"allow_backorder":false},"12":{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":139}],"allow_backorder":false},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":140}],"allow_backorder":false},"14":{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":141}],"allow_backorder":false},"15":{"image":null,"stock":153,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":142}],"allow_backorder":false},"16":{"image":null,"stock":131,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":143}],"allow_backorder":false},"17":{"image":null,"stock":121,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":144}],"allow_backorder":false},"18":{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":145}],"allow_backorder":false},"19":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":146}],"allow_backorder":false},"20":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":147}],"allow_backorder":false},"21":{"image":null,"stock":152,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":148}],"allow_backorder":false},"22":{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":149}],"allow_backorder":false},"23":{"image":null,"stock":139,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":150}],"allow_backorder":false},"24":{"image":null,"stock":76,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":151}],"allow_backorder":false},"25":{"image":null,"stock":125,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":152}],"allow_backorder":false},"26":{"image":null,"stock":101,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":243},{"attribute_id":34,"attribute_option_id":153}],"allow_backorder":false}},"tags":["bracelet","sale","non-custom","ws","charm bracelet","braceletbracelet","bracelet for guys","c initial brackets","intial","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GIPN":{"id":79,"details_loaded_time":"2024-02-22 19:29:23","sku":"GIPN","price":"58.00","name":"Initial Pendant Necklace_old","allow_backorder":0,"erp_id":371,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":79,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":34,"name":"Letter","description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","description":null,"type":"list","options":[{"id":264,"name":"1.4 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":52,"attribute_option_id":264}],"allow_backorder":false}],"tags":["necklace","non-custom","silver","charm","charms","m necklace","j necklace","e necklaces","initial necklace","initial","s necklace","j pendant","b necklace","initial j","c necklace","v initial","k necklace","b initial necklace","t letter chain","j chain","gold n necklace","letter j necklace","initial charm","w necklace","letter d necklace","r necklace","sliver necklaces","sliver","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","men s initial","chunky charm necklace","g necklace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GIPNKIT":{"id":3479,"details_loaded_time":"2025-07-20 07:34:40","sku":"GIPNKIT","price":"58.00","name":"Initial Pendant Necklace","allow_backorder":1,"erp_id":1702,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3479,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":634,"name":"Initial Pendant Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2007,"name":"Initial Pendant Necklace--Pendant","skip":false,"item":{"id":554,"name":"Initial Pendant Necklace--Pendant","SKU":"GIPNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":86,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":176,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":176,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":158,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":141,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":197,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":171,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":105,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":105,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":180,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":109,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":190,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":101,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":98,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":103,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":142,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":585,"attribute_option_id":1884},{"attribute_id":634,"attribute_option_id":2007}],"allow_backorder":true}],"tags":["non-custom","charm","charms","silver","m necklace","j necklace","e necklaces","initial necklace","initial","s necklace","j pendant","b necklace","initial j","c necklace","v initial","k necklace","b initial necklace","t letter chain","j chain","gold n necklace","letter j necklace","initial charm","w necklace","letter d necklace","r necklace","sliver necklaces","sliver","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","water proof","men s initial","chunky charm necklace","g necklace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GIPNpen":{"id":868,"details_loaded_time":"2025-07-20 08:36:37","sku":"GIPNpen","price":"17.50","name":"Initial Pendant Necklace--Pendant","allow_backorder":1,"erp_id":554,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":868,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":86,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":176,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":176,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":158,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":141,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":197,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":171,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":105,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":105,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":180,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":109,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":190,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":101,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":98,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":103,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":142,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GJP":{"id":52,"details_loaded_time":"2020-05-29 12:11:03","sku":"GJP","price":"46.00","name":"Gold Jesus Piece","allow_backorder":1,"erp_id":344,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":52,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["new","religious"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GLBCHARMNECK":{"id":3633,"details_loaded_time":"2025-07-20 07:18:17","sku":"GLBCHARMNECK","price":"65.00","name":"Good Luck Babe Charm Necklace","allow_backorder":1,"erp_id":1826,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3633,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2246}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":683,"name":"Carabiner Chain Type","quantity":1,"description":null,"type":"item","options":[{"id":2171,"name":"Choose Your Carabiner Chain","skip":false,"item":{"id":1802,"name":"Carabiner Chain Type","SKU":"CARANECK"},"attributes_per_every_item":[{"id":692,"name":"Carabiner Chain","quantity":1,"description":null,"type":"List","options":[{"id":2246,"name":"Dainty Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2247,"name":"Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2248,"name":"Dainty Curb Carabiner Chain","skip":false,"parent_attribute":null},{"id":2249,"name":"Curb Carabiner Chain","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":692,"attribute_option_id":2246}],[{"attribute_id":692,"attribute_option_id":2247}],[{"attribute_id":692,"attribute_option_id":2248}],[{"attribute_id":692,"attribute_option_id":2249}]],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2246}]},{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2247}]},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2248}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2249}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":696,"name":"Good Luck Babe Charm","quantity":1,"description":null,"type":"item","options":[{"id":2261,"name":"Good Luck Babe Charm","skip":false,"item":{"id":1806,"name":"Good Luck Charm","SKU":"GLC"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":697,"name":"Lucky You Charm","quantity":1,"description":null,"type":"item","options":[{"id":2263,"name":"Lucky You Charm","skip":false,"item":{"id":1813,"name":"Lucky You Charm","SKU":"LYC"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":698,"name":"Gem Charm Crystal","quantity":1,"description":null,"type":"item","options":[{"id":2265,"name":"Gem Charm Crystal","skip":false,"item":{"id":1811,"name":"Gem Charm","SKU":"GEMC"},"attributes_per_every_item":[{"id":680,"name":"Gem Charm","quantity":1,"description":null,"type":"List","options":[{"id":2151,"name":"Garnet","skip":false,"parent_attribute":null},{"id":2152,"name":"Amethyst","skip":false,"parent_attribute":null},{"id":2153,"name":"Blue","skip":false,"parent_attribute":null},{"id":2154,"name":"Crystal","skip":false,"parent_attribute":null},{"id":2155,"name":"Emerald","skip":false,"parent_attribute":null},{"id":2156,"name":"Lavender","skip":false,"parent_attribute":null},{"id":2157,"name":"Ruby","skip":false,"parent_attribute":null},{"id":2158,"name":"Green","skip":false,"parent_attribute":null},{"id":2159,"name":"Cobalt","skip":false,"parent_attribute":null},{"id":2160,"name":"Pink","skip":false,"parent_attribute":null},{"id":2161,"name":"Champagne","skip":false,"parent_attribute":null},{"id":2162,"name":"Sky","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":680,"attribute_option_id":2154}]],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2151}]},{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2152}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2153}]},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2154}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2155}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2156}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2157}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2158}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2159}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2160}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2161}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2162}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":683,"attribute_option_id":2171},{"attribute_id":696,"attribute_option_id":2261},{"attribute_id":697,"attribute_option_id":2263},{"attribute_id":698,"attribute_option_id":2265}],"allow_backorder":true}],"tags":["necklace","new","non-custom","the casual edit campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GLBCN":{"id":3636,"details_loaded_time":"2025-07-20 07:18:04","sku":"GLBCN","price":"50.00","name":"Choose Your Holder","allow_backorder":1,"erp_id":1801,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3636,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":693,"name":"Carabiner Chain Holder","quantity":1,"description":null,"type":"list","options":[{"id":2252,"name":"Dainty Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2253,"name":"Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2254,"name":"Dainty Curb Carabiner Chain","skip":false,"parent_attribute":null},{"id":2255,"name":"Curb Carabiner Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":693,"attribute_option_id":2252}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":693,"attribute_option_id":2253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":693,"attribute_option_id":2254}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":693,"attribute_option_id":2255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GLC":{"id":3635,"details_loaded_time":"2025-07-20 07:18:26","sku":"GLC","price":"18.00","name":"Good Luck Charm","allow_backorder":1,"erp_id":1806,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3635,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","charm","charms","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GMR":{"id":1283,"details_loaded_time":"2022-04-11 12:40:28","sku":"GMR","price":"40.00","name":"Green Marbled Ring","allow_backorder":0,"erp_id":808,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1283,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["ring","new","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GNN":{"id":54,"details_loaded_time":"2021-02-23 17:40:24","sku":"GNN","price":"69.00","name":"Graffiti Nameplate Necklace","allow_backorder":true,"erp_id":346,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":54,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GOODVC":{"id":3649,"details_loaded_time":"2025-07-20 07:14:35","sku":"GOODVC","price":"18.00","name":"Good Vibes Charm","allow_backorder":1,"erp_id":1820,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3649,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GRADN":{"id":1189,"details_loaded_time":"2025-07-20 08:16:34","sku":"GRADN","price":"60.00","name":"Graduation Necklace","allow_backorder":true,"erp_id":792,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1189,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":138,"name":"Date","quantity":1,"description":null,"type":"text","validation":{"min_chars":4,"max_chars":4,"required":true,"type":"only_numbers","free_chars":4,"addtional_price_per_char":null,"special_chars":false,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["giftcol","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GRANDN":{"id":1179,"details_loaded_time":"2025-07-20 08:20:06","sku":"GRANDN","price":"60.00","name":"Grandma Necklace","allow_backorder":0,"erp_id":790,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1179,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","mama chains","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GRHANDC":{"id":3834,"details_loaded_time":"2025-07-20 07:18:17","sku":"GRHANDC","price":"55.00","name":"Graham Hand Chain","allow_backorder":1,"erp_id":1903,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3834,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GSN":{"id":55,"details_loaded_time":"2025-07-20 06:32:16","sku":"GSN","price":"80.00","name":"Greek Symbol Necklace","allow_backorder":true,"erp_id":347,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":55,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":46,"name":"Greek Letters","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","silver","alpha chi omega","delta zeta","tri delt","sigma","phi sigma sigma","chi omega","alpha beta pi","phi beta pi","alpha phi","sorority","sororities","greek life","items_mobile_app","kappa delta","greek letter"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GTAFCT":{"id":3022,"details_loaded_time":"2025-07-20 07:58:12","sku":"GTAFCT","price":"12.00","name":"Good things are F*cking Coming small tray","allow_backorder":1,"erp_id":1410,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3022,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":155,"name":"Black","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155}],"allow_backorder":true}],"tags":["gg x vs","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GTH":{"id":53,"details_loaded_time":"2025-07-20 06:32:24","sku":"GTH","price":"35.00","name":"Gold Twist Hoops","allow_backorder":0,"erp_id":345,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":53,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":41,"name":"Size","quantity":1,"description":null,"type":"list","options":[{"id":171,"name":"Small","skip":false,"parent_attribute":null},{"id":172,"name":"Medium","skip":false,"parent_attribute":null},{"id":173,"name":"Large","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","fine thin hoops","items_mobile_app","chunky hoops","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GVB":{"id":1250,"details_loaded_time":"2023-09-01 17:21:21","sku":"GVB","price":null,"name":"Good Vibes Band","allow_backorder":0,"erp_id":802,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1250,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":35,"name":"Ring Size","type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ring for women","iced smiley","woman blue ring","stay smiling","joy","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"GVL":{"id":647,"details_loaded_time":"2025-07-20 08:52:14","sku":"GVL","price":"60.00","name":"Good Vibes Line","allow_backorder":0,"erp_id":465,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":647,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":95,"name":"Choose Necklace","quantity":1,"description":null,"type":"list","options":[{"id":379,"name":"hope","skip":false,"parent_attribute":null},{"id":380,"name":"energy","skip":false,"parent_attribute":null},{"id":381,"name":"manifest","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":95,"attribute_option_id":379}],"allow_backorder":false},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":95,"attribute_option_id":380}],"allow_backorder":false},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":95,"attribute_option_id":381}],"allow_backorder":false}],"tags":["necklace","non-custom","ws","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HBA":{"id":831,"details_loaded_time":"2025-07-20 08:42:26","sku":"HBA","price":"50.00","name":"Herringbone Anklet","allow_backorder":1,"erp_id":526,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":831,"force_allow_backorder":false,"warning_quantity":15,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","topsell","non-custom","ankle bracelet","toe rings","ank","ryan anklets","sanklets","anklet bracelets","anklet clasps","bikini","swimwear","herrington bone chain","cuban anklet","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HBC":{"id":686,"details_loaded_time":"2025-07-20 08:48:41","sku":"HBC","price":"55.00","name":"Herringbone Chain","allow_backorder":0,"erp_id":476,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":686,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","men","men s","men chains","men necklace","mens chains","mens necklace","men jewelry","mens gold chains","mens jewelry","necklace for him","gold plated chain mens","gold chain men","men herringbone gold chain","chains for men","chain gold men","rings for men silver","mans necklace","best sellers","top seller","best seller","bikini","swimwear","herrington bone chain","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","men s chains","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HBRACE":{"id":3624,"details_loaded_time":"2025-07-20 07:20:19","sku":"HBRACE","price":"50.00","name":"Herringbone Bracelet","allow_backorder":1,"erp_id":1793,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3624,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HCTBN":{"id":1191,"details_loaded_time":"2025-07-20 08:15:39","sku":"HCTBN","price":"60.00","name":"Here Comes The Bride Necklace","allow_backorder":0,"erp_id":789,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1191,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","giftcol","wedding","mrs","moh","maid of honor","briide","items_mobile_app","bridal sets","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HDCLR":{"id":827,"details_loaded_time":"2025-07-20 08:44:04","sku":"HDCLR","price":"36.00","name":"Heart & Dagger Chain Link Ring","allow_backorder":0,"erp_id":522,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":827,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","silver","silver","rings for men silver","sliver","diamond link ring","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","don't notify","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HEPN":{"id":838,"details_loaded_time":"2025-07-20 08:40:43","sku":"HEPN","price":"32.00","name":"Heart Pendant Necklace","allow_backorder":0,"erp_id":533,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":838,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":112,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","silver","silver","heart lock","15 inch sterling silver name necklace","sterling silver necklaces","sliver necklaces","sliver","got it on lock","pindens","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","lock nec","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HERBELLYCHAIN":{"id":3531,"details_loaded_time":"2025-07-20 07:24:34","sku":"HERBELLYCHAIN","price":"55.00","name":"Herringbone Belly Chain","allow_backorder":1,"erp_id":1761,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3531,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":507,"name":"Belly Chain Length","quantity":1,"description":null,"type":"list","options":[{"id":1531,"name":"60 cm + 20 cm extender","skip":false,"parent_attribute":null},{"id":1533,"name":"80 cm + 20 cm extender","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true}],"tags":["new","accessories","bikini","swimwear","gold belly button studs","waist","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","body chain","bellychain","items_mobile_app","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HERBLPN":{"id":3441,"details_loaded_time":"2025-07-20 07:36:20","sku":"HERBLPN","price":"60.00","name":"Herringbone Block Letter Pendant Necklace","allow_backorder":1,"erp_id":1698,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3441,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":629,"name":"Dainty Herringbone Chain","quantity":1,"description":null,"type":"item","options":[{"id":1996,"name":"Dainty Herringbone Chain","skip":false,"item":{"id":1696,"name":"Dainty Herringbone Chain","SKU":"DHERCH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":630,"name":"Block Letter Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1997,"name":"Block Letter Pendant","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","SKU":"BLKLNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":629,"attribute_option_id":1996},{"attribute_id":630,"attribute_option_id":1997}],"allow_backorder":true}],"tags":["necklace","topsell","silver","charm","charms","silver","m necklace","j necklace","e necklaces","initial necklace","initial","s necklace","j pendant","b necklace","initial j","c necklace","v initial","k necklace","b initial necklace","t letter chain","j chain","gold n necklace","letter j necklace","initial charm","w necklace","letter d necklace","best sellers","15 inch sterling silver name necklace","sterling silver necklaces","top seller","best seller","r necklace","sliver necklaces","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","water proof","leo season","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HERMEN3":{"id":3095,"details_loaded_time":"2025-07-20 07:52:13","sku":"HERMEN3","price":"110.00","name":"3 mm Herringbone Chain","allow_backorder":1,"erp_id":1467,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3095,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":24,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HERMEN6":{"id":3097,"details_loaded_time":"2025-07-20 07:52:04","sku":"HERMEN6","price":"120.00","name":"6 mm Herringbone Chain","allow_backorder":1,"erp_id":1466,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3097,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HERNN":{"id":1983,"details_loaded_time":"2025-07-20 08:06:20","sku":"HERNN","price":"85.00","name":"Herringbone Nameplate Necklace","allow_backorder":true,"erp_id":1147,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1983,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":236,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.00","special_chars":false,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true}],"tags":["necklace","custom","nameplate essential necklace","curbchain nameplate","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","name neclace","custom herringbone","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HFNN":{"id":152,"details_loaded_time":"2022-12-06 10:06:18","sku":"HFNN","price":"48.00","name":"High Fashion Nameplate Necklace","allow_backorder":true,"erp_id":447,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":152,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["necklace","custom","topsell"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HGTB":{"id":2664,"details_loaded_time":"2025-07-20 08:00:22","sku":"HGTB","price":"65.00","name":"Hour Glass Tennis Bracelet","allow_backorder":1,"erp_id":1327,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2664,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":true}],"tags":["bracelet","non-custom","silver","silver","tennis chain","brackets","braceletbracelet","iced curban","14k gold","sliver","rhinestone","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold","tennis","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HGTC":{"id":2663,"details_loaded_time":"2025-07-20 08:00:26","sku":"HGTC","price":"85.00","name":"Hour Glass Tennis Chain","allow_backorder":0,"erp_id":1326,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2663,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":false}],"tags":["necklace","non-custom","silver","silver","tennis chain","tennis necklace","mens diamond chain","diamond cut cuban bracelets","14k gold","sliver necklaces","sliver","sliver chin","rhinestone","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold","tennis","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HHEAR":{"id":3621,"details_loaded_time":"2025-07-20 07:20:31","sku":"HHEAR","price":"55.00","name":"Hugo Hoops","allow_backorder":1,"erp_id":1791,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3621,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HHERN":{"id":3415,"details_loaded_time":"2025-07-20 07:40:27","sku":"HHERN","price":"65.00","name":"Heritage Herringbone Necklace","allow_backorder":0,"erp_id":1625,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3415,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","herrington bone chain","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HHSCN":{"id":3199,"details_loaded_time":"2025-07-20 07:48:09","sku":"HHSCN","price":"85.00","name":"Herringbone Heart Script Custom Nameplate","allow_backorder":true,"erp_id":1511,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3199,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":118,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_text","free_chars":13,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HMTE":{"id":3053,"details_loaded_time":"2024-05-15 16:24:36","sku":"HMTE","price":"55.00","name":"Hug Me Tight Earrings","allow_backorder":0,"erp_id":1423,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3053,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":false}],"tags":["new","earrings","sale","non-custom","ws","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HNHN":{"id":1142,"details_loaded_time":"2025-07-20 08:24:41","sku":"HNHN","price":"40.00","name":"Half N Half Necklace","allow_backorder":0,"erp_id":720,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1142,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","dior","dior necklace","chanel","beads","perl necklace","pearlpear","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","beaded necklace","bead","vivienne westwood","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HNN":{"id":56,"details_loaded_time":"2025-07-20 06:32:10","sku":"HNN","price":"80.00","name":"Heart Nameplate Necklace","allow_backorder":true,"erp_id":348,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":56,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":397,"name":"Standard Anklet","skip":false,"parent_attribute":null,"weight":null},{"id":398,"name":"Standard Bracelet","skip":false,"parent_attribute":null,"weight":null},{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":47,"name":"Jewelry item","quantity":1,"description":null,"type":"list","options":[{"id":218,"name":"Anklet","skip":false,"parent_attribute":null},{"id":219,"name":"Necklace","skip":false,"parent_attribute":null},{"id":220,"name":"Bracelet","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"22":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"37":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"40":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"43":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"46":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"49":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"52":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"55":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true},"58":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":219}],"allow_backorder":true}},"tags":["necklace","custom","daniel","gabriel neckless","nathan","alessandra","15 inch sterling silver name necklace","dominique","addison","nameplate essential necklace","delores name necklace","delores name charm","yasmine","malena","bikini","swimwear","cayden","savannah","andrew","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","18k gold plated neckless alex","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HNPA":{"id":3299,"details_loaded_time":"2025-07-20 07:44:20","sku":"HNPA","price":"80.00","name":"Heart Nameplate Anklet","allow_backorder":true,"erp_id":1613,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3299,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":47,"name":"Jewelry item","quantity":1,"description":null,"type":"list","options":[{"id":218,"name":"Anklet","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":222,"name":"7.8\"","skip":false,"parent_attribute":null,"weight":78}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":218}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":218}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":218}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":218}],"allow_backorder":true}],"tags":["anklet","custom","tarnish-free","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HNPB":{"id":3298,"details_loaded_time":"2025-07-20 07:44:26","sku":"HNPB","price":"80.00","name":"Heart Nameplate Bracelet","allow_backorder":true,"erp_id":1612,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3298,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":47,"name":"Jewelry item","quantity":1,"description":null,"type":"list","options":[{"id":220,"name":"Bracelet","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":220}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":220}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":47,"attribute_option_id":220}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":47,"attribute_option_id":220}],"allow_backorder":true}],"tags":["bracelet","custom","tarnish-free","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HOF":{"id":1170,"details_loaded_time":"2021-11-24 19:13:35","sku":"HOF","price":"22.40","name":"Heart On Fire","allow_backorder":0,"erp_id":768,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1170,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HOFAME":{"id":3882,"details_loaded_time":"2025-07-20 06:51:26","sku":"HOFAME","price":"35.00","name":"The Hall of Fame Hat","allow_backorder":1,"erp_id":1938,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3882,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":2380,"name":"Khaki Solid","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2380}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HONHOOP":{"id":3827,"details_loaded_time":"2025-07-20 06:59:39","sku":"HONHOOP","price":"60.00","name":"The Honey Hoops","allow_backorder":1,"erp_id":1897,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3827,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HONN":{"id":154,"details_loaded_time":"2022-12-06 10:06:04","sku":"HONN","price":"37.80","name":"Homegirl Nameplate Necklace","allow_backorder":0,"erp_id":449,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":154,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HPG":{"id":2224,"details_loaded_time":"2025-07-20 08:02:42","sku":"HPG","price":"2.00","name":"Heatpress Graphics","allow_backorder":1,"erp_id":1224,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":2224,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":327,"name":"Graphic","quantity":1,"description":null,"type":"list","options":[{"id":1076,"name":"God Bless the 314","skip":false,"parent_attribute":null},{"id":1078,"name":"Love Our Mother","skip":false,"parent_attribute":null},{"id":1077,"name":"Marlboro Saint Louis","skip":false,"parent_attribute":null},{"id":1255,"name":"Angel Wing","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":327,"attribute_option_id":1076}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":327,"attribute_option_id":1078}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":327,"attribute_option_id":1077}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":327,"attribute_option_id":1255}],"allow_backorder":true}],"tags":["workorder","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HPN":{"id":59,"details_loaded_time":"2025-07-20 09:01:50","sku":"HPN","price":"58.00","name":"Horoscope Pendant Necklace","allow_backorder":0,"erp_id":351,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":59,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":24,"name":"Horoscope","quantity":1,"description":null,"type":"list","options":[{"id":97,"name":"Aries","skip":false,"parent_attribute":null},{"id":105,"name":"Aquarius","skip":false,"parent_attribute":null},{"id":106,"name":"Cancer","skip":false,"parent_attribute":null},{"id":102,"name":"Capricorn","skip":false,"parent_attribute":null},{"id":103,"name":"Gemini","skip":false,"parent_attribute":null},{"id":108,"name":"Pisces","skip":false,"parent_attribute":null},{"id":104,"name":"Libra","skip":false,"parent_attribute":null},{"id":98,"name":"Leo","skip":false,"parent_attribute":null},{"id":99,"name":"Sagittarius","skip":false,"parent_attribute":null},{"id":107,"name":"Scorpio","skip":false,"parent_attribute":null},{"id":100,"name":"Taurus","skip":false,"parent_attribute":null},{"id":101,"name":"Virgo","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"list","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"1":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"2":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"3":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"4":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"5":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"6":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"7":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"8":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"9":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"10":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"11":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"12":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"13":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"14":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"15":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"16":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"17":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"18":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"19":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"20":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"21":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"22":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"23":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"24":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"25":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"26":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"27":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"28":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"29":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"30":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"31":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"32":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"33":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"34":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"35":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"36":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"37":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"38":{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"39":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"40":{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"41":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"42":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"43":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"44":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"45":{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"46":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"47":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"48":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"49":{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"50":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"51":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"52":{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"53":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"54":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"55":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"56":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"57":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"58":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"59":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"60":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"61":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"62":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"63":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"64":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"65":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"66":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"67":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"68":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"69":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"70":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"71":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"72":{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"73":{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"74":{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"75":{"image":null,"stock":88,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"76":{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"77":{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"78":{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"79":{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"80":{"image":null,"stock":130,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"81":{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"82":{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"83":{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"96":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"97":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"98":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"99":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"100":{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"101":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"102":{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"103":{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"104":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"105":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"106":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"107":{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}},"tags":["necklace","topsell","non-custom","silver","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","charm","charms","silver","scorpion","astrology","gemini necklace","aries necklace","leo necklace","capricorn af","horoscope pendant necklace","horroscope pendant necklace","pisceszodiac","gemini moon","star sign","starsign","aquarius necklace","taurus necklace","virgo necklace","libra necklace","scorpio necklace","sagittarius necklace","capricorn necklace","pisces necklace","star girl","coin necklace","best sellers","15 inch sterling silver name necklace","sterling silver necklaces","top seller","birthday charms","best seller","sliver necklaces","sliver","pindens","waterproof","birthstone","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","1984","leo season","1981","1944 necklace","january","89 necklace","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HPNKIT":{"id":3316,"details_loaded_time":"2025-07-20 07:42:37","sku":"HPNKIT","price":"58.00","name":"Horoscope Necklace- Kit","allow_backorder":1,"erp_id":1636,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3316,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"HPN":"HPN","REC":"REC"}},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null,"skus":{"HPN":"HPN","REC":"REC"}},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null,"skus":{"HPN":"HPN","REC":"REC"}}],"skus":{"HPN":"HPN","REC":"REC"},"top_level":true},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"skus":{"HPN":"HPN","REC":"REC"}},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"skus":{"HPN":"HPN","REC":"REC"}},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"skus":{"HPN":"HPN","REC":"REC"}}],"skus":{"HPN":"HPN","REC":"REC"},"top_level":true}],"grouped_attributes_ids":[11,14],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":{"11":11,"14":14}},"attributes":[{"id":28,"name":"Horoscope Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":115,"name":"Horoscope Pendant Necklace","skip":false,"item":{"id":351,"name":"Horoscope Pendant Necklace","SKU":"HPN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":24,"name":"Horoscope","quantity":1,"description":null,"type":"List","options":[{"id":97,"name":"Aries","skip":false,"parent_attribute":null},{"id":105,"name":"Aquarius","skip":false,"parent_attribute":null},{"id":106,"name":"Cancer","skip":false,"parent_attribute":null},{"id":102,"name":"Capricorn","skip":false,"parent_attribute":null},{"id":103,"name":"Gemini","skip":false,"parent_attribute":null},{"id":108,"name":"Pisces","skip":false,"parent_attribute":null},{"id":104,"name":"Libra","skip":false,"parent_attribute":null},{"id":98,"name":"Leo","skip":false,"parent_attribute":null},{"id":99,"name":"Sagittarius","skip":false,"parent_attribute":null},{"id":107,"name":"Scorpio","skip":false,"parent_attribute":null},{"id":100,"name":"Taurus","skip":false,"parent_attribute":null},{"id":101,"name":"Virgo","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"List","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":{"0":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"1":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"2":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"3":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"4":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"5":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"6":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"7":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"8":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"9":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"10":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"11":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"12":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"13":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"14":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"15":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"16":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"17":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"18":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"19":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"20":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"21":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"22":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"23":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"24":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"25":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"26":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"27":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"28":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"29":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"30":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"31":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"32":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"33":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"34":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"35":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"36":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"37":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"38":{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"39":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"40":{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"41":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"42":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"43":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"44":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"45":{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"46":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"47":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"48":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"49":{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"50":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"51":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"52":{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"53":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"54":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"55":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"56":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"57":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"58":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"59":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"60":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"61":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"62":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"63":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"64":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"65":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"66":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"67":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"68":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"69":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"70":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"71":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"72":{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"73":{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"74":{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"75":{"image":null,"stock":88,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"76":{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"77":{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"78":{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"79":{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"80":{"image":null,"stock":130,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"81":{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"82":{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"83":{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"96":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"97":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"98":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"99":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"100":{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"101":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"102":{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"103":{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"104":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"105":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"106":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"107":{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":587,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1887,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":28,"attribute_option_id":115},{"attribute_id":587,"attribute_option_id":1887}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","silver","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","charm","charms","silver","scorpion","astrology","gemini necklace","aries necklace","leo necklace","capricorn af","horoscope pendant necklace","horroscope pendant necklace","pisceszodiac","gemini moon","star sign","starsign","aquarius necklace","taurus necklace","virgo necklace","libra necklace","scorpio necklace","sagittarius necklace","capricorn necklace","pisces necklace","star girl","coin necklace","best sellers","15 inch sterling silver name necklace","sterling silver necklaces","top seller","birthday charms","best seller","sliver necklaces","sliver","pindens","waterproof","birthstone","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","1984","leo season","1981","1944 necklace","january","89 necklace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HPNpen":{"id":863,"details_loaded_time":"2025-07-20 08:38:11","sku":"HPNpen","price":"58.00","name":"Horoscope Pendant Necklace - Pendant","allow_backorder":1,"erp_id":550,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":863,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":24,"name":"Horoscope","quantity":1,"description":null,"type":"list","options":[{"id":97,"name":"Aries","skip":false,"parent_attribute":null},{"id":98,"name":"Leo","skip":false,"parent_attribute":null},{"id":99,"name":"Sagittarius","skip":false,"parent_attribute":null},{"id":100,"name":"Taurus","skip":false,"parent_attribute":null},{"id":101,"name":"Virgo","skip":false,"parent_attribute":null},{"id":102,"name":"Capricorn","skip":false,"parent_attribute":null},{"id":103,"name":"Gemini","skip":false,"parent_attribute":null},{"id":104,"name":"Libra","skip":false,"parent_attribute":null},{"id":105,"name":"Aquarius","skip":false,"parent_attribute":null},{"id":106,"name":"Cancer","skip":false,"parent_attribute":null},{"id":107,"name":"Scorpio","skip":false,"parent_attribute":null},{"id":108,"name":"Pisces","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"list","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HR":{"id":1115,"details_loaded_time":"2021-10-18 17:46:36","sku":"HR","price":"31.50","name":"Heart Ring","allow_backorder":0,"erp_id":632,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1115,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":418,"name":"Gold","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HSBC":{"id":3191,"details_loaded_time":"2025-07-20 07:48:26","sku":"HSBC","price":"85.00","name":"Heart Script Belly Chain","allow_backorder":true,"erp_id":1512,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3191,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":507,"name":"Belly Chain Length","quantity":1,"description":null,"type":"list","options":[{"id":1531,"name":"60 cm + 20 cm extender","skip":false,"parent_attribute":null},{"id":1532,"name":"70 cm + 20 cm extender","skip":false,"parent_attribute":null},{"id":1533,"name":"80 cm + 20 cm extender","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":1533}],"allow_backorder":true}],"tags":["custom","accessories","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","items_mobile_app","endless summer campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HSH":{"id":671,"details_loaded_time":"2025-07-20 08:50:29","sku":"HSH","price":"34.00","name":"Heart Script Hoops","allow_backorder":0,"erp_id":471,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":671,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":58,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":132,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":68,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","e earring","initial","initial j","v initial","b initial necklace","initial charm","earrings sterling","intial","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HSN":{"id":57,"details_loaded_time":"2025-07-20 06:32:06","sku":"HSN","price":"80.00","name":"Heart Script Nameplate","allow_backorder":true,"erp_id":349,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":57,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","topsell","15 inch sterling silver name necklace","delores name necklace","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HSPN":{"id":58,"details_loaded_time":"2022-11-25 14:35:21","sku":"HSPN","price":"28.35","name":"Heaven Sent Pendant Necklace","allow_backorder":0,"erp_id":350,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":58,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null,"weight":170},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","type":"list","options":[{"id":251,"name":"1.9 cm x 1.7 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"4":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":251},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}},"tags":["necklace","sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"HSPNpen":{"id":862,"details_loaded_time":"2021-01-25 16:42:24","sku":"HSPNpen","price":"19.50","name":"Heaven Sent Pendant Necklace--Pendant","allow_backorder":1,"erp_id":549,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":862,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","type":"list","options":[{"id":251,"name":"1.9 cm x 1.7 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":251},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":52,"attribute_option_id":251},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IACPN":{"id":60,"details_loaded_time":"2020-08-14 20:17:14","sku":"IACPN","price":"59.00","name":"Iced Ankh Cross Pendant Necklace","allow_backorder":1,"erp_id":352,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":60,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":null,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IBB":{"id":814,"details_loaded_time":"2022-12-06 09:28:27","sku":"IBB","price":"44.80","name":"Iced Baguette Bracelet","allow_backorder":0,"erp_id":519,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":814,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["bracelet","new","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IBFPNKIT":{"id":3480,"details_loaded_time":"2025-03-03 20:27:04","sku":"IBFPNKIT","price":"58.00","name":"Iced Butterfly Pendant Necklace","allow_backorder":1,"erp_id":1703,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3480,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":636,"name":"Iced Butterfly Pendant Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2011,"name":"Iced Butterfly Pendant Necklace--Pendant","skip":false,"item":{"id":551,"name":"Iced Butterfly Pendant Necklace--Pendant","SKU":"IBPNpen"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17776,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1448,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1726,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":726,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2748,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1211,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":495,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":349,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":636,"attribute_option_id":2011}],"allow_backorder":true}],"tags":["necklace","topsell","sale","non-custom","ws","euphoria","charm","charms","bejeweled pendant necklace","bejeweled","bejeweled pendant","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IBLB":{"id":63,"details_loaded_time":"2025-07-20 06:30:13","sku":"IBLB","price":"28.00","name":"Iced Bubble Letter Bracelet","allow_backorder":0,"erp_id":355,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":63,"force_allow_backorder":false,"warning_quantity":0,"warning_on_screen":"OUT OF STOCK! Discontinued","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":101,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":85,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["bracelet","topsell","sale","non-custom","ws","tennis chain","brackets","bejeweled","charm bracelet","braceletbracelet","bubble pendant","bracelet for guys","c initial brackets","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IBPN":{"id":64,"details_loaded_time":"2024-03-29 14:41:29","sku":"IBPN","price":"58.00","name":"Iced Butterfly Pendant Necklace DNU","allow_backorder":0,"erp_id":356,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":64,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","euphoria","charm","charms","bejeweled pendant necklace","bejeweled","bejeweled pendant","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IBPNpen":{"id":864,"details_loaded_time":"2025-03-03 21:34:05","sku":"IBPNpen","price":"58.00","name":"Iced Butterfly Pendant Necklace--Pendant","allow_backorder":1,"erp_id":551,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":864,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["sale","non-custom","ws","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IBR":{"id":62,"details_loaded_time":"2025-07-20 06:30:19","sku":"IBR","price":"40.00","name":"Iced Band","allow_backorder":0,"erp_id":354,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":62,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":254,"name":"Sterling Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false}],"tags":["sale","non-custom","ws","silver","bejeweled","sliver","diamond link ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","crown rings","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IC1":{"id":67,"details_loaded_time":"2025-07-20 09:16:34","sku":"IC1","price":"58.00","name":"Iced Croix Kit","allow_backorder":0,"erp_id":359,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":67,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","charm","charms","cross ne","cross necklace","iced cross pearl choker","rosary","silver cross","bejeweled","bejeweled pendant","golden diamond cross","saint christopher","cross men","saint mary","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","big cross"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IC1KIT":{"id":3321,"details_loaded_time":"2025-07-20 07:42:18","sku":"IC1KIT","price":"58.00","name":"Iced Croix","allow_backorder":1,"erp_id":1641,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3321,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":494,"name":"Iced Croix Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1501,"name":"Iced Croix Pendant","skip":false,"item":{"id":504,"name":"Iced Croix--Pendant","SKU":"IC1pen"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":494,"attribute_option_id":1501},{"attribute_id":496,"attribute_option_id":1505}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","charm","charms","cross ne","cross necklace","iced cross pearl choker","rosary","silver cross","bejeweled","bejeweled pendant","golden diamond cross","saint christopher","cross men","saint mary","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","big cross"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IC1pen":{"id":865,"details_loaded_time":"2025-07-20 08:38:04","sku":"IC1pen","price":"58.00","name":"Iced Croix--Pendant","allow_backorder":1,"erp_id":504,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":865,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ICB":{"id":840,"details_loaded_time":"2025-07-20 08:40:34","sku":"ICB","price":"55.00","name":"Iced Cross Bracelet","allow_backorder":1,"erp_id":535,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":840,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","sale","non-custom","ws","silver cross","brackets","bejeweled","iced cross b","cross men","crucifix","bracelet for guys","saint benedict coin","mini virgen","personalized bracelets for men","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ICCE":{"id":65,"details_loaded_time":"2022-09-15 21:03:07","sku":"ICCE","price":"23.31","name":"Iced Chain Cuff","allow_backorder":0,"erp_id":357,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":65,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ICH":{"id":68,"details_loaded_time":"2023-08-14 13:21:43","sku":"ICH","price":"58.00","name":"Iced Cross Huggies","allow_backorder":0,"erp_id":360,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":68,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["earrings","cross ne","cross necklace","iced cross pearl choker","silver cross","bejeweled","iced cross b","saint christopher","earrings men","cross men","saint mary","crucifix","saint benedict coin","mini virgen","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ICLB":{"id":69,"details_loaded_time":"2025-07-20 09:16:26","sku":"ICLB","price":"55.00","name":"Iced Cuban Link Bracelet","allow_backorder":1,"erp_id":361,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":69,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon! Only 1 left!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":242,"name":"2.7\"","skip":false,"parent_attribute":null,"weight":27}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":242}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":242}],"allow_backorder":true}],"tags":["bracelet","sale","non-custom","ws","tennis chain","tennis necklace","curb chain bff bracelet","brackets","bejeweled","cuban mariner","braceletbracelet","diamond cut cuban bracelets","iced curban","bracelet for guys","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ICLR":{"id":66,"details_loaded_time":"2025-07-20 06:28:42","sku":"ICLR","price":"60.00","name":"Iced Chain Link Ring","allow_backorder":0,"erp_id":358,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":66,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":22,"name":"Platinum","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":22},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":22},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":22},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":22},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["ring","non-custom","bejeweled","diamond link ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ICN":{"id":70,"details_loaded_time":"2025-07-20 09:16:18","sku":"ICN","price":"40.00","name":"Iced Cuban Link Necklace","allow_backorder":1,"erp_id":362,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":70,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon! When its gone its gone!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK! Discontinued","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":true},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","silver","silver","bejeweled","cuban mariner","sterling silver necklaces","iced curban","sliver necklaces","sliver","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ICPC":{"id":850,"details_loaded_time":"2025-07-20 08:38:42","sku":"ICPC","price":"65.00","name":"Iced Cross Pearl Choker","allow_backorder":0,"erp_id":541,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":850,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","iced cross pearl choker","tennis necklace","chocked","bejeweled","iced cross b","beads","saint christopher","st augustine cross necklace","saint mary","crucifix","saint benedict coin","pearlpear","link choker","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","beaded necklace","bead","vivienne westwood","items_mobile_app","vintage edit","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IDB":{"id":61,"details_loaded_time":"2025-07-20 06:30:25","sku":"IDB","price":"36.00","name":"Iced Baguette Ring","allow_backorder":0,"erp_id":353,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":61,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["sale","non-custom","ws","silver","silver","bejeweled","sliver","diamond link ring","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IDR":{"id":76,"details_loaded_time":"2025-07-20 09:14:23","sku":"IDR","price":"40.00","name":"Iced Ring","allow_backorder":1,"erp_id":368,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":76,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":85,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true}],"tags":["ring","topsell","sale","non-custom","ws","silver","silver","rings for men silver","wedding","bejeweled","ring for women","sliver","diamond link ring","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","crown rings","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IH2":{"id":157,"details_loaded_time":"2025-03-04 16:48:43","sku":"IH2","price":"50.00","name":"Interlocked Hoops","allow_backorder":1,"erp_id":456,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":157,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","topsell","sale","non-custom","ws","swimwear","got it on lock","boyfriend","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","chunky hoops","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IHE":{"id":3192,"details_loaded_time":"2025-07-20 07:48:22","sku":"IHE","price":"62.00","name":"Initial Hoop Earrings","allow_backorder":true,"erp_id":1509,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3192,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":509,"name":"Enter One Letter","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":1,"required":true,"type":"only_text","free_chars":1,"addtional_price_per_char":null,"special_chars":false,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true}],"tags":["custom","earrings"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IHN":{"id":839,"details_loaded_time":"2025-07-20 08:40:38","sku":"IHN","price":"42.00","name":"Italian Horn Necklace","allow_backorder":0,"erp_id":534,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":839,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","charm","charms","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IIA":{"id":906,"details_loaded_time":"2025-07-20 08:34:27","sku":"IIA","price":"35.00","name":"Iced Initial Anklet","allow_backorder":0,"erp_id":573,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":906,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"3":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"4":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"5":{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"6":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"7":{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"8":{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"10":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"11":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"13":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"14":{"image":null,"stock":143,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"15":{"image":null,"stock":69,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"16":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"17":{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"20":{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"21":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"22":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"23":{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"24":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"25":{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}},"tags":["anklet","topsell","sale","non-custom","ws","ankle bracelet","toe rings","ank","bejeweled","ryan anklets","sanklets","anklet bracelets","d anklet","anklet clasps","cuban anklet","intial","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IIPN":{"id":71,"details_loaded_time":"2025-07-20 09:16:10","sku":"IIPN","price":"38.00","name":"Iced Initial Pendant Necklace","allow_backorder":0,"erp_id":363,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":71,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"1":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"2":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"4":{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"5":{"image":null,"stock":183,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"6":{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"7":{"image":null,"stock":118,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"8":{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"11":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"13":{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"14":{"image":null,"stock":140,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"15":{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"16":{"image":null,"stock":159,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"17":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"19":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"20":{"image":null,"stock":161,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"21":{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"22":{"image":null,"stock":147,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"23":{"image":null,"stock":111,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"24":{"image":null,"stock":134,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"25":{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"78":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"79":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"80":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"81":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"82":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"83":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"84":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"85":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"86":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"87":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"88":{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"89":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"90":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"91":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"92":{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"93":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"94":{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"95":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"96":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"97":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"98":{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"99":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"100":{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"101":{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"102":{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false},"103":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":false}},"tags":["necklace","sale","non-custom","ws","silver","mens","men s","silver","initial necklace","initial","b initial necklace","initial charm","bejeweled pendant necklace","bejeweled","bejeweled pendant","letter d necklace","15 inch sterling silver name necklace","sterling silver necklaces","r necklace","sliver necklaces","sliver","intial","pindens","l necklace","j leclace","boyfriend","fiagro","men s initial","g necklace","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ILA":{"id":77,"details_loaded_time":"2025-07-20 09:14:16","sku":"ILA","price":"38.00","name":"Initial Letter Anklet","allow_backorder":0,"erp_id":369,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":77,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":240,"name":"8.2\"","skip":false,"parent_attribute":null,"weight":82}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":false},{"image":null,"stock":139,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":132}],"allow_backorder":false},{"image":null,"stock":545,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":133}],"allow_backorder":false},{"image":null,"stock":312,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":134}],"allow_backorder":false},{"image":null,"stock":423,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":135}],"allow_backorder":false},{"image":null,"stock":483,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":136}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":137}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":138}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":139}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":140}],"allow_backorder":false},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":141}],"allow_backorder":false},{"image":null,"stock":436,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":142}],"allow_backorder":false},{"image":null,"stock":307,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":143}],"allow_backorder":false},{"image":null,"stock":326,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":144}],"allow_backorder":false},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":145}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":146}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":147}],"allow_backorder":false},{"image":null,"stock":317,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":148}],"allow_backorder":false},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":149}],"allow_backorder":false},{"image":null,"stock":201,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":150}],"allow_backorder":false},{"image":null,"stock":144,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":151}],"allow_backorder":false},{"image":null,"stock":83,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":153}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":false},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":false},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":false},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":132}],"allow_backorder":false},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":133}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":134}],"allow_backorder":false},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":135}],"allow_backorder":false},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":136}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":137}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":138}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":139}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":140}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":141}],"allow_backorder":false},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":142}],"allow_backorder":false},{"image":null,"stock":58,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":143}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":144}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":145}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":146}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":147}],"allow_backorder":false},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":148}],"allow_backorder":false},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":149}],"allow_backorder":false},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":150}],"allow_backorder":false},{"image":null,"stock":63,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":151}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":153}],"allow_backorder":false},{"image":null,"stock":246,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":152}],"allow_backorder":false},{"image":null,"stock":76,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":152}],"allow_backorder":false}],"tags":["anklet","sale","non-custom","ws","ankle bracelet","initial charm","toe rings","ank","ryan anklets","sanklets","anklet bracelets","d anklet","anklet clasps","cuban anklet","intial","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ILH":{"id":72,"details_loaded_time":"2025-07-20 09:16:05","sku":"ILH","price":"58.00","name":"Iced Link Hoops","allow_backorder":0,"erp_id":364,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":72,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":85,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["earrings","non-custom","bejeweled","items_mobile_app","chunky hoops","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IMP":{"id":73,"details_loaded_time":"2024-02-22 16:23:11","sku":"IMP","price":"65.00","name":"Iced Mary Pendant","allow_backorder":0,"erp_id":365,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":73,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","non-custom","virgin mary","charm","charms","virgin mary necklace","bejeweled pendant necklace","guadalupe","bejeweled","bejeweled pendant","gold diamond virgin mary necklace","mother mary","our lady of guadalupe","saint mary","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IMPKIT":{"id":3481,"details_loaded_time":"2025-07-20 07:34:28","sku":"IMPKIT","price":"65.00","name":"Iced Mary Pendant Necklace","allow_backorder":1,"erp_id":1704,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3481,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":635,"name":"Iced Mary Pendant--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2009,"name":"Iced Mary Pendant--Pendant","skip":false,"item":{"id":552,"name":"Iced Mary Pendant--Pendant","SKU":"IMPpen"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":635,"attribute_option_id":2009}],"allow_backorder":true}],"tags":["non-custom","virgin mary","charm","charms","virgin mary necklace","bejeweled pendant necklace","guadalupe","bejeweled","bejeweled pendant","gold diamond virgin mary necklace","mother mary","our lady of guadalupe","saint mary","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IMPpen":{"id":866,"details_loaded_time":"2025-07-20 08:36:42","sku":"IMPpen","price":"65.00","name":"Iced Mary Pendant--Pendant","allow_backorder":1,"erp_id":552,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":866,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["religious","non-custom","j pendant","mother mary","saint mary","saint benedict coin"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"INTIALCHARM":{"id":3622,"details_loaded_time":"2025-07-20 07:20:28","sku":"INTIALCHARM","price":"18.00","name":"Initial Charm","allow_backorder":1,"erp_id":1829,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3622,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":690,"name":"Charm Letters","quantity":1,"description":null,"type":"list","options":[{"id":2214,"name":"A","skip":false,"parent_attribute":null},{"id":2215,"name":"B","skip":false,"parent_attribute":null},{"id":2216,"name":"C","skip":false,"parent_attribute":null},{"id":2217,"name":"D","skip":false,"parent_attribute":null},{"id":2218,"name":"E","skip":false,"parent_attribute":null},{"id":2219,"name":"F","skip":false,"parent_attribute":null},{"id":2220,"name":"G","skip":false,"parent_attribute":null},{"id":2221,"name":"H","skip":false,"parent_attribute":null},{"id":2222,"name":"I","skip":false,"parent_attribute":null},{"id":2223,"name":"J","skip":false,"parent_attribute":null},{"id":2224,"name":"K","skip":false,"parent_attribute":null},{"id":2225,"name":"L","skip":false,"parent_attribute":null},{"id":2226,"name":"M","skip":false,"parent_attribute":null},{"id":2227,"name":"N","skip":false,"parent_attribute":null},{"id":2228,"name":"O","skip":false,"parent_attribute":null},{"id":2229,"name":"P","skip":false,"parent_attribute":null},{"id":2230,"name":"Q","skip":false,"parent_attribute":null},{"id":2231,"name":"R","skip":false,"parent_attribute":null},{"id":2232,"name":"S","skip":false,"parent_attribute":null},{"id":2233,"name":"T","skip":false,"parent_attribute":null},{"id":2234,"name":"U","skip":false,"parent_attribute":null},{"id":2235,"name":"V","skip":false,"parent_attribute":null},{"id":2236,"name":"W","skip":false,"parent_attribute":null},{"id":2237,"name":"X","skip":false,"parent_attribute":null},{"id":2238,"name":"Y","skip":false,"parent_attribute":null},{"id":2239,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"INTSTD":{"id":738,"details_loaded_time":"2025-07-20 08:46:18","sku":"INTSTD","price":"30.00","name":"Initial Studs","allow_backorder":0,"erp_id":503,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":738,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":false},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":false},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":false},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":false},{"image":null,"stock":132,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132}],"allow_backorder":false},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133}],"allow_backorder":false},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134}],"allow_backorder":false},{"image":null,"stock":124,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135}],"allow_backorder":false},{"image":null,"stock":164,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137}],"allow_backorder":false},{"image":null,"stock":63,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138}],"allow_backorder":false},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140}],"allow_backorder":false},{"image":null,"stock":119,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141}],"allow_backorder":false},{"image":null,"stock":146,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142}],"allow_backorder":false},{"image":null,"stock":140,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143}],"allow_backorder":false},{"image":null,"stock":156,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144}],"allow_backorder":false},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145}],"allow_backorder":false},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146}],"allow_backorder":false},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147}],"allow_backorder":false},{"image":null,"stock":157,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148}],"allow_backorder":false},{"image":null,"stock":152,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149}],"allow_backorder":false},{"image":null,"stock":150,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150}],"allow_backorder":false},{"image":null,"stock":162,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151}],"allow_backorder":false},{"image":null,"stock":148,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152}],"allow_backorder":false},{"image":null,"stock":147,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","initial","initial j","v initial","initial charm","earrings men","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","s earring","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IOP":{"id":74,"details_loaded_time":"2020-10-01 17:01:37","sku":"IOP","price":"30.00","name":"Iced Om Pendant","allow_backorder":0,"erp_id":366,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":74,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":"1","price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IOPpen":{"id":867,"details_loaded_time":"2020-12-03 22:07:03","sku":"IOPpen","price":"15.00","name":"Iced Om Pendant--Pendant","allow_backorder":1,"erp_id":553,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":867,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IPCC":{"id":78,"details_loaded_time":"2025-07-20 09:14:08","sku":"IPCC","price":"35.00","name":"Initial Pendant Choker","allow_backorder":0,"erp_id":370,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":78,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":244,"name":"15.8\"","skip":false,"parent_attribute":null,"weight":158}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":75,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":83,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":100,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":75,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":88,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":244},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","initial necklace","initial","initial j","v initial","b initial necklace","initial charm","chocked","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IRC":{"id":3193,"details_loaded_time":"2025-07-20 07:48:18","sku":"IRC","price":"75.00","name":"Initial Ring","allow_backorder":true,"erp_id":1510,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3193,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":509,"name":"Enter One Letter","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":1,"required":true,"type":"only_text","free_chars":1,"addtional_price_per_char":null,"special_chars":false,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":35,"attribute_option_id":212}],"allow_backorder":true}],"tags":["ring","new","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IRN":{"id":848,"details_loaded_time":"2025-07-20 08:40:10","sku":"IRN","price":"65.00","name":"Iced Ruby Necklace","allow_backorder":0,"erp_id":539,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":848,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon! When its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","red ruby","ruby","emerald stone necklace","bejeweled","necklace with a gem","amethyst","emerald gold necklace","sapphire","garnet","pindens","waterproof","birthstone","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","birth stone","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IRR":{"id":75,"details_loaded_time":"2025-07-20 09:14:35","sku":"IRR","price":"38.00","name":"Iced Rainbow Ring","allow_backorder":1,"erp_id":367,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":75,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":103,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":123,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],"allow_backorder":true}],"tags":["ring","sale","non-custom","ws","bejeweled","ring for women","woman blue ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ISABC":{"id":3643,"details_loaded_time":"2025-07-20 07:16:17","sku":"ISABC","price":"18.00","name":"Isabel Charm","allow_backorder":1,"erp_id":1814,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3643,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ISNE":{"id":1158,"details_loaded_time":"2022-11-22 14:07:05","sku":"ISNE","price":"42.00","name":"Iced Smiley Necklace","allow_backorder":0,"erp_id":759,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1158,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","new","sale","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"IZS":{"id":708,"details_loaded_time":"2025-07-20 08:48:05","sku":"IZS","price":"160.00","name":"Iced Zodiac Set","allow_backorder":1,"erp_id":428,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":708,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":27,"name":"Classic Old English Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":584,"name":"Block Letter Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1882,"name":"Block Letter Necklace--Pendant","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","SKU":"BLKLNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":56,"name":"Iced Ring","quantity":1,"description":null,"type":"item","options":[{"id":270,"name":"Iced Ring","skip":false,"item":{"id":368,"name":"Iced Ring","SKU":"IDR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":85,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":27,"attribute_option_id":113},{"attribute_id":56,"attribute_option_id":270},{"attribute_id":584,"attribute_option_id":1882},{"attribute_id":585,"attribute_option_id":1884}],"allow_backorder":true}],"tags":["set","custom-set","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","horoscope pendant necklace","horroscope pendant necklace","pisceszodiac","star sign","starsign","star girl","bejeweled","birthday charms","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"JBPN":{"id":80,"details_loaded_time":"2024-03-29 17:34:18","sku":"JBPN","price":"58.00","name":"Jade Buddha Pendant Necklace","allow_backorder":0,"erp_id":372,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":80,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","non-custom","charm","charms","emerald stone necklace","necklace with a gem","emerald gold necklace","green marbled","pindens","waterproof","birthstone","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"JBPNKIT":{"id":3320,"details_loaded_time":"2025-07-20 07:42:25","sku":"JBPNKIT","price":"58.00","name":"Jade Buddha Pendant Necklace Kit","allow_backorder":1,"erp_id":1640,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3320,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"JBPNpen":"JBPNpen","REC":"REC"}},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null,"skus":{"JBPNpen":"JBPNpen","REC":"REC"}}],"skus":{"JBPNpen":"JBPNpen","REC":"REC"},"top_level":true}],"grouped_attributes_ids":[11],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":{"11":11}},"attributes":[{"id":591,"name":"Jade Buddha Pendant Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1892,"name":"Jade Buddha Pendant Necklace--Pendant","skip":false,"item":{"id":555,"name":"Jade Buddha Pendant Necklace--Pendant","SKU":"JBPNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":442,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1360,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":442,"attribute_option_id":1360},{"attribute_id":591,"attribute_option_id":1892}],"allow_backorder":true}],"tags":["necklace","non-custom","charm","charms","emerald stone necklace","necklace with a gem","emerald gold necklace","green marbled","pindens","waterproof","birthstone","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"JBPNpen":{"id":869,"details_loaded_time":"2025-07-20 08:36:34","sku":"JBPNpen","price":"58.00","name":"Jade Buddha Pendant Necklace--Pendant","allow_backorder":1,"erp_id":555,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":869,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon! When its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["sale","non-custom","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"JULHOOP":{"id":3823,"details_loaded_time":"2025-07-20 07:01:15","sku":"JULHOOP","price":"60.00","name":"Julienne Hoops","allow_backorder":1,"erp_id":1893,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3823,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"KC":{"id":3638,"details_loaded_time":"2025-07-20 07:16:37","sku":"KC","price":"18.00","name":"Key Charm","allow_backorder":1,"erp_id":1808,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3638,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"Kit Item Test":{"id":717,"details_loaded_time":"2020-05-28 12:40:37","sku":"Kit Item Test","price":"120.00","name":"Kit Item Test","allow_backorder":1,"erp_id":485,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":717,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":2,"attribute_option_id":1}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":98,"name":"Test Item 1","type":"item","options":[{"id":394,"name":"Test Item 1","skip":false,"item":{"id":483,"name":"Test Item 1","SKU":"TestItem1"},"item_option_combinations":[{"attribute_id":2,"attribute_option_id":1},{"attribute_id":2,"attribute_option_id":4},{"attribute_id":2,"attribute_option_id":5}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":99,"name":"Test Item 2","type":"item","options":[{"id":396,"name":"Test Item 2","skip":false,"item":{"id":484,"name":"Test Item 2","SKU":"Test Item 2"},"item_option_combinations":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":34,"attribute_option_id":131}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":98,"attribute_option_id":394},{"attribute_id":99,"attribute_option_id":396}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LBN":{"id":849,"details_loaded_time":"2025-07-20 08:40:05","sku":"LBN","price":"38.00","name":"Linked Bar Necklace","allow_backorder":0,"erp_id":540,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":849,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LC":{"id":3651,"details_loaded_time":"2025-07-20 07:14:27","sku":"LC","price":"18.00","name":"Lock Charm","allow_backorder":1,"erp_id":1805,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3651,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","charm","charms","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LCN":{"id":833,"details_loaded_time":"2025-07-20 08:42:21","sku":"LCN","price":"40.00","name":"Link Chain Necklace","allow_backorder":0,"erp_id":528,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":833,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":63,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","mens mini chain","chocked","baby chain","swimwear","link choker","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LCNECK":{"id":3868,"details_loaded_time":"2025-07-20 06:53:19","sku":"LCNECK","price":"65.00","name":"Layering Cross Necklace","allow_backorder":1,"erp_id":1927,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3868,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LEGCN":{"id":3862,"details_loaded_time":"2025-07-20 06:53:36","sku":"LEGCN","price":"65.00","name":"Legacy Chain","allow_backorder":1,"erp_id":1921,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3862,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LEMDEAR":{"id":3830,"details_loaded_time":"2025-07-20 06:59:30","sku":"LEMDEAR","price":"65.00","name":"Lemon Drop Earrings","allow_backorder":1,"erp_id":1899,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3830,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LFC":{"id":779,"details_loaded_time":"2024-04-04 18:13:45","sku":"LFC","price":"55.00","name":"Layering Figaro Chain","allow_backorder":0,"erp_id":510,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":779,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","figaro c","baby chain","fig layering","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LFIN":{"id":81,"details_loaded_time":"2025-07-20 09:12:40","sku":"LFIN","price":"80.00","name":"Love Forever Initial Necklace","allow_backorder":true,"erp_id":373,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":81,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":117,"name":"Initials","quantity":1,"description":null,"type":"text","validation":{"min_chars":2,"max_chars":2,"required":true,"type":"only_text","free_chars":2,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","silver","initial necklace","initial","initial j","b initial necklace","initial charm","wedding","15 inch sterling silver name necklace","sterling silver necklaces","sliver necklaces","sliver","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LFL":{"id":82,"details_loaded_time":"2025-03-20 12:53:15","sku":"LFL","price":"40.00","name":"Love Forever Locket","allow_backorder":0,"erp_id":374,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":82,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"list","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","photo necklace","heart lock","lock it necklace","got it on lock","pindens","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","lock nec","items_mobile_app","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LFLP":{"id":3438,"details_loaded_time":"2024-02-28 15:31:25","sku":"LFLP","price":"40.00","name":"Love Forever Locket- Pendant","allow_backorder":1,"erp_id":1634,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3438,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":566,"name":"Love Forever Locket","description":null,"type":"item","options":[{"id":1836,"name":"Love Forever Locket","skip":false,"item":{"id":374,"name":"Love Forever Locket","SKU":"LFL"},"attributes_per_every_item":[{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","description":null,"type":"List","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17892,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1560,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":2357,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":831,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2240,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1262,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":503,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":356,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":566,"attribute_option_id":1836}],"allow_backorder":true}],"tags":["non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LFLpen":{"id":870,"details_loaded_time":"2024-04-04 20:01:58","sku":"LFLpen","price":"21.00","name":"Love Forever Locket--Pendant","allow_backorder":1,"erp_id":556,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":870,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","description":null,"type":"list","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LKN":{"id":687,"details_loaded_time":"2025-02-14 16:29:15","sku":"LKN","price":"38.00","name":"Locked Necklace","allow_backorder":0,"erp_id":477,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":687,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","playboy","got it on lock","pindens","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","lock nec","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LMC":{"id":3637,"details_loaded_time":"2025-07-20 07:16:41","sku":"LMC","price":"18.00","name":"Love Me Charm","allow_backorder":1,"erp_id":1807,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3637,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LNKH":{"id":695,"details_loaded_time":"2024-08-29 20:27:04","sku":"LNKH","price":"46.00","name":"Linked Hoops","allow_backorder":0,"erp_id":478,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":695,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","items_mobile_app","chunky hoops","don't notify"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LOTNECKIT":{"id":3846,"details_loaded_time":"2025-07-20 06:57:09","sku":"LOTNECKIT","price":"65.00","name":"Lotus Necklace","allow_backorder":1,"erp_id":1912,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3846,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":736,"name":"Lotus Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2376,"name":"Lotus Pendant","skip":false,"item":{"id":1905,"name":"Lotus Pendant","SKU":"LOTPENDANT"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":716,"name":"Dainty Herringbone Chain","quantity":1,"description":null,"type":"item","options":[{"id":2307,"name":"Dainty Herringbone Chain","skip":false,"item":{"id":1696,"name":"Dainty Herringbone Chain","SKU":"DHERCH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":716,"attribute_option_id":2307},{"attribute_id":736,"attribute_option_id":2376}],"allow_backorder":true}],"tags":["necklace","new","topsell","charm","charms","e necklaces","best sellers","top seller","best seller","waterproof","tarnish free","water proof","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LOTPENDANT":{"id":3836,"details_loaded_time":"2025-07-20 06:59:04","sku":"LOTPENDANT","price":"65.00","name":"Lotus Pendant","allow_backorder":1,"erp_id":1905,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3836,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LRIN":{"id":1166,"details_loaded_time":"2025-07-20 08:22:08","sku":"LRIN","price":"60.00","name":"Lucky Ring","allow_backorder":1,"erp_id":760,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1166,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon! When its gone its gone!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":498,"name":"Brass","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":498}],"allow_backorder":true}],"tags":["ring","sale","non-custom","ws","horseshoe","ring for women","horse shoe","horse shoe ring","waterproof","horse show ring","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LSHBN":{"id":1506,"details_loaded_time":"2025-07-20 08:12:04","sku":"LSHBN","price":"55.00","name":"Layered Stack Herringbone Necklace","allow_backorder":0,"erp_id":1055,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1506,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","men herringbone gold chain","say my name","say my name collection","summer collection","bikini","swimwear","herrington bone chain","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LUBMEN":{"id":3098,"details_loaded_time":"2025-07-20 07:50:40","sku":"LUBMEN","price":"115.00","name":"Linked Up Bracelet","allow_backorder":0,"erp_id":1465,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3098,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LUCMEN":{"id":3099,"details_loaded_time":"2025-07-20 07:50:36","sku":"LUCMEN","price":"129.00","name":"Linked Up Chain","allow_backorder":1,"erp_id":1464,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3099,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LUS":{"id":908,"details_loaded_time":"2025-07-20 08:34:16","sku":"LUS","price":"160.00","name":"Linked Up Set","allow_backorder":0,"erp_id":579,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":908,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":115,"name":"Chunky Link Necklace","quantity":1,"description":null,"type":"item","options":[{"id":442,"name":"Chunky Link Necklace","skip":false,"item":{"id":468,"name":"Chunky Link Necklace","SKU":"CLN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":122,"name":"Old English Lock Necklace","quantity":1,"description":null,"type":"item","options":[{"id":452,"name":"Old English Lock Necklace","skip":false,"item":{"id":463,"name":"Old English Lock Necklace","SKU":"OELN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":366,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":213,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":124,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":56,"name":"Iced Ring","quantity":1,"description":null,"type":"item","options":[{"id":270,"name":"Iced Ring","skip":false,"item":{"id":368,"name":"Iced Ring","SKU":"IDR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":85,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":56,"attribute_option_id":270},{"attribute_id":115,"attribute_option_id":442},{"attribute_id":122,"attribute_option_id":452}],"allow_backorder":false}],"tags":["set","non-custom","men chains","men chain","gold plated chain mens","gold chain men","chains for men","chain gold men","lock it necklace","baby chain","iced curban","cuban anklet","got it on lock","diamond link ring","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","lock nec","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LUXEN":{"id":3417,"details_loaded_time":"2024-05-14 14:13:58","sku":"LUXEN","price":null,"name":"Luxe Necklace","allow_backorder":1,"erp_id":1630,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3417,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LVMN":{"id":1513,"details_loaded_time":"2023-08-11 16:07:32","sku":"LVMN","price":"65.00","name":"Love Me Necklace","allow_backorder":0,"erp_id":1066,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1513,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","type":"list","options":[{"id":799,"name":"Pink","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":799},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","sale","non-custom","ws","say my name","heart lock","necklace with a gem","say my name collection","summer collection","playboy","waterproof","baby pink bubble clip","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LYC":{"id":3642,"details_loaded_time":"2025-07-20 07:18:28","sku":"LYC","price":"18.00","name":"Lucky You Charm","allow_backorder":1,"erp_id":1813,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3642,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"LYTH":{"id":3511,"details_loaded_time":"2025-07-20 07:28:34","sku":"LYTH","price":"25.00","name":"Lucky You Trucker Hat","allow_backorder":1,"erp_id":1737,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3511,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":549,"name":"Cream","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":549}],"allow_backorder":true}],"tags":["new","accessories","non-custom","hat","trucker","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MACB":{"id":1144,"details_loaded_time":"2025-07-20 08:24:32","sku":"MACB","price":"50.00","name":"Mariner Chain Bracelet","allow_backorder":0,"erp_id":736,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1144,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["bracelet","topsell","non-custom","brackets","braceletbracelet","bracelet for guys","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MACHARM":{"id":3748,"details_loaded_time":"2025-07-20 07:03:42","sku":"MACHARM","price":"18.00","name":"Mama Charm","allow_backorder":1,"erp_id":1877,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3748,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MACPN":{"id":86,"details_loaded_time":"2025-07-20 09:12:20","sku":"MACPN","price":"58.00","name":"Mini Ankh Cross Pendant Necklace","allow_backorder":1,"erp_id":378,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":86,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":56,"name":"Skip","skip":true,"parent_attribute":null,"weight":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},"2":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},"4":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}},"tags":["necklace","sale","non-custom","ws","charm","charms","iced cross pearl choker","silver cross","ank","eye of ra","ankah","cross men","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MACPNpen":{"id":872,"details_loaded_time":"2022-08-08 12:59:39","sku":"MACPNpen","price":"16.10","name":"Mini Ankh Cross Pendant Necklace--Pendant","allow_backorder":1,"erp_id":558,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":872,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MAHOGSET":{"id":3912,"details_loaded_time":"2025-07-20 06:49:17","sku":"MAHOGSET","price":"135.00","name":"Mahogony Set","allow_backorder":1,"erp_id":1949,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3912,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":738,"name":"Mahogony Chain","quantity":1,"description":null,"type":"item","options":[{"id":2384,"name":"Mahogony Chain","skip":false,"item":{"id":1931,"name":"Mahogony Chain","SKU":"MCNECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":740,"name":"Mahogony Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":2388,"name":"Mahogony Bracelet","skip":false,"item":{"id":1846,"name":"The Mahogany Bracelet","SKU":"TMBRACE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":739,"name":"Major League Band","quantity":1,"description":null,"type":"item","options":[{"id":2386,"name":"Major League Band","skip":false,"item":{"id":1947,"name":"Major League Band","SKU":"MLBAND"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160}]],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":738,"attribute_option_id":2384},{"attribute_id":739,"attribute_option_id":2386},{"attribute_id":740,"attribute_option_id":2388}],"allow_backorder":true}],"tags":["new","set","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MAMAN":{"id":1181,"details_loaded_time":"2025-07-20 08:18:35","sku":"MAMAN","price":"60.00","name":"Mama Necklace","allow_backorder":0,"erp_id":787,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1181,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","mama chains","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MARCANK":{"id":3537,"details_loaded_time":"2025-07-20 07:24:11","sku":"MARCANK","price":"50.00","name":"Mariner Chain Anklet","allow_backorder":1,"erp_id":1766,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3537,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":222,"name":"7.8\"","skip":false,"parent_attribute":null,"weight":78}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","non-custom","ankle bracelet","toe rings","ank","sanklets","anklet bracelets","anklet clasps","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","endless summer campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MARTC":{"id":3648,"details_loaded_time":"2025-07-20 07:14:39","sku":"MARTC","price":"18.00","name":"Martini Charm","allow_backorder":1,"erp_id":1819,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3648,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MBHE":{"id":87,"details_loaded_time":"2025-07-20 09:12:15","sku":"MBHE","price":"55.00","name":"Mini Bamboo Huggie Earrings","allow_backorder":1,"erp_id":379,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":87,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","non-custom","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCCH":{"id":90,"details_loaded_time":"2025-04-04 14:04:35","sku":"MCCH","price":"49.00","name":"Mini Crystal Cross Huggies","allow_backorder":1,"erp_id":382,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":90,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Only 2 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["earrings","sale","non-custom","ws","cross ne","cross necklace","silver cross","earrings men","cross men","st augustine cross necklace","crucifix","saint benedict coin","mini virgen","st jude","cross tag necklace","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCH":{"id":696,"details_loaded_time":"2024-05-10 12:29:17","sku":"MCH","price":"48.00","name":"Mini Cable Hoops","allow_backorder":0,"erp_id":479,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":696,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","earrings sterling","14k gold","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","chunky hoops"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCHARM":{"id":3753,"details_loaded_time":"2025-07-20 07:03:24","sku":"MCHARM","price":"18.00","name":"Match Charm","allow_backorder":1,"erp_id":1882,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3753,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCLBMEN":{"id":3092,"details_loaded_time":"2025-07-20 07:52:27","sku":"MCLBMEN","price":"79.00","name":"Men's Cuban Link Band","allow_backorder":1,"erp_id":1458,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3092,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":155,"name":"Black","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null},{"id":792,"name":"11","skip":false,"parent_attribute":null},{"id":793,"name":"12","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":792},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":793},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":792},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":792},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":793},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":793},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens rings","men rings","mens jewelry","rings for men silver","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCLN":{"id":852,"details_loaded_time":"2025-07-20 08:38:34","sku":"MCLN","price":"49.00","name":"Mini Chunky Link Necklace","allow_backorder":0,"erp_id":543,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":852,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","baby chain","mini mar","link choker","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCLR":{"id":88,"details_loaded_time":"2022-11-22 14:19:21","sku":"MCLR","price":"25.90","name":"Mini Chain Link Ring","allow_backorder":0,"erp_id":380,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":88,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":254,"name":"Sterling Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false}],"tags":["ring","sale","non-custom","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCNECK":{"id":3871,"details_loaded_time":"2025-07-20 06:53:10","sku":"MCNECK","price":"65.00","name":"Mahogony Chain","allow_backorder":1,"erp_id":1931,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3871,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","chain","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCP":{"id":89,"details_loaded_time":"2021-01-09 00:03:36","sku":"MCP","price":"25.00","name":"Mini Cross Pendant","allow_backorder":0,"erp_id":381,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":89,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","type":"list","options":[{"id":258,"name":"1.7 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":258},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":1,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":258},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCPpen":{"id":873,"details_loaded_time":"2020-12-06 14:15:39","sku":"MCPpen","price":"12.50","name":"Mini Cross Pendant-Pendant","allow_backorder":1,"erp_id":559,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":873,"force_allow_backorder":false,"attributes":[{"id":52,"name":"Pendant Size","type":"list","options":[{"id":258,"name":"1.7 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":52,"attribute_option_id":258},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MCR":{"id":921,"details_loaded_time":"2022-12-06 08:57:13","sku":"MCR","price":"15.75","name":"Minty Chain Ring","allow_backorder":0,"erp_id":607,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":921,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MION":{"id":1192,"details_loaded_time":"2025-07-20 08:15:33","sku":"MION","price":"60.00","name":"Make it Official Necklace","allow_backorder":0,"erp_id":788,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1192,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","giftcol","wedding","mrs","moh","maid of honor","briide","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MIRR":{"id":91,"details_loaded_time":"2025-07-20 09:10:40","sku":"MIRR","price":"34.00","name":"Mini Iced Rainbow Ring","allow_backorder":0,"erp_id":383,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":91,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":75,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":105,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["sale","non-custom","ws","bejeweled","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MIXCUFF":{"id":3840,"details_loaded_time":"2025-07-20 06:57:27","sku":"MIXCUFF","price":"55.00","name":"Mixed Metal Earcuff","allow_backorder":1,"erp_id":1895,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3840,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MJA":{"id":83,"details_loaded_time":"2020-05-28 18:55:18","sku":"MJA","price":"55.00","name":"Mary Jane Anklet","allow_backorder":1,"erp_id":375,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":83,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":221,"name":"7.3\"","skip":false,"parent_attribute":null,"weight":73}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":221},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["anklet","mayfair"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MJH":{"id":84,"details_loaded_time":"2025-07-20 09:12:30","sku":"MJH","price":"36.00","name":"Mary Jane Huggies","allow_backorder":0,"erp_id":376,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":84,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","weed","leaf","weed leaf","cigars","marijuana earrings","earrings men","mini mar","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","pot leaf","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MJPN":{"id":85,"details_loaded_time":"2024-01-02 14:26:09","sku":"MJPN","price":"58.00","name":"Mary Jane Pendant Necklace Kit","allow_backorder":0,"erp_id":377,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":85,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","description":null,"type":"list","options":[{"id":257,"name":"2.2 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":257}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":257}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":257}],"allow_backorder":false}],"tags":["necklace","non-custom","ws","weed","leaf","charm","charms","weed leaf","cigars","marijuana earrings","mini mar","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","pot leaf","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MJPNKIT":{"id":3317,"details_loaded_time":"2025-07-20 07:42:30","sku":"MJPNKIT","price":"58.00","name":"Mary Jane Pendant Necklace","allow_backorder":1,"erp_id":1637,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3317,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":257}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":588,"name":"Mary Jane Pendant Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1888,"name":"Mary Jane Pendant Necklace--Pendant","skip":false,"item":{"id":557,"name":"Mary Jane Pendant Necklace--Pendant","SKU":"MJPNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"List","options":[{"id":257,"name":"2.2 cm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":257}]],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":257}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":588,"attribute_option_id":1888}],"allow_backorder":true}],"tags":["necklace","non-custom","ws","weed","leaf","charm","charms","weed leaf","cigars","marijuana earrings","mini mar","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","pot leaf","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MJPNpen":{"id":871,"details_loaded_time":"2025-07-20 08:36:29","sku":"MJPNpen","price":"17.50","name":"Mary Jane Pendant Necklace--Pendant","allow_backorder":1,"erp_id":557,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":871,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"list","options":[{"id":257,"name":"2.2 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":257}],"allow_backorder":true}],"tags":["sale","non-custom","ws","weed","weed leaf","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MLBAND":{"id":3892,"details_loaded_time":"2025-07-20 06:50:30","sku":"MLBAND","price":"60.00","name":"Major League Band","allow_backorder":1,"erp_id":1947,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3892,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MMCR":{"id":3709,"details_loaded_time":"2025-07-20 07:09:40","sku":"MMCR","price":"60.00","name":"Mixed Metal Cable Ring","allow_backorder":1,"erp_id":1842,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3709,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MMN":{"id":92,"details_loaded_time":"2025-07-20 09:10:34","sku":"MMN","price":"58.00","name":"Mini Mary Necklace","allow_backorder":1,"erp_id":384,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":92,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","virgin mary","charm","charms","virgin mary necklace","guadalupe","gold diamond virgin mary necklace","mother mary","our lady of guadalupe","saint mary","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MMNpen":{"id":874,"details_loaded_time":"2025-07-20 08:36:20","sku":"MMNpen","price":"58.00","name":"Mini Mary Necklace Pendant","allow_backorder":1,"erp_id":560,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":874,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true},{"image":null,"stock":165,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":true}],"tags":["necklace","religious","non-custom","pindens","tarnish free","tarnishfree","tarnish-free"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MMPN":{"id":3162,"details_loaded_time":"2025-07-20 07:48:30","sku":"MMPN","price":"58.00","name":"Mini Mary Pendant","allow_backorder":0,"erp_id":1481,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3162,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MNBN":{"id":94,"details_loaded_time":"2025-07-20 09:10:21","sku":"MNBN","price":"80.00","name":"Multi-Name Block Nameplate","allow_backorder":true,"erp_id":386,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":94,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":49,"name":"word2","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","daniel","gabriel neckless","brooklyn love","nathan","alessandra","dominique","addison","multi name nameplate","nameplate essential necklace","delores name charm","yasmine","malena","bikini","swimwear","cayden","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","18k gold plated neckless alex","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","ny necklace","nyc","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MNHN":{"id":95,"details_loaded_time":"2025-07-20 09:10:16","sku":"MNHN","price":"80.00","name":"Multi-Name Heart Nameplate","allow_backorder":true,"erp_id":387,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":95,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":49,"name":"word2","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","multi name nameplate","nameplate essential necklace","14k gold","waterproof","18k gold plated neckless alex","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MNSN":{"id":96,"details_loaded_time":"2025-07-20 09:10:11","sku":"MNSN","price":"80.00","name":"Multi-Name Script Nameplate","allow_backorder":true,"erp_id":388,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":96,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":38,"name":"Word","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":49,"name":"word2","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","multi name nameplate","delores name necklace","waterproof","18k gold platedwith your nameneckless alex","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MOMN":{"id":1183,"details_loaded_time":"2025-07-20 08:18:23","sku":"MOMN","price":"60.00","name":"Mommy Necklace","allow_backorder":0,"erp_id":785,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1183,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","mama chains","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MOMNE":{"id":1182,"details_loaded_time":"2025-07-20 08:18:29","sku":"MOMNE","price":"60.00","name":"Mom Necklace","allow_backorder":0,"erp_id":786,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1182,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","mama chains","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MONCRIS":{"id":3831,"details_loaded_time":"2025-07-20 06:59:26","sku":"MONCRIS","price":"60.00","name":"The Monte Cristo","allow_backorder":1,"erp_id":1900,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3831,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MOR":{"id":1288,"details_loaded_time":"2024-05-09 18:35:51","sku":"MOR","price":"38.00","name":"Moo Ring","allow_backorder":0,"erp_id":811,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1288,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Item Discontinued","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","moon","ring for women","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MPBC":{"id":3505,"details_loaded_time":"2025-07-20 07:30:13","sku":"MPBC","price":"4.05","name":"5 Panel Mid Profile Baseball Cap","allow_backorder":0,"erp_id":1449,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3505,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":1474,"name":"0311 Blk\/Natl","skip":false,"parent_attribute":null},{"id":1508,"name":"1731 DK. Green\/Natl","skip":false,"parent_attribute":null},{"id":1490,"name":"0431 Nvy\/Natrl","skip":false,"parent_attribute":null},{"id":1516,"name":"3217 Kha\/DkGrn","skip":false,"parent_attribute":null},{"id":1744,"name":"0316 - Blk\/Wht","skip":false,"parent_attribute":null},{"id":2049,"name":"003 - Solid Black","skip":false,"parent_attribute":null},{"id":2380,"name":"Khaki Solid","skip":false,"parent_attribute":null},{"id":2381,"name":"0231 Red\/Nat","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":1474}],"allow_backorder":false},"2":{"image":null,"stock":162,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":1490}],"allow_backorder":false},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":1516}],"allow_backorder":false},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":1744}],"allow_backorder":false},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2049}],"allow_backorder":false},"6":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2380}],"allow_backorder":false},"7":{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2381}],"allow_backorder":false}},"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MPH":{"id":93,"details_loaded_time":"2025-07-20 09:10:28","sku":"MPH","price":"55.00","name":"Mini Pearl Hoops","allow_backorder":0,"erp_id":385,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":93,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":68,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["earrings","topsell","non-custom","chanel","wedding","pearlpear","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","sofia richie","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MPNMEN":{"id":3091,"details_loaded_time":"2025-07-20 07:52:31","sku":"MPNMEN","price":"105.00","name":"Men's Pendant Necklace","allow_backorder":1,"erp_id":1461,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3091,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens chain","mens jewelry","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MR":{"id":1116,"details_loaded_time":"2024-02-08 16:07:43","sku":"MR","price":"30.00","name":"Melted Ring","allow_backorder":0,"erp_id":633,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1116,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":418,"name":"Gold","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MRCMEN2":{"id":3096,"details_loaded_time":"2025-07-20 07:52:09","sku":"MRCMEN2","price":"79.00","name":"2.3 mm Rope Chain","allow_backorder":1,"erp_id":1452,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3096,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"10.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"10.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MRCMEN4":{"id":3103,"details_loaded_time":"2025-07-20 07:50:18","sku":"MRCMEN4","price":"99.00","name":"4 mm Rope Chain","allow_backorder":1,"erp_id":1453,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3103,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"11.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":25,"price_change":"11.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MRCMEN6":{"id":3105,"details_loaded_time":"2025-07-20 07:50:09","sku":"MRCMEN6","price":"115.00","name":"6 mm Rope Chain","allow_backorder":1,"erp_id":1454,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3105,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"10.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"10.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MRCMEN8":{"id":3107,"details_loaded_time":"2025-07-20 07:48:42","sku":"MRCMEN8","price":"129.00","name":"8 mm Rope Chain","allow_backorder":1,"erp_id":1455,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3107,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"6.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"6.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MRCN":{"id":1502,"details_loaded_time":"2025-07-20 08:12:15","sku":"MRCN","price":"55.00","name":"Mariner Chain","allow_backorder":0,"erp_id":1062,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1502,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":68,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","say my name","cuban mariner","say my name collection","summer collection","fall","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MRH":{"id":813,"details_loaded_time":"2025-07-20 08:44:14","sku":"MRH","price":"55.00","name":"Mini Rope Hoops","allow_backorder":0,"erp_id":518,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":813,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","non-custom","items_mobile_app","chunky hoops","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MRING":{"id":3520,"details_loaded_time":"2025-07-20 08:55:04","sku":"MRING","price":"55.00","name":"Moonlight Ring","allow_backorder":1,"erp_id":1748,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3520,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","mens","mens rings","men rings","men ring","top seller","pearlpear","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","men s rings","endless summer campaign","pearl ring","pearl","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MTDB":{"id":3756,"details_loaded_time":"2025-07-20 07:04:06","sku":"MTDB","price":"65.00","name":"The Daily Chain Bracelet","allow_backorder":1,"erp_id":1140,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3756,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":920,"name":"8\"","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":920}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":920}],"allow_backorder":true}],"tags":["non-custom","men","mens","mens chain","for men","men jewelry","gold plated chain mens","chains for men","chain gold men","bracelet for guys","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MTDC":{"id":3755,"details_loaded_time":"2025-07-20 07:04:02","sku":"MTDC","price":"65.00","name":"The Daily Chain Necklace","allow_backorder":1,"erp_id":1139,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3755,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":1493,"name":"25","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":1493}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":1493}],"allow_backorder":true}],"tags":["non-custom","men","silver","men chain","for men","gold plated chain mens","gold chain men","chains for men","chain gold men","sliver necklaces","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MTH":{"id":1147,"details_loaded_time":"2025-07-20 08:24:19","sku":"MTH","price":"55.00","name":"Mini Tube Hoops","allow_backorder":1,"erp_id":734,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1147,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","topsell","non-custom","best sellers","top seller","best seller","items_mobile_app","chunky hoops","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MUSHN":{"id":1285,"details_loaded_time":"2022-08-26 14:15:39","sku":"MUSHN","price":"58.00","name":"Mushroom Necklace","allow_backorder":0,"erp_id":819,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1285,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","non-custom","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","shroom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MVPCUFF":{"id":3872,"details_loaded_time":"2025-07-20 06:53:06","sku":"MVPCUFF","price":"65.00","name":"MVP Cuff","allow_backorder":1,"erp_id":1932,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3872,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Pre-Order Items will ship within 10 business days!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MWHN":{"id":3019,"details_loaded_time":"2025-07-20 07:58:21","sku":"MWHN","price":"60.00","name":"Midwest Honey Necklace","allow_backorder":1,"erp_id":1407,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3019,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":true}],"tags":["necklace","non-custom","gg x vs","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MXMLSET":{"id":3430,"details_loaded_time":"2025-01-27 15:30:13","sku":"MXMLSET","price":"140.00","name":"Mixed Metal Set","allow_backorder":1,"erp_id":1651,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3430,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":1321}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":614,"name":"Off Duty Chain","quantity":1,"description":null,"type":"item","options":[{"id":1941,"name":"Off Duty Chain","skip":false,"item":{"id":1319,"name":"Off Duty Chain","SKU":"ODC"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":1321,"name":"Mixed Metal","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":53,"attribute_option_id":1321}]],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":1321}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":615,"name":"The Icon Chain","quantity":1,"description":null,"type":"item","options":[{"id":1942,"name":"The Icon Chain","skip":false,"item":{"id":1318,"name":"The Icon Chain","SKU":"TIC"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":1321,"name":"Mixed Metal","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":53,"attribute_option_id":1321}]],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":1321}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":616,"name":"Two Tone Twist Hoops","quantity":1,"description":null,"type":"item","options":[{"id":1943,"name":"Two Tone Twist Hoops","skip":false,"item":{"id":1052,"name":"Two Tone Twist Hoops","SKU":"TWTTH"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":614,"attribute_option_id":1941},{"attribute_id":615,"attribute_option_id":1942},{"attribute_id":616,"attribute_option_id":1943}],"allow_backorder":true}],"tags":["set","off duty","offduty","off duty collection"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MYSTERYBOX2G":{"id":3540,"details_loaded_time":"2025-07-20 07:22:44","sku":"MYSTERYBOX2G","price":"28.00","name":"2 Item Mystery Box Gold","allow_backorder":0,"erp_id":1769,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3540,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[],"active_combinations":[],"tags":["set","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MYSTERYBOX2S":{"id":3541,"details_loaded_time":"2025-07-20 07:22:40","sku":"MYSTERYBOX2S","price":"28.00","name":"2 Item Mystery Box Silver","allow_backorder":0,"erp_id":1770,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3541,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[],"active_combinations":[],"tags":["set","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MYSTERYBOX3G":{"id":3542,"details_loaded_time":"2025-07-20 07:22:36","sku":"MYSTERYBOX3G","price":"35.00","name":"3 Item Mystery Box Gold","allow_backorder":1,"erp_id":1771,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3542,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[],"active_combinations":[],"tags":["new","set","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MYSTERYBOX3S":{"id":3543,"details_loaded_time":"2025-07-20 07:22:32","sku":"MYSTERYBOX3S","price":"35.00","name":"3 Item Mystery Box Silver","allow_backorder":0,"erp_id":1772,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3543,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[],"active_combinations":[],"tags":["new","set","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MYSTERYBOX4G":{"id":3544,"details_loaded_time":"2025-07-20 07:22:29","sku":"MYSTERYBOX4G","price":"40.00","name":"4 Item Mystery Box Gold","allow_backorder":1,"erp_id":1773,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3544,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[],"active_combinations":[],"tags":["new","set","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"MYSTERYBOX4S":{"id":3545,"details_loaded_time":"2025-07-20 07:22:25","sku":"MYSTERYBOX4S","price":"40.00","name":"4 Item Mystery Box SIlver","allow_backorder":1,"erp_id":1774,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3545,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[],"active_combinations":[],"tags":["new","set","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"NANN":{"id":1180,"details_loaded_time":"2025-07-20 08:18:41","sku":"NANN","price":"60.00","name":"Nana Necklace","allow_backorder":0,"erp_id":784,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1180,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","mama chains","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"NEAR":{"id":3519,"details_loaded_time":"2025-07-20 07:26:41","sku":"NEAR","price":"65.00","name":"Nonna's Earrings","allow_backorder":1,"erp_id":1747,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3519,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","non-custom","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","gold","endless summer campaign","shell earrings","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"NFBAND":{"id":3628,"details_loaded_time":"2025-07-20 07:18:41","sku":"NFBAND","price":"55.00","name":"No.5 Band","allow_backorder":1,"erp_id":1796,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3628,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"NLR":{"id":1112,"details_loaded_time":"2024-05-09 18:43:20","sku":"NLR","price":"28.00","name":"Nude Loop Ring","allow_backorder":0,"erp_id":629,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1112,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"NLS":{"id":932,"details_loaded_time":"2024-11-15 16:00:24","sku":"NLS","price":"17.50","name":"Nude Leather Scrunchie","allow_backorder":0,"erp_id":615,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":932,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":489,"name":"Leather","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":489}],"allow_backorder":false}],"tags":["non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"NURN":{"id":1184,"details_loaded_time":"2025-07-20 08:18:18","sku":"NURN","price":"60.00","name":"Nurse Necklace","allow_backorder":1,"erp_id":783,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1184,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","giftcol","items_mobile_app","don't notify","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"NYGH":{"id":3074,"details_loaded_time":"2025-07-20 07:54:24","sku":"NYGH","price":"55.00","name":"Not Your Grandma's Hoops","allow_backorder":0,"erp_id":1444,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3074,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","topsell","non-custom","vintage edit","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OANH":{"id":1299,"details_loaded_time":"2023-08-04 19:03:39","sku":"OANH","price":"89.00","name":"Onyx Angel Number Hoodie DNU","allow_backorder":1,"erp_id":859,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1299,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":143,"name":"Size:","type":"list","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":140,"name":"Choose your numbers","type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true}],"tags":["items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OANHCI":{"id":2005,"details_loaded_time":"2024-02-12 19:02:35","sku":"OANHCI","price":"10.00","name":"Onyx Angel Wing Hoodie -blank","allow_backorder":1,"erp_id":1101,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":2005,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will receive  an SMS text message !","attributes":[{"id":143,"name":"Size:","description":null,"type":"list","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":true}],"tags":["items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OANHCOLLAB":{"id":2006,"details_loaded_time":"2025-07-20 08:06:07","sku":"OANHCOLLAB","price":"89.00","name":"Onyx Angel Number Hoodie X Heitmat","allow_backorder":1,"erp_id":1172,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":true,"db_id":2006,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":144,"name":"Angel Numbers Necklace","quantity":1,"description":null,"type":"item","options":[{"id":534,"name":"ANGN2","skip":false,"item":{"id":801,"name":"Angel Numbers Necklace","SKU":"ANGN2"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"List","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null},{"id":501,"name":"222","skip":false,"parent_attribute":null},{"id":502,"name":"333","skip":false,"parent_attribute":null},{"id":503,"name":"444","skip":false,"parent_attribute":null},{"id":504,"name":"555","skip":false,"parent_attribute":null},{"id":509,"name":"666","skip":false,"parent_attribute":null},{"id":505,"name":"777","skip":false,"parent_attribute":null},{"id":506,"name":"888","skip":false,"parent_attribute":null},{"id":507,"name":"999","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}]],"active_combinations":{"18":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}]},"19":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}]},"20":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}]},"21":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}]},"22":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}]},"23":{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}]},"24":{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}]},"25":{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}]},"26":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}]},"27":{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}]},"28":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}]},"29":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}]},"30":{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}]},"31":{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}]},"32":{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}]},"33":{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}]},"34":{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}]},"35":{"image":null,"stock":86,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":483,"name":"Onyx Hoodie","quantity":1,"description":null,"type":"item","options":[{"id":1455,"name":"Size:","skip":false,"item":{"id":1080,"name":"Onyx Hoodie","SKU":"BLKHEIT"},"attributes_per_every_item":[{"id":143,"name":"Size:","quantity":1,"description":null,"type":"List","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null},{"id":602,"name":"3XL","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":143,"attribute_option_id":532}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":528}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":529}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":530}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":531}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":143,"attribute_option_id":532}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":333,"name":"Angel Numbers","quantity":1,"description":null,"type":"item","options":[{"id":1101,"name":"Pick your 3 numbers","skip":false,"item":{"id":1171,"name":"Angel Numbers service item","SKU":"ANGNNUM"},"attributes_per_every_item":[{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"List","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null},{"id":501,"name":"222","skip":false,"parent_attribute":null},{"id":502,"name":"333","skip":false,"parent_attribute":null},{"id":503,"name":"444","skip":false,"parent_attribute":null},{"id":504,"name":"555","skip":false,"parent_attribute":null},{"id":509,"name":"666","skip":false,"parent_attribute":null},{"id":505,"name":"777","skip":false,"parent_attribute":null},{"id":506,"name":"888","skip":false,"parent_attribute":null},{"id":507,"name":"999","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":140,"attribute_option_id":507}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":500}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":501}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":502}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":503}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":504}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":509}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":505}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":506}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":140,"attribute_option_id":507}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":144,"attribute_option_id":534},{"attribute_id":333,"attribute_option_id":1101},{"attribute_id":483,"attribute_option_id":1455}],"allow_backorder":true}],"tags":["collab","hoodie","angel","tops","items_mobile_app","nodiscount"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":{"ANGN2":"0","BLKHEIT":"-1","ANGNNUM":"0"}},"OANHCOLLABS":{"id":2221,"details_loaded_time":"2022-09-20 18:34:38","sku":"OANHCOLLABS","price":"89.00","name":"Onyx Angel Number Hoodie x Heitmat","allow_backorder":1,"erp_id":1286,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":true,"db_id":2221,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":144,"name":"Angel Numbers Necklace","type":"item","options":[{"id":534,"name":"ANGN2","skip":false,"item":{"id":801,"name":"Angel Numbers Necklace","SKU":"ANGN2"},"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":247,"name":"Onyx Hoodie","type":"item","options":[{"id":857,"name":"Size:","skip":false,"item":{"id":1080,"name":"Black Hoodie--child item","SKU":"BLKHEIT"},"item_option_combinations":[[{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":143,"attribute_option_id":532}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":333,"name":"Angel Numbers","type":"item","options":[{"id":1101,"name":"Pick your 3 numbers","skip":false,"item":{"id":1171,"name":"Angel Numbers service item","SKU":"ANGNNUM"},"item_option_combinations":[[{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":140,"attribute_option_id":507}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":405,"name":"Angel Wing","type":"item","options":[{"id":1257,"name":"Angel Wing","skip":false,"item":{"id":1224,"name":"Heatpress Graphics","SKU":"HPG"},"item_option_combinations":[[{"attribute_id":327,"attribute_option_id":1255}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":144,"attribute_option_id":534},{"attribute_id":247,"attribute_option_id":857},{"attribute_id":333,"attribute_option_id":1101},{"attribute_id":405,"attribute_option_id":1257}],"allow_backorder":true}],"tags":["collab","hoodie","angel","angel number"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":{"ANGN2":"0","ANGNNUM":"-1"}},"OANHH":{"id":1297,"details_loaded_time":"2022-08-09 02:15:28","sku":"OANHH","price":"89.00","name":"Onyx Angel Number Hoodie x Heitmat","allow_backorder":1,"erp_id":861,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":1297,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":144,"name":"Angel Numbers Necklace","type":"item","options":[{"id":534,"name":"ANGN2","skip":false,"item":{"id":801,"name":"Angel Numbers Necklace","SKU":"ANGN2"},"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":500}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":501}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":502}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":503}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":504}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":509}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":505}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":506}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":140,"attribute_option_id":507}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":145,"name":"Onyx Angel Number Hoodie","type":"item","options":[{"id":536,"name":"Onyx hoodie","skip":false,"item":{"id":859,"name":"Onyx Angel Number Hoodie","SKU":"OANH"},"item_option_combinations":[[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":528}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":529}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":530}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":531}],[{"attribute_id":140,"attribute_option_id":500},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":501},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":502},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":503},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":504},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":509},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":505},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":506},{"attribute_id":143,"attribute_option_id":532}],[{"attribute_id":140,"attribute_option_id":507},{"attribute_id":143,"attribute_option_id":532}]],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":144,"attribute_option_id":534},{"attribute_id":145,"attribute_option_id":536}],"allow_backorder":true}],"tags":["collab","angel"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OBHE":{"id":1146,"details_loaded_time":"2025-07-20 08:24:24","sku":"OBHE","price":"36.00","name":"Open Ball Hoop Earrings","allow_backorder":0,"erp_id":733,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1146,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ODC":{"id":2656,"details_loaded_time":"2025-02-06 16:45:17","sku":"ODC","price":"55.00","name":"Off Duty Chain","allow_backorder":1,"erp_id":1319,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2656,"force_allow_backorder":false,"warning_quantity":1,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1321,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":1321}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","silver","silver","gold chain men","top seller","14k gold","sliver","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","mix metal","mixed metal","gold","gold chain","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ODH":{"id":2660,"details_loaded_time":"2025-07-20 08:00:39","sku":"ODH","price":"55.00","name":"Off Duty Hoops","allow_backorder":0,"erp_id":1323,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2660,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":false}],"tags":["earrings","topsell","non-custom","silver","silver","fig layering","diamond cuff earring","top seller","fine thin hoops","earrings sterling","earrings men","14k gold","sliver","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold","chunky hoops","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEBA":{"id":29,"details_loaded_time":"2025-07-20 06:38:21","sku":"OEBA","price":"70.00","name":"Custom Anklet","allow_backorder":true,"erp_id":320,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":29,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":222,"name":"7.8\"","skip":false,"parent_attribute":null,"weight":78}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":37,"name":"Name","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":222},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","custom","topsell","1992","1999","1996","birth year","birthyear","2003","2004","ankle bracelet","1995","1988","2000","1986","2008","2002","1987","1989","1991","1993","1994","1997","1998","2001","2005","2006","2007","toe rings","ank","ryan anklets","sanklets","anklet bracelets","anklet clasps","birthday charms","bikini","swimwear","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","1984","necklace foot","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEBDN":{"id":98,"details_loaded_time":"2025-07-20 09:08:37","sku":"OEBDN","price":"80.00","name":"Old English Birthdate Necklace","allow_backorder":true,"erp_id":390,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":98,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":259,"name":"15\"","skip":false,"parent_attribute":null,"weight":150},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":22,"name":"Year","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_numbers","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","topsell","kids","1992","1999","1996","1990","birth year","birthyear","2003","2004","1995","1988","2000","1986","2008","2002","1987","1989","1991","1993","1994","1997","1998","2001","2005","2006","2007","best sellers","top seller","1212","112124","birthday charms","best seller","sliver","90 necklace","bikini","swimwear","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","1984","leo season","1981","1944 necklace","89 necklace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OECLR":{"id":844,"details_loaded_time":"2025-07-20 08:40:14","sku":"OECLR","price":"38.00","name":"Old English Chain Link Ring","allow_backorder":0,"erp_id":527,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":844,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"3":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"5":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"6":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"8":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"9":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"11":{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"12":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"13":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"15":{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"16":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"17":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"18":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"19":{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"20":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"21":{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"22":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"23":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"24":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"25":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"26":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"27":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"28":{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"29":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"30":{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"32":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"33":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"36":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"37":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"38":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"39":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"41":{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"42":{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"43":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"44":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"45":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"46":{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"47":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"48":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"49":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"50":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"51":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"52":{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"53":{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"54":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"58":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"59":{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"60":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"61":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"62":{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"63":{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"64":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"65":{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"66":{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"67":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"68":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"69":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"70":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"71":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"72":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"73":{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"74":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"75":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"76":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"77":{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}},"tags":["sale","non-custom","ws","diamond link ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","don't notify","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEDB":{"id":97,"details_loaded_time":"2025-07-20 09:10:05","sku":"OEDB","price":"70.00","name":"Old English Birthdate Bracelet","allow_backorder":true,"erp_id":389,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":97,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":241,"name":"6\"","skip":false,"parent_attribute":null,"weight":60}],"show_with_one_option":false},{"id":50,"name":"Custom Date","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_numbers","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":241}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":241}],"allow_backorder":true}],"tags":["bracelet","custom","1992","1999","1996","1990","birth year","birthyear","2003","2004","1995","1988","2000","1986","2008","2002","1987","1989","1991","1993","1994","1997","1998","2001","2005","2006","2007","brackets","birthday charms","bracelet for guys","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEDLN":{"id":99,"details_loaded_time":"2025-07-20 09:08:29","sku":"OEDLN","price":"80.00","name":"Old English Double Letter Necklace","allow_backorder":true,"erp_id":391,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":99,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220},{"id":250,"name":"24\"","skip":false,"parent_attribute":null,"weight":240}],"show_with_one_option":false},{"id":117,"name":"Initials","quantity":1,"description":null,"type":"text","validation":{"min_chars":2,"max_chars":2,"required":true,"type":"only_text","free_chars":2,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","initial necklace","initial","initial j","v initial","b initial necklace","initial charm","intial","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEHE":{"id":672,"details_loaded_time":"2025-07-20 08:50:23","sku":"OEHE","price":"42.00","name":"Old English Huggie Earrings","allow_backorder":0,"erp_id":472,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":672,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":70,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":75,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","e earring","initial","initial j","v initial","initial charm","oe huggies","earrings sterling","earrings men","oe initial huggies","oe initial huggies","intial","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","s earring","letter earrings","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEIC":{"id":100,"details_loaded_time":"2025-07-20 09:08:22","sku":"OEIC","price":"28.00","name":"Old English Initial Choker","allow_backorder":0,"erp_id":392,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":100,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":260,"name":"12\"","skip":false,"parent_attribute":null,"weight":120}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":69,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":86,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":86,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":75,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":76,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":88,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":58,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":79,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":107,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":86,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":260},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","initial necklace","initial","initial j","v initial","b initial necklace","initial charm","chocked","intial","link choker","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEIN2":{"id":101,"details_loaded_time":"2025-07-20 09:08:15","sku":"OEIN2","price":"80.00","name":"Old English Initial Necklace","allow_backorder":true,"erp_id":393,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":101,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":25,"name":"Initial","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":1,"required":true,"type":"only_text","free_chars":1,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","topsell","mens","men s","mens chain","initial necklace","initial","initial j","v initial","b initial necklace","initial charm","wedding","letter d necklace","best sellers","top seller","best seller","r necklace","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","men s initial","g necklace","items_mobile_app","don't notify"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OELN":{"id":481,"details_loaded_time":"2025-07-20 08:52:28","sku":"OELN","price":"58.00","name":"Old English Lock Necklace","allow_backorder":0,"erp_id":463,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":481,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":366,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":213,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":124,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","silver","charm","charms","silver","b initial necklace","rings for men silver","figaro c","wedding","heart lock","lock it necklace","best sellers","sterling silver necklaces","best seller","sliver","swimwear","intial","got it on lock","pindens","l necklace","j leclace","boyfriend","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","lock nec","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OEPN":{"id":740,"details_loaded_time":"2025-07-20 09:01:25","sku":"OEPN","price":"60.00","name":"Old English Pride Necklace","allow_backorder":0,"erp_id":450,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":740,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":86,"name":"Pride_Necklace_Text","quantity":1,"description":null,"type":"list","options":[{"id":361,"name":"Pride","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":86,"attribute_option_id":361}],"allow_backorder":false}],"tags":["non-custom","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OESR":{"id":698,"details_loaded_time":"2025-07-20 08:48:13","sku":"OESR","price":"35.00","name":"Old English Signet Ring","allow_backorder":0,"erp_id":481,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":698,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":68,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":58,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":179,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":154,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","topsell","sale","non-custom","ws","ring for women","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","l ring","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OETB":{"id":842,"details_loaded_time":"2025-07-20 08:40:25","sku":"OETB","price":"38.00","name":"Old English Tag Bracelet","allow_backorder":0,"erp_id":538,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":842,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["bracelet","sale","non-custom","ws","brackets","charm bracelet","braceletbracelet","bracelet for guys","c initial brackets","personalized bracelets for men","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","custom used bracelet","customize bracelet cubana","engraved bracelet","dog tag","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OETN":{"id":677,"details_loaded_time":"2025-07-20 08:50:16","sku":"OETN","price":"42.00","name":"Old English Tag Necklace","allow_backorder":0,"erp_id":473,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":677,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":112,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":103,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":63,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":77,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","silver","silver","initial necklace","initial","15 inch sterling silver name necklace","sterling silver necklaces","sliver necklaces","sliver","intial","cross tag necklace","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","dog tag","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OFN":{"id":697,"details_loaded_time":"2022-12-06 09:44:22","sku":"OFN","price":"58.00","name":"On Fire Necklace","allow_backorder":0,"erp_id":480,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":697,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","bunny pendant necklace","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OFR":{"id":1198,"details_loaded_time":"2024-05-09 20:49:02","sku":"OFR","price":null,"name":"Orange Flame Ring","allow_backorder":0,"erp_id":773,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1198,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ring for women","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OGS":{"id":1123,"details_loaded_time":"2021-05-31 19:25:44","sku":"OGS","price":"95.00","name":"Omggabbie Set","allow_backorder":0,"erp_id":641,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":1123,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":134,"name":"Dice Necklace","type":"item","options":[{"id":492,"name":"Dice Necklace","skip":false,"item":{"id":638,"name":"Dice Necklace","SKU":"DINE"},"item_option_combinations":[{"attribute_id":14,"attribute_option_id":37}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":135,"name":"Blue Sapphire Necklace","type":"item","options":[{"id":494,"name":"Blue Sapphire Necklace","skip":false,"item":{"id":639,"name":"Blue Sapphire Necklace","SKU":"BSAPHN"},"item_option_combinations":[{"attribute_id":14,"attribute_option_id":38}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":136,"name":"OMG Ring","type":"item","options":[{"id":496,"name":"OMG Ring","skip":false,"item":{"id":640,"name":"OMG Ring","SKU":"OMGR"},"item_option_combinations":[{"attribute_id":35,"attribute_option_id":159}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":134,"attribute_option_id":492},{"attribute_id":135,"attribute_option_id":494},{"attribute_id":136,"attribute_option_id":496}],"allow_backorder":false}],"tags":["set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OHBC":{"id":1942,"details_loaded_time":"2025-07-20 08:06:34","sku":"OHBC","price":"55.00","name":"Open Heart Belly Chain","allow_backorder":1,"erp_id":1092,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1942,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":true}],"tags":["accessories","non-custom","bikini","swimwear","gold belly button studs","waist","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","body chain","bellychain","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OHCN":{"id":1507,"details_loaded_time":"2025-03-17 16:52:41","sku":"OHCN","price":"58.00","name":"Open Heart Choker","allow_backorder":0,"erp_id":1056,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1507,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","iced cross pearl choker","chocked","say my name","heart lock","say my name collection","summer collection","playboy","link choker","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OHE":{"id":829,"details_loaded_time":"2025-07-20 08:42:34","sku":"OHE","price":"55.00","name":"Open Hoop Earrings","allow_backorder":0,"erp_id":524,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":829,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":41,"name":"Size","quantity":1,"description":null,"type":"list","options":[{"id":172,"name":"Medium","skip":false,"parent_attribute":null},{"id":173,"name":"Large","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","non-custom","fine thin hoops","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OHHOOPS":{"id":3518,"details_loaded_time":"2025-04-04 12:15:36","sku":"OHHOOPS","price":"55.00","name":"On Holiday Hoops","allow_backorder":1,"erp_id":1746,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3518,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","sale","non-custom","ws","items_mobile_app","endless summer campaign","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OLRING":{"id":3824,"details_loaded_time":"2025-07-20 07:01:10","sku":"OLRING","price":"58.00","name":"The Olive Ring","allow_backorder":1,"erp_id":1894,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3824,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OMGR":{"id":1120,"details_loaded_time":"2021-05-31 19:25:48","sku":"OMGR","price":"31.67","name":"OMG Ring","allow_backorder":0,"erp_id":640,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1120,"force_allow_backorder":false,"attributes":[{"id":35,"name":"Ring Size","type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":false}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ONPARC":{"id":2192,"details_loaded_time":"2025-02-11 17:31:29","sku":"ONPARC","price":"65.00","name":"Onyx Paris Chain","allow_backorder":0,"erp_id":1260,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2192,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":1218,"name":"Onyx Black","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":1218},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","necklace with a gem","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","paris","girls night","girls night collection","girls night out","items_mobile_app","paris choker","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OOFCHOKER":{"id":3495,"details_loaded_time":"2025-07-20 07:32:05","sku":"OOFCHOKER","price":"58.00","name":"Out Of Office Choker","allow_backorder":1,"erp_id":1722,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3495,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","sale","non-custom","ws","items_mobile_app","working woman campaign","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OPNMEN":{"id":3090,"details_loaded_time":"2025-07-20 07:52:36","sku":"OPNMEN","price":"95.00","name":"Onyx Pendant Necklace","allow_backorder":1,"erp_id":1460,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3090,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OSRINGBRACE":{"id":3887,"details_loaded_time":"2025-07-20 06:51:04","sku":"OSRINGBRACE","price":"60.00","name":"Oversized Ring Bracelet","allow_backorder":1,"erp_id":1941,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3887,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Pre-Order Items will ship within 10 business days!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OTWR":{"id":1287,"details_loaded_time":"2024-05-09 18:47:59","sku":"OTWR","price":null,"name":"Off The Wall Ring","allow_backorder":0,"erp_id":810,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1287,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","non-custom","ws","ring for women","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"OUTLINEGRILL":{"id":3234,"details_loaded_time":"2025-06-04 18:43:14","sku":"OUTLINEGRILL","price":"40.00","name":"Outline Grill","allow_backorder":1,"erp_id":1551,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3234,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":519,"name":"VibeSzn Grill Impression Mold","quantity":1,"description":null,"type":"item","options":[{"id":1562,"name":"VibeSzn Grill Impression Mold","skip":false,"item":{"id":1508,"name":"VibeSzn Grill Impression Mold","SKU":"VGIM"},"attributes_per_every_item":[],"item_option_combinations":[],"active_combinations":[],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":525,"name":"VibeSzn Grill","quantity":1,"description":null,"type":"item","options":[{"id":1680,"name":"VibeSzn Grill","skip":false,"item":{"id":1550,"name":"VibeSzn Grill","SKU":"VSG"},"attributes_per_every_item":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"List","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}]},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"List","options":[{"id":1641,"name":"4 Top","skip":false,"parent_attribute":null},{"id":1643,"name":"4 Bottom","skip":false,"parent_attribute":null},{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null},{"id":1669,"name":"12 Top","skip":false,"parent_attribute":null},{"id":1670,"name":"12 Bottom","skip":false,"parent_attribute":null},{"id":1645,"name":"TR-1","skip":false,"parent_attribute":null},{"id":1646,"name":"TR-2","skip":false,"parent_attribute":null},{"id":1647,"name":"TR-3","skip":false,"parent_attribute":null},{"id":1648,"name":"TR-4","skip":false,"parent_attribute":null},{"id":1649,"name":"TR-5","skip":false,"parent_attribute":null},{"id":1650,"name":"TL-1","skip":false,"parent_attribute":null},{"id":1651,"name":"TL-2","skip":false,"parent_attribute":null},{"id":1652,"name":"TL-3","skip":false,"parent_attribute":null},{"id":1653,"name":"TL-4","skip":false,"parent_attribute":null},{"id":1654,"name":"TL-5","skip":false,"parent_attribute":null},{"id":1655,"name":"BR-1","skip":false,"parent_attribute":null},{"id":1656,"name":"BR-2","skip":false,"parent_attribute":null},{"id":1657,"name":"BR-3","skip":false,"parent_attribute":null},{"id":1658,"name":"BR-4","skip":false,"parent_attribute":null},{"id":1659,"name":"BR-5","skip":false,"parent_attribute":null},{"id":1660,"name":"BL-1","skip":false,"parent_attribute":null},{"id":1661,"name":"BL-2","skip":false,"parent_attribute":null},{"id":1662,"name":"BL-3","skip":false,"parent_attribute":null},{"id":1663,"name":"BL-4","skip":false,"parent_attribute":null},{"id":1664,"name":"BL-5","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}]],"active_combinations":[{"image":null,"stock":false,"price_change":"120.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"120.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"440.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"440.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":519,"attribute_option_id":1562},{"attribute_id":525,"attribute_option_id":1680}],"allow_backorder":true}],"tags":["items_mobile_app","nodiscount","don't notify","grill","grills","grillz","no discounts allowed","tooth gem"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PANGN":{"id":1295,"details_loaded_time":"2022-11-22 13:23:33","sku":"PANGN","price":"52.00","name":"Pearl Angel Necklace","allow_backorder":0,"erp_id":817,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1295,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[],"tags":["items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PANN":{"id":2631,"details_loaded_time":"2025-07-20 08:02:37","sku":"PANN","price":"36.00","name":"Pearl Angel Numbers Necklace","allow_backorder":0,"erp_id":1307,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":2631,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":140,"name":"Choose your numbers","quantity":1,"description":null,"type":"list","options":[{"id":500,"name":"111","skip":false,"parent_attribute":null,"weight":500},{"id":501,"name":"222","skip":false,"parent_attribute":null,"weight":501},{"id":502,"name":"333","skip":false,"parent_attribute":null,"weight":502},{"id":503,"name":"444","skip":false,"parent_attribute":null,"weight":503},{"id":504,"name":"555","skip":false,"parent_attribute":null,"weight":504},{"id":509,"name":"666","skip":false,"parent_attribute":null,"weight":505},{"id":505,"name":"777","skip":false,"parent_attribute":null,"weight":506},{"id":506,"name":"888","skip":false,"parent_attribute":null,"weight":507},{"id":507,"name":"999","skip":false,"parent_attribute":null,"weight":509}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},"1":{"image":null,"stock":112,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},"2":{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},"3":{"image":null,"stock":79,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":503}],"allow_backorder":false},"4":{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},"5":{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},"6":{"image":null,"stock":111,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},"7":{"image":null,"stock":105,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},"8":{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false},"9":{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":500}],"allow_backorder":false},"10":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":501}],"allow_backorder":false},"11":{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":502}],"allow_backorder":false},"13":{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":504}],"allow_backorder":false},"14":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":509}],"allow_backorder":false},"15":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":505}],"allow_backorder":false},"16":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":506}],"allow_backorder":false},"17":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":140,"attribute_option_id":507}],"allow_backorder":false}},"tags":["necklace","sale","non-custom","ws","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","angel number necklace","beads","perl necklace","pearlpear","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","beaded necklace","bead","anngel numbers","vivienne westwood","items_mobile_app","do not reorder","last chance page","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PANNwrong":{"id":1171,"details_loaded_time":"2023-06-23 13:36:29","sku":"PANNwrong","price":"45.00","name":"Pearl Angel Numbers Necklace wrong","allow_backorder":true,"erp_id":772,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1171,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":137,"name":"Custom Text","type":"text","validation":{"min_chars":3,"max_chars":3,"required":true,"type":"only_numbers","free_chars":3,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":31,"name":"Font","type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","sale","ws","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","angel number necklace","beads","perl necklace","pearlpear","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","beaded necklace","bead","anngel numbers","vivienne westwood","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PBR":{"id":1107,"details_loaded_time":"2024-05-09 16:21:08","sku":"PBR","price":"28.35","name":"Pink Bubble Ring","allow_backorder":0,"erp_id":623,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1107,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","pink planet","waterproof","baby pink bubble clip","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PBR1":{"id":1117,"details_loaded_time":"2024-05-09 16:19:09","sku":"PBR1","price":"28.35","name":"Purple Band Ring","allow_backorder":0,"erp_id":634,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1117,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Low Stock. Order Soon!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PCHH":{"id":1503,"details_loaded_time":"2024-08-19 15:46:51","sku":"PCHH","price":"42.00","name":"Pink Crystal Heart Huggies","allow_backorder":0,"erp_id":1059,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1503,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Sold Out!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":33,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":799,"name":"Pink","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":799},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","heart shape diamond ring","say my name","say my name collection","summer collection","pink planet","waterproof","baby pink bubble clip","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PCN":{"id":103,"details_loaded_time":"2025-07-20 09:08:04","sku":"PCN","price":"55.00","name":"Paperclip Chain Necklace","allow_backorder":1,"erp_id":395,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":103,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":36,"name":"Style","quantity":1,"description":null,"type":"list","options":[{"id":163,"name":"Style 1","skip":false,"parent_attribute":null},{"id":164,"name":"Style 2","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":164},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["necklace","non-custom","paper clip","waterproof","fiagro","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PCR":{"id":104,"details_loaded_time":"2025-07-20 09:06:39","sku":"PCR","price":"45.00","name":"Pastel Crystal Ring","allow_backorder":0,"erp_id":396,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":104,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PDHC":{"id":3745,"details_loaded_time":"2025-07-20 07:05:12","sku":"PDHC","price":"18.00","name":"Pink Dripping Heart Charm","allow_backorder":1,"erp_id":1874,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3745,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PENMM":{"id":3754,"details_loaded_time":"2025-07-20 07:03:21","sku":"PENMM","price":"58.00","name":"Mini Mary Pendant Necklace","allow_backorder":1,"erp_id":1885,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3754,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","virgin mary","charm","charms","virgin mary necklace","guadalupe","gold diamond virgin mary necklace","mother mary","our lady of guadalupe","saint mary","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PHN":{"id":1155,"details_loaded_time":"2023-03-08 17:37:32","sku":"PHN","price":"22.40","name":"Pink Heart Necklace","allow_backorder":0,"erp_id":762,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1155,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale","non-custom","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PICN":{"id":1157,"details_loaded_time":"2021-11-24 15:18:18","sku":"PICN","price":"42.00","name":"Pink Crystal Necklace","allow_backorder":0,"erp_id":761,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1157,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PLAYCLUB":{"id":3884,"details_loaded_time":"2025-07-20 06:51:17","sku":"PLAYCLUB","price":"35.00","name":"The Players Club Hat","allow_backorder":1,"erp_id":1939,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3884,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":2381,"name":"0231 Red\/Nat","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2381}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PLE":{"id":102,"details_loaded_time":"2025-01-06 19:00:29","sku":"PLE","price":"40.00","name":"Padlock Earrings","allow_backorder":0,"erp_id":394,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":102,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","earrings men","got it on lock","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","lock nec","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PLN":{"id":3867,"details_loaded_time":"2025-07-20 06:53:23","sku":"PLN","price":"70.00","name":"Pearl Lariat Necklace","allow_backorder":1,"erp_id":1926,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3867,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":2379,"name":"28\"","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1322,"name":"Stainless Steel\/Pearl","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":2379},{"attribute_id":53,"attribute_option_id":1322}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PLR":{"id":928,"details_loaded_time":"2024-05-09 19:00:46","sku":"PLR","price":null,"name":"Purple Loop Ring","allow_backorder":0,"erp_id":604,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":928,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":40,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PNN":{"id":1167,"details_loaded_time":"2025-07-20 08:22:04","sku":"PNN","price":"85.00","name":"Pearl Nameplate Necklace","allow_backorder":true,"erp_id":769,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1167,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":true}],"tags":["necklace","custom","chanel","wedding","daniel","gabriel neckless","nathan","pearl necklace name","15 inch sterling silver name necklace","dominique","beads","addison","perl necklace","nameplate essential necklace","pearl name necklace","delores name necklace","delores name charm","sliver","sports","yasmine","malena","pearlpear","cayden","savannah","andrew","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","18k gold plated neckless alex","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","beaded necklace","bead","cursive name necklace","vivienne westwood","items_mobile_app","sofia richie"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"POPRING":{"id":3832,"details_loaded_time":"2025-07-20 08:55:19","sku":"POPRING","price":"60.00","name":"Poppy Band","allow_backorder":1,"erp_id":1901,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3832,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"POSPENN":{"id":3524,"details_loaded_time":"2025-07-20 08:55:10","sku":"POSPENN","price":"65.00","name":"Positano Pendant","allow_backorder":1,"erp_id":1752,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3524,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["sale","non-custom","ws","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"POSPENNKIT":{"id":3546,"details_loaded_time":"2025-07-20 08:55:08","sku":"POSPENNKIT","price":"65.00","name":"Positano Pendant Necklace","allow_backorder":1,"erp_id":1754,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3546,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":665,"name":"Positano Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2086,"name":"Positano Pendant Necklace","skip":false,"item":{"id":1752,"name":"Positano Pendant","SKU":"POSPENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":664,"name":"Extended Chain","quantity":1,"description":null,"type":"item","options":[{"id":2084,"name":"Extended Chain","skip":false,"item":{"id":1093,"name":"Everyday Belly Chain","SKU":"EDBC"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":664,"attribute_option_id":2084},{"attribute_id":665,"attribute_option_id":2086}],"allow_backorder":true}],"tags":["necklace","new","sale","non-custom","ws","pearl name necklace","endless summer campaign","pearl ring","pearl","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PPN":{"id":105,"details_loaded_time":"2025-01-07 21:28:14","sku":"PPN","price":"58.00","name":"Pistol Pendant NecklaceDNU","allow_backorder":0,"erp_id":397,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":105,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","gun","gun necklace","charm","charms","gun charm","top gun","8mm","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PPNKIT":{"id":3482,"details_loaded_time":"2025-07-20 07:34:23","sku":"PPNKIT","price":"40.00","name":"Pistol Pendant Necklace","allow_backorder":1,"erp_id":1705,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3482,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":637,"name":"Pistol Pendant Necklace-Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2012,"name":"Pistol Pendant Necklace-Pendant","skip":false,"item":{"id":561,"name":"Pistol Pendant Necklace-Pendant","SKU":"PPNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":637,"attribute_option_id":2012}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","gun","gun necklace","charm","charms","gun charm","top gun","2 charm","8mm","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PPNpen":{"id":875,"details_loaded_time":"2025-07-20 08:36:16","sku":"PPNpen","price":"58.00","name":"Pistol Pendant Necklace-Pendant","allow_backorder":1,"erp_id":561,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":875,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","gun","gun necklace","charm","charms","gun charm","top gun","top seller","8mm","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PPR":{"id":1173,"details_loaded_time":"2023-03-16 13:32:41","sku":"PPR","price":"40.00","name":"Pink Planet Ring","allow_backorder":0,"erp_id":779,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1173,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":1,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":498,"name":"Brass","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":498}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":498}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":498}],"allow_backorder":false}],"tags":["ring","new","sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PRESRING":{"id":3503,"details_loaded_time":"2025-03-05 12:52:42","sku":"PRESRING","price":"60.00","name":"Presidential Ring","allow_backorder":0,"erp_id":1727,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3503,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}},"tags":["ring","new","sale","non-custom","ws","mens rings","ring for women","tumb rings","thumb rings","items_mobile_app","do not reorder","working woman campaign","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PSR":{"id":917,"details_loaded_time":"2024-05-09 19:14:57","sku":"PSR","price":null,"name":"Purple Star Ring","allow_backorder":0,"erp_id":600,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":917,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":51,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PTC":{"id":1140,"details_loaded_time":"2025-07-20 08:26:09","sku":"PTC","price":"55.00","name":"Pop Top Chain","allow_backorder":1,"erp_id":718,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1140,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PUPR":{"id":924,"details_loaded_time":"2024-05-09 19:13:28","sku":"PUPR","price":"25.00","name":"Purple Pretzel Ring","allow_backorder":0,"erp_id":610,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":924,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PURYYS":{"id":1164,"details_loaded_time":"2021-11-11 14:26:42","sku":"PURYYS","price":"22.40","name":"Purple Yin Yang Studs","allow_backorder":0,"erp_id":764,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1164,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["new","earrings","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PYYN":{"id":1177,"details_loaded_time":"2022-03-10 15:07:15","sku":"PYYN","price":"22.40","name":"Pink Yin Yang Necklace","allow_backorder":0,"erp_id":775,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1177,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"PYYS":{"id":1165,"details_loaded_time":"2021-11-03 18:34:12","sku":"PYYS","price":"22.40","name":"Pink Yin Yang Studs","allow_backorder":0,"erp_id":763,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1165,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":3,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["new","earrings","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RCANK":{"id":1512,"details_loaded_time":"2025-07-20 08:10:20","sku":"RCANK","price":"50.00","name":"Rope Chain Anklet","allow_backorder":1,"erp_id":1064,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1512,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["anklet","topsell","non-custom","ankle bracelet","toe rings","ank","say my name","anklet bracelets","say my name collection","anklet clasps","summer collection","bikini","swimwear","cuban anklet","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","fall","twist chain anklet","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RCE":{"id":3076,"details_loaded_time":"2024-05-09 18:27:10","sku":"RCE","price":"45.00","name":"Ridged Cuff","allow_backorder":0,"erp_id":1447,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3076,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false}],"tags":["new","earrings","sale","non-custom","ws","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RCSMEN":{"id":3089,"details_loaded_time":"2025-07-20 07:52:40","sku":"RCSMEN","price":"85.00","name":"Round Cut Stud","allow_backorder":0,"erp_id":1459,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3089,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","men","men jewelry","mens jewelry","mens collection","earrings men","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"REC":{"id":777,"details_loaded_time":"2025-07-20 08:57:04","sku":"REC","price":"20.00","name":"Everyday Chain","allow_backorder":0,"erp_id":509,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":777,"force_allow_backorder":false,"warning_quantity":20,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":false},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":false},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":false},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":false},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":false},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","baby chain","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RESET":{"id":3856,"details_loaded_time":"2025-07-20 06:55:17","sku":"RESET","price":"35.00","name":"The Reset Hat","allow_backorder":1,"erp_id":1928,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3856,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":428,"name":"Camo hat color","quantity":1,"description":null,"type":"list","options":[{"id":1326,"name":"Camo","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":428,"attribute_option_id":1326}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RGHR":{"id":1290,"details_loaded_time":"2024-05-10 12:54:19","sku":"RGHR","price":"42.00","name":"Red Gem Heart Ring","allow_backorder":0,"erp_id":813,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1290,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","sale","non-custom","heart shape diamond ring","ring for women","blue heart ring","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RNL":{"id":107,"details_loaded_time":"2025-07-20 09:06:21","sku":"RNL","price":"36.00","name":"Rose Necklace","allow_backorder":0,"erp_id":400,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":107,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],"allow_backorder":false}},"tags":["necklace","sale","non-custom","ws","silver","charm","charms","silver","sunflower","15 inch sterling silver name necklace","sterling silver necklaces","sliver necklaces","sliver","pindens","waterproof","lotus","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RNN":{"id":106,"details_loaded_time":"2025-07-20 09:06:27","sku":"RNN","price":"80.00","name":"Roman Numeral Necklace","allow_backorder":true,"erp_id":398,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":106,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":32,"name":"Numbers","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"only_numbers","free_chars":15,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":106,"name":"Roman Numerals","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":15,"required":true,"type":"only_text","free_chars":15,"addtional_price_per_char":"0.00","special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","roman numbers","111717","1212","112124","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ROCHARM":{"id":3751,"details_loaded_time":"2025-07-20 07:03:31","sku":"ROCHARM","price":"18.00","name":"Rose Charm","allow_backorder":1,"erp_id":1880,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3751,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RODS":{"id":133,"details_loaded_time":"2025-07-10 13:48:05","sku":"RODS","price":"40.00","name":"Ride Or Die Set","allow_backorder":0,"erp_id":427,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":133,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","bestfriend","top gun","bff","playboy","friendship","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","best friennds","bestie","items_mobile_app","nodiscount","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ROME":{"id":1163,"details_loaded_time":"2022-11-21 14:02:14","sku":"ROME","price":"22.40","name":"Rain On Me Earrings\u00a0","allow_backorder":0,"erp_id":765,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1163,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["new","earrings","sale","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RPCHN":{"id":2185,"details_loaded_time":"2025-07-20 08:04:32","sku":"RPCHN","price":"55.00","name":"Rope Chain Necklace","allow_backorder":0,"erp_id":1068,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2185,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","fall","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RPECH":{"id":2193,"details_loaded_time":"2022-08-25 16:56:07","sku":"RPECH","price":"55.00","name":"Rope Chain","allow_backorder":0,"erp_id":1261,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2193,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":1219,"name":"silver","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":1219},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":1219},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","topsell","mens gold chains","chains for men","tarnish free"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RPH":{"id":725,"details_loaded_time":"2025-07-20 08:46:26","sku":"RPH","price":"55.00","name":"Rope Hoops","allow_backorder":1,"erp_id":491,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":725,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","non-custom","items_mobile_app","chunky hoops","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RSNKCH":{"id":3323,"details_loaded_time":"2025-07-20 07:43:01","sku":"RSNKCH","price":"55.00","name":"Round Snake Chain","allow_backorder":1,"erp_id":1631,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3323,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","non-custom","chain gold men","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RTDE":{"id":1162,"details_loaded_time":"2021-11-24 19:16:36","sku":"RTDE","price":"22.40","name":"Roll The Dice Earrings\u00a0","allow_backorder":0,"erp_id":766,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1162,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["new","earrings","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"RZRCN":{"id":1510,"details_loaded_time":"2025-07-20 08:10:29","sku":"RZRCN","price":"55.00","name":"Razor Chain","allow_backorder":0,"erp_id":1061,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1510,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","silver","silver","chocked","say my name","15 inch sterling silver name necklace","sterling silver necklaces","say my name collection","summer collection","sliver necklaces","sliver","swimwear","waterproof","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","sliver chin","fall","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SAGEPEN":{"id":3825,"details_loaded_time":"2025-07-20 07:01:06","sku":"SAGEPEN","price":"65.00","name":"The Sage Pendant","allow_backorder":1,"erp_id":1896,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3825,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SBCN":{"id":108,"details_loaded_time":"2022-12-06 10:53:04","sku":"SBCN","price":"30.87","name":"Saint Benedict Coin Necklace","allow_backorder":0,"erp_id":401,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":108,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","type":"list","options":[{"id":262,"name":"2.5 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":262},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":262},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":262},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SBCNpen":{"id":876,"details_loaded_time":"2021-02-02 19:50:17","sku":"SBCNpen","price":"21.00","name":"Saint Benedict Coin Necklace--Pendant","allow_backorder":1,"erp_id":562,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":876,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":52,"name":"Pendant Size","type":"list","options":[{"id":262,"name":"2.5 cm","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":52,"attribute_option_id":262},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SBR":{"id":3071,"details_loaded_time":"2025-07-20 07:54:35","sku":"SBR","price":"55.00","name":"Stacked Band Ring","allow_backorder":1,"erp_id":1441,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3071,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true}],"tags":["ring","topsell","non-custom","vintage edit","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SCNECK":{"id":3859,"details_loaded_time":"2025-07-20 06:55:04","sku":"SCNECK","price":"75.00","name":"Serena Cross Necklace","allow_backorder":1,"erp_id":1925,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3859,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SCP":{"id":3523,"details_loaded_time":"2025-07-20 07:26:24","sku":"SCP","price":"65.00","name":"Santorini Cross Pendant","allow_backorder":1,"erp_id":1751,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3523,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","non-custom","best sellers","top seller","best seller","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SCRRNGSET":{"id":3435,"details_loaded_time":"2025-07-20 07:38:05","sku":"SCRRNGSET","price":"150.00","name":"Script Ring Set","allow_backorder":1,"erp_id":1656,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3435,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":623,"name":"Script Signet Ring","quantity":1,"description":null,"type":"item","options":[{"id":1960,"name":"Script Signet Ring","skip":false,"item":{"id":523,"name":"Script Signet Ring","SKU":"SCSR"},"attributes_per_every_item":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":161,"name":"Cuban Link Ring","quantity":1,"description":null,"type":"item","options":[{"id":585,"name":"Cuban Link Ring","skip":false,"item":{"id":737,"name":"Cuban Link Ring","SKU":"CULR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":624,"name":"Classic Crystal Ring","quantity":1,"description":null,"type":"item","options":[{"id":1961,"name":"Classic Crystal Ring","skip":false,"item":{"id":307,"name":"Classic Crystal Ring","SKU":"CCR"},"attributes_per_every_item":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":430,"name":"Orange","skip":false,"parent_attribute":null},{"id":431,"name":"Purple","skip":false,"parent_attribute":null},{"id":432,"name":"Pink","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":158}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":159}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":160}],[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":158}],[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":159}],[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":160}],[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":158}],[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":159}],[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":160}],[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":158}],[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":159}],[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":160}]],"active_combinations":[{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":159}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":160}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":159}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":430},{"attribute_id":35,"attribute_option_id":160}]},{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":159}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":431},{"attribute_id":35,"attribute_option_id":160}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":159}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":432},{"attribute_id":35,"attribute_option_id":160}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":161,"attribute_option_id":585},{"attribute_id":623,"attribute_option_id":1960},{"attribute_id":624,"attribute_option_id":1961}],"allow_backorder":true}],"tags":["ring","set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SCSMEN":{"id":3088,"details_loaded_time":"2025-07-20 07:54:04","sku":"SCSMEN","price":"85.00","name":"Square Cut Stud","allow_backorder":0,"erp_id":1421,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3088,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1323,"name":"Stainless Steel & Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":1323}],"allow_backorder":false}],"tags":["non-custom","men","men jewelry","mens collection","earrings men","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SCSR":{"id":828,"details_loaded_time":"2025-07-20 08:42:39","sku":"SCSR","price":"35.00","name":"Script Signet Ring","allow_backorder":0,"erp_id":523,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":828,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","topsell","sale","non-custom","ws","wedding","ring for women","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","l ring","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SDNAURA":{"id":1195,"details_loaded_time":"2021-12-09 13:43:39","sku":"SDNAURA","price":"30.00","name":"Space Dust Necklace","allow_backorder":0,"erp_id":798,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1195,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":418,"name":"Gold","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false}],"tags":["necklace","new","sale","ws","aura"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SEAR":{"id":3493,"details_loaded_time":"2025-07-20 07:32:13","sku":"SEAR","price":"65.00","name":"Sculpted Earrings","allow_backorder":1,"erp_id":1721,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3493,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","non-custom","items_mobile_app","working woman campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SEASR":{"id":1124,"details_loaded_time":"2024-05-09 20:39:30","sku":"SEASR","price":null,"name":"Sea Square Ring","allow_backorder":0,"erp_id":645,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1124,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SES":{"id":783,"details_loaded_time":"2025-07-20 08:44:26","sku":"SES","price":"60.00","name":"Stacked Earring Set","allow_backorder":1,"erp_id":511,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":783,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"SSH":"SSH","MBHE":"MBHE"}}],"skus":{"SSH":"SSH","MBHE":"MBHE"},"top_level":true}],"grouped_attributes_ids":[11],"active_combinations":[{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":{"11":11}},"attributes":[{"id":112,"name":"Simple Stack Huggies","quantity":1,"description":null,"type":"item","options":[{"id":436,"name":"Simple Stack Huggies","skip":false,"item":{"id":507,"name":"Simple Stack Huggies","SKU":"SSH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":111,"name":"Mini Bamboo Huggies","quantity":1,"description":null,"type":"item","options":[{"id":434,"name":"Mini Bamboo Huggies","skip":false,"item":{"id":379,"name":"Mini Bamboo Huggie Earrings","SKU":"MBHE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":111,"attribute_option_id":434},{"attribute_id":112,"attribute_option_id":436}],"allow_backorder":true}],"tags":["earrings","set","topsell","non-custom","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SFHE":{"id":1149,"details_loaded_time":"2025-06-10 14:37:32","sku":"SFHE","price":"55.00","name":"Summer Friday Hoop Earrings","allow_backorder":0,"erp_id":746,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1149,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Only 2 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SHBNN":{"id":2182,"details_loaded_time":"2025-07-20 08:04:41","sku":"SHBNN","price":"85.00","name":"Script Herringbone Nameplate Necklace","allow_backorder":0,"erp_id":1015,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2182,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121}],"allow_backorder":false}],"tags":["necklace","new","custom","topsell","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SHCNN":{"id":112,"details_loaded_time":"2021-02-23 17:11:29","sku":"SHCNN","price":"69.00","name":"Showcase Nameplate Necklace","allow_backorder":true,"erp_id":406,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":112,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SHRING":{"id":3817,"details_loaded_time":"2025-07-20 07:01:19","sku":"SHRING","price":"58.00","name":"Sweetheart Ring","allow_backorder":1,"erp_id":1892,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3817,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SIGLB":{"id":3491,"details_loaded_time":"2025-07-20 07:32:22","sku":"SIGLB","price":"55.00","name":"Signature Link Bracelet","allow_backorder":1,"erp_id":1716,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3491,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","brackets","braceletbracelet","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","working woman campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SIN":{"id":110,"details_loaded_time":"2020-06-25 20:58:06","sku":"SIN","price":"59.00","name":"Script Initial Necklace","allow_backorder":true,"erp_id":404,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":110,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":45,"name":"Letter","type":"text","validation":{"min_chars":1,"max_chars":1,"required":true,"type":"only_text","free_chars":1,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SINGLET":{"id":3244,"details_loaded_time":"2025-06-04 18:41:43","sku":"SINGLET","price":"40.00","name":"VibeSzn Single Tooth Grill","allow_backorder":1,"erp_id":1563,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3244,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"list","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"list","options":[{"id":1645,"name":"TR-1","skip":false,"parent_attribute":null},{"id":1646,"name":"TR-2","skip":false,"parent_attribute":null},{"id":1647,"name":"TR-3","skip":false,"parent_attribute":null},{"id":1648,"name":"TR-4","skip":false,"parent_attribute":null},{"id":1649,"name":"TR-5","skip":false,"parent_attribute":null},{"id":1650,"name":"TL-1","skip":false,"parent_attribute":null},{"id":1651,"name":"TL-2","skip":false,"parent_attribute":null},{"id":1652,"name":"TL-3","skip":false,"parent_attribute":null},{"id":1653,"name":"TL-4","skip":false,"parent_attribute":null},{"id":1654,"name":"TL-5","skip":false,"parent_attribute":null},{"id":1655,"name":"BR-1","skip":false,"parent_attribute":null},{"id":1656,"name":"BR-2","skip":false,"parent_attribute":null},{"id":1657,"name":"BR-3","skip":false,"parent_attribute":null},{"id":1658,"name":"BR-4","skip":false,"parent_attribute":null},{"id":1659,"name":"BR-5","skip":false,"parent_attribute":null},{"id":1660,"name":"BL-1","skip":false,"parent_attribute":null},{"id":1661,"name":"BL-2","skip":false,"parent_attribute":null},{"id":1662,"name":"BL-3","skip":false,"parent_attribute":null},{"id":1663,"name":"BL-4","skip":false,"parent_attribute":null},{"id":1664,"name":"BL-5","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true}],"tags":["don't notify","vendor fulfilled grill","grill","grills","grillz"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SIR":{"id":116,"details_loaded_time":"2025-07-20 09:04:18","sku":"SIR","price":"60.00","name":"Stacked Iced Ring","allow_backorder":1,"erp_id":410,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":116,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":254,"name":"Sterling Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":98,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":true},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":true},{"image":null,"stock":84,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":true},{"image":null,"stock":127,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":true}],"tags":["ring","non-custom","ws","silver","silver","rings for men silver","bejeweled","sliver","diamond link ring","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","crown rings","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SISN":{"id":1185,"details_loaded_time":"2025-07-20 08:18:11","sku":"SISN","price":"60.00","name":"Sista Sista Necklace","allow_backorder":0,"erp_id":782,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1185,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","items_mobile_app","don't notify","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SIXITEMGOLD":{"id":3811,"details_loaded_time":"2025-07-20 07:01:24","sku":"SIXITEMGOLD","price":"60.00","name":"6 Item Mystery Box Gold","allow_backorder":1,"erp_id":1890,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3811,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true}],"tags":["new","set","custom-set","non-custom","don't notify","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SIXITEMSILVER":{"id":3810,"details_loaded_time":"2025-07-20 07:01:30","sku":"SIXITEMSILVER","price":"60.00","name":"6 Item Mystery Box Silver","allow_backorder":1,"erp_id":1891,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3810,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":157}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":161}],"allow_backorder":true}],"tags":["new","set","custom-set","non-custom","don't notify","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SMR":{"id":929,"details_loaded_time":"2025-06-25 18:18:25","sku":"SMR","price":"31.50","name":"Smiley Ring","allow_backorder":0,"erp_id":612,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":929,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["ring","sale","non-custom","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SN":{"id":736,"details_loaded_time":"2020-06-05 16:46:05","sku":"SN","price":"50.00","name":"Scorpio Necklace (Test Item)","allow_backorder":1,"erp_id":502,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":736,"force_allow_backorder":false,"attributes":[{"id":12,"name":"Zodiac","type":"list","options":[{"id":31,"name":"ScorpioAF","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null},{"id":55,"name":"Skip","skip":true,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":31},{"attribute_id":13,"attribute_option_id":35}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":31},{"attribute_id":13,"attribute_option_id":36}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":31},{"attribute_id":13,"attribute_option_id":55}],"allow_backorder":true}],"tags":["new"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SNE":{"id":118,"details_loaded_time":"2025-07-20 09:04:05","sku":"SNE","price":"35.00","name":"Stormi Necklace","allow_backorder":0,"erp_id":412,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":118,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":419,"name":"Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":263,"name":"14\"","skip":false,"parent_attribute":null,"weight":140}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"1":{"image":null,"stock":157,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":263},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"2":{"image":null,"stock":273,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":419},{"attribute_id":14,"attribute_option_id":263},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}},"tags":["necklace","sale","non-custom","ws","moon","lightning","tarnish free","lightning bolt","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SNHBC":{"id":1504,"details_loaded_time":"2022-06-08 19:46:32","sku":"SNHBC","price":"55.00","name":"Snake Herringbone Chain","allow_backorder":0,"erp_id":1053,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1504,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","topsell"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SNN":{"id":111,"details_loaded_time":"2025-07-20 09:06:05","sku":"SNN","price":"80.00","name":"Script Nameplate Necklace","allow_backorder":true,"erp_id":405,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":111,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","topsell","silver","dior","dior necklace","euphoria","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","astrology","gemini necklace","aries necklace","leo necklace","capricorn af","horoscope pendant necklace","horroscope pendant necklace","aquarius necklace","taurus necklace","cancer necklace","virgo necklace","libra necklace","scorpio necklace","sagittarius necklace","capricorn necklace","pisces necklace","wedding","daniel","best sellers","gabriel neckless","nathan","alessandra","15 inch sterling silver name necklace","dominique","addison","top seller","nameplate essential necklace","best seller","sliver necklaces","delores name necklace","delores name charm","sliver","yasmine","malena","bikini","cayden","savannah","andrew","curbchain nameplate","kelli","waterproof","18k gold platedwith your nameneckless alex","18k gold plated neckless alex","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","leo season","january","items_mobile_app","vintage edit","don't notify"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SNR":{"id":2658,"details_loaded_time":"2024-02-08 15:58:21","sku":"SNR","price":"45.00","name":"Supernova Ring","allow_backorder":0,"erp_id":1321,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2658,"force_allow_backorder":false,"warning_quantity":1,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":false}],"tags":["ring","new","topsell","sale","non-custom","ws","silver","silver","ring for women","thumb rings","top seller","14k gold","sliver rings","waterproof","tarnish free","tarnishfree","water proof","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","mix metal","mixed metal","gold"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SOAP":{"id":317,"details_loaded_time":"2020-05-29 12:45:03","sku":"SOAP","price":"30.00","name":"Example Item Remove","allow_backorder":1,"erp_id":459,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":317,"force_allow_backorder":false,"attributes":[{"id":12,"name":"Zodiac","type":"list","options":[{"id":23,"name":"AquariusAF","skip":false,"parent_attribute":null},{"id":25,"name":"CancerAF","skip":false,"parent_attribute":null},{"id":26,"name":"CapricornAF","skip":false,"parent_attribute":null},{"id":27,"name":"GeminiAF","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":23}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":25}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":26}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":27}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SOILDGRILL":{"id":3245,"details_loaded_time":"2025-06-04 18:39:31","sku":"SOILDGRILL","price":"40.00","name":"Solid Grill","allow_backorder":1,"erp_id":1567,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3245,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":519,"name":"VibeSzn Grill Impression Mold","quantity":1,"description":null,"type":"item","options":[{"id":1562,"name":"VibeSzn Grill Impression Mold","skip":false,"item":{"id":1508,"name":"VibeSzn Grill Impression Mold","SKU":"VGIM"},"attributes_per_every_item":[],"item_option_combinations":[],"active_combinations":[],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":525,"name":"VibeSzn Grill","quantity":1,"description":null,"type":"item","options":[{"id":1680,"name":"VibeSzn Grill","skip":false,"item":{"id":1550,"name":"VibeSzn Grill","SKU":"VSG"},"attributes_per_every_item":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"List","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}]},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"List","options":[{"id":1641,"name":"4 Top","skip":false,"parent_attribute":null},{"id":1643,"name":"4 Bottom","skip":false,"parent_attribute":null},{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null},{"id":1669,"name":"12 Top","skip":false,"parent_attribute":null},{"id":1670,"name":"12 Bottom","skip":false,"parent_attribute":null},{"id":1645,"name":"TR-1","skip":false,"parent_attribute":null},{"id":1646,"name":"TR-2","skip":false,"parent_attribute":null},{"id":1647,"name":"TR-3","skip":false,"parent_attribute":null},{"id":1648,"name":"TR-4","skip":false,"parent_attribute":null},{"id":1649,"name":"TR-5","skip":false,"parent_attribute":null},{"id":1650,"name":"TL-1","skip":false,"parent_attribute":null},{"id":1651,"name":"TL-2","skip":false,"parent_attribute":null},{"id":1652,"name":"TL-3","skip":false,"parent_attribute":null},{"id":1653,"name":"TL-4","skip":false,"parent_attribute":null},{"id":1654,"name":"TL-5","skip":false,"parent_attribute":null},{"id":1655,"name":"BR-1","skip":false,"parent_attribute":null},{"id":1656,"name":"BR-2","skip":false,"parent_attribute":null},{"id":1657,"name":"BR-3","skip":false,"parent_attribute":null},{"id":1658,"name":"BR-4","skip":false,"parent_attribute":null},{"id":1659,"name":"BR-5","skip":false,"parent_attribute":null},{"id":1660,"name":"BL-1","skip":false,"parent_attribute":null},{"id":1661,"name":"BL-2","skip":false,"parent_attribute":null},{"id":1662,"name":"BL-3","skip":false,"parent_attribute":null},{"id":1663,"name":"BL-4","skip":false,"parent_attribute":null},{"id":1664,"name":"BL-5","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}]],"active_combinations":[{"image":null,"stock":false,"price_change":"120.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"120.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"440.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"440.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":519,"attribute_option_id":1562},{"attribute_id":525,"attribute_option_id":1680}],"allow_backorder":true}],"tags":["don't notify","grill","grills","grillz","no discounts allowed","tooth gem"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPDN":{"id":1188,"details_loaded_time":"2025-07-20 08:16:39","sku":"SPDN","price":"80.00","name":"Special Date Necklace","allow_backorder":true,"erp_id":793,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1188,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":139,"name":"Date","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_text","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["custom","giftcol","items_mobile_app","don't notify"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPENN":{"id":3705,"details_loaded_time":"2025-07-20 07:13:09","sku":"SPENN","price":"65.00","name":"Suede Pendant Necklace","allow_backorder":1,"erp_id":1854,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3705,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPN":{"id":109,"details_loaded_time":"2020-12-02 16:07:34","sku":"SPN","price":"45.00","name":"Scorpion Pendant Necklace","allow_backorder":0,"erp_id":403,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":109,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPN2":{"id":680,"details_loaded_time":"2025-07-20 08:50:12","sku":"SPN2","price":"38.00","name":"Snake Pendant Necklace","allow_backorder":0,"erp_id":474,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":680,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Almost out of stock","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK! Discontinued","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","gucci","charm","charms","scorpion","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPN2pen":{"id":881,"details_loaded_time":"2022-08-08 12:59:16","sku":"SPN2pen","price":"18.20","name":"Snake Pendant Necklace--Pendant","allow_backorder":1,"erp_id":567,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":881,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPN3":{"id":843,"details_loaded_time":"2025-07-20 08:40:20","sku":"SPN3","price":"42.00","name":"Script Pendant Necklace","allow_backorder":1,"erp_id":537,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":843,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","initial necklace","initial","initial j","v initial","b initial necklace","initial charm","heart lock","lock it necklace","intial","got it on lock","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","lock nec","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPNECK":{"id":3864,"details_loaded_time":"2025-07-20 06:53:31","sku":"SPNECK","price":"65.00","name":"Star Pendant Necklace","allow_backorder":1,"erp_id":1922,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3864,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SPNpen":{"id":877,"details_loaded_time":"2020-12-28 19:19:28","sku":"SPNpen","price":"22.50","name":"Scorpion Pendant Necklace--Pendant","allow_backorder":0,"erp_id":563,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":877,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":null,"combination":[{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SRR":{"id":115,"details_loaded_time":"2025-07-20 09:04:24","sku":"SRR","price":"42.00","name":"Slanted Rainbow Ring","allow_backorder":0,"erp_id":409,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":115,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SSD":{"id":119,"details_loaded_time":"2025-07-20 09:02:39","sku":"SSD","price":"30.00","name":"Stormi Studs","allow_backorder":0,"erp_id":413,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":119,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":521,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","moon","lightning","lightning bolt","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SSH":{"id":768,"details_loaded_time":"2025-07-20 08:45:07","sku":"SSH","price":"55.00","name":"Simple Stack Huggies","allow_backorder":1,"erp_id":507,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":768,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","non-custom","nose ring","nose rings","cuff","wedding","diamond cuff earring","fine thin hoops","earrings men","waterproof","noserings","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","sofia richie","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SSN":{"id":117,"details_loaded_time":"2025-07-20 09:04:11","sku":"SSN","price":"80.00","name":"Stargirl Nameplate","allow_backorder":true,"erp_id":411,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":117,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","silver","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","silver","astrology","gemini necklace","aries necklace","leo necklace","horoscope pendant necklace","horroscope pendant necklace","pisceszodiac","star sign","starsign","aquarius necklace","taurus necklace","cancer necklace","virgo necklace","libra necklace","scorpio necklace","sagittarius necklace","capricorn necklace","pisces necklace","star girl","15 inch sterling silver name necklace","sterling silver necklaces","sliver necklaces","sliver","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","leo season","january","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SSNAURA":{"id":1194,"details_loaded_time":"2022-11-21 13:40:16","sku":"SSNAURA","price":"30.00","name":"Stay Smiling Necklace","allow_backorder":0,"erp_id":797,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1194,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":11,"name":"Color","type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":37}],"allow_backorder":false}],"tags":["necklace","new","sale","ws","aura","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SSNN":{"id":113,"details_loaded_time":"2025-07-20 09:04:34","sku":"SSNN","price":"80.00","name":"Signature Script Nameplate Necklace","allow_backorder":true,"erp_id":407,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":113,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","topsell","15 inch sterling silver name necklace","nameplate essential necklace","delores name necklace","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","name neclace","items_mobile_app","don't notify"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SSR":{"id":114,"details_loaded_time":"2025-07-20 09:04:29","sku":"SSR","price":"55.00","name":"Simple Stacked Ring","allow_backorder":0,"erp_id":408,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":114,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":254,"name":"Sterling Silver","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":254}],"allow_backorder":false}],"tags":["ring","topsell","non-custom","ring for women","tumb rings","thumb rings","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"STARC":{"id":3644,"details_loaded_time":"2025-07-20 07:16:13","sku":"STARC","price":"18.00","name":"Star Charm","allow_backorder":1,"erp_id":1815,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3644,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"STARR":{"id":1517,"details_loaded_time":"2025-07-20 08:08:05","sku":"STARR","price":"60.00","name":"Star Ring","allow_backorder":0,"erp_id":1067,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1517,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":660,"name":"Star color","quantity":1,"description":null,"type":"list","options":[{"id":2059,"name":"Pink","skip":false,"parent_attribute":null},{"id":2061,"name":"Light Blue","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","say my name","star girl","ring for women","say my name collection","summer collection","woman blue ring","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"STH":{"id":3507,"details_loaded_time":"2025-07-20 07:30:05","sku":"STH","price":"25.00","name":"Spoiled Trucker Hat","allow_backorder":1,"erp_id":1734,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3507,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":1542,"name":"Red\/Wht\/Red","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1542}],"allow_backorder":true}],"tags":["new","accessories","non-custom","hat","trucker","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"STKEARSET":{"id":3432,"details_loaded_time":"2025-07-20 07:38:18","sku":"STKEARSET","price":"100.00","name":"Stacked Ear Set","allow_backorder":1,"erp_id":1653,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3432,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":618,"name":"Not Your Grandma's Hoops","quantity":1,"description":null,"type":"item","options":[{"id":1950,"name":"Not Your Grandma's Hoops - gold","skip":false,"item":{"id":1444,"name":"Not Your Grandma's Hoops","SKU":"NYGH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":546,"name":"Mini Pearl Hoops","quantity":1,"description":null,"type":"item","options":[{"id":1790,"name":"Mini Pearl Hoops - gold","skip":false,"item":{"id":385,"name":"Mini Pearl Hoops","SKU":"MPH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":68,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":619,"name":"Gold Huggie Earrings","quantity":1,"description":null,"type":"item","options":[{"id":1951,"name":"Gold Huggie Earrings","skip":false,"item":{"id":342,"name":"Gold Huggie Earrings","SKU":"GHE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":546,"attribute_option_id":1790},{"attribute_id":618,"attribute_option_id":1950},{"attribute_id":619,"attribute_option_id":1951}],"allow_backorder":true}],"tags":["earrings","set","topsell"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"STRH":{"id":1511,"details_loaded_time":"2025-01-06 21:37:10","sku":"STRH","price":"42.00","name":"Star Huggies","allow_backorder":0,"erp_id":1063,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1511,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":660,"name":"Star color","quantity":1,"description":null,"type":"list","options":[{"id":2059,"name":"Pink","skip":false,"parent_attribute":null},{"id":2060,"name":"Yellow","skip":false,"parent_attribute":null},{"id":2061,"name":"Light Blue","skip":false,"parent_attribute":null},{"id":2062,"name":"White","skip":false,"parent_attribute":null},{"id":2063,"name":"Black","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2060}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2062}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2063}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2059}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2060}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2061}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2062}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":660,"attribute_option_id":2063}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","say my name","star girl","say my name collection","summer collection","playboy","pink planet","waterproof","baby pink bubble clip","tarnish free","tarnishfree","tarnish-free","water proof","fall","items_mobile_app","don't notify","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"SWNASET":{"id":3431,"details_loaded_time":"2025-07-20 07:38:23","sku":"SWNASET","price":"90.00","name":"Shawna Set","allow_backorder":1,"erp_id":1652,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3431,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":128,"name":"Paperclip Chain Necklace","quantity":1,"description":null,"type":"item","options":[{"id":464,"name":"Paperclip Chain Necklace Style 1","skip":false,"item":{"id":395,"name":"Paperclip Chain Necklace","SKU":"PCN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":36,"name":"Style","quantity":1,"description":null,"type":"List","options":[{"id":163,"name":"Style 1","skip":false,"parent_attribute":null},{"id":164,"name":"Style 2","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":164},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":538,"name":"Delicate Rope Chain Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1773,"name":"Delicate Rope Chain Necklace","skip":false,"item":{"id":529,"name":"Delicate Rope Chain Necklace","SKU":"DRCN"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":128,"attribute_option_id":464},{"attribute_id":538,"attribute_option_id":1773}],"allow_backorder":true}],"tags":["set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TABN":{"id":1141,"details_loaded_time":"2025-07-20 08:26:04","sku":"TABN","price":"40.00","name":"Tab Necklace","allow_backorder":0,"erp_id":719,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1141,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TAE":{"id":3858,"details_loaded_time":"2025-07-20 06:55:08","sku":"TAE","price":"70.00","name":"The Alexis Earrings","allow_backorder":1,"erp_id":1919,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3858,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TAES":{"id":912,"details_loaded_time":"2025-07-20 08:32:32","sku":"TAES","price":"150.00","name":"The Angel Energy Set","allow_backorder":0,"erp_id":583,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":912,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":128,"name":"Paperclip Chain Necklace","quantity":1,"description":null,"type":"item","options":[{"id":464,"name":"Paperclip Chain Necklace Style 1","skip":false,"item":{"id":395,"name":"Paperclip Chain Necklace","SKU":"PCN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":36,"name":"Style","quantity":1,"description":null,"type":"List","options":[{"id":163,"name":"Style 1","skip":false,"parent_attribute":null},{"id":164,"name":"Style 2","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":163},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":36,"attribute_option_id":164},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":129,"name":"Cherub Necklace","quantity":1,"description":null,"type":"item","options":[{"id":466,"name":"Cherub Necklace","skip":false,"item":{"id":467,"name":"Cherub Necklace","SKU":"CHRBN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":130,"name":"Old English Signet Ring","quantity":1,"description":null,"type":"item","options":[{"id":468,"name":"Old English Signet Ring","skip":false,"item":{"id":481,"name":"Old English Signet Ring","SKU":"OESR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":68,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":58,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":50,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":179,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":154,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":128,"attribute_option_id":464},{"attribute_id":129,"attribute_option_id":466},{"attribute_id":130,"attribute_option_id":468}],"allow_backorder":false}],"tags":["set","non-custom","angel","coin necklace","heaven sent","saint christopher","saint mary","saint benedict coin","mini mar","mini virgen","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TAPN":{"id":837,"details_loaded_time":"2025-07-20 08:42:04","sku":"TAPN","price":"58.00","name":"Te Amo Pendant Necklace","allow_backorder":1,"erp_id":532,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":837,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","non-custom","charm","charms","heart lock","got it on lock","pindens","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TAS":{"id":787,"details_loaded_time":"2025-07-20 08:44:18","sku":"TAS","price":"150.00","name":"The Anna Set","allow_backorder":1,"erp_id":513,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":787,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":115,"name":"Chunky Link Necklace","quantity":1,"description":null,"type":"item","options":[{"id":442,"name":"Chunky Link Necklace","skip":false,"item":{"id":468,"name":"Chunky Link Necklace","SKU":"CLN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":116,"name":"Snake Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":444,"name":"Snake Pendant Necklace","skip":false,"item":{"id":474,"name":"Snake Pendant Necklace","SKU":"SPN2"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":115,"attribute_option_id":442},{"attribute_id":116,"attribute_option_id":444}],"allow_backorder":true}],"tags":["set","sale","ws","mens chain","gold chain men","chains for men","chain gold men","baby chain","curbchain nameplate","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","chunky charm necklace","items_mobile_app","nodiscount","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TBCC":{"id":836,"details_loaded_time":"2025-07-20 08:42:08","sku":"TBCC","price":"35.00","name":"Thick Box Chain Choker","allow_backorder":0,"erp_id":531,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":836,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":171,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","chocked","link choker","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TBCNECK":{"id":3497,"details_loaded_time":"2025-07-20 07:31:04","sku":"TBCNECK","price":"58.00","name":"The Bone Chain","allow_backorder":1,"erp_id":1723,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3497,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","items_mobile_app","working woman campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TBFFN":{"id":1156,"details_loaded_time":"2022-05-19 20:57:35","sku":"TBFFN","price":"36.54","name":"The BFF Necklace","allow_backorder":0,"erp_id":767,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1156,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","new","sale","ws","bestfriend"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TBLN":{"id":3072,"details_loaded_time":"2024-08-05 19:01:30","sku":"TBLN","price":"46.00","name":"To Be Loved Necklace","allow_backorder":0,"erp_id":1442,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3072,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TBS":{"id":785,"details_loaded_time":"2020-09-17 17:33:06","sku":"TBS","price":"85.00","name":"The Brooke Set","allow_backorder":1,"erp_id":512,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":785,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":113,"name":"Babygirl Nameplate Necklace","type":"item","options":[{"id":438,"name":"Babygirl Nameplate Necklace","skip":false,"item":{"id":295,"name":"Babygirl Nameplate Necklace","SKU":"BGNN"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":114,"name":"Chained Earrings","type":"item","options":[{"id":440,"name":"Chained Earrings","skip":false,"item":{"id":466,"name":"Chained Earrings","SKU":"CHERNG"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":255}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":113,"attribute_option_id":438},{"attribute_id":114,"attribute_option_id":440}],"allow_backorder":true}],"tags":["new","set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCALNECK":{"id":3516,"details_loaded_time":"2025-07-20 07:28:12","sku":"TCALNECK","price":"58.00","name":"The Caldera Necklace","allow_backorder":1,"erp_id":1744,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3516,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","best sellers","top seller","best seller","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCCUFF":{"id":3514,"details_loaded_time":"2025-07-20 07:28:20","sku":"TCCUFF","price":"55.00","name":"The Capri Cuff","allow_backorder":0,"erp_id":1741,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3514,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["bracelet","new","topsell","non-custom","brackets","braceletbracelet","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCH":{"id":3618,"details_loaded_time":"2025-07-20 07:22:07","sku":"TCH","price":"50.00","name":"The Croissant Hoops","allow_backorder":1,"erp_id":1800,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3618,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":41,"name":"Size","quantity":1,"description":null,"type":"list","options":[{"id":171,"name":"Small","skip":false,"parent_attribute":null},{"id":172,"name":"Medium","skip":false,"parent_attribute":null},{"id":173,"name":"Large","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"2.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCOASTSET":{"id":3535,"details_loaded_time":"2025-07-20 07:24:18","sku":"TCOASTSET","price":"125.00","name":"The Coastal Set","allow_backorder":1,"erp_id":1764,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3535,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":671,"name":"Bubble Initial Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2099,"name":"Bubble Initial Necklace","skip":false,"item":{"id":1749,"name":"Bubble Initial Necklace","SKU":"BUBBLEINECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":672,"name":"Coastal Beaded Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2101,"name":"Coastal Beaded Necklace","skip":false,"item":{"id":1757,"name":"Coastal Beaded Necklace","SKU":"CBN"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":2080,"name":"Stainless Steel\/Beaded","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":2080}]],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":2080}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":673,"name":"Moonlight Ring","quantity":1,"description":null,"type":"item","options":[{"id":2103,"name":"Moonlight Ring","skip":false,"item":{"id":1748,"name":"Moonlight Ring","SKU":"MRING"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":671,"attribute_option_id":2099},{"attribute_id":672,"attribute_option_id":2101},{"attribute_id":673,"attribute_option_id":2103}],"allow_backorder":true}],"tags":["set","non-custom","endless summer campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCOR":{"id":2184,"details_loaded_time":"2025-03-21 13:04:16","sku":"TCOR","price":"45.00","name":"Twisted Chain Open Ring","allow_backorder":0,"erp_id":1060,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2184,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":800,"name":"One Size","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":800},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","new","topsell","non-custom","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCPN":{"id":120,"details_loaded_time":"2024-02-28 14:45:17","sku":"TCPN","price":"58.00","name":"The Croix Pendant Necklace_old","allow_backorder":0,"erp_id":414,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":120,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","non-custom","cross ne","cross necklace","iced cross pearl choker","silver cross","golden diamond cross","cross men","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","big cross","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCPNKIT":{"id":3484,"details_loaded_time":"2025-07-20 08:56:50","sku":"TCPNKIT","price":"58.00","name":"The Croix Pendant Necklace","allow_backorder":1,"erp_id":1708,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3484,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":642,"name":"The Croix Pendant Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2021,"name":"The Croix Pendant Necklace--Pendant","skip":false,"item":{"id":564,"name":"The Croix Pendant Necklace--Pendant","SKU":"TCPNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":642,"attribute_option_id":2021}],"allow_backorder":true}],"tags":["necklace","topsell","non-custom","cross necklace","iced cross pearl choker","silver cross","golden diamond cross","cross men","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","water proof","items_mobile_app","big cross","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCPNpen":{"id":878,"details_loaded_time":"2025-07-20 08:57:36","sku":"TCPNpen","price":"58.00","name":"The Croix Pendant Necklace--Pendant","allow_backorder":1,"erp_id":564,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":878,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":["necklace","non-custom","cross necklace","cross men","saint benedict coin","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","big cross"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCR":{"id":922,"details_loaded_time":"2021-04-27 15:32:40","sku":"TCR","price":"45.00","name":"Tortoise Chain Ring","allow_backorder":0,"erp_id":608,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":922,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":null,"combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TCRSHERSET":{"id":3425,"details_loaded_time":"2025-07-20 07:40:04","sku":"TCRSHERSET","price":"105.00","name":"Crystal Herringbone Set","allow_backorder":1,"erp_id":1647,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3425,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1470}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":605,"name":"Crystal Herringbone Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1923,"name":"Crystal Herringbone Necklace","skip":false,"item":{"id":1425,"name":"Crystal Herringbone Necklace","SKU":"CHBN"},"attributes_per_every_item":[{"id":485,"name":"Stone Color","quantity":1,"description":null,"type":"List","options":[{"id":1470,"name":"Crystal","skip":false,"parent_attribute":null},{"id":1471,"name":"Emerald","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1470}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1471}]],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1470}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1471}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":606,"name":"Crystal Herringbone Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":1924,"name":"Crystal Herringbone Bracelet","skip":false,"item":{"id":1426,"name":"Crystal Herringbone Bracelet","SKU":"CHBB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":485,"name":"Stone Color","quantity":1,"description":null,"type":"List","options":[{"id":1470,"name":"Crystal","skip":false,"parent_attribute":null},{"id":1471,"name":"Emerald","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1470}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1471}]],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1470}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":485,"attribute_option_id":1471}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":605,"attribute_option_id":1923},{"attribute_id":606,"attribute_option_id":1924}],"allow_backorder":true}],"tags":["set","sale","ws","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TDAILYSET":{"id":3761,"details_loaded_time":"2025-07-20 07:03:04","sku":"TDAILYSET","price":"115.00","name":"The Daily Set","allow_backorder":1,"erp_id":1887,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3761,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":729,"name":"The Daily Chain","quantity":1,"description":null,"type":"item","options":[{"id":2363,"name":"The Daily Chain","skip":false,"item":{"id":1139,"name":"The Daily Chain Necklace","SKU":"MTDC"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null},{"id":1493,"name":"25","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":1493}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":1493}]],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":1493}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":1493}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":730,"name":"The Daily Chain Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":2365,"name":"The Daily Chain Bracelet","skip":false,"item":{"id":1140,"name":"The Daily Chain Bracelet","SKU":"MTDB"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":920,"name":"8\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":920}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":920}]],"active_combinations":[{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":920}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":920}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":729,"attribute_option_id":2363},{"attribute_id":730,"attribute_option_id":2365}],"allow_backorder":true}],"tags":["non-custom","men","for men"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TDBND":{"id":3492,"details_loaded_time":"2025-07-20 07:32:18","sku":"TDBND","price":"55.00","name":"The Daily Band","allow_backorder":1,"erp_id":1717,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3492,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","mens","silver","mens rings","men rings","men ring","top seller","sliver","sliver rings","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","men s rings","working woman campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TDEAR":{"id":3414,"details_loaded_time":"2025-07-20 07:41:03","sku":"TDEAR","price":"55.00","name":"Teardrop Earring","allow_backorder":1,"erp_id":1626,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3414,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TDS":{"id":910,"details_loaded_time":"2024-03-29 13:49:10","sku":"TDS","price":"160.00","name":"The Dreamers Set","allow_backorder":0,"erp_id":582,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":910,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":126,"name":"Layering Figaro Chain","description":null,"type":"item","options":[{"id":460,"name":"Layering Figaro Chain","skip":false,"item":{"id":510,"name":"Layering Figaro Chain","SKU":"LFC"},"attributes_per_every_item":[{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":127,"name":"Iced Butterfly Pendant Necklace","description":null,"type":"item","options":[{"id":462,"name":"Iced Butterfly Pendant Necklace","skip":false,"item":{"id":356,"name":"Iced Butterfly Pendant Necklace DNU","SKU":"IBPN"},"attributes_per_every_item":[{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":26,"name":"Old English Birthdate Necklace","description":null,"type":"item","options":[{"id":111,"name":"Old English Birthdate Necklace","skip":false,"item":{"id":390,"name":"Old English Birthdate Necklace","SKU":"OEBDN"},"attributes_per_every_item":[{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","description":null,"type":"List","options":[{"id":259,"name":"15\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":22,"name":"Year","description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_numbers","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":26,"attribute_option_id":111},{"attribute_id":126,"attribute_option_id":460},{"attribute_id":127,"attribute_option_id":462}],"allow_backorder":false}],"tags":["set","1992","1999","1996","1990","birth year","birthyear","2003","2004","1995","1988","2000","1986","2008","2002","1987","1989","1991","1993","1994","1997","1998","2001","2005","2006","2007","bejeweled pendant necklace","bejeweled","bejeweled pendant","birthday charms","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TDUCHRING":{"id":3504,"details_loaded_time":"2024-08-15 18:21:12","sku":"TDUCHRING","price":"50.00","name":"The Duchess","allow_backorder":0,"erp_id":1728,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3504,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},"2":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}},"tags":["ring","new","topsell","sale","non-custom","ws","ring for women","tumb rings","top seller","items_mobile_app","don't notify"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TEDBANG":{"id":3654,"details_loaded_time":"2025-07-20 07:14:11","sku":"TEDBANG","price":"60.00","name":"Thick Everyday Bangle","allow_backorder":1,"erp_id":1809,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3654,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","vintage edit","bangle","bangles","sofia richie","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TEDRING":{"id":3707,"details_loaded_time":"2025-07-20 07:13:13","sku":"TEDRING","price":"55.00","name":"Teddy Ring","allow_backorder":1,"erp_id":1843,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3707,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TELIASET":{"id":3427,"details_loaded_time":"2025-07-20 07:38:34","sku":"TELIASET","price":"140.00","name":"The Elianna Set","allow_backorder":1,"erp_id":1649,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3427,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":124,"name":"Iced Ruby Necklace","quantity":1,"description":null,"type":"item","options":[{"id":456,"name":"Iced Ruby Necklace","skip":false,"item":{"id":539,"name":"Iced Ruby Necklace","SKU":"IRN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":612,"name":"Block Letter Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1936,"name":"Block Letter Necklace Kit","skip":false,"item":{"id":1635,"name":"Block Letter Pendant Necklace","SKU":"BLNKIT"},"attributes_per_every_item":[{"id":584,"name":"Block Letter Pendant Necklace","quantity":1,"description":null,"type":"Item","options":[{"id":1882,"name":"Block Letter Necklace--Pendant","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","type":"Unserialized","updated_at":null,"description":null,"SKU":"BLKLNpen","price":"58.00","category":"Jewelry","collection":[],"tags":["Necklace","non-custom","m necklace","j necklace","initial necklace","k necklace","t letter chain","letter j necklace","letter d necklace","l necklace","waterproof","tarnish free","tarnishfree","tarnish-free","water proof"],"allow_backorder":true,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"0.05","weight_unit":1,"images":["https:\/\/ma.aioboportal.com\/images\/item\/vpZ4202405310911Block%20Letter%20Pendant%20Necklace.png"],"shape":null,"allow_warning":1,"warning_quantity":10,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","gtin":null},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}]},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"Item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","type":"Unserialized","updated_at":null,"description":"<h5><font face=\"Arial\" size=\"2\"><span style=\"white-space: pre-wrap;\">Description<\/span><\/font><\/h5><p dir=\"ltr\" style=\"line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"font-size: 10pt; font-family: Arial;\">Micro & dainty double helix pattern chain. Layers perfectly with the Layering Figaro & the Link Chain Necklace. Vibe\u2019s Chain can tie together your swimsuit look or your going out to lunch with the squad attire.<\/span><\/p><p><\/p><h5 style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 11px; font-family: Roboto, sans-serif; font-weight: 400; line-height: 1.2; color: rgb(66, 66, 66); font-size: 1rem; text-shadow: rgba(0, 0, 0, 0.15) 0px 0px 1px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; orphans: auto; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"box-sizing: border-box; font-size: 10pt; font-family: Arial;\">Details<\/span><\/h5><p><\/p><p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; caret-color: rgb(0, 0, 0); color: rgb(0, 0, 0); font-family: Roboto, sans-serif; font-size: 14px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration: none;\"><b><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">Avoid contact with harsh chemicals, moisture, and friction to prolong your jewelry. Clean your jewelry regularly with a soft cloth to restore shine. Please check our\u00a0<\/span><a href=\"https:\/\/vibeszn.com\/pages\/faq\" target=\"_blank\" class=\"js-no-transition\" style=\"color: rgb(28, 29, 29); background-color: rgb(255, 255, 255); font-family: Futura, sans-serif; font-size: 18px; letter-spacing: 0.44999998807907104px;\"><span style=\"font-family: Arial;\">FAQ page<\/span><\/a><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">\u00a0for details.\u00a0<\/span><\/b><br><\/p><p><\/p>","SKU":"REC","price":"20.00","category":"Jewelry","collection":[],"tags":["Necklace","topsell","non-custom","baby chain","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"allow_backorder":false,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"0.10","weight_unit":1,"images":["https:\/\/ma.aioboportal.com\/images\/item\/509%20-%200.jpg"],"shape":null,"allow_warning":1,"warning_quantity":20,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","gtin":null},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":584,"attribute_option_id":1882},{"attribute_id":585,"attribute_option_id":1884}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":584,"attribute_option_id":1882},{"attribute_id":585,"attribute_option_id":1884}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":78,"name":"Chain Link Ring","quantity":1,"description":null,"type":"item","options":[{"id":316,"name":"Chain Link Ring","skip":false,"item":{"id":305,"name":"Chain Link Ring","SKU":"CLR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":155,"name":"Black","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":78,"attribute_option_id":316},{"attribute_id":124,"attribute_option_id":456},{"attribute_id":612,"attribute_option_id":1936}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TELVSET":{"id":3326,"details_loaded_time":"2025-07-20 07:40:36","sku":"TELVSET","price":"145.00","name":"The Elevated Set","allow_backorder":1,"erp_id":1643,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3326,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":595,"name":"Ball & Chain Cross Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1896,"name":"Ball & Chain Cross Necklace","skip":false,"item":{"id":1611,"name":"Ball & Chain Cross Necklace","SKU":"BCROSSN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":596,"name":"Teardrop Earring","quantity":1,"description":null,"type":"item","options":[{"id":1897,"name":"Teardrop Earring","skip":false,"item":{"id":1626,"name":"Teardrop Earring","SKU":"TDEAR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":597,"name":"Gemstone Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":1898,"name":"Gemstone Bracelet","skip":false,"item":{"id":1624,"name":"Gemstone Bracelet","SKU":"GEMBR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":33,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":1838,"name":"Multicolor","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":1838},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":1838},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":595,"attribute_option_id":1896},{"attribute_id":596,"attribute_option_id":1897},{"attribute_id":597,"attribute_option_id":1898}],"allow_backorder":true}],"tags":["set","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TER":{"id":3078,"details_loaded_time":"2025-07-20 07:54:08","sku":"TER","price":"60.00","name":"The Evelyn Ring","allow_backorder":1,"erp_id":1448,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3078,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","topsell","non-custom","vintage edit","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TES":{"id":911,"details_loaded_time":"2025-07-20 08:32:41","sku":"TES","price":"160.00","name":"The Essentials Set","allow_backorder":0,"erp_id":581,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":911,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":115,"name":"Chunky Link Necklace","quantity":1,"description":null,"type":"item","options":[{"id":442,"name":"Chunky Link Necklace","skip":false,"item":{"id":468,"name":"Chunky Link Necklace","SKU":"CLN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":154,"name":"17\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":154},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":56,"name":"Iced Ring","quantity":1,"description":null,"type":"item","options":[{"id":270,"name":"Iced Ring","skip":false,"item":{"id":368,"name":"Iced Ring","SKU":"IDR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":85,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":72,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":136,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":125,"name":"Old English Huggie Earrings","quantity":1,"description":null,"type":"item","options":[{"id":458,"name":"Old English Huggie Earrings","skip":false,"item":{"id":472,"name":"Old English Huggie Earrings","SKU":"OEHE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":70,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":75,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":56,"attribute_option_id":270},{"attribute_id":115,"attribute_option_id":442},{"attribute_id":125,"attribute_option_id":458}],"allow_backorder":false}],"tags":["set","non-custom","initial","chain gold men","initial charm","iced curban","oe initial huggies","intial","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","chain link neckless","crown rings","letter earrings","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TESSET":{"id":3616,"details_loaded_time":"2025-07-20 07:22:16","sku":"TESSET","price":"140.00","name":"The Eloise Stack","allow_backorder":1,"erp_id":1827,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3616,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":261}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":686,"name":"The Plaza Ring","quantity":1,"description":null,"type":"item","options":[{"id":2176,"name":"The Plaza Ring Size","skip":false,"item":{"id":1797,"name":"The Plaza Ring","SKU":"TPR"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":261}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":261}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":261}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":261}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":261}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":261}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":685,"name":"Essential Band","quantity":2,"description":null,"type":"item","options":[{"id":2174,"name":"Essential Band Ring","skip":false,"item":{"id":716,"name":"Essential Band Ring","SKU":"EBR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":685,"attribute_option_id":2174},{"attribute_id":686,"attribute_option_id":2176}],"allow_backorder":true}],"tags":["ring","new","set","non-custom","the casual edit campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TFA":{"id":851,"details_loaded_time":"2025-07-20 08:38:38","sku":"TFA","price":"50.00","name":"Thick Figaro Anklet","allow_backorder":0,"erp_id":542,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":851,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["anklet","topsell","non-custom","ankle bracelet","toe rings","ank","sanklets","anklet bracelets","anklet clasps","cuban anklet","waterproof","fiagro","tarnish free","tarnishfree","tarnish-free","water proof","necklace foot","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TFBMEN":{"id":3102,"details_loaded_time":"2025-07-20 07:50:23","sku":"TFBMEN","price":"89.00","name":"Thick Figaro Bracelet","allow_backorder":1,"erp_id":1469,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3102,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","mens jewelry","mens collection","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TFIPN":{"id":1305,"details_loaded_time":"2025-07-20 08:13:16","sku":"TFIPN","price":"34.00","name":"Ignite Pendant Necklace","allow_backorder":0,"erp_id":867,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1305,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","twinflames","bunny pendant necklace","charm","charms","twin flame","twin flames","twinflames flame pendant","to my soulmate","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TFIYH":{"id":3506,"details_loaded_time":"2025-07-20 07:30:09","sku":"TFIYH","price":"27.00","name":"The Future is Yours Hat","allow_backorder":1,"erp_id":1733,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3506,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":2050,"name":"Black hat","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2050}],"allow_backorder":true}],"tags":["new","accessories","non-custom","hat","trucker","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TFNN":{"id":1302,"details_loaded_time":"2025-07-20 08:13:27","sku":"TFNN","price":"25.00","name":"TwinFlames. Nameplate","allow_backorder":0,"erp_id":866,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1302,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["sale","ws","twinflames","twin flame","twin flames","bestfriend","twinflames flame pendant","to my soulmate","friendship","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","best friennds","bestie","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TFNPN":{"id":2669,"details_loaded_time":"2025-07-20 07:58:43","sku":"TFNPN","price":"80.00","name":"The Future Nameplate Necklace","allow_backorder":true,"erp_id":1332,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2669,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"list","options":[{"id":1316,"name":"Curb Chain","skip":false,"parent_attribute":null},{"id":1313,"name":"Figaro","skip":false,"parent_attribute":null},{"id":1314,"name":"Herringbone","skip":false,"parent_attribute":null},{"id":1315,"name":"Regular Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":1319,"name":"FRZ Cyber Idaten","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":118,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_text","free_chars":13,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"12":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"13":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"14":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"15":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"32":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"33":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"34":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"35":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1316}],"allow_backorder":true},"36":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"37":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"38":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"39":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1313}],"allow_backorder":true},"40":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"41":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"42":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"43":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1314}],"allow_backorder":true},"44":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"45":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"46":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true},"47":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":1319},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":1315}],"allow_backorder":true}},"tags":["necklace","custom","silver","silver","15 inch sterling silver name necklace","multi name nameplate","nameplate essential necklace","14k gold","sliver necklaces","delores name necklace","sliver","curbchain nameplate","name neclace","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TFTSR":{"id":1306,"details_loaded_time":"2025-07-20 08:13:11","sku":"TFTSR","price":"55.00","name":"Two Souls Ring","allow_backorder":0,"erp_id":868,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1306,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","non-custom","twinflames","twin flame","twin flames","bestfriend","ring for women","to my soulmate","friendship","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","best friennds","bestie","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TGEMR":{"id":3886,"details_loaded_time":"2025-07-20 06:51:09","sku":"TGEMR","price":"68.00","name":"The Gem Ring","allow_backorder":1,"erp_id":1943,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3886,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":true},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TGENBAND":{"id":3711,"details_loaded_time":"2025-07-20 07:09:16","sku":"TGENBAND","price":"60.00","name":"The Genevieve Band","allow_backorder":1,"erp_id":1844,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3711,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":944,"name":"Emerald","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TGMCN":{"id":2190,"details_loaded_time":"2025-03-11 17:05:25","sku":"TGMCN","price":"65.00","name":"The Gem Chain","allow_backorder":0,"erp_id":1258,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2190,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws","necklace with a gem","birthstone","tarnish free","fall","items_mobile_app","birth stone","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TGOLDENHSET":{"id":3532,"details_loaded_time":"2025-07-20 07:24:29","sku":"TGOLDENHSET","price":"130.00","name":"The Golden Hour Set","allow_backorder":1,"erp_id":1762,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3532,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":666,"name":"The Capri Cuff","quantity":1,"description":null,"type":"item","options":[{"id":2091,"name":"The Capri Cuff","skip":false,"item":{"id":1741,"name":"The Capri Cuff","SKU":"TCCUFF"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":667,"name":"Almafi Band","quantity":1,"description":null,"type":"item","options":[{"id":2092,"name":"Almafi Band","skip":false,"item":{"id":1742,"name":"Amalfi Band","SKU":"ABAND"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":668,"name":"The Caldera Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2093,"name":"The Caldera Necklace","skip":false,"item":{"id":1744,"name":"The Caldera Necklace","SKU":"TCALNECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":666,"attribute_option_id":2091},{"attribute_id":667,"attribute_option_id":2092},{"attribute_id":668,"attribute_option_id":2093}],"allow_backorder":true}],"tags":["new","set","non-custom","endless summer campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TGOLDSET":{"id":3426,"details_loaded_time":"2025-07-20 07:38:40","sku":"TGOLDSET","price":"140.00","name":"The Gold Set","allow_backorder":1,"erp_id":1648,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3426,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":608,"name":"Herringbone Chain","quantity":1,"description":null,"type":"item","options":[{"id":1929,"name":"Herringbone Chain","skip":false,"item":{"id":476,"name":"Herringbone Chain","SKU":"HBC"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":609,"name":"Mini Tube Hoops","quantity":1,"description":null,"type":"item","options":[{"id":1930,"name":"Mini Tube Hoops","skip":false,"item":{"id":734,"name":"Mini Tube Hoops","SKU":"MTH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":610,"name":"Stacked Band Ring","quantity":1,"description":null,"type":"item","options":[{"id":1931,"name":"Stacked Band Ring","skip":false,"item":{"id":1441,"name":"Stacked Band Ring","SKU":"SBR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160}]],"active_combinations":[{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":608,"attribute_option_id":1929},{"attribute_id":609,"attribute_option_id":1930},{"attribute_id":610,"attribute_option_id":1931}],"allow_backorder":true}],"tags":["set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THAC":{"id":3627,"details_loaded_time":"2025-07-20 07:20:06","sku":"THAC","price":"55.00","name":"The Hailey Chain","allow_backorder":1,"erp_id":1795,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3627,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","top seller","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THBRACE":{"id":3876,"details_loaded_time":"2025-07-20 06:51:43","sku":"THBRACE","price":"58.00","name":"Thick Herringbone Bracelet","allow_backorder":1,"erp_id":1933,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3876,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THC":{"id":3700,"details_loaded_time":"2025-07-20 07:13:16","sku":"THC","price":"58.00","name":"The Hardware Chain","allow_backorder":1,"erp_id":1853,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3700,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEAS":{"id":135,"details_loaded_time":"2023-11-15 17:12:10","sku":"THEAS","price":"160.00","name":"The Ashley Set","allow_backorder":1,"erp_id":430,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":135,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":27,"name":"Classic Old English Nameplate Necklace","type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"8":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"9":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"10":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"11":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"16":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"17":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"18":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"19":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":59,"name":"Old English Double Letter Necklace","type":"item","options":[{"id":276,"name":"Old English Double Letter Necklace","skip":false,"item":{"id":391,"name":"Old English Double Letter Necklace","SKU":"OEDLN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null},{"id":250,"name":"24\"","skip":false,"parent_attribute":null}]},{"id":117,"name":"Initials","type":"Text","validation":{"min_chars":2,"max_chars":2,"required":true,"type":"only_text","free_chars":2,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":60,"name":"Angel Baby Pendant Necklace","type":"item","options":[{"id":278,"name":"Angel Baby Pendant","skip":false,"item":{"id":291,"name":"Angel Baby Pendant","SKU":"ABP"},"attributes_per_every_item":[{"id":121,"name":"Angel Baby Pendant","type":"Item","options":[{"id":449,"name":"Angel Baby Pendant","skip":false,"item":{"id":521,"name":"Angel Baby Pendant -- Pendant","type":"Unserialized","updated_at":null,"description":"<p><span style=\"color: rgb(28, 29, 29); font-family: Poppins, sans-serif; letter-spacing: 0.35px;\">Gold-Plated Copper\u00a0<\/span><br><\/p>","SKU":"ABPpen","price":"9.80","category":null,"collection":[],"tags":["non-custom","items_mobile_app"],"allow_backorder":true,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"5.89","weight_unit":2,"images":[],"shape":null,"allow_warning":1,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","type":"List","options":[{"id":248,"name":"1.8 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":37,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":52,"attribute_option_id":248},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}]},{"id":119,"name":"Chain","type":"Item","options":[{"id":446,"name":"Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","type":"Unserialized","updated_at":null,"description":"<h5><font face=\"Arial\" size=\"2\"><span style=\"white-space: pre-wrap;\">Description<\/span><\/font><\/h5><p dir=\"ltr\" style=\"line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"font-size: 10pt; font-family: Arial;\">Micro & dainty double helix pattern chain. Layers perfectly with the Layering Figaro & the Link Chain Necklace. Vibe\u2019s Chain can tie together your swimsuit look or your going out to lunch with the squad attire.<\/span><\/p><p><\/p><h5 style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 11px; font-family: Roboto, sans-serif; font-weight: 400; line-height: 1.2; color: rgb(66, 66, 66); font-size: 1rem; text-shadow: rgba(0, 0, 0, 0.15) 0px 0px 1px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; orphans: auto; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"box-sizing: border-box; font-size: 10pt; font-family: Arial;\">Details<\/span><\/h5><p><\/p><p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; caret-color: rgb(0, 0, 0); color: rgb(0, 0, 0); font-family: Roboto, sans-serif; font-size: 14px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration: none;\"><b><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">Avoid contact with harsh chemicals, moisture, and friction to prolong your jewelry. Clean your jewelry regularly with a soft cloth to restore shine. Please check our\u00a0<\/span><a href=\"https:\/\/vibeszn.com\/pages\/faq\" target=\"_blank\" class=\"js-no-transition\" style=\"color: rgb(28, 29, 29); background-color: rgb(255, 255, 255); font-family: Futura, sans-serif; font-size: 18px; letter-spacing: 0.44999998807907104px;\"><span style=\"font-family: Arial;\">FAQ page<\/span><\/a><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">\u00a0for details.\u00a0<\/span><\/b><br><\/p><p><\/p>","SKU":"REC","price":"20.00","category":"Jewelry","collection":[],"tags":["Necklace","non-custom","baby chain","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"allow_backorder":false,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"0.10","weight_unit":1,"images":["https:\/\/ma.aioboportal.com\/images\/item\/509%20-%200.jpg"],"shape":null,"allow_warning":1,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"SOLD OUT!"},"attributes_per_every_item":[{"id":14,"name":"Length","type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","type":"List","options":[{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":16857,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1641,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":2837,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":904,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":3290,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1242,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":505,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":358,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":119,"attribute_option_id":446},{"attribute_id":121,"attribute_option_id":449}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":119,"attribute_option_id":446},{"attribute_id":121,"attribute_option_id":449}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":27,"attribute_option_id":113},{"attribute_id":59,"attribute_option_id":276},{"attribute_id":60,"attribute_option_id":278}],"allow_backorder":true}],"tags":["set","custom-set","multi name nameplate","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THECHAMPSET":{"id":3915,"details_loaded_time":"2025-07-20 06:49:04","sku":"THECHAMPSET","price":"180.00","name":"The Champion Set","allow_backorder":1,"erp_id":1952,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3915,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":747,"name":"Dainty Bubble Initial Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2402,"name":"Dainty Bubble Initial Necklace","skip":false,"item":{"id":1917,"name":"Dainty Bubble Initial Necklace","SKU":"DBINECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":748,"name":"Bezzel Band","quantity":1,"description":null,"type":"item","options":[{"id":2404,"name":"Bezzel Band","skip":false,"item":{"id":1946,"name":"Bezzel Band","SKU":"BEZBAND"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":261}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":261}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":261}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":261}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":261}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":261}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":746,"name":"Thick Herringbone Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":2400,"name":"Thick Herringbone Bracelet","skip":false,"item":{"id":1933,"name":"Thick Herringbone Bracelet","SKU":"THBRACE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":749,"name":"Alexis Earrings","quantity":1,"description":null,"type":"item","options":[{"id":2406,"name":"The Alexis Earrings","skip":false,"item":{"id":1919,"name":"The Alexis Earrings","SKU":"TAE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":746,"attribute_option_id":2400},{"attribute_id":747,"attribute_option_id":2402},{"attribute_id":748,"attribute_option_id":2404},{"attribute_id":749,"attribute_option_id":2406}],"allow_backorder":true}],"tags":["new","set","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THECLASSSET":{"id":3734,"details_loaded_time":"2025-07-20 07:07:18","sku":"THECLASSSET","price":"190.00","name":"The Classic Set","allow_backorder":1,"erp_id":1864,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3734,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":714,"name":"Croissant Hoops","quantity":1,"description":null,"type":"item","options":[{"id":2303,"name":"Croissant Hoops","skip":false,"item":{"id":1800,"name":"The Croissant Hoops","SKU":"TCH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":41,"name":"Size","quantity":1,"description":null,"type":"List","options":[{"id":171,"name":"Small","skip":false,"parent_attribute":null},{"id":172,"name":"Medium","skip":false,"parent_attribute":null},{"id":173,"name":"Large","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":171},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"2.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":172},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"5.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":41,"attribute_option_id":173},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":603,"name":"Everyday Bangle","quantity":1,"description":null,"type":"item","options":[{"id":1919,"name":"Everyday Bangle","skip":false,"item":{"id":1445,"name":"Everyday Bangle","SKU":"EDBB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":658,"name":"The Heart Locket","quantity":1,"description":null,"type":"item","options":[{"id":2056,"name":"The Heart Locket","skip":false,"item":{"id":1725,"name":"Classic Heart Locket","SKU":"THLOCK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":716,"name":"Dainty Herringbone Chain","quantity":1,"description":null,"type":"item","options":[{"id":2307,"name":"Dainty Herringbone Chain","skip":false,"item":{"id":1696,"name":"Dainty Herringbone Chain","SKU":"DHERCH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":715,"name":"No. 5 Band","quantity":1,"description":null,"type":"item","options":[{"id":2305,"name":"No.5 Band","skip":false,"item":{"id":1796,"name":"No.5 Band","SKU":"NFBAND"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":603,"attribute_option_id":1919},{"attribute_id":658,"attribute_option_id":2056},{"attribute_id":714,"attribute_option_id":2303},{"attribute_id":715,"attribute_option_id":2305},{"attribute_id":716,"attribute_option_id":2307}],"allow_backorder":true}],"tags":["new","set","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THECS":{"id":136,"details_loaded_time":"2020-09-17 17:42:05","sku":"THECS","price":"120.00","name":"The City Set","allow_backorder":1,"erp_id":431,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":136,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":27,"name":"Classic Old English Nameplate Necklace","type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":61,"name":"Area Code Necklace","type":"item","options":[{"id":280,"name":"Area Code Necklace","skip":false,"item":{"id":294,"name":"Area Code Necklace","SKU":"ACN"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":62,"name":"Custom Area Code Studs","type":"item","options":[{"id":282,"name":"Custom Area Code Studs","skip":false,"item":{"id":321,"name":"Custom Area Code Studs","SKU":"CACS"},"item_option_combinations":[],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":27,"attribute_option_id":113},{"attribute_id":61,"attribute_option_id":280},{"attribute_id":62,"attribute_option_id":282}],"allow_backorder":true}],"tags":["set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEDS":{"id":137,"details_loaded_time":"2025-03-03 19:14:08","sku":"THEDS","price":"122.50","name":"The Delaney Set","allow_backorder":1,"erp_id":432,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":137,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":27,"name":"Classic Old English Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"8":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"9":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"10":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"11":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"16":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"17":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"18":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"19":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":63,"name":"Iced Rainbow Ring","quantity":1,"description":null,"type":"item","options":[{"id":284,"name":"Iced Rainbow Ring","skip":false,"item":{"id":367,"name":"Iced Rainbow Ring","SKU":"IRR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":29,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":107,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":128,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":133,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":5,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":99,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":131,"name":"Bejeweled Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":470,"name":"Bejeweled Pendant Necklace","skip":false,"item":{"id":296,"name":"Bejeweled Pendant Necklace","SKU":"BJPN"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":33,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null},{"id":125,"name":"Ruby Red","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[],"active_combinations":{"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}]},"3":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}]},"5":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":33,"attribute_option_id":125},{"attribute_id":53,"attribute_option_id":253}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":641,"name":"Pistol Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2019,"name":"Pistol Pendant","skip":false,"item":{"id":561,"name":"Pistol Pendant Necklace-Pendant","SKU":"PPNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17776,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1448,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1726,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":726,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2748,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1211,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":495,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":349,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":27,"attribute_option_id":113},{"attribute_id":63,"attribute_option_id":284},{"attribute_id":131,"attribute_option_id":470},{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":641,"attribute_option_id":2019}],"allow_backorder":true}],"tags":["custom","set","custom-set","gun","gun necklace","gun charm","top gun","nameplate essential necklace","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEGEMSET":{"id":3914,"details_loaded_time":"2025-07-20 06:49:09","sku":"THEGEMSET","price":"165.00","name":"The Gemstone Set","allow_backorder":1,"erp_id":1951,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3914,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":744,"name":"Serena Cross Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2396,"name":"Serena Cross Necklace","skip":false,"item":{"id":1925,"name":"Serena Cross Necklace","SKU":"SCNECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":745,"name":"Gem Ring","quantity":1,"description":null,"type":"item","options":[{"id":2398,"name":"Gem Ring","skip":false,"item":{"id":1943,"name":"The Gem Ring","SKU":"TGEMR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":597,"name":"Gemstone Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":1898,"name":"Gemstone Bracelet","skip":false,"item":{"id":1624,"name":"Gemstone Bracelet","SKU":"GEMBR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":33,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":1838,"name":"Multicolor","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":1838},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":1838},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":597,"attribute_option_id":1898},{"attribute_id":744,"attribute_option_id":2396},{"attribute_id":745,"attribute_option_id":2398}],"allow_backorder":true}],"tags":["new","set","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEGS":{"id":138,"details_loaded_time":"2025-07-20 08:58:30","sku":"THEGS","price":"160.00","name":"The Gabrielle Set","allow_backorder":1,"erp_id":433,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":138,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":66,"name":"Script Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":292,"name":"Script Nameplate Necklace","skip":false,"item":{"id":405,"name":"Script Nameplate Necklace","SKU":"SNN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":67,"name":"Old English Initial Necklace","quantity":1,"description":null,"type":"item","options":[{"id":293,"name":"Old English Initial Necklace","skip":false,"item":{"id":393,"name":"Old English Initial Necklace","SKU":"OEIN2"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":25,"name":"Initial","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":1,"required":true,"type":"only_text","free_chars":1,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":648,"name":"Classic Jesus Piece Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2033,"name":"Classic Jesus Piece Necklace","skip":false,"item":{"id":1711,"name":"Classic Jesus Piece Necklace","SKU":"CJPKIT"},"attributes_per_every_item":[{"id":647,"name":"Classic Jesus Piece--Pendant","quantity":1,"description":null,"type":"Item","options":[{"id":2031,"name":"Classic Jesus Piece--Pendant","skip":false,"item":{"id":1712,"name":"Classic Jesus Piece--Pendant","type":"Unserialized","updated_at":null,"description":"<h5>Description<\/h5><p><span data-sheets-value=\"{\"1\":2,\"2\":\"At the center of this crystal studded oval is Vibe\u2019s Classic Jesus Piece. The necklace that fits any vibe and style. The detailing in this necklace is incredible! Wear alone or in a layered stack of necklaces.\"}\" data-sheets-userformat=\"{\"2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":[null,2,0],\"15\":\"Arial\"}\" style=\"font-size: 10pt; font-family: Arial;\">At the center of this crystal studded oval is Vibe\u2019s Classic Jesus Piece. The necklace that fits any vibe and style. The detailing in this necklace is incredible! Wear alone or in a layered stack of necklaces.<\/span><br><\/p><h5>Details<\/h5><p>Pendant Size: 0.75\" x 1.06\"<\/p><p class=\"MsoNormal\" style=\"margin: 0in; font-size: medium; font-family: \"Times New Roman\", serif;\"><span style=\"font-size: 11pt; font-family: Arial, sans-serif;\">Avoid contact with harsh chemicals, moisture, and friction to prolong your jewelry. Clean your jewelry regularly with a soft cloth to restore shine. Please check our\u00a0<\/span><a href=\"https:\/\/vibeszn.com\/pages\/faq\" target=\"_blank\"><span style=\"font-size: 11pt; font-family: Arial, sans-serif; color: black;\">FAQ page<\/span><\/a><span style=\"font-size: 11pt; font-family: Arial, sans-serif;\">\u00a0<\/span><span style=\"font-size: 11pt; font-family: Arial, sans-serif;\">for details.<\/span><span style=\"font-size: 11pt; font-family: Arial, sans-serif;\"><o:p><\/o:p><\/span><\/p>","SKU":"CJPpen","price":null,"category":"Jewelry","collection":[],"tags":["Necklace","non-custom","charm","charms","cross ne","cross necklace","iced cross pearl choker","saint christopher","cross men","st augustine cross necklace","saint mary","crucifix","saint benedict coin","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"allow_backorder":true,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"0.17","weight_unit":1,"images":[],"shape":null,"allow_warning":1,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","gtin":null},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]],"active_combinations":[{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]}],"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":647,"attribute_option_id":2031}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":647,"attribute_option_id":2031}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":66,"attribute_option_id":292},{"attribute_id":67,"attribute_option_id":293},{"attribute_id":648,"attribute_option_id":2033}],"allow_backorder":true}],"tags":["set","custom-set","virgin mary","cross necklace","initial","virgin mary necklace","b initial necklace","initial charm","bejeweled pendant necklace","bejeweled pendant","gold diamond virgin mary necklace","old english nameplate mary","mother mary","iced cross b","saint christopher","saint mary","saint benedict coin","mini mar","mini virgen","curbchain nameplate","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEHS":{"id":139,"details_loaded_time":"2025-07-20 08:58:24","sku":"THEHS","price":"160.00","name":"The Holly Set","allow_backorder":1,"erp_id":434,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":139,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":26,"name":"Old English Birthdate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":111,"name":"Old English Birthdate Necklace","skip":false,"item":{"id":390,"name":"Old English Birthdate Necklace","SKU":"OEBDN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null},{"id":259,"name":"15\"","skip":false,"parent_attribute":null}]},{"id":22,"name":"Year","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_numbers","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":27,"name":"Classic Old English Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":67,"name":"Old English Initial Necklace","quantity":1,"description":null,"type":"item","options":[{"id":293,"name":"Old English Initial Necklace","skip":false,"item":{"id":393,"name":"Old English Initial Necklace","SKU":"OEIN2"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":25,"name":"Initial","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":1,"required":true,"type":"only_text","free_chars":1,"addtional_price_per_char":"0.10","special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":26,"attribute_option_id":111},{"attribute_id":27,"attribute_option_id":113},{"attribute_id":67,"attribute_option_id":293}],"allow_backorder":true}],"tags":["set","custom-set","1992","1999","1996","1990","birth year","birthyear","2003","2004","1995","1988","2000","initial necklace","initial","1986","2008","initial j","2002","v initial","b initial necklace","initial charm","1987","1989","1991","1993","1994","1997","1998","2001","2005","2006","2007","birthday charms","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","1984","1981","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEHS2":{"id":140,"details_loaded_time":"2025-07-20 08:58:14","sku":"THEHS2","price":"150.00","name":"The Horoscope Set","allow_backorder":1,"erp_id":435,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":140,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":28,"name":"Horoscope Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":115,"name":"Horoscope Pendant Necklace","skip":false,"item":{"id":351,"name":"Horoscope Pendant Necklace","SKU":"HPN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":24,"name":"Horoscope","quantity":1,"description":null,"type":"List","options":[{"id":97,"name":"Aries","skip":false,"parent_attribute":null},{"id":105,"name":"Aquarius","skip":false,"parent_attribute":null},{"id":106,"name":"Cancer","skip":false,"parent_attribute":null},{"id":102,"name":"Capricorn","skip":false,"parent_attribute":null},{"id":103,"name":"Gemini","skip":false,"parent_attribute":null},{"id":108,"name":"Pisces","skip":false,"parent_attribute":null},{"id":104,"name":"Libra","skip":false,"parent_attribute":null},{"id":98,"name":"Leo","skip":false,"parent_attribute":null},{"id":99,"name":"Sagittarius","skip":false,"parent_attribute":null},{"id":107,"name":"Scorpio","skip":false,"parent_attribute":null},{"id":100,"name":"Taurus","skip":false,"parent_attribute":null},{"id":101,"name":"Virgo","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"List","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":{"0":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"1":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"2":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"3":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"4":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"5":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"6":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"7":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"8":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"9":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"10":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"11":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"12":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"13":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"14":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"15":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"16":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"17":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"18":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"19":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"20":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"21":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"22":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"23":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"24":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"25":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"26":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"27":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"28":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"29":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"30":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"31":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"32":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"33":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"34":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"35":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"36":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"37":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"38":{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"39":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"40":{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"41":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"42":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"43":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"44":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"45":{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"46":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"47":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"48":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"49":{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"50":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"51":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"52":{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"53":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"54":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"55":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"56":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"57":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"58":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"59":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"60":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"61":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"62":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"63":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"64":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"65":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"66":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"67":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"68":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"69":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"70":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"71":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"72":{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"73":{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"74":{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"75":{"image":null,"stock":88,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"76":{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"77":{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"78":{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"79":{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"80":{"image":null,"stock":130,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"81":{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"82":{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"83":{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"96":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"97":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"98":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"99":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"100":{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"101":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"102":{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"103":{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"104":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"105":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"106":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"107":{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":69,"name":"Stargirl Nameplate","quantity":1,"description":null,"type":"item","options":[{"id":296,"name":"Stargirl Nameplate","skip":false,"item":{"id":411,"name":"Stargirl Nameplate","SKU":"SSN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":28,"attribute_option_id":115},{"attribute_id":69,"attribute_option_id":296}],"allow_backorder":true}],"tags":["set","custom-set","silver","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","charm","charms","scorpion","astrology","gemini necklace","aries necklace","leo necklace","capricorn af","horoscope pendant necklace","pisceszodiac","gemini moon","star sign","starsign","aquarius necklace","taurus necklace","cancer necklace","virgo necklace","libra necklace","scorpio necklace","sagittarius necklace","capricorn necklace","pisces necklace","star girl","coin necklace","birthday charms","pindens","waterproof","birthstone","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THELS":{"id":144,"details_loaded_time":"2025-07-20 08:56:43","sku":"THELS","price":"160.00","name":"The Laci Set","allow_backorder":1,"erp_id":439,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":144,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":61,"name":"Area Code Necklace","quantity":1,"description":null,"type":"item","options":[{"id":280,"name":"Area Code Necklace","skip":false,"item":{"id":294,"name":"Area Code Necklace","SKU":"ACN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":40,"name":"Area Code","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":8,"required":true,"type":"only_numbers","free_chars":8,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":76,"name":"Box Chain Hanging Script Nameplate","quantity":1,"description":null,"type":"item","options":[{"id":314,"name":"Box Chain Hanging Script Nameplate","skip":false,"item":{"id":300,"name":"Box Chain Hanging Script Nameplate","SKU":"BCHSN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":77,"name":"Iced Croix","quantity":1,"description":null,"type":"item","options":[{"id":313,"name":"Iced Croix","skip":false,"item":{"id":359,"name":"Iced Croix Kit","SKU":"IC1"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":61,"attribute_option_id":280},{"attribute_id":76,"attribute_option_id":314},{"attribute_id":77,"attribute_option_id":313}],"allow_backorder":true}],"tags":["set","custom-set","bejeweled","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THELXS":{"id":145,"details_loaded_time":"2025-07-20 08:56:33","sku":"THELXS","price":"160.00","name":"The Lexie Set","allow_backorder":1,"erp_id":440,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":145,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":28,"name":"Horoscope Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":115,"name":"Horoscope Pendant Necklace","skip":false,"item":{"id":351,"name":"Horoscope Pendant Necklace","SKU":"HPN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":24,"name":"Horoscope","quantity":1,"description":null,"type":"List","options":[{"id":97,"name":"Aries","skip":false,"parent_attribute":null},{"id":105,"name":"Aquarius","skip":false,"parent_attribute":null},{"id":106,"name":"Cancer","skip":false,"parent_attribute":null},{"id":102,"name":"Capricorn","skip":false,"parent_attribute":null},{"id":103,"name":"Gemini","skip":false,"parent_attribute":null},{"id":108,"name":"Pisces","skip":false,"parent_attribute":null},{"id":104,"name":"Libra","skip":false,"parent_attribute":null},{"id":98,"name":"Leo","skip":false,"parent_attribute":null},{"id":99,"name":"Sagittarius","skip":false,"parent_attribute":null},{"id":107,"name":"Scorpio","skip":false,"parent_attribute":null},{"id":100,"name":"Taurus","skip":false,"parent_attribute":null},{"id":101,"name":"Virgo","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"List","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":{"0":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"1":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"2":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"3":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"4":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"5":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"6":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"7":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"8":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"9":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"10":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"11":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"12":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"13":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"14":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"15":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"16":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"17":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"18":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"19":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"20":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"21":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"22":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"23":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"24":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"25":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"26":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"27":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"28":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"29":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"30":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"31":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"32":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"33":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"34":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"35":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"36":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"37":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"38":{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"39":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"40":{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"41":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"42":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"43":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"44":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"45":{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"46":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"47":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"48":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"49":{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"50":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"51":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"52":{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"53":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"54":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"55":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"56":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"57":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"58":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"59":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"60":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"61":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"62":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"63":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"64":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"65":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"66":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"67":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"68":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"69":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"70":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"71":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"72":{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"73":{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"74":{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"75":{"image":null,"stock":88,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"76":{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"77":{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"78":{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"79":{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"80":{"image":null,"stock":130,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"81":{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"82":{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"83":{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"96":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"97":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"98":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"99":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"100":{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"101":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"102":{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"103":{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"104":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"105":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"106":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"107":{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":61,"name":"Area Code Necklace","quantity":1,"description":null,"type":"item","options":[{"id":280,"name":"Area Code Necklace","skip":false,"item":{"id":294,"name":"Area Code Necklace","SKU":"ACN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":40,"name":"Area Code","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":8,"required":true,"type":"only_numbers","free_chars":8,"addtional_price_per_char":null,"special_chars":false,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":66,"name":"Script Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":292,"name":"Script Nameplate Necklace","skip":false,"item":{"id":405,"name":"Script Nameplate Necklace","SKU":"SNN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":28,"attribute_option_id":115},{"attribute_id":61,"attribute_option_id":280},{"attribute_id":66,"attribute_option_id":292}],"allow_backorder":true}],"tags":["set","custom-set","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","angel numbers","angle numbers","angle number","angel number","horoscope pendant necklace","horroscope pendant necklace","angel number necklace","new york","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","leo season","january","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEMARG":{"id":3702,"details_loaded_time":"2025-07-20 07:13:20","sku":"THEMARG","price":"60.00","name":"The Margot","allow_backorder":1,"erp_id":1848,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3702,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEMYS":{"id":148,"details_loaded_time":"2023-11-15 17:01:21","sku":"THEMYS","price":"160.00","name":"The Mya Set","allow_backorder":1,"erp_id":443,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":148,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":27,"name":"Classic Old English Nameplate Necklace","type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"8":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"9":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"10":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"11":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"16":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"17":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"18":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"19":{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":28,"name":"Horoscope Pendant Necklace","type":"item","options":[{"id":115,"name":"Horoscope Pendant Necklace","skip":false,"item":{"id":351,"name":"Horoscope Pendant Necklace","SKU":"HPN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":24,"name":"Horoscope","type":"List","options":[{"id":97,"name":"Aries","skip":false,"parent_attribute":null},{"id":105,"name":"Aquarius","skip":false,"parent_attribute":null},{"id":106,"name":"Cancer","skip":false,"parent_attribute":null},{"id":102,"name":"Capricorn","skip":false,"parent_attribute":null},{"id":103,"name":"Gemini","skip":false,"parent_attribute":null},{"id":108,"name":"Pisces","skip":false,"parent_attribute":null},{"id":104,"name":"Libra","skip":false,"parent_attribute":null},{"id":98,"name":"Leo","skip":false,"parent_attribute":null},{"id":99,"name":"Sagittarius","skip":false,"parent_attribute":null},{"id":107,"name":"Scorpio","skip":false,"parent_attribute":null},{"id":100,"name":"Taurus","skip":false,"parent_attribute":null},{"id":101,"name":"Virgo","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","type":"List","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":{"0":{"image":null,"stock":37,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"1":{"image":null,"stock":42,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"2":{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"3":{"image":null,"stock":34,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"4":{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"5":{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"6":{"image":null,"stock":34,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"7":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"8":{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"9":{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"10":{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"11":{"image":null,"stock":29,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"12":{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"13":{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"14":{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"15":{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"16":{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"17":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"18":{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"19":{"image":null,"stock":37,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"20":{"image":null,"stock":40,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"21":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"22":{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"23":{"image":null,"stock":60,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"24":{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"25":{"image":null,"stock":41,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"26":{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"27":{"image":null,"stock":29,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"28":{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"29":{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"30":{"image":null,"stock":49,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"31":{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"32":{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"33":{"image":null,"stock":28,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"34":{"image":null,"stock":24,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"35":{"image":null,"stock":56,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"36":{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"37":{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"38":{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"39":{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"40":{"image":null,"stock":31,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"41":{"image":null,"stock":44,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"42":{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"43":{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"44":{"image":null,"stock":32,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"45":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"46":{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"47":{"image":null,"stock":34,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"48":{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"49":{"image":null,"stock":35,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"50":{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"51":{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"52":{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"53":{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"54":{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"55":{"image":null,"stock":13,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"56":{"image":null,"stock":30,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"57":{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"58":{"image":null,"stock":16,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"59":{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"60":{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"61":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"62":{"image":null,"stock":28,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"63":{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"64":{"image":null,"stock":27,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"65":{"image":null,"stock":18,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"66":{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"67":{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"68":{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"69":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"70":{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"71":{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"72":{"image":null,"stock":63,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"73":{"image":null,"stock":43,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"74":{"image":null,"stock":28,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"75":{"image":null,"stock":60,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"76":{"image":null,"stock":42,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"77":{"image":null,"stock":50,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"78":{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"79":{"image":null,"stock":38,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"80":{"image":null,"stock":78,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"81":{"image":null,"stock":67,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"82":{"image":null,"stock":47,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"83":{"image":null,"stock":34,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"96":{"image":null,"stock":28,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"97":{"image":null,"stock":26,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"98":{"image":null,"stock":53,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"99":{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"100":{"image":null,"stock":50,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"101":{"image":null,"stock":53,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"102":{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"103":{"image":null,"stock":42,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"104":{"image":null,"stock":25,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"105":{"image":null,"stock":29,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"106":{"image":null,"stock":48,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"107":{"image":null,"stock":39,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":65,"name":"Pistol Pendant Necklace","type":"item","options":[{"id":288,"name":"Pistol Pendant Necklace","skip":false,"item":{"id":397,"name":"Pistol Pendant Necklace","SKU":"PPN"},"attributes_per_every_item":[{"id":11,"name":"Color","type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":16,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":21,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":27,"attribute_option_id":113},{"attribute_id":28,"attribute_option_id":115},{"attribute_id":65,"attribute_option_id":288}],"allow_backorder":true}],"tags":["set","custom-set","pisces","gun","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","gun necklace","leo necklace","horoscope pendant necklace","horroscope pendant necklace","pisceszodiac","gun charm","top gun","nameplate essential necklace","curbchain nameplate","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","leo season","january","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEOAK":{"id":3713,"details_loaded_time":"2025-07-20 07:09:08","sku":"THEOAK","price":"65.00","name":"The Oakmont","allow_backorder":1,"erp_id":1847,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3713,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","non-custom","items_mobile_app","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THEOS":{"id":149,"details_loaded_time":"2025-07-20 08:56:12","sku":"THEOS","price":"160.00","name":"The Olivia Set","allow_backorder":1,"erp_id":444,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":149,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":66,"name":"Script Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":292,"name":"Script Nameplate Necklace","skip":false,"item":{"id":405,"name":"Script Nameplate Necklace","SKU":"SNN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":645,"name":"The Madonna Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2027,"name":"The Madonna Necklace","skip":false,"item":{"id":1709,"name":"The Madonna Necklace","SKU":"TMNKIT"},"attributes_per_every_item":[{"id":644,"name":"The Madonna Necklace--Pendant","quantity":1,"description":null,"type":"Item","options":[{"id":2025,"name":"The Madonna Necklace--Pendant","skip":false,"item":{"id":565,"name":"The Madonna Necklace--Pendant","type":"Unserialized","updated_at":null,"description":null,"SKU":"TMNpen","price":"14.70","category":"Jewelry","collection":[],"tags":[],"allow_backorder":true,"is_orderable":false,"is_orderable_within_kit":true,"orderable":false,"weight":"0.11","weight_unit":1,"images":[],"shape":null,"allow_warning":1,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","gtin":null},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":205,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":625,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}]},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"Item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","type":"Unserialized","updated_at":null,"description":"<h5><font face=\"Arial\" size=\"2\"><span style=\"white-space: pre-wrap;\">Description<\/span><\/font><\/h5><p dir=\"ltr\" style=\"line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"font-size: 10pt; font-family: Arial;\">Micro & dainty double helix pattern chain. Layers perfectly with the Layering Figaro & the Link Chain Necklace. Vibe\u2019s Chain can tie together your swimsuit look or your going out to lunch with the squad attire.<\/span><\/p><p><\/p><h5 style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 11px; font-family: Roboto, sans-serif; font-weight: 400; line-height: 1.2; color: rgb(66, 66, 66); font-size: 1rem; text-shadow: rgba(0, 0, 0, 0.15) 0px 0px 1px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; orphans: auto; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"box-sizing: border-box; font-size: 10pt; font-family: Arial;\">Details<\/span><\/h5><p><\/p><p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; caret-color: rgb(0, 0, 0); color: rgb(0, 0, 0); font-family: Roboto, sans-serif; font-size: 14px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration: none;\"><b><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">Avoid contact with harsh chemicals, moisture, and friction to prolong your jewelry. Clean your jewelry regularly with a soft cloth to restore shine. Please check our\u00a0<\/span><a href=\"https:\/\/vibeszn.com\/pages\/faq\" target=\"_blank\" class=\"js-no-transition\" style=\"color: rgb(28, 29, 29); background-color: rgb(255, 255, 255); font-family: Futura, sans-serif; font-size: 18px; letter-spacing: 0.44999998807907104px;\"><span style=\"font-family: Arial;\">FAQ page<\/span><\/a><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">\u00a0for details.\u00a0<\/span><\/b><br><\/p><p><\/p>","SKU":"REC","price":"20.00","category":"Jewelry","collection":[],"tags":["Necklace","topsell","non-custom","baby chain","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"allow_backorder":false,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"0.10","weight_unit":1,"images":["https:\/\/ma.aioboportal.com\/images\/item\/509%20-%200.jpg"],"shape":null,"allow_warning":1,"warning_quantity":20,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","gtin":null},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":585,"attribute_option_id":1884},{"attribute_id":644,"attribute_option_id":2025}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":585,"attribute_option_id":1884},{"attribute_id":644,"attribute_option_id":2025}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":643,"name":"The Croix Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2023,"name":"The Croix Pendant Necklace","skip":false,"item":{"id":1708,"name":"The Croix Pendant Necklace","SKU":"TCPNKIT"},"attributes_per_every_item":[{"id":642,"name":"The Croix Pendant Necklace--Pendant","quantity":1,"description":null,"type":"Item","options":[{"id":2021,"name":"The Croix Pendant Necklace--Pendant","skip":false,"item":{"id":564,"name":"The Croix Pendant Necklace--Pendant","type":"Unserialized","updated_at":null,"description":null,"SKU":"TCPNpen","price":"58.00","category":"Jewelry","collection":[],"tags":["Necklace","non-custom","cross necklace","cross men","saint benedict coin","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","big cross"],"allow_backorder":true,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"6.36","weight_unit":2,"images":["https:\/\/ma.aioboportal.com\/images\/item\/n1PO202405310903The%20Croix%20Pendant.png"],"shape":null,"allow_warning":1,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","gtin":null},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":122,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}]},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"Item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","type":"Unserialized","updated_at":null,"description":"<h5><font face=\"Arial\" size=\"2\"><span style=\"white-space: pre-wrap;\">Description<\/span><\/font><\/h5><p dir=\"ltr\" style=\"line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"font-size: 10pt; font-family: Arial;\">Micro & dainty double helix pattern chain. Layers perfectly with the Layering Figaro & the Link Chain Necklace. Vibe\u2019s Chain can tie together your swimsuit look or your going out to lunch with the squad attire.<\/span><\/p><p><\/p><h5 style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 11px; font-family: Roboto, sans-serif; font-weight: 400; line-height: 1.2; color: rgb(66, 66, 66); font-size: 1rem; text-shadow: rgba(0, 0, 0, 0.15) 0px 0px 1px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; orphans: auto; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none;\"><span data-sheets-value=\"{\" 1\":2,\"2\":\"micro=\"\" &=\"\" dainty=\"\" double=\"\" helix=\"\" pattern=\"\" chain.=\"\" layers=\"\" perfectly=\"\" with=\"\" the=\"\" layering=\"\" figaro=\"\" link=\"\" chain=\"\" necklace.=\"\" vibe\u2019s=\"\" can=\"\" tie=\"\" together=\"\" your=\"\" swimsuit=\"\" look=\"\" or=\"\" going=\"\" out=\"\" to=\"\" lunch=\"\" squad=\"\" attire.\"}\"=\"\" data-sheets-userformat=\"{\" 2\":6913,\"3\":{\"1\":0},\"11\":4,\"12\":0,\"14\":{\"1\":2,\"2\":0},\"15\":\"arial\"}\"=\"\" style=\"box-sizing: border-box; font-size: 10pt; font-family: Arial;\">Details<\/span><\/h5><p><\/p><p style=\"box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; caret-color: rgb(0, 0, 0); color: rgb(0, 0, 0); font-family: Roboto, sans-serif; font-size: 14px; font-style: normal; font-variant-caps: normal; letter-spacing: normal; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration: none;\"><b><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">Avoid contact with harsh chemicals, moisture, and friction to prolong your jewelry. Clean your jewelry regularly with a soft cloth to restore shine. Please check our\u00a0<\/span><a href=\"https:\/\/vibeszn.com\/pages\/faq\" target=\"_blank\" class=\"js-no-transition\" style=\"color: rgb(28, 29, 29); background-color: rgb(255, 255, 255); font-family: Futura, sans-serif; font-size: 18px; letter-spacing: 0.44999998807907104px;\"><span style=\"font-family: Arial;\">FAQ page<\/span><\/a><span style=\"font-family: Arial; font-size: 18px; letter-spacing: 0.44999998807907104px;\">\u00a0for details.\u00a0<\/span><\/b><br><\/p><p><\/p>","SKU":"REC","price":"20.00","category":"Jewelry","collection":[],"tags":["Necklace","topsell","non-custom","baby chain","swimwear","waterproof","fiagro","swim figaro women chain","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","shopify_sync"],"allow_backorder":false,"is_orderable":true,"is_orderable_within_kit":true,"orderable":true,"weight":"0.10","weight_unit":1,"images":["https:\/\/ma.aioboportal.com\/images\/item\/509%20-%200.jpg"],"shape":null,"allow_warning":1,"warning_quantity":20,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","gtin":null},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":642,"attribute_option_id":2021}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":642,"attribute_option_id":2021}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":66,"attribute_option_id":292},{"attribute_id":643,"attribute_option_id":2023},{"attribute_id":645,"attribute_option_id":2027}],"allow_backorder":true}],"tags":["set","custom-set","virgin mary","cross ne","cross necklace","virgin mary necklace","gold diamond virgin mary necklace","mother mary","golden diamond cross","14k gold","st augustine cross necklace","saint mary","mini mar","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THESILVSET":{"id":3735,"details_loaded_time":"2025-07-20 07:07:12","sku":"THESILVSET","price":"180.00","name":"The Silver Set","allow_backorder":1,"erp_id":1865,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3735,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":720,"name":"Bubble Initial Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2315,"name":"Bubble Initial Necklace","skip":false,"item":{"id":1749,"name":"Bubble Initial Necklace","SKU":"BUBBLEINECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":719,"name":"Balloon Ring","quantity":1,"description":null,"type":"item","options":[{"id":2313,"name":"Balloon Ring","skip":false,"item":{"id":1627,"name":"Balloon Ring","SKU":"BALRNG"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":717,"name":"Dainty Herringbone Chain","quantity":1,"description":null,"type":"item","options":[{"id":2309,"name":"Dainty Herringbone Chain","skip":false,"item":{"id":1696,"name":"Dainty Herringbone Chain","SKU":"DHERCH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":721,"name":"Off Duty Hoops","quantity":1,"description":null,"type":"item","options":[{"id":2317,"name":"Off Duty Hoops","skip":false,"item":{"id":1323,"name":"Off Duty Hoops","SKU":"ODH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20}]],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":718,"name":"Signature Link Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":2311,"name":"Signature Link Bracelet","skip":false,"item":{"id":1716,"name":"Signature Link Bracelet","SKU":"SIGLB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":717,"attribute_option_id":2309},{"attribute_id":718,"attribute_option_id":2311},{"attribute_id":719,"attribute_option_id":2313},{"attribute_id":720,"attribute_option_id":2315},{"attribute_id":721,"attribute_option_id":2317}],"allow_backorder":true}],"tags":["new","set","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THESS":{"id":150,"details_loaded_time":"2025-07-20 08:56:05","sku":"THESS","price":"170.00","name":"The Sofia Set","allow_backorder":1,"erp_id":445,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":150,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":26,"name":"Old English Birthdate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":111,"name":"Old English Birthdate Necklace","skip":false,"item":{"id":390,"name":"Old English Birthdate Necklace","SKU":"OEBDN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null},{"id":259,"name":"15\"","skip":false,"parent_attribute":null}]},{"id":22,"name":"Year","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_numbers","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":74,"name":"Signature Script Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":309,"name":"Signature Script Nameplate Necklace","skip":false,"item":{"id":407,"name":"Signature Script Nameplate Necklace","SKU":"SSNN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":27,"name":"Classic Old English Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":647,"name":"Classic Jesus Piece--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2031,"name":"Classic Jesus Piece--Pendant","skip":false,"item":{"id":1712,"name":"Classic Jesus Piece--Pendant","SKU":"CJPpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]],"active_combinations":[{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":94,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":54,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":26,"attribute_option_id":111},{"attribute_id":27,"attribute_option_id":113},{"attribute_id":74,"attribute_option_id":309},{"attribute_id":647,"attribute_option_id":2031}],"allow_backorder":true}],"tags":["set","custom-set","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THESUMSET":{"id":3913,"details_loaded_time":"2025-07-20 06:49:13","sku":"THESUMSET","price":"150.00","name":"The Summer Set","allow_backorder":1,"erp_id":1950,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3913,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":741,"name":"Custom Herringbone Anklet","quantity":1,"description":null,"type":"item","options":[{"id":2390,"name":"Custom Herringbone Anklet","skip":false,"item":{"id":1760,"name":"Custom Herringbone Anklet","SKU":"CHERGANK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":571,"name":"Pick Your Anklet","quantity":1,"description":null,"type":"List","options":[{"id":1852,"name":"Herringbone Anklet","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":571,"attribute_option_id":1852}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":742,"name":"Elevated Pearl Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":2392,"name":"Elevated Pearl Bracelet","skip":false,"item":{"id":1935,"name":"Elevated Pearl Bracelet","SKU":"EPB"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":1322,"name":"Stainless Steel\/Pearl","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":1322}]],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":1322}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":743,"name":"Pearl Lariat Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2394,"name":"Pearl Lariat Necklace","skip":false,"item":{"id":1926,"name":"Pearl Lariat Necklace","SKU":"PLN"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":2379,"name":"28\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":1322,"name":"Stainless Steel\/Pearl","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":2379},{"attribute_id":53,"attribute_option_id":1322}]],"active_combinations":[{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":2379},{"attribute_id":53,"attribute_option_id":1322}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":741,"attribute_option_id":2390},{"attribute_id":742,"attribute_option_id":2392},{"attribute_id":743,"attribute_option_id":2394}],"allow_backorder":true}],"tags":["new","custom","set","topsell","don't notify","the players club campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THETSS":{"id":132,"details_loaded_time":"2025-07-20 09:00:17","sku":"THETSS","price":"170.00","name":"The Top Sellers Set","allow_backorder":1,"erp_id":426,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":132,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":26,"name":"Old English Birthdate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":111,"name":"Old English Birthdate Necklace","skip":false,"item":{"id":390,"name":"Old English Birthdate Necklace","SKU":"OEBDN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null},{"id":259,"name":"15\"","skip":false,"parent_attribute":null}]},{"id":22,"name":"Year","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"only_numbers","free_chars":13,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":259},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":27,"name":"Classic Old English Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":113,"name":"Classic Old English Nameplate Necklace","skip":false,"item":{"id":311,"name":"Classic Old English Nameplate Necklace","SKU":"COENN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":31,"name":"Font","quantity":1,"description":null,"type":"List","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"2":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"8":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"11":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"16":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"17":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"18":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]},"19":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":28,"name":"Horoscope Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":115,"name":"Horoscope Pendant Necklace","skip":false,"item":{"id":351,"name":"Horoscope Pendant Necklace","SKU":"HPN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":24,"name":"Horoscope","quantity":1,"description":null,"type":"List","options":[{"id":97,"name":"Aries","skip":false,"parent_attribute":null},{"id":105,"name":"Aquarius","skip":false,"parent_attribute":null},{"id":106,"name":"Cancer","skip":false,"parent_attribute":null},{"id":102,"name":"Capricorn","skip":false,"parent_attribute":null},{"id":103,"name":"Gemini","skip":false,"parent_attribute":null},{"id":108,"name":"Pisces","skip":false,"parent_attribute":null},{"id":104,"name":"Libra","skip":false,"parent_attribute":null},{"id":98,"name":"Leo","skip":false,"parent_attribute":null},{"id":99,"name":"Sagittarius","skip":false,"parent_attribute":null},{"id":107,"name":"Scorpio","skip":false,"parent_attribute":null},{"id":100,"name":"Taurus","skip":false,"parent_attribute":null},{"id":101,"name":"Virgo","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","quantity":1,"description":null,"type":"List","options":[{"id":246,"name":"2 cm","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":{"0":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"1":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"2":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"3":{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"4":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"5":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"6":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"7":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"8":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"9":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"10":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"11":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"12":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"13":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"14":{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"15":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"16":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"17":{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"18":{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"19":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"20":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"21":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"22":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"23":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"24":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"25":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"26":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"27":{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"28":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"29":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"30":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"31":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"32":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"33":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"34":{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"35":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"36":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"37":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"38":{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"39":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"40":{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"41":{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"42":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"43":{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"44":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"45":{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"46":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"47":{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"48":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"49":{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"50":{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"51":{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"52":{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"53":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"54":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"55":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"56":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"57":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"58":{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"59":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"60":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"61":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"62":{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"63":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"64":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"65":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"66":{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"67":{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"68":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"69":{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"70":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"71":{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"72":{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"73":{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"74":{"image":null,"stock":87,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"75":{"image":null,"stock":88,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"76":{"image":null,"stock":80,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"77":{"image":null,"stock":110,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"78":{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"79":{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"80":{"image":null,"stock":130,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"81":{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"82":{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"83":{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"96":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":97},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"97":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":98},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"98":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":99},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"99":{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":100},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"100":{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":101},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"101":{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":102},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"102":{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":103},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"103":{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":104},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"104":{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":105},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"105":{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":106},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"106":{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":107},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]},"107":{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":24,"attribute_option_id":108},{"attribute_id":52,"attribute_option_id":246},{"attribute_id":53,"attribute_option_id":253}]}},"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":29,"name":"Initial Letter Anklet","quantity":1,"description":null,"type":"item","options":[{"id":117,"name":"Initial Letter Anklet","skip":false,"item":{"id":369,"name":"Initial Letter Anklet","SKU":"ILA"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":240,"name":"8.2\"","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":153}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":128}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":129}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":130}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":131}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":132}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":133}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":134}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":135}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":136}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":137}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":138}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":139}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":140}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":141}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":142}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":143}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":144}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":145}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":146}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":147}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":148}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":149}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":150}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":151}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":153}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":152}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":152}]],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":139,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":545,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":312,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":423,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":483,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":436,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":307,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":326,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":317,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":102,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":201,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":144,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":83,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":153}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":128}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":129}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":130}]},{"image":null,"stock":38,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":131}]},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":132}]},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":133}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":134}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":135}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":136}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":137}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":138}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":139}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":140}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":141}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":142}]},{"image":null,"stock":58,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":143}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":144}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":145}]},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":146}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":147}]},{"image":null,"stock":64,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":148}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":149}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":150}]},{"image":null,"stock":63,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":151}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":153}]},{"image":null,"stock":246,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":152}]},{"image":null,"stock":76,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":240},{"attribute_id":34,"attribute_option_id":152}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":26,"attribute_option_id":111},{"attribute_id":27,"attribute_option_id":113},{"attribute_id":28,"attribute_option_id":115},{"attribute_id":29,"attribute_option_id":117}],"allow_backorder":true}],"tags":["set","custom-set","pisces","aries","scorpio","gemini","capricorn","aquarius","leo","virgo","libra","taurus","sagittarius","cancer","1992","1999","1996","1990","birth year","birthyear","scorpion","2003","2004","astrology","1995","gemini necklace","1988","2000","aries necklace","leo necklace","capricorn af","1986","2008","2002","1998 necklace","pisceszodiac","gemini moon","star sign","starsign","aquarius necklace","taurus necklace","cancer necklace","virgo necklace","libra necklace","scorpio necklace","sagittarius necklace","capricorn necklace","pisces necklace","1987","1989","1991","1993","1994","1997","1998","2001","2005","2006","2007","top seller set","90 necklace","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","zodiac","1984","leo season","1981","1944 necklace","89 necklace","items_mobile_app","nodiscount","don't notify"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THLDYSET":{"id":3422,"details_loaded_time":"2024-05-14 14:12:19","sku":"THLDYSET","price":"160.00","name":"The Holiday Set","allow_backorder":1,"erp_id":1644,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3422,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":599,"name":"Luxe Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1911,"name":"Luxe Necklace","skip":false,"item":{"id":1630,"name":"Luxe Necklace","SKU":"LUXEN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":33,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":600,"name":"Heritage Herringbone Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1913,"name":"Heritage Herringbone Necklace","skip":false,"item":{"id":1625,"name":"Heritage Herringbone Necklace","SKU":"HHERN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":33,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":126,"name":"Crystal","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":33,"attribute_option_id":126},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":601,"name":"Cable Cuff Ring","quantity":1,"description":null,"type":"item","options":[{"id":1914,"name":"Cable Cuff Ring","skip":false,"item":{"id":1629,"name":"Cable Cuff Ring","SKU":"CBLCFR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":39,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":599,"attribute_option_id":1911},{"attribute_id":600,"attribute_option_id":1913},{"attribute_id":601,"attribute_option_id":1914}],"allow_backorder":true}],"tags":["new","set","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THLOCK":{"id":3494,"details_loaded_time":"2025-07-20 07:37:16","sku":"THLOCK","price":"58.00","name":"Classic Heart Locket","allow_backorder":1,"erp_id":1725,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3494,"force_allow_backorder":false,"warning_quantity":15,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","non-custom","heart lock","lock it necklace","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THLOCKKIT":{"id":3513,"details_loaded_time":"2025-07-20 07:28:25","sku":"THLOCKKIT","price":"58.00","name":"The Classic Locket","allow_backorder":1,"erp_id":1738,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3513,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":658,"name":"The Heart Locket","quantity":1,"description":null,"type":"item","options":[{"id":2056,"name":"The Heart Locket","skip":false,"item":{"id":1725,"name":"Classic Heart Locket","SKU":"THLOCK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":659,"name":"Delicate Rope Chain Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2057,"name":"Delicate Rope Chain Necklace","skip":false,"item":{"id":529,"name":"Delicate Rope Chain Necklace","SKU":"DRCN"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":658,"attribute_option_id":2056},{"attribute_id":659,"attribute_option_id":2057}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","heart lock","lock it necklace","items_mobile_app","the casual edit campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THLSR":{"id":2186,"details_loaded_time":"2022-12-16 21:42:18","sku":"THLSR","price":"55.00","name":"The Hills Ring","allow_backorder":0,"erp_id":1254,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2186,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","type":"list","options":[{"id":800,"name":"One Size","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":800},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","new","sale","non-custom","ws","ring for women","14k gold","tarnish free","fall","hill","the hills","girls night","girls night collection","girls night out","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THREECHARMNECK":{"id":3653,"details_loaded_time":"2025-07-20 07:14:16","sku":"THREECHARMNECK","price":"78.00","name":"3 Charm Necklace","allow_backorder":1,"erp_id":1833,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3653,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2246}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":683,"name":"Carabiner Chain Type","quantity":1,"description":null,"type":"item","options":[{"id":2171,"name":"Choose Your Carabiner Chain","skip":false,"item":{"id":1802,"name":"Carabiner Chain Type","SKU":"CARANECK"},"attributes_per_every_item":[{"id":692,"name":"Carabiner Chain","quantity":1,"description":null,"type":"List","options":[{"id":2246,"name":"Dainty Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2247,"name":"Paperclip Carabiner Chain","skip":false,"parent_attribute":null},{"id":2248,"name":"Dainty Curb Carabiner Chain","skip":false,"parent_attribute":null},{"id":2249,"name":"Curb Carabiner Chain","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":692,"attribute_option_id":2246}],[{"attribute_id":692,"attribute_option_id":2247}],[{"attribute_id":692,"attribute_option_id":2248}],[{"attribute_id":692,"attribute_option_id":2249}]],"active_combinations":[{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2246}]},{"image":null,"stock":43,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2247}]},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2248}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":692,"attribute_option_id":2249}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":689,"name":"Initial Charm","quantity":1,"description":null,"type":"item","options":[{"id":2212,"name":"Initial Charm","skip":false,"item":{"id":1830,"name":"Charm Letters","SKU":"CHARMLETTERS"},"attributes_per_every_item":[{"id":690,"name":"Charm Letters","quantity":1,"description":null,"type":"List","options":[{"id":2214,"name":"A","skip":false,"parent_attribute":null},{"id":2215,"name":"B","skip":false,"parent_attribute":null},{"id":2216,"name":"C","skip":false,"parent_attribute":null},{"id":2217,"name":"D","skip":false,"parent_attribute":null},{"id":2218,"name":"E","skip":false,"parent_attribute":null},{"id":2219,"name":"F","skip":false,"parent_attribute":null},{"id":2220,"name":"G","skip":false,"parent_attribute":null},{"id":2221,"name":"H","skip":false,"parent_attribute":null},{"id":2222,"name":"I","skip":false,"parent_attribute":null},{"id":2223,"name":"J","skip":false,"parent_attribute":null},{"id":2224,"name":"K","skip":false,"parent_attribute":null},{"id":2225,"name":"L","skip":false,"parent_attribute":null},{"id":2226,"name":"M","skip":false,"parent_attribute":null},{"id":2227,"name":"N","skip":false,"parent_attribute":null},{"id":2228,"name":"O","skip":false,"parent_attribute":null},{"id":2229,"name":"P","skip":false,"parent_attribute":null},{"id":2230,"name":"Q","skip":false,"parent_attribute":null},{"id":2231,"name":"R","skip":false,"parent_attribute":null},{"id":2232,"name":"S","skip":false,"parent_attribute":null},{"id":2233,"name":"T","skip":false,"parent_attribute":null},{"id":2234,"name":"U","skip":false,"parent_attribute":null},{"id":2235,"name":"V","skip":false,"parent_attribute":null},{"id":2236,"name":"W","skip":false,"parent_attribute":null},{"id":2237,"name":"X","skip":false,"parent_attribute":null},{"id":2238,"name":"Y","skip":false,"parent_attribute":null},{"id":2239,"name":"Z","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}]],"active_combinations":[{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2214}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2215}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2216}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2217}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2218}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2219}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2220}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2221}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2222}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2223}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2224}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2225}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2226}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2227}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2228}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2229}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2230}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2231}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2232}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2233}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2234}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2235}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2236}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2237}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2238}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":690,"attribute_option_id":2239}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":694,"name":"Select Charm 1","quantity":1,"description":null,"type":"item","options":[{"id":2257,"name":"Select Charm","skip":false,"item":{"id":1831,"name":"Charm 1","SKU":"CHARM1"},"attributes_per_every_item":[{"id":678,"name":"Select Charm","quantity":1,"description":null,"type":"List","options":[{"id":2140,"name":"Amore Charm","skip":false,"parent_attribute":null},{"id":2136,"name":"Angel Baby charm","skip":false,"parent_attribute":null},{"id":2144,"name":"Angel Wing Charm","skip":false,"parent_attribute":null},{"id":2141,"name":"Blessed Charm","skip":false,"parent_attribute":null},{"id":2133,"name":"Good Luck Charm","skip":false,"parent_attribute":null},{"id":2143,"name":"Good Vibes Charm","skip":false,"parent_attribute":null},{"id":2139,"name":"Isabel Charm","skip":false,"parent_attribute":null},{"id":2135,"name":"Key Charm","skip":false,"parent_attribute":null},{"id":2132,"name":"Lock Charm","skip":false,"parent_attribute":null},{"id":2134,"name":"Love Me Charm","skip":false,"parent_attribute":null},{"id":2138,"name":"Lucky You Charm","skip":false,"parent_attribute":null},{"id":2142,"name":"Martini Charm","skip":false,"parent_attribute":null},{"id":2145,"name":"Star Charm","skip":false,"parent_attribute":null},{"id":2131,"name":"Vintage Gem Charm","skip":false,"parent_attribute":null},{"id":2137,"name":"Wish Bone Charm","skip":false,"parent_attribute":null},{"id":2329,"name":"Crystal Dice Charm","skip":false,"parent_attribute":null},{"id":2330,"name":"Crystal Rainbow Charm","skip":false,"parent_attribute":null},{"id":2331,"name":"Crystal Cross Charm","skip":false,"parent_attribute":null},{"id":2332,"name":"Cupid Charm","skip":false,"parent_attribute":null},{"id":2333,"name":"Butterfly Charm","skip":false,"parent_attribute":null},{"id":2334,"name":"Pink Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2335,"name":"Crystal Dripping Heart Charm","skip":false,"parent_attribute":null},{"id":2336,"name":"Balloon Dog Charm","skip":false,"parent_attribute":null},{"id":2337,"name":"Mama Charm","skip":false,"parent_attribute":null},{"id":2338,"name":"Ace Of Hearts Charm","skip":false,"parent_attribute":null},{"id":2339,"name":"Ace of Spades Charm","skip":false,"parent_attribute":null},{"id":2340,"name":"Rose Charm","skip":false,"parent_attribute":null},{"id":2341,"name":"Gummy Bear Charm","skip":false,"parent_attribute":null},{"id":2342,"name":"Match Charm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":678,"attribute_option_id":2140}],[{"attribute_id":678,"attribute_option_id":2136}],[{"attribute_id":678,"attribute_option_id":2144}],[{"attribute_id":678,"attribute_option_id":2141}],[{"attribute_id":678,"attribute_option_id":2133}],[{"attribute_id":678,"attribute_option_id":2143}],[{"attribute_id":678,"attribute_option_id":2139}],[{"attribute_id":678,"attribute_option_id":2135}],[{"attribute_id":678,"attribute_option_id":2132}],[{"attribute_id":678,"attribute_option_id":2134}],[{"attribute_id":678,"attribute_option_id":2138}],[{"attribute_id":678,"attribute_option_id":2142}],[{"attribute_id":678,"attribute_option_id":2145}],[{"attribute_id":678,"attribute_option_id":2131}],[{"attribute_id":678,"attribute_option_id":2137}],[{"attribute_id":678,"attribute_option_id":2329}],[{"attribute_id":678,"attribute_option_id":2330}],[{"attribute_id":678,"attribute_option_id":2331}],[{"attribute_id":678,"attribute_option_id":2332}],[{"attribute_id":678,"attribute_option_id":2333}],[{"attribute_id":678,"attribute_option_id":2334}],[{"attribute_id":678,"attribute_option_id":2335}],[{"attribute_id":678,"attribute_option_id":2336}],[{"attribute_id":678,"attribute_option_id":2337}],[{"attribute_id":678,"attribute_option_id":2338}],[{"attribute_id":678,"attribute_option_id":2339}],[{"attribute_id":678,"attribute_option_id":2340}],[{"attribute_id":678,"attribute_option_id":2341}],[{"attribute_id":678,"attribute_option_id":2342}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2140}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2136}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2144}]},{"image":null,"stock":35,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2141}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2133}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2143}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2139}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2135}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2132}]},{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2134}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2138}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2142}]},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2145}]},{"image":null,"stock":32,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2131}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2137}]},{"image":null,"stock":16,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2329}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2330}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2331}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2332}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2333}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2334}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2335}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2336}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2337}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2338}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2339}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2340}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2341}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":678,"attribute_option_id":2342}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":681,"name":"Gem Charm","quantity":1,"description":null,"type":"item","options":[{"id":2164,"name":"Gem Charm","skip":false,"item":{"id":1811,"name":"Gem Charm","SKU":"GEMC"},"attributes_per_every_item":[{"id":680,"name":"Gem Charm","quantity":1,"description":null,"type":"List","options":[{"id":2151,"name":"Garnet","skip":false,"parent_attribute":null},{"id":2152,"name":"Amethyst","skip":false,"parent_attribute":null},{"id":2153,"name":"Blue","skip":false,"parent_attribute":null},{"id":2154,"name":"Crystal","skip":false,"parent_attribute":null},{"id":2155,"name":"Emerald","skip":false,"parent_attribute":null},{"id":2156,"name":"Lavender","skip":false,"parent_attribute":null},{"id":2157,"name":"Ruby","skip":false,"parent_attribute":null},{"id":2158,"name":"Green","skip":false,"parent_attribute":null},{"id":2159,"name":"Cobalt","skip":false,"parent_attribute":null},{"id":2160,"name":"Pink","skip":false,"parent_attribute":null},{"id":2161,"name":"Champagne","skip":false,"parent_attribute":null},{"id":2162,"name":"Sky","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":680,"attribute_option_id":2151}],[{"attribute_id":680,"attribute_option_id":2152}],[{"attribute_id":680,"attribute_option_id":2153}],[{"attribute_id":680,"attribute_option_id":2154}],[{"attribute_id":680,"attribute_option_id":2155}],[{"attribute_id":680,"attribute_option_id":2156}],[{"attribute_id":680,"attribute_option_id":2157}],[{"attribute_id":680,"attribute_option_id":2158}],[{"attribute_id":680,"attribute_option_id":2159}],[{"attribute_id":680,"attribute_option_id":2160}],[{"attribute_id":680,"attribute_option_id":2161}],[{"attribute_id":680,"attribute_option_id":2162}]],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2151}]},{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2152}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2153}]},{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2154}]},{"image":null,"stock":51,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2155}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2156}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2157}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2158}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2159}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2160}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2161}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":680,"attribute_option_id":2162}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":681,"attribute_option_id":2164},{"attribute_id":683,"attribute_option_id":2171},{"attribute_id":689,"attribute_option_id":2212},{"attribute_id":694,"attribute_option_id":2257}],"allow_backorder":true}],"tags":["necklace","new","custom","topsell","non-custom","the casual edit campaign"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"THYNECK":{"id":3833,"details_loaded_time":"2025-07-20 06:59:17","sku":"THYNECK","price":"58.00","name":"Thyme Necklace","allow_backorder":1,"erp_id":1902,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3833,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TIC":{"id":2655,"details_loaded_time":"2025-07-20 08:02:21","sku":"TIC","price":"55.00","name":"The Icon Chain","allow_backorder":0,"erp_id":1318,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2655,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1321,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":1321}],"allow_backorder":false}],"tags":["necklace","non-custom","silver","chains for men","figaro c","fig layering","top seller","14k gold","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","mix metal","mixed metal","gold","chain","gold chain","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TIGERSR":{"id":3020,"details_loaded_time":"2024-07-05 17:26:17","sku":"TIGERSR","price":null,"name":"Tiger Signet Ring","allow_backorder":1,"erp_id":1408,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3020,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","sale","non-custom","ws","gg x vs"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TIGERSSR":{"id":3021,"details_loaded_time":"2024-05-09 19:22:53","sku":"TIGERSSR","price":"62.00","name":"Square Tiger Ring","allow_backorder":0,"erp_id":1409,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3021,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","gg x vs"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TIS":{"id":141,"details_loaded_time":"2020-05-05 03:31:26","sku":"TIS","price":"125.00","name":"Isabella Set","allow_backorder":1,"erp_id":436,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":141,"force_allow_backorder":false,"attributes":[],"active_combinations":[],"tags":["custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TISABAND":{"id":3710,"details_loaded_time":"2025-07-20 07:09:44","sku":"TISABAND","price":"55.00","name":"The Isabel Band","allow_backorder":1,"erp_id":1845,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3710,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TJS":{"id":142,"details_loaded_time":"2020-09-17 17:40:28","sku":"TJS","price":"128.00","name":"The Joy Set","allow_backorder":1,"erp_id":437,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":142,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":66,"name":"Script Nameplate Necklace","type":"item","options":[{"id":292,"name":"Script Nameplate Necklace","skip":false,"item":{"id":405,"name":"Script Nameplate Necklace","SKU":"SNN"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":72,"name":"Iced Initial Pendant Necklace","type":"item","options":[{"id":305,"name":"Iced Initial Pendant Necklace","skip":false,"item":{"id":363,"name":"Iced Initial Pendant Necklace","SKU":"IIPN"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256},{"attribute_id":53,"attribute_option_id":256}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":73,"name":"Iced Chain Link Ring","type":"item","options":[{"id":306,"name":"Iced Chain Link Ring","skip":false,"item":{"id":358,"name":"Iced Chain Link Ring","SKU":"ICLR"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":253},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":53,"attribute_option_id":253},{"attribute_id":53,"attribute_option_id":253}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":66,"attribute_option_id":292},{"attribute_id":72,"attribute_option_id":305},{"attribute_id":73,"attribute_option_id":306}],"allow_backorder":true}],"tags":["set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TKCUFF":{"id":3879,"details_loaded_time":"2025-07-20 06:51:39","sku":"TKCUFF","price":"65.00","name":"The Knockout Cuff","allow_backorder":1,"erp_id":1934,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3879,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TKS":{"id":143,"details_loaded_time":"2025-03-17 18:16:02","sku":"TKS","price":"160.00","name":"The Kayla Set","allow_backorder":1,"erp_id":438,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":143,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":56,"name":"Iced Ring","quantity":1,"description":null,"type":"item","options":[{"id":270,"name":"Iced Ring","skip":false,"item":{"id":368,"name":"Iced Ring","SKU":"IDR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":157,"name":"5","skip":false,"parent_attribute":null},{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":43,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":36,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":14,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":17,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":137,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":157},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":37,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":45,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":56,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":52,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":46,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":74,"name":"Signature Script Nameplate Necklace","quantity":1,"description":null,"type":"item","options":[{"id":309,"name":"Signature Script Nameplate Necklace","skip":false,"item":{"id":407,"name":"Signature Script Nameplate Necklace","SKU":"SSNN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"List","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null},{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":40,"name":"22\"","skip":false,"parent_attribute":null}]},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"Text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":75,"name":"Butterfly Effect Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":310,"name":"Butterfly Effect Pendant Necklace","skip":false,"item":{"id":303,"name":"Butterfly Effect Pendant Necklace","SKU":"BEPN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":56,"attribute_option_id":270},{"attribute_id":74,"attribute_option_id":309},{"attribute_id":75,"attribute_option_id":310}],"allow_backorder":true}],"tags":["set","custom-set","bejeweled","pindens","diamond link ring","waterproof","18k gold platedwith your nameneckless alex","tarnish free","tarnishfree","tarnish-free","water proof","cursive name necklace","crown rings","name neclace","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TLEGH":{"id":3883,"details_loaded_time":"2025-07-20 06:51:21","sku":"TLEGH","price":"35.00","name":"The Legacy Hat","allow_backorder":1,"erp_id":1937,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3883,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":2380,"name":"Khaki Solid","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2380}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TLGN":{"id":3629,"details_loaded_time":"2025-07-20 07:18:37","sku":"TLGN","price":"58.00","name":"The Lover Girl Necklace","allow_backorder":1,"erp_id":1799,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3629,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":47,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TLS":{"id":146,"details_loaded_time":"2025-07-20 08:56:25","sku":"TLS","price":"160.00","name":"The Lovers Set","allow_backorder":1,"erp_id":441,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":146,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":584,"name":"Block Letter Pendant Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1882,"name":"Block Letter Necklace--Pendant","skip":false,"item":{"id":545,"name":"Block Letter Necklace--Pendant","SKU":"BLKLNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":40,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":155,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":73,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":39,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":53,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":116,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":48,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":184,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":46,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":59,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":71,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":67,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":90,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":115,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":65,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":60,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":93,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":113,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":61,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":56,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":37,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":81,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":96,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":104,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":95,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":78,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":78,"name":"Chain Link Ring","quantity":1,"description":null,"type":"item","options":[{"id":316,"name":"Chain Link Ring","skip":false,"item":{"id":305,"name":"Chain Link Ring","SKU":"CLR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":155,"name":"Black","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":33,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":639,"name":"Crystal Heart Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2015,"name":"Crystal Heart Necklace--Pendant","skip":false,"item":{"id":548,"name":"Crystal Heart Necklace--Pendant","SKU":"CHN2pen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":78,"attribute_option_id":316},{"attribute_id":496,"attribute_option_id":1505},{"attribute_id":584,"attribute_option_id":1882},{"attribute_id":585,"attribute_option_id":1884},{"attribute_id":639,"attribute_option_id":2015}],"allow_backorder":true}],"tags":["set","initial necklace","initial","initial j","b initial necklace","initial charm","heart shape diamond ring","intial","pindens","l necklace","j leclace","boyfriend","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMBRACE":{"id":3712,"details_loaded_time":"2025-07-20 07:09:12","sku":"TMBRACE","price":"50.00","name":"The Mahogany Bracelet","allow_backorder":1,"erp_id":1846,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3712,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TME":{"id":3852,"details_loaded_time":"2025-07-20 06:55:33","sku":"TME","price":"70.00","name":"The Muse Earrings","allow_backorder":1,"erp_id":1920,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3852,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","topsell","non-custom","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMJS":{"id":147,"details_loaded_time":"2024-01-02 13:55:42","sku":"TMJS","price":"110.00","name":"The Mary Jane Set","allow_backorder":0,"erp_id":442,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":147,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":257}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":79,"name":"Mary Jane Pendant Necklace","description":null,"type":"item","options":[{"id":320,"name":"Mary Jane Pendant Necklace","skip":false,"item":{"id":377,"name":"Mary Jane Pendant Necklace Kit","SKU":"MJPN"},"attributes_per_every_item":[{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":52,"name":"Pendant Size","description":null,"type":"List","options":[{"id":257,"name":"2.2 cm","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":257}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":257}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":257}]],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":52,"attribute_option_id":257}]},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":52,"attribute_option_id":257}]},{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":52,"attribute_option_id":257}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":80,"name":"Mary Jane Huggies","description":null,"type":"item","options":[{"id":319,"name":"Mary Jane Huggies","skip":false,"item":{"id":376,"name":"Mary Jane Huggies","SKU":"MJH"},"attributes_per_every_item":[{"id":11,"name":"Color","description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":79,"attribute_option_id":320},{"attribute_id":80,"attribute_option_id":319}],"allow_backorder":false}],"tags":["set","non-custom","weed","leaf","weed leaf","cigars","marijuana earrings","mini mar","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","pot leaf","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMMS":{"id":3708,"details_loaded_time":"2025-07-20 07:09:28","sku":"TMMS","price":"150.00","name":"Timeless Mixed Metal Set","allow_backorder":1,"erp_id":1861,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3708,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":706,"name":"Mixed Metal Cable Ring","quantity":1,"description":null,"type":"item","options":[{"id":2290,"name":"Mixed Metal Cable Ring","skip":false,"item":{"id":1842,"name":"Mixed Metal Cable Ring","SKU":"MMCR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":707,"name":"The Margot","quantity":1,"description":null,"type":"item","options":[{"id":2289,"name":"The Margot Mixed Metal","skip":false,"item":{"id":1848,"name":"The Margot","SKU":"THEMARG"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":2270,"name":"Mixed Metal","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":45,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":2270},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":708,"name":"The Isabel Band","quantity":1,"description":null,"type":"item","options":[{"id":2291,"name":"The Isabel Band","skip":false,"item":{"id":1845,"name":"The Isabel Band","SKU":"TISABAND"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":706,"attribute_option_id":2290},{"attribute_id":707,"attribute_option_id":2289},{"attribute_id":708,"attribute_option_id":2291}],"allow_backorder":true}],"tags":["new","set","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMN":{"id":121,"details_loaded_time":"2025-07-20 09:02:33","sku":"TMN","price":"42.00","name":"The Madonna Necklace_old","allow_backorder":0,"erp_id":415,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":121,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},"5":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}},"tags":["necklace","sale","non-custom","charm","charms","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMN2":{"id":122,"details_loaded_time":"2022-03-10 16:43:37","sku":"TMN2","price":"22.05","name":"The Mary Necklace","allow_backorder":0,"erp_id":416,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":122,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":418,"name":"Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":22,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":418},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMNKIT":{"id":3485,"details_loaded_time":"2025-07-20 08:56:45","sku":"TMNKIT","price":"42.00","name":"The Madonna Necklace","allow_backorder":1,"erp_id":1709,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3485,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"TMNpen":"TMNpen","REC":"REC"}},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null,"skus":{"TMNpen":"TMNpen","REC":"REC"}}],"skus":{"TMNpen":"TMNpen","REC":"REC"},"top_level":true}],"grouped_attributes_ids":[11],"active_combinations":[{"image":null,"stock":205,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":625,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"attributes_nested_skip_ids":{"11":11}},"attributes":[{"id":644,"name":"The Madonna Necklace--Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2025,"name":"The Madonna Necklace--Pendant","skip":false,"item":{"id":565,"name":"The Madonna Necklace--Pendant","SKU":"TMNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":205,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":625,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":585,"name":"Everyday Chain","quantity":1,"description":null,"type":"item","options":[{"id":1884,"name":"Everyday Chain","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":585,"attribute_option_id":1884},{"attribute_id":644,"attribute_option_id":2025}],"allow_backorder":true}],"tags":["sale","non-custom","charm","charms","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","tarnish free","tarnishfree","water proof","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMNV":{"id":2662,"details_loaded_time":"2025-02-25 13:30:09","sku":"TMNV","price":"32.00","name":"The Moment Necklace","allow_backorder":1,"erp_id":1325,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2662,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Only 1 left when its gone its gone!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":1322,"name":"Stainless Steel\/Pearl","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":1322}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","silver","silver","pearl necklace name","perl necklace","sliver","pearlpear","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","chain","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMNpen":{"id":879,"details_loaded_time":"2025-07-20 08:57:35","sku":"TMNpen","price":"14.70","name":"The Madonna Necklace--Pendant","allow_backorder":1,"erp_id":565,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":879,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":205,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true},{"image":null,"stock":625,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TMT":{"id":3860,"details_loaded_time":"2025-07-20 06:53:40","sku":"TMT","price":"60.00","name":"The Motto Tag","allow_backorder":1,"erp_id":1924,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3860,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","non-custom","shopify_sync","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TNEXTUP":{"id":3857,"details_loaded_time":"2025-07-20 06:55:12","sku":"TNEXTUP","price":"35.00","name":"The Next Up Hat","allow_backorder":1,"erp_id":1929,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3857,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":428,"name":"Camo hat color","quantity":1,"description":null,"type":"list","options":[{"id":1326,"name":"Camo","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":428,"attribute_option_id":1326}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TNN":{"id":123,"details_loaded_time":"2025-07-20 09:02:23","sku":"TNN","price":"80.00","name":"The Number Necklace","allow_backorder":true,"erp_id":417,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":123,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":51,"name":"Number","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":10,"required":true,"type":"only_numbers","free_chars":10,"addtional_price_per_char":null,"special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","topsell","1212","112124","number 2 charm","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TOB":{"id":3701,"details_loaded_time":"2025-07-20 07:13:18","sku":"TOB","price":"55.00","name":"The Oliver Band","allow_backorder":1,"erp_id":1852,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3701,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","new","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TORTC":{"id":935,"details_loaded_time":"2024-11-13 20:36:03","sku":"TORTC","price":"16.80","name":"Tortoise Clip","allow_backorder":0,"erp_id":620,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":935,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":490,"name":"Acrylic","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":490}],"allow_backorder":false}],"tags":["non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TPPNECK":{"id":3501,"details_loaded_time":"2024-11-06 17:22:18","sku":"TPPNECK","price":"58.00","name":"The Power Pendant","allow_backorder":1,"erp_id":1726,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3501,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","new","topsell","sale","non-custom","ws","best sellers","top seller","best seller","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","working woman campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TPR":{"id":3617,"details_loaded_time":"2025-07-20 07:23:01","sku":"TPR","price":"60.00","name":"The Plaza Ring","allow_backorder":1,"erp_id":1797,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3617,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":261,"name":"Cubic Zirconia","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":261}],"allow_backorder":true}],"tags":["ring","new","topsell","non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TPS":{"id":134,"details_loaded_time":"2025-07-20 09:00:06","sku":"TPS","price":"140.00","name":"The Pride Set","allow_backorder":1,"erp_id":429,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":134,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":86,"attribute_option_id":361}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":57,"name":"Old English Pride Necklace","quantity":1,"description":null,"type":"item","options":[{"id":272,"name":"Old English Pride Necklace","skip":false,"item":{"id":450,"name":"Old English Pride Necklace","SKU":"OEPN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":86,"name":"Pride_Necklace_Text","quantity":1,"description":null,"type":"List","options":[{"id":361,"name":"Pride","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":86,"attribute_option_id":361}]],"active_combinations":[{"image":null,"stock":26,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":86,"attribute_option_id":361}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":63,"name":"Iced Rainbow Ring","quantity":1,"description":null,"type":"item","options":[{"id":284,"name":"Iced Rainbow Ring","skip":false,"item":{"id":367,"name":"Iced Rainbow Ring","SKU":"IRR"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null},{"id":212,"name":"10","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":256,"name":"Copper & Zirconia","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":103,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":123,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":129,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]},{"image":null,"stock":97,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":212},{"attribute_id":53,"attribute_option_id":256}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":57,"attribute_option_id":272},{"attribute_id":63,"attribute_option_id":284}],"allow_backorder":true}],"tags":["set","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TRAESET":{"id":3437,"details_loaded_time":"2025-07-20 07:36:37","sku":"TRAESET","price":"140.00","name":"The Rae Set","allow_backorder":1,"erp_id":1660,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3437,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":545,"name":"Beaded Cross Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1788,"name":"Beaded Cross Necklace","skip":false,"item":{"id":1443,"name":"Beaded Cross Necklace","SKU":"BCN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":604,"name":"The Evelyn Ring","quantity":1,"description":null,"type":"item","options":[{"id":1920,"name":"The Evelyn Ring","skip":false,"item":{"id":1448,"name":"The Evelyn Ring","SKU":"TER"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":658,"name":"The Heart Locket","quantity":1,"description":null,"type":"item","options":[{"id":2056,"name":"The Heart Locket","skip":false,"item":{"id":1725,"name":"Classic Heart Locket","SKU":"THLOCK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":659,"name":"Delicate Rope Chain Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2057,"name":"Delicate Rope Chain Necklace","skip":false,"item":{"id":529,"name":"Delicate Rope Chain Necklace","SKU":"DRCN"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":55,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":545,"attribute_option_id":1788},{"attribute_id":604,"attribute_option_id":1920},{"attribute_id":658,"attribute_option_id":2056},{"attribute_id":659,"attribute_option_id":2057}],"allow_backorder":true}],"tags":["set","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TRR":{"id":919,"details_loaded_time":"2021-06-25 15:32:41","sku":"TRR","price":"22.50","name":"Turquoise Ribbed Ring","allow_backorder":0,"erp_id":605,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":919,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TRUCKHAT":{"id":3508,"details_loaded_time":"2025-07-20 07:28:43","sku":"TRUCKHAT","price":"3.80","name":"Trucker Hat Colors blank","allow_backorder":0,"erp_id":1131,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3508,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":155,"name":"Black","skip":false,"parent_attribute":null},{"id":430,"name":"Orange","skip":false,"parent_attribute":null},{"id":432,"name":"Pink","skip":false,"parent_attribute":null},{"id":549,"name":"Cream","skip":false,"parent_attribute":null},{"id":787,"name":"Green","skip":false,"parent_attribute":null},{"id":788,"name":"Blue","skip":false,"parent_attribute":null},{"id":945,"name":"White","skip":false,"parent_attribute":null},{"id":969,"name":"Brown\/Cream","skip":false,"parent_attribute":null},{"id":970,"name":"Red","skip":false,"parent_attribute":null},{"id":1258,"name":"Brown","skip":false,"parent_attribute":null},{"id":1361,"name":"Light Pink","skip":false,"parent_attribute":null},{"id":1383,"name":"Navy Blue and Cream","skip":false,"parent_attribute":null},{"id":1509,"name":"Kly\/Whte\/Kly","skip":false,"parent_attribute":null},{"id":1542,"name":"Red\/Wht\/Red","skip":false,"parent_attribute":null},{"id":1807,"name":"Ryl\/Wht\/Ryl","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":432}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":788}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":787}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":155}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":969}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":430}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":970}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":549}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1258}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1361}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1383}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":945}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1509}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1542}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":1807}],"allow_backorder":false}],"tags":["non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSBELLYC":{"id":3525,"details_loaded_time":"2025-07-20 07:26:16","sku":"TSBELLYC","price":"55.00","name":"The Sofia Belly Chain","allow_backorder":1,"erp_id":1755,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3525,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":507,"name":"Belly Chain Length","quantity":1,"description":null,"type":"list","options":[{"id":2082,"name":"65 cm + 20.5 cm extender","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":53,"attribute_option_id":255},{"attribute_id":507,"attribute_option_id":2082}],"allow_backorder":true}],"tags":["new","accessories","non-custom","bellychain","endless summer campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSE":{"id":3706,"details_loaded_time":"2025-07-20 07:13:11","sku":"TSE","price":"65.00","name":"The Sloane","allow_backorder":1,"erp_id":1855,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3706,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["new","earrings","non-custom","szn's greetings campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSETKIT":{"id":3436,"details_loaded_time":"2025-07-20 07:36:41","sku":"TSETKIT","price":"125.00","name":"Tennis Chain Sets","allow_backorder":1,"erp_id":1658,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3436,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":626,"name":"Tennis Chain Necklaces","quantity":1,"description":null,"type":"list","options":[{"id":1972,"name":"Classic Tennis Chain Necklace","skip":false,"font_data":null,"parent_attribute":null},{"id":1973,"name":"Box Tennis Chain","skip":false,"font_data":null,"parent_attribute":null},{"id":1974,"name":"Hour Glass Tennis Chain","skip":false,"font_data":null,"parent_attribute":null}],"show_with_one_option":false},{"id":627,"name":"Tennis Chain Bracelet","quantity":1,"description":null,"type":"list","options":[{"id":1977,"name":"Box Tennis Chain Bracelet","skip":false,"parent_attribute":null},{"id":1978,"name":"Hour Glass Tennis Bracelet","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":626,"attribute_option_id":1972},{"attribute_id":627,"attribute_option_id":1977}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":626,"attribute_option_id":1972},{"attribute_id":627,"attribute_option_id":1978}],"allow_backorder":true},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":626,"attribute_option_id":1973},{"attribute_id":627,"attribute_option_id":1977}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":626,"attribute_option_id":1973},{"attribute_id":627,"attribute_option_id":1978}],"allow_backorder":true},{"image":null,"stock":3,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":626,"attribute_option_id":1974},{"attribute_id":627,"attribute_option_id":1977}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":626,"attribute_option_id":1974},{"attribute_id":627,"attribute_option_id":1978}],"allow_backorder":true}],"tags":["set","non-custom","don't notify","bridal sets","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSH":{"id":3077,"details_loaded_time":"2025-07-20 07:54:13","sku":"TSH","price":"55.00","name":"The Statement Hoops","allow_backorder":1,"erp_id":1446,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3077,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["earrings","topsell","non-custom","vintage edit","sofia richie","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSN":{"id":124,"details_loaded_time":"2025-07-20 09:02:20","sku":"TSN","price":"65.00","name":"The Saint Necklace Pendant","allow_backorder":0,"erp_id":418,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":124,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":24,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","non-custom","charm","charms","cross ne","cross necklace","iced cross pearl choker","silver cross","bejeweled pendant necklace","guadalupe","bejeweled","bejeweled pendant","2 charm","gold diamond virgin mary necklace","mother mary","our lady of guadalupe","golden diamond cross","saint christopher","cross men","st augustine cross necklace","saint mary","crucifix","saint benedict coin","mini mar","mini virgen","pindens","st jude","waterproof","iced croix pearl necklace","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSNK":{"id":3158,"details_loaded_time":"2025-07-20 07:48:33","sku":"TSNK","price":"65.00","name":"The Saint Necklace","allow_backorder":0,"erp_id":1478,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3158,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"IC1pen":"IC1pen","MMNpen":"MMNpen","REC":"REC"}}],"skus":{"IC1pen":"IC1pen","MMNpen":"MMNpen","REC":"REC"},"top_level":true}],"grouped_attributes_ids":[11],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]},{"image":null,"stock":165,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}]}],"attributes_nested_skip_ids":{"11":11}},"attributes":[{"id":494,"name":"Iced Croix Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1501,"name":"Iced Croix Pendant","skip":false,"item":{"id":504,"name":"Iced Croix--Pendant","SKU":"IC1pen"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]],"active_combinations":[{"image":null,"stock":49,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":495,"name":"Mini Mary Pendant","quantity":1,"description":null,"type":"item","options":[{"id":1503,"name":"Mini Mary Pendant","skip":false,"item":{"id":560,"name":"Mini Mary Necklace Pendant","SKU":"MMNpen"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":108,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]},{"image":null,"stock":165,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":496,"name":"Everyday Chain 18K Gold-plated","quantity":1,"description":null,"type":"item","options":[{"id":1505,"name":"Everyday Chain 18K Gold-plated","skip":false,"item":{"id":509,"name":"Everyday Chain","SKU":"REC"},"attributes_per_every_item":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null},{"id":39,"name":"20\"","skip":false,"parent_attribute":null},{"id":122,"name":"23\"","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]],"active_combinations":[{"image":null,"stock":17551,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1424,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":1584,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":714,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":2928,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":1204,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":122}]},{"image":null,"stock":493,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39}]},{"image":null,"stock":348,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":122}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":494,"attribute_option_id":1501},{"attribute_id":495,"attribute_option_id":1503},{"attribute_id":496,"attribute_option_id":1505}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","charm","charms","cross ne","iced cross pearl choker","silver cross","bejeweled pendant necklace","guadalupe","bejeweled","bejeweled pendant","2 charm","gold diamond virgin mary necklace","mother mary","our lady of guadalupe","golden diamond cross","top seller","cross men","st augustine cross necklace","saint mary","crucifix","saint benedict coin","mini mar","mini virgen","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSPLSET":{"id":3322,"details_loaded_time":"2025-07-20 07:42:14","sku":"TSPLSET","price":"125.00","name":"The Staple Set","allow_backorder":1,"erp_id":1642,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3322,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":592,"name":"Round Snake Chain","quantity":1,"description":null,"type":"item","options":[{"id":1893,"name":"Round Snake Chain","skip":false,"item":{"id":1631,"name":"Round Snake Chain","SKU":"RSNKCH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":593,"name":"Classic Cuff Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":1894,"name":"Classic Cuff Bracelet","skip":false,"item":{"id":1628,"name":"Classic Cuff Bracelet","SKU":"CCUFFB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":594,"name":"Balloon Ring","quantity":1,"description":null,"type":"item","options":[{"id":1895,"name":"Balloon Ring","skip":false,"item":{"id":1627,"name":"Balloon Ring","SKU":"BALRNG"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":592,"attribute_option_id":1893},{"attribute_id":593,"attribute_option_id":1894},{"attribute_id":594,"attribute_option_id":1895}],"allow_backorder":true}],"tags":["set","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSR":{"id":923,"details_loaded_time":"2021-04-27 15:32:35","sku":"TSR","price":"43.00","name":"Tortoise Stack Ring","allow_backorder":0,"erp_id":609,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":923,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":null,"combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TSS":{"id":151,"details_loaded_time":"2021-02-23 16:56:31","sku":"TSS","price":"140.00","name":"The Stormi Set","allow_backorder":1,"erp_id":446,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":151,"force_allow_backorder":false,"top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":83,"name":"Bolt Nameplate Necklace","type":"item","options":[{"id":328,"name":"Bolt Nameplate Necklace","skip":false,"item":{"id":299,"name":"Bolt Nameplate Necklace","SKU":"BOLNN"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":53,"attribute_option_id":255}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":84,"name":"Stormi Necklace","type":"item","options":[{"id":329,"name":"Stormi Necklace","skip":false,"item":{"id":412,"name":"Stormi Necklace","SKU":"SNE"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":253}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":85,"name":"Stormi Studs","type":"item","options":[{"id":330,"name":"Stormi Studs","skip":false,"item":{"id":413,"name":"Stormi Studs","SKU":"SSD"},"item_option_combinations":[{"attribute_id":53,"attribute_option_id":255}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":83,"attribute_option_id":328},{"attribute_id":84,"attribute_option_id":329},{"attribute_id":85,"attribute_option_id":330}],"allow_backorder":true}],"tags":["set","custom-set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TVC":{"id":2654,"details_loaded_time":"2025-07-20 08:02:25","sku":"TVC","price":"60.00","name":"The Vibe Chain","allow_backorder":0,"erp_id":1317,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2654,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":41,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","topsell","non-custom","silver","silver","chains for men","chain gold men","sterling silver necklaces","top seller","14k gold","sliver necklaces","sliver","sliver chin","chain link neckless","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","gold","chain","gold chain","men s chains","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TVSET":{"id":3718,"details_loaded_time":"2025-07-20 07:07:27","sku":"TVSET","price":"180.00","name":"The Vivienne Set","allow_backorder":1,"erp_id":1862,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3718,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":709,"name":"The Mahogany Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":2295,"name":"The Mahogany Bracelet","skip":false,"item":{"id":1846,"name":"The Mahogany Bracelet","SKU":"TMBRACE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":34,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":711,"name":"Gem Cross Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2297,"name":"Gem Cross Pendant","skip":false,"item":{"id":1850,"name":"Gem Cross Pendant","SKU":"GEMCPEN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":422,"name":"Crystal","skip":false,"parent_attribute":null},{"id":944,"name":"Emerald","skip":false,"parent_attribute":null}]},{"id":426,"name":"Chain Type","quantity":1,"description":null,"type":"List","options":[{"id":2271,"name":"Dainty Figaro Chain","skip":false,"parent_attribute":null},{"id":2272,"name":"Dainty Herringbone Chain","skip":false,"parent_attribute":null},{"id":2273,"name":"Delicate Rope Chain","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}],[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":422},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2271}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2272}]},{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":944},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":426,"attribute_option_id":2273}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":608,"name":"Herringbone Chain","quantity":1,"description":null,"type":"item","options":[{"id":1929,"name":"Herringbone Chain","skip":false,"item":{"id":476,"name":"Herringbone Chain","SKU":"HBC"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":57,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":710,"name":"Double Down Huggies","quantity":1,"description":null,"type":"item","options":[{"id":2296,"name":"Double Down Huggies","skip":false,"item":{"id":1790,"name":"Double Down Huggies","SKU":"DDH"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":608,"attribute_option_id":1929},{"attribute_id":709,"attribute_option_id":2295},{"attribute_id":710,"attribute_option_id":2296},{"attribute_id":711,"attribute_option_id":2297}],"allow_backorder":true}],"tags":["new","set","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TVSZNGSET":{"id":3423,"details_loaded_time":"2025-07-20 07:40:12","sku":"TVSZNGSET","price":"90.00","name":"The VibeSzn Girl Set","allow_backorder":1,"erp_id":1645,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3423,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null,"skus":{"VCN":"VCN","VBB":"VBB"}},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null,"skus":{"VCN":"VCN","VBB":"VBB"}}],"skus":{"VCN":"VCN","VBB":"VBB"},"top_level":true}],"grouped_attributes_ids":[11],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":{"11":11}},"attributes":[{"id":548,"name":"VIBESZN CHAIN","quantity":1,"description":null,"type":"item","options":[{"id":1794,"name":"VIBESZN CHAIN","skip":false,"item":{"id":1487,"name":"VIBESZN CHAIN","SKU":"VCN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":602,"name":"VibeSzn Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":1917,"name":"VibeSzn Bracelet","skip":false,"item":{"id":1488,"name":"VibeSzn Bracelet","SKU":"VBB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":548,"attribute_option_id":1794},{"attribute_id":602,"attribute_option_id":1917}],"allow_backorder":true}],"tags":["set"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TVTGEDSET":{"id":3424,"details_loaded_time":"2025-07-20 07:40:08","sku":"TVTGEDSET","price":"140.00","name":"The Vintage Edit Set","allow_backorder":1,"erp_id":1646,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3424,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":545,"name":"Beaded Cross Necklace","quantity":1,"description":null,"type":"item","options":[{"id":1788,"name":"Beaded Cross Necklace","skip":false,"item":{"id":1443,"name":"Beaded Cross Necklace","SKU":"BCN"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":603,"name":"Everyday Bangle","quantity":1,"description":null,"type":"item","options":[{"id":1919,"name":"Everyday Bangle","skip":false,"item":{"id":1445,"name":"Everyday Bangle","SKU":"EDBB"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19}]],"active_combinations":[{"image":null,"stock":44,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":604,"name":"The Evelyn Ring","quantity":1,"description":null,"type":"item","options":[{"id":1920,"name":"The Evelyn Ring","skip":false,"item":{"id":1448,"name":"The Evelyn Ring","SKU":"TER"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":25,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":545,"attribute_option_id":1788},{"attribute_id":603,"attribute_option_id":1919},{"attribute_id":604,"attribute_option_id":1920}],"allow_backorder":true}],"tags":["set","vintage edit"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TWIY":{"id":3870,"details_loaded_time":"2025-07-20 06:53:14","sku":"TWIY","price":"35.00","name":"The Motto Hat","allow_backorder":1,"erp_id":1930,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3870,"force_allow_backorder":false,"warning_quantity":2,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":2380,"name":"Khaki Solid","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":2380}],"allow_backorder":true}],"tags":["new","topsell","non-custom","hat","the players club campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TWTTH":{"id":1501,"details_loaded_time":"2025-02-24 19:07:29","sku":"TWTTH","price":"55.00","name":"Two Tone Twist Hoops","allow_backorder":0,"erp_id":1052,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1501,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws","silver","fine thin hoops","earrings sterling","14k gold","sliver","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","fall","two tone","2 tones","girls night","girls night collection","girls night out","items_mobile_app","last chance page"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TYA":{"id":682,"details_loaded_time":"2025-07-20 08:50:06","sku":"TYA","price":"30.00","name":"The Year Anklet","allow_backorder":0,"erp_id":475,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":682,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":96,"name":"90's","quantity":1,"description":null,"type":"list","options":[{"id":383,"name":"90","skip":false,"parent_attribute":null},{"id":384,"name":"91","skip":false,"parent_attribute":null},{"id":385,"name":"92","skip":false,"parent_attribute":null},{"id":386,"name":"93","skip":false,"parent_attribute":null},{"id":387,"name":"94","skip":false,"parent_attribute":null},{"id":388,"name":"95","skip":false,"parent_attribute":null},{"id":389,"name":"96","skip":false,"parent_attribute":null},{"id":390,"name":"97","skip":false,"parent_attribute":null},{"id":391,"name":"98","skip":false,"parent_attribute":null},{"id":392,"name":"99","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":82,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":383}],"allow_backorder":false},{"image":null,"stock":42,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":384}],"allow_backorder":false},{"image":null,"stock":114,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":385}],"allow_backorder":false},{"image":null,"stock":91,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":386}],"allow_backorder":false},{"image":null,"stock":111,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":387}],"allow_backorder":false},{"image":null,"stock":89,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":388}],"allow_backorder":false},{"image":null,"stock":66,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":389}],"allow_backorder":false},{"image":null,"stock":92,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":390}],"allow_backorder":false},{"image":null,"stock":74,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":391}],"allow_backorder":false},{"image":null,"stock":62,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":392}],"allow_backorder":false},{"image":null,"stock":52,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":383}],"allow_backorder":false},{"image":null,"stock":132,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":384}],"allow_backorder":false},{"image":null,"stock":272,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":385}],"allow_backorder":false},{"image":null,"stock":159,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":386}],"allow_backorder":false},{"image":null,"stock":133,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":387}],"allow_backorder":false},{"image":null,"stock":126,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":388}],"allow_backorder":false},{"image":null,"stock":117,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":389}],"allow_backorder":false},{"image":null,"stock":131,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":390}],"allow_backorder":false},{"image":null,"stock":126,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":391}],"allow_backorder":false},{"image":null,"stock":128,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255},{"attribute_id":96,"attribute_option_id":392}],"allow_backorder":false}],"tags":["anklet","sale","non-custom","ws","1992","1999","1996","1990","birth year","birthyear","2003","2004","ankle bracelet","1995","2000","1986","2008","2002","1987","1989","1991","1993","1994","1997","1998","2001","2005","2006","2007","toe rings","ank","2 charm","sanklets","anklet bracelets","anklet clasps","sports","cuban anklet","waterproof","birthstone","tarnish free","tarnishfree","tarnish-free","water proof","1984","necklace foot","number18","33 necklace","1981","89 necklace","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"Test Item 2":{"id":712,"details_loaded_time":"2020-06-05 16:46:15","sku":"Test Item 2","price":"45.00","name":"Test Item 2","allow_backorder":1,"erp_id":484,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":712,"force_allow_backorder":false,"attributes":[{"id":34,"name":"Letter","type":"list","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":null,"combination":[{"attribute_id":34,"attribute_option_id":128}],"allow_backorder":true},{"image":null,"stock":10,"price_change":null,"combination":[{"attribute_id":34,"attribute_option_id":129}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":34,"attribute_option_id":130}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":34,"attribute_option_id":131}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"Test Item 3":{"id":721,"details_loaded_time":"2020-05-28 12:40:34","sku":"Test Item 3","price":"50.00","name":"Test Item 3","allow_backorder":1,"erp_id":488,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":721,"force_allow_backorder":false,"attributes":[{"id":10,"name":"Carrier","type":null,"options":[{"id":14,"name":"Simple Mobile","skip":false,"parent_attribute":null},{"id":16,"name":"Total Wireless","skip":false,"parent_attribute":null},{"id":18,"name":"Go Smart","skip":false,"parent_attribute":null},{"id":52,"name":"Skip","skip":true,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":10,"attribute_option_id":14}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":10,"attribute_option_id":16}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":10,"attribute_option_id":18}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":10,"attribute_option_id":52}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"TestItem1":{"id":711,"details_loaded_time":"2020-06-05 16:46:18","sku":"TestItem1","price":"35.00","name":"Test Item 1","allow_backorder":1,"erp_id":483,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":711,"force_allow_backorder":false,"attributes":[{"id":2,"name":"Color (wrong)","type":"list","options":[{"id":1,"name":"Gold","skip":false,"parent_attribute":null},{"id":4,"name":"Yellow","skip":false,"parent_attribute":null},{"id":5,"name":"Gray","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":2,"attribute_option_id":1}],"allow_backorder":true},{"image":null,"stock":2,"price_change":null,"combination":[{"attribute_id":2,"attribute_option_id":4}],"allow_backorder":true},{"image":null,"stock":2,"price_change":null,"combination":[{"attribute_id":2,"attribute_option_id":5}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"UAN":{"id":3018,"details_loaded_time":"2025-07-20 07:58:25","sku":"UAN","price":"65.00","name":"Unapologetic Necklace","allow_backorder":1,"erp_id":1405,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3018,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","non-custom","gg x vs","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"USH":{"id":3512,"details_loaded_time":"2025-07-20 07:28:29","sku":"USH","price":"27.00","name":"Universal Sports Hat","allow_backorder":1,"erp_id":1736,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3512,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":1744,"name":"0316 - Blk\/Wht","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":9,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":486,"attribute_option_id":1744}],"allow_backorder":true}],"tags":["new","accessories","non-custom","hat","trucker","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VALBRAC":{"id":3829,"details_loaded_time":"2025-07-20 06:59:35","sku":"VALBRAC","price":"55.00","name":"Valentina Bracelet","allow_backorder":1,"erp_id":1898,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3829,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","new","topsell","non-custom","top seller","shopify_sync","vibeszn market campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VBB":{"id":3202,"details_loaded_time":"2025-07-20 07:46:37","sku":"VBB","price":"52.00","name":"VibeSzn Bracelet","allow_backorder":1,"erp_id":1488,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3202,"force_allow_backorder":false,"warning_quantity":10,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["bracelet","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VBCSN":{"id":126,"details_loaded_time":"2025-07-20 09:02:05","sku":"VBCSN","price":"80.00","name":"Vertical Script Nameplate Necklace","allow_backorder":true,"erp_id":420,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":126,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom","15 inch sterling silver name necklace","18k gold platedwith your nameneckless alex","cursive name necklace","name neclace","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VCN":{"id":3201,"details_loaded_time":"2025-07-20 07:46:42","sku":"VCN","price":"58.00","name":"VIBESZN CHAIN","allow_backorder":0,"erp_id":1487,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3201,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","non-custom","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VGC":{"id":3619,"details_loaded_time":"2025-07-20 07:20:39","sku":"VGC","price":"18.00","name":"Vintage Gem Charm","allow_backorder":1,"erp_id":1804,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3619,"force_allow_backorder":false,"warning_quantity":5,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":30,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","charm","charms","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VGIM":{"id":3235,"details_loaded_time":"2025-06-04 18:44:02","sku":"VGIM","price":"40.00","name":"VibeSzn Grill Impression Mold","allow_backorder":1,"erp_id":1508,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3235,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[],"active_combinations":[],"tags":["don't notify","postage paid mold"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN1":{"id":3057,"details_loaded_time":"2023-08-30 16:50:37","sku":"VIN1","price":"84.00","name":"Vintage 1","allow_backorder":0,"erp_id":1427,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3057,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN10":{"id":3066,"details_loaded_time":"2023-08-30 16:44:41","sku":"VIN10","price":"48.00","name":"Vintage 10","allow_backorder":0,"erp_id":1436,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3066,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN11":{"id":3067,"details_loaded_time":"2023-08-30 16:44:38","sku":"VIN11","price":"40.00","name":"Vintage 11","allow_backorder":0,"erp_id":1437,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3067,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN12":{"id":3068,"details_loaded_time":"2023-08-30 16:44:34","sku":"VIN12","price":"42.00","name":"Vintage 12","allow_backorder":0,"erp_id":1438,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3068,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN13":{"id":3069,"details_loaded_time":"2023-08-30 16:41:43","sku":"VIN13","price":"40.00","name":"Vintage 13","allow_backorder":0,"erp_id":1439,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3069,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN14":{"id":3070,"details_loaded_time":"2023-08-30 16:41:39","sku":"VIN14","price":"42.00","name":"Vintage 14","allow_backorder":0,"erp_id":1440,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3070,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN2":{"id":3058,"details_loaded_time":"2023-08-30 16:50:33","sku":"VIN2","price":"40.00","name":"Vintage 2","allow_backorder":0,"erp_id":1428,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3058,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN3":{"id":3059,"details_loaded_time":"2023-08-30 16:50:29","sku":"VIN3","price":"40.00","name":"Vintage 3","allow_backorder":0,"erp_id":1429,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3059,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN4":{"id":3060,"details_loaded_time":"2023-08-30 16:50:26","sku":"VIN4","price":"40.00","name":"Vintage 4","allow_backorder":0,"erp_id":1430,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3060,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN5":{"id":3061,"details_loaded_time":"2023-08-30 16:50:22","sku":"VIN5","price":"70.00","name":"Vintage 5","allow_backorder":0,"erp_id":1431,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3061,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN6":{"id":3062,"details_loaded_time":"2023-08-30 16:50:18","sku":"VIN6","price":"42.00","name":"Vintage 6","allow_backorder":0,"erp_id":1432,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3062,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN7":{"id":3063,"details_loaded_time":"2023-08-30 16:50:14","sku":"VIN7","price":"70.00","name":"Vintage 7","allow_backorder":0,"erp_id":1433,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3063,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN8":{"id":3064,"details_loaded_time":"2023-08-30 16:50:10","sku":"VIN8","price":"40.00","name":"Vintage 8","allow_backorder":0,"erp_id":1434,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3064,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VIN9":{"id":3065,"details_loaded_time":"2023-08-30 16:47:40","sku":"VIN9","price":"60.00","name":"Vintage 9","allow_backorder":0,"erp_id":1435,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3065,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock!","attributes":[],"active_combinations":[],"tags":["non-custom","watch"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VJC":{"id":1279,"details_loaded_time":"2022-11-09 22:33:36","sku":"VJC","price":"24.00","name":"VibeSzn Jewelry Case","allow_backorder":0,"erp_id":805,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":1279,"force_allow_backorder":false,"attributes":[],"active_combinations":[],"tags":["accessories","jewelry case","travel case","traveling case","vibe szn jewelry case","jewelry box","vibeszn case","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VJC2":{"id":2642,"details_loaded_time":"2025-07-20 08:02:33","sku":"VJC2","price":"24.00","name":"VibeSzn Jewelry Case","allow_backorder":0,"erp_id":1308,"hidden":0,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":2642,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[],"active_combinations":[],"tags":["accessories","non-custom","jewelry case","travel case","traveling case","vibe szn jewelry case","jewelry box","vibeszn case","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VLC":{"id":2874,"details_loaded_time":"2025-07-20 07:58:36","sku":"VLC","price":"36.00","name":"VibeSzn Layering Clasp","allow_backorder":0,"erp_id":1333,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2874,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":81,"price_change":"0.00","gtin":"840435824662","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":79,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["accessories","topsell","non-custom","layer clasp","necklace clasp","clasp","tangle free","tangle","necklace tangle free","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VLYH":{"id":3696,"details_loaded_time":"2025-07-20 07:11:35","sku":"VLYH","price":"25.00","name":"Vintage Lucky You Hat","allow_backorder":1,"erp_id":1836,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3696,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":486,"name":"5 Panel Mid Profile Baseball Cap Color Combo","quantity":1,"description":null,"type":"list","options":[{"id":1474,"name":"0311 Blk\/Natl","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":150,"name":"Thread Color:","quantity":1,"description":null,"type":"list","options":[{"id":558,"name":"Black","skip":false,"parent_attribute":null},{"id":2266,"name":"Cream","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":31,"attribute_option_id":121},{"attribute_id":150,"attribute_option_id":558},{"attribute_id":486,"attribute_option_id":1474}],"allow_backorder":true},{"image":null,"stock":2,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":31,"attribute_option_id":121},{"attribute_id":150,"attribute_option_id":2266},{"attribute_id":486,"attribute_option_id":1474}],"allow_backorder":true}],"tags":["new","accessories","hat","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VOENN":{"id":125,"details_loaded_time":"2025-07-20 09:02:12","sku":"VOENN","price":"80.00","name":"Vertical Old English Nameplate Necklace","allow_backorder":true,"erp_id":419,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":125,"force_allow_backorder":true,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","quantity":1,"description":null,"type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null},{"id":36,"name":"Box Chain","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","quantity":1,"description":null,"type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":{"0":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"1":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"3":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"4":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"6":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"7":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"9":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},"10":{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}},"tags":["necklace","custom","old english nameplate mary","items_mobile_app"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSB":{"id":770,"details_loaded_time":"2025-07-20 08:44:39","sku":"VSB","price":"4.90","name":"VibeSzn Box","allow_backorder":0,"erp_id":505,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":770,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[],"active_combinations":[],"tags":["set","non-custom","items_mobile_app","nodiscount","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSDCGRILL":{"id":3241,"details_loaded_time":"2025-06-04 18:41:46","sku":"VSDCGRILL","price":"40.00","name":"VibeSzn Diamond Cut Grill","allow_backorder":1,"erp_id":1561,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3241,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"list","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"list","options":[{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true}],"tags":["don't notify","vendor fulfilled grill","no discounts allowed"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSG":{"id":3236,"details_loaded_time":"2025-06-04 18:44:04","sku":"VSG","price":"40.00","name":"VibeSzn Grill","allow_backorder":1,"erp_id":1550,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3236,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"list","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"list","options":[{"id":1641,"name":"4 Top","skip":false,"parent_attribute":null},{"id":1643,"name":"4 Bottom","skip":false,"parent_attribute":null},{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null},{"id":1669,"name":"12 Top","skip":false,"parent_attribute":null},{"id":1670,"name":"12 Bottom","skip":false,"parent_attribute":null},{"id":1645,"name":"TR-1","skip":false,"parent_attribute":null},{"id":1646,"name":"TR-2","skip":false,"parent_attribute":null},{"id":1647,"name":"TR-3","skip":false,"parent_attribute":null},{"id":1648,"name":"TR-4","skip":false,"parent_attribute":null},{"id":1649,"name":"TR-5","skip":false,"parent_attribute":null},{"id":1650,"name":"TL-1","skip":false,"parent_attribute":null},{"id":1651,"name":"TL-2","skip":false,"parent_attribute":null},{"id":1652,"name":"TL-3","skip":false,"parent_attribute":null},{"id":1653,"name":"TL-4","skip":false,"parent_attribute":null},{"id":1654,"name":"TL-5","skip":false,"parent_attribute":null},{"id":1655,"name":"BR-1","skip":false,"parent_attribute":null},{"id":1656,"name":"BR-2","skip":false,"parent_attribute":null},{"id":1657,"name":"BR-3","skip":false,"parent_attribute":null},{"id":1658,"name":"BR-4","skip":false,"parent_attribute":null},{"id":1659,"name":"BR-5","skip":false,"parent_attribute":null},{"id":1660,"name":"BL-1","skip":false,"parent_attribute":null},{"id":1661,"name":"BL-2","skip":false,"parent_attribute":null},{"id":1662,"name":"BL-3","skip":false,"parent_attribute":null},{"id":1663,"name":"BL-4","skip":false,"parent_attribute":null},{"id":1664,"name":"BL-5","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"120.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"120.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"440.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"440.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"380.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1220.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1641},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"500.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1643},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1669},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1580.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1670},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true}],"tags":["custom-set","don't notify","vendor fulfilled grill"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSGRILLBAR":{"id":3239,"details_loaded_time":"2025-06-04 18:41:49","sku":"VSGRILLBAR","price":"40.00","name":"VibeSzn Grill Bar","allow_backorder":1,"erp_id":1559,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3239,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"list","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"list","options":[{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true}],"tags":["don't notify","vendor fulfilled grill"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSGRILLDRIP":{"id":3237,"details_loaded_time":"2025-06-04 18:41:52","sku":"VSGRILLDRIP","price":"40.00","name":"VibeSzn Grill Drip","allow_backorder":1,"erp_id":1556,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3237,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"list","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"list","options":[{"id":1642,"name":"6 Top","skip":false,"parent_attribute":null},{"id":1644,"name":"6 Bottom","skip":false,"parent_attribute":null},{"id":1665,"name":"8 Top","skip":false,"parent_attribute":null},{"id":1666,"name":"8 Bottom","skip":false,"parent_attribute":null},{"id":1667,"name":"10 Top","skip":false,"parent_attribute":null},{"id":1668,"name":"10 Bottom","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"200.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"280.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"360.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1672}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1674}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1676}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"590.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"800.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1010.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1673}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1675}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1677}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1642},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"770.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1644},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1665},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1040.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1666},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1667},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"1310.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1668},{"attribute_id":524,"attribute_option_id":1678}],"allow_backorder":true}],"tags":["don't notify","vendor fulfilled grill"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSHB":{"id":882,"details_loaded_time":"2023-03-14 13:15:35","sku":"VSHB","price":"4.90","name":"VibeSzn Holiday Box","allow_backorder":0,"erp_id":568,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":882,"force_allow_backorder":false,"warning_quantity":null,"warning_on_screen":null,"allow_notification":0,"allow_warning":0,"notification_quantity":null,"notification_on_screen":null,"attributes":[],"active_combinations":[],"tags":["non-custom","items_mobile_app","nodiscount"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSN":{"id":127,"details_loaded_time":"2021-02-23 17:06:25","sku":"VSN","price":"69.00","name":"VibeSzn Nameplate Necklace","allow_backorder":true,"erp_id":421,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":127,"force_allow_backorder":true,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160},{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":40,"name":"22\"","skip":false,"parent_attribute":null,"weight":220}],"show_with_one_option":false},{"id":15,"name":"Custom Text","type":"text","validation":{"min_chars":1,"max_chars":13,"required":true,"type":"alphanumeric","free_chars":13,"addtional_price_per_char":"0.10","special_chars":true,"emojis":false}},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":11,"attribute_option_id":21},{"attribute_id":14,"attribute_option_id":40},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","custom"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSSINGLET":{"id":3243,"details_loaded_time":"2025-06-04 18:41:04","sku":"VSSINGLET","price":"40.00","name":"Single Solid Tooth","allow_backorder":1,"erp_id":1564,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3243,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[],"attributes_nested_skip_ids":[]},"attributes":[{"id":519,"name":"VibeSzn Grill Impression Mold","quantity":1,"description":null,"type":"item","options":[{"id":1562,"name":"VibeSzn Grill Impression Mold","skip":false,"item":{"id":1508,"name":"VibeSzn Grill Impression Mold","SKU":"VGIM"},"attributes_per_every_item":[],"item_option_combinations":[],"active_combinations":[],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":529,"name":"VibeSzn Single Tooth","quantity":1,"description":null,"type":"item","options":[{"id":1684,"name":"VibeSzn Single Tooth","skip":false,"item":{"id":1563,"name":"VibeSzn Single Tooth Grill","SKU":"SINGLET"},"attributes_per_every_item":[{"id":524,"name":"Grill Material","quantity":1,"description":null,"type":"List","options":[{"id":1672,"name":"Silver","skip":false,"parent_attribute":null},{"id":1674,"name":"10K White Gold","skip":false,"parent_attribute":null},{"id":1676,"name":"10K Yellow Gold","skip":false,"parent_attribute":null},{"id":1673,"name":"10K Rose Gold","skip":false,"parent_attribute":null},{"id":1675,"name":"14K White Gold","skip":false,"parent_attribute":null},{"id":1677,"name":"14K Yellow Gold","skip":false,"parent_attribute":null},{"id":1678,"name":"14K Rose Gold","skip":false,"parent_attribute":null}]},{"id":523,"name":"Select Teeth","quantity":1,"description":null,"type":"List","options":[{"id":1645,"name":"TR-1","skip":false,"parent_attribute":null},{"id":1646,"name":"TR-2","skip":false,"parent_attribute":null},{"id":1647,"name":"TR-3","skip":false,"parent_attribute":null},{"id":1648,"name":"TR-4","skip":false,"parent_attribute":null},{"id":1649,"name":"TR-5","skip":false,"parent_attribute":null},{"id":1650,"name":"TL-1","skip":false,"parent_attribute":null},{"id":1651,"name":"TL-2","skip":false,"parent_attribute":null},{"id":1652,"name":"TL-3","skip":false,"parent_attribute":null},{"id":1653,"name":"TL-4","skip":false,"parent_attribute":null},{"id":1654,"name":"TL-5","skip":false,"parent_attribute":null},{"id":1655,"name":"BR-1","skip":false,"parent_attribute":null},{"id":1656,"name":"BR-2","skip":false,"parent_attribute":null},{"id":1657,"name":"BR-3","skip":false,"parent_attribute":null},{"id":1658,"name":"BR-4","skip":false,"parent_attribute":null},{"id":1659,"name":"BR-5","skip":false,"parent_attribute":null},{"id":1660,"name":"BL-1","skip":false,"parent_attribute":null},{"id":1661,"name":"BL-2","skip":false,"parent_attribute":null},{"id":1662,"name":"BL-3","skip":false,"parent_attribute":null},{"id":1663,"name":"BL-4","skip":false,"parent_attribute":null},{"id":1664,"name":"BL-5","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}],[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}],[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1672}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1674}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1676}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"65.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1673}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1675}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1677}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1645},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1646},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1647},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1648},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1649},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1650},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1651},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1652},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1653},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1654},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1655},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1656},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1657},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1658},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1659},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1660},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1661},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1662},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1663},{"attribute_id":524,"attribute_option_id":1678}]},{"image":null,"stock":false,"price_change":"95.00","gtin":null,"combination":[{"attribute_id":523,"attribute_option_id":1664},{"attribute_id":524,"attribute_option_id":1678}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":519,"attribute_option_id":1562},{"attribute_id":529,"attribute_option_id":1684}],"allow_backorder":true}],"tags":["don't notify","grill","grills","grillz"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"VSSTARTER":{"id":3736,"details_loaded_time":"2025-07-20 07:07:05","sku":"VSSTARTER","price":"160.00","name":"VS Starter Pack","allow_backorder":1,"erp_id":1866,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3736,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":724,"name":"Bubble Initial Necklace","quantity":1,"description":null,"type":"item","options":[{"id":2323,"name":"Bubble Initial Necklace","skip":false,"item":{"id":1749,"name":"Bubble Initial Necklace","SKU":"BUBBLEINECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":34,"name":"Letter","quantity":1,"description":null,"type":"List","options":[{"id":128,"name":"A","skip":false,"parent_attribute":null},{"id":129,"name":"B","skip":false,"parent_attribute":null},{"id":130,"name":"C","skip":false,"parent_attribute":null},{"id":131,"name":"D","skip":false,"parent_attribute":null},{"id":132,"name":"E","skip":false,"parent_attribute":null},{"id":133,"name":"F","skip":false,"parent_attribute":null},{"id":134,"name":"G","skip":false,"parent_attribute":null},{"id":135,"name":"H","skip":false,"parent_attribute":null},{"id":136,"name":"I","skip":false,"parent_attribute":null},{"id":137,"name":"J","skip":false,"parent_attribute":null},{"id":138,"name":"K","skip":false,"parent_attribute":null},{"id":139,"name":"L","skip":false,"parent_attribute":null},{"id":140,"name":"M","skip":false,"parent_attribute":null},{"id":141,"name":"N","skip":false,"parent_attribute":null},{"id":142,"name":"O","skip":false,"parent_attribute":null},{"id":143,"name":"P","skip":false,"parent_attribute":null},{"id":144,"name":"Q","skip":false,"parent_attribute":null},{"id":145,"name":"R","skip":false,"parent_attribute":null},{"id":146,"name":"S","skip":false,"parent_attribute":null},{"id":147,"name":"T","skip":false,"parent_attribute":null},{"id":148,"name":"U","skip":false,"parent_attribute":null},{"id":149,"name":"V","skip":false,"parent_attribute":null},{"id":150,"name":"W","skip":false,"parent_attribute":null},{"id":151,"name":"X","skip":false,"parent_attribute":null},{"id":152,"name":"Y","skip":false,"parent_attribute":null},{"id":153,"name":"Z","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":27,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":31,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":128},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":129},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":130},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":131},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":132},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":133},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":134},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":135},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":136},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":137},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":138},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":139},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":140},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":141},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":142},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":143},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":144},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":14,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":145},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":21,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":146},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":147},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":148},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":149},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":150},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":151},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":152},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":34,"attribute_option_id":153},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":725,"name":"Balloon Ring","quantity":1,"description":null,"type":"item","options":[{"id":2325,"name":"Balloon Ring","skip":false,"item":{"id":1627,"name":"Balloon Ring","SKU":"BALRNG"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null},{"id":161,"name":"9","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":28,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":23,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":11,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":35,"attribute_option_id":161},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":722,"name":"Hugo Hoops","quantity":1,"description":null,"type":"item","options":[{"id":2320,"name":"Hugo Hoops","skip":false,"item":{"id":1791,"name":"Hugo Hoops","SKU":"HHEAR"},"attributes_per_every_item":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":29,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":723,"name":"Herringbone Bracelet","quantity":1,"description":null,"type":"item","options":[{"id":2321,"name":"Herringbone Bracelet","skip":false,"item":{"id":1793,"name":"Herringbone Bracelet","SKU":"HBRACE"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":6,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":722,"attribute_option_id":2320},{"attribute_id":723,"attribute_option_id":2321},{"attribute_id":724,"attribute_option_id":2323},{"attribute_id":725,"attribute_option_id":2325}],"allow_backorder":true}],"tags":["new","set","topsell","non-custom","szn's greetings campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WBC":{"id":937,"details_loaded_time":"2021-06-25 22:34:35","sku":"WBC","price":"5.00","name":"White Bubble Clip","allow_backorder":0,"erp_id":616,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":937,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":490,"name":"Acrylic","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":490}],"allow_backorder":false}],"tags":["accessories","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WBCHARM":{"id":3641,"details_loaded_time":"2025-07-20 07:16:25","sku":"WBCHARM","price":"18.00","name":"Wish Bone Charm","allow_backorder":1,"erp_id":1812,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":3641,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":36,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["non-custom","the casual edit campaign","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WHOOD":{"id":3008,"details_loaded_time":"2024-02-12 21:26:09","sku":"WHOOD","price":null,"name":"Bone Hoodie","allow_backorder":0,"erp_id":1123,"hidden":1,"add_by_text_field":0,"custom_css":"","kit_item_status":false,"db_id":3008,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":143,"name":"Size:","description":null,"type":"list","options":[{"id":528,"name":"Small","skip":false,"parent_attribute":null},{"id":602,"name":"3XL","skip":false,"parent_attribute":null},{"id":529,"name":"Medium","skip":false,"parent_attribute":null},{"id":530,"name":"Large","skip":false,"parent_attribute":null},{"id":531,"name":"X-Large","skip":false,"parent_attribute":null},{"id":532,"name":"2XL","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":528}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":529}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":530}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":531}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":532}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":143,"attribute_option_id":602}],"allow_backorder":false}],"tags":[],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WHR":{"id":1311,"details_loaded_time":"2025-07-20 08:12:30","sku":"WHR","price":"36.00","name":"White Heart Ring","allow_backorder":1,"erp_id":873,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1311,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":8,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":17,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":7,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["ring","sale","non-custom","ws","heart shape diamond ring","ring for women","blue heart ring","items_mobile_app","opal","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WIN":{"id":1187,"details_loaded_time":"2025-07-20 08:16:43","sku":"WIN","price":"60.00","name":"Wifey Necklace","allow_backorder":0,"erp_id":780,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1187,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":19,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":22,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":1,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["custom","giftcol","wedding","mrs","moh","maid of honor","briide","items_mobile_app","shopify_sync"],"back_order_warning":false,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WIN2":{"id":1186,"details_loaded_time":"2025-07-20 08:18:05","sku":"WIN2","price":"60.00","name":"Wife Necklace","allow_backorder":0,"erp_id":781,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1186,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":31,"name":"Font","quantity":1,"description":null,"type":"list","options":[{"id":120,"name":"Old English","skip":false,"parent_attribute":null},{"id":121,"name":"Script","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":10,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":120},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":18,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":31,"attribute_option_id":121},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["non-custom","giftcol","wedding","items_mobile_app","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WLR":{"id":918,"details_loaded_time":"2021-06-19 03:07:21","sku":"WLR","price":"48.00","name":"White Link Ring","allow_backorder":0,"erp_id":601,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":918,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["ring","new","non-custom"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WPN":{"id":128,"details_loaded_time":"2025-07-20 09:00:38","sku":"WPN","price":"46.00","name":"Winged Pendant Necklace","allow_backorder":1,"erp_id":422,"hidden":0,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":128,"force_allow_backorder":false,"warning_quantity":8,"warning_on_screen":"Almost out of stock! Last Chance to purchase this item!","allow_notification":0,"allow_warning":1,"notification_quantity":null,"notification_on_screen":null,"attributes":[{"id":14,"name":"Length","quantity":1,"description":null,"type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":5,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":true}],"tags":["necklace","sale","non-custom","ws","angel numbers","angle numbers","1111","angle number","angel number","11 11","111","222","333","444","555","666","777","888","999","chicken","pindens","waterproof","tarnish free","tarnishfree","tarnish-free","water proof","items_mobile_app","last chance page","shopify_sync"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WTR":{"id":1109,"details_loaded_time":"2024-05-09 19:58:12","sku":"WTR","price":null,"name":"White Twist Ring","allow_backorder":0,"erp_id":628,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1109,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":4,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"WWSET":{"id":3500,"details_loaded_time":"2024-11-06 17:27:56","sku":"WWSET","price":"140.00","name":"Working Woman Set","allow_backorder":1,"erp_id":1730,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":true,"db_id":3500,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":0,"allow_warning":0,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","top_level":{"attributes":[],"grouped_attributes_ids":[],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"attributes_nested_skip_ids":[]},"attributes":[{"id":650,"name":"The Power Pendant","quantity":1,"description":null,"type":"item","options":[{"id":2038,"name":"The Power Pendant","skip":false,"item":{"id":1726,"name":"The Power Pendant","SKU":"TPPNECK"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":14,"name":"Length","quantity":1,"description":null,"type":"List","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":651,"name":"Executive Studs","quantity":1,"description":null,"type":"item","options":[{"id":2040,"name":"Executive Studs","skip":false,"item":{"id":1715,"name":"Executive Studs","SKU":"EXEST"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":15,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":20},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false},{"id":652,"name":"Daily Band","quantity":1,"description":null,"type":"item","options":[{"id":2042,"name":"Daily Band","skip":false,"item":{"id":1717,"name":"The Daily Band","SKU":"TDBND"},"attributes_per_every_item":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"List","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}]},{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"List","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}]},{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"List","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}]}],"item_option_combinations":[[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}],[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]],"active_combinations":[{"image":null,"stock":12,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":158},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":20,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":159},{"attribute_id":53,"attribute_option_id":255}]},{"image":null,"stock":13,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":35,"attribute_option_id":160},{"attribute_id":53,"attribute_option_id":255}]}],"parent_attribute":null}],"show_with_one_option":false,"skippable":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":650,"attribute_option_id":2038},{"attribute_id":651,"attribute_option_id":2040},{"attribute_id":652,"attribute_option_id":2042}],"allow_backorder":true}],"tags":["new","set","sale","non-custom","ws","don't notify","working woman campaign"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"YLN":{"id":2657,"details_loaded_time":"2024-10-30 16:51:50","sku":"YLN","price":"55.00","name":"Your Loss Necklace","allow_backorder":0,"erp_id":1320,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2657,"force_allow_backorder":false,"warning_quantity":3,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Discontinued Item","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","new","sale","non-custom","ws","silver","silver","heart lock","necklace with a gem","sterling silver necklaces","14k gold","sliver","winter","winter collection","off duty","offduty","off duty collection","future","futuristic","mix metal","mixed metal","gold"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"YRR":{"id":927,"details_loaded_time":"2024-05-09 20:41:00","sku":"YRR","price":"28.35","name":"Yellow Ribbed Ring","allow_backorder":0,"erp_id":603,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":927,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"OUT OF STOCK!","attributes":[{"id":53,"name":"Jewelry Material","quantity":1,"description":null,"type":"list","options":[{"id":488,"name":"Resin","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":53,"attribute_option_id":488}],"allow_backorder":false}],"tags":["sale","non-custom","ws","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"YTHE":{"id":129,"details_loaded_time":"2021-06-25 20:47:08","sku":"YTHE","price":"10.00","name":"Yours Truly Huggie Earrings","allow_backorder":0,"erp_id":423,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":129,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":1,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["earrings","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"YYN":{"id":1176,"details_loaded_time":"2022-03-10 15:07:19","sku":"YYN","price":"20.16","name":"Yin Yang Necklace","allow_backorder":0,"erp_id":776,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1176,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":497,"name":"Zinc","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":37,"name":"16\"","skip":false,"parent_attribute":null,"weight":160}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":33,"price_change":"0.00","combination":[{"attribute_id":14,"attribute_option_id":37},{"attribute_id":53,"attribute_option_id":497}],"allow_backorder":false}],"tags":["necklace","new","sale","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"YYR":{"id":1249,"details_loaded_time":"2024-05-09 18:56:38","sku":"YYR","price":"45.00","name":"Yin Yang Ring","allow_backorder":0,"erp_id":803,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1249,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock. Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Item Discontinued","attributes":[{"id":35,"name":"Ring Size","quantity":1,"description":null,"type":"list","options":[{"id":158,"name":"6","skip":false,"parent_attribute":null},{"id":159,"name":"7","skip":false,"parent_attribute":null},{"id":160,"name":"8","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":35,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":158}],"allow_backorder":false},{"image":null,"stock":11,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":159}],"allow_backorder":false},{"image":null,"stock":23,"price_change":"0.00","combination":[{"attribute_id":35,"attribute_option_id":160}],"allow_backorder":false}],"tags":["ring","sale","non-custom","ws","ying yang","yin yang","ring for women","ying yang ring","pink yin yang","items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ZAF":{"id":1,"details_loaded_time":"2020-05-19 18:11:07","sku":"ZAF","price":"65.00","name":"Zodiac AF","allow_backorder":1,"erp_id":288,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":1,"force_allow_backorder":false,"attributes":[{"id":12,"name":"Zodiac","type":"list","options":[{"id":23,"name":"AquariusAF","skip":false,"parent_attribute":null},{"id":24,"name":"AriesAF","skip":false,"parent_attribute":null},{"id":25,"name":"CancerAF","skip":false,"parent_attribute":null},{"id":26,"name":"CapricornAF","skip":false,"parent_attribute":null},{"id":27,"name":"GeminiAF","skip":false,"parent_attribute":null},{"id":28,"name":"LeoAF","skip":false,"parent_attribute":null},{"id":29,"name":"LibraAF","skip":false,"parent_attribute":null},{"id":30,"name":"PiscesAF","skip":false,"parent_attribute":null},{"id":31,"name":"ScorpioAF","skip":false,"parent_attribute":null},{"id":32,"name":"SagittariusAF","skip":false,"parent_attribute":null},{"id":33,"name":"TaurusAF","skip":false,"parent_attribute":null},{"id":34,"name":"VirgoAF","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":13,"name":"Chain","type":"list","options":[{"id":35,"name":"Regular","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":14,"name":"Length","type":"list","options":[{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200}],"show_with_one_option":false}],"active_combinations":[{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":23},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":24},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":25},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":26},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":27},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":28},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":29},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":30},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":31},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":32},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":33},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true},{"stock":false,"price_change":null,"combination":[{"attribute_id":12,"attribute_option_id":34},{"attribute_id":13,"attribute_option_id":35},{"attribute_id":14,"attribute_option_id":39}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ZAFN":{"id":131,"details_loaded_time":"2022-03-10 16:40:10","sku":"ZAFN","price":"40.60","name":"ZodiacAF Necklace","allow_backorder":0,"erp_id":425,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":131,"force_allow_backorder":false,"attributes":[{"id":11,"name":"Color","type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":12,"name":"Zodiac","type":"list","options":[{"id":23,"name":"AquariusAF","skip":false,"parent_attribute":null},{"id":24,"name":"AriesAF","skip":false,"parent_attribute":null},{"id":25,"name":"CancerAF","skip":false,"parent_attribute":null},{"id":26,"name":"CapricornAF","skip":false,"parent_attribute":null},{"id":27,"name":"GeminiAF","skip":false,"parent_attribute":null},{"id":28,"name":"LeoAF","skip":false,"parent_attribute":null},{"id":29,"name":"LibraAF","skip":false,"parent_attribute":null},{"id":30,"name":"PiscesAF","skip":false,"parent_attribute":null},{"id":31,"name":"ScorpioAF","skip":false,"parent_attribute":null},{"id":32,"name":"SagittariusAF","skip":false,"parent_attribute":null},{"id":33,"name":"TaurusAF","skip":false,"parent_attribute":null},{"id":34,"name":"VirgoAF","skip":false,"parent_attribute":null}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":255,"name":"Stainless Steel","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":23},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":24},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":25},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":16,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":26},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":27},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":28},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":29},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":30},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":31},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":32},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":4,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":33},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","combination":[{"attribute_id":11,"attribute_option_id":19},{"attribute_id":12,"attribute_option_id":34},{"attribute_id":53,"attribute_option_id":255}],"allow_backorder":false}],"tags":["necklace","mayfair","sale","non-custom","ws"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ZTN":{"id":130,"details_loaded_time":"2020-10-07 15:53:40","sku":"ZTN","price":"35.00","name":"Zen Tag Necklace","allow_backorder":0,"erp_id":424,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":130,"force_allow_backorder":false,"attributes":[{"id":14,"name":"Length","type":"list","options":[{"id":38,"name":"18\"","skip":false,"parent_attribute":null,"weight":180},{"id":39,"name":"20\"","skip":false,"parent_attribute":null,"weight":200},{"id":122,"name":"23\"","skip":false,"parent_attribute":null,"weight":230}],"show_with_one_option":false},{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":38},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":"1","price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":39},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false},{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":14,"attribute_option_id":122},{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":false}],"tags":["necklace","sale"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"ZTNpen":{"id":880,"details_loaded_time":"2021-02-11 19:18:10","sku":"ZTNpen","price":"17.50","name":"Zen Tag Necklace--Pendant","allow_backorder":1,"erp_id":566,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":880,"force_allow_backorder":false,"attributes":[{"id":53,"name":"Jewelry Material","type":"list","options":[{"id":253,"name":"Copper","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":null,"combination":[{"attribute_id":53,"attribute_option_id":253}],"allow_backorder":true}],"tags":[],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]},"jit":{"id":2181,"details_loaded_time":"2025-07-20 08:06:04","sku":"jit","price":"41.00","name":"JITEM","allow_backorder":0,"erp_id":569,"hidden":1,"add_by_text_field":0,"custom_css":null,"kit_item_status":false,"db_id":2181,"force_allow_backorder":false,"warning_quantity":4,"warning_on_screen":"Low Stock Order Soon!","allow_notification":1,"allow_warning":1,"notification_quantity":0,"notification_on_screen":"Notify me when this item is back in stock! You will be notified via SMS text message.","attributes":[{"id":11,"name":"Color","quantity":1,"description":null,"type":"list","options":[{"id":19,"name":"18K Gold-Plated","skip":false,"parent_attribute":null},{"id":20,"name":"Silver Plated","skip":false,"parent_attribute":null},{"id":21,"name":"Rose Gold","skip":false,"parent_attribute":null},{"id":22,"name":"Platinum","skip":false,"parent_attribute":null}],"show_with_one_option":false}],"active_combinations":[{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":19}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":20}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":21}],"allow_backorder":false},{"image":null,"stock":false,"price_change":"0.00","gtin":null,"combination":[{"attribute_id":11,"attribute_option_id":22}],"allow_backorder":false}],"tags":["items_mobile_app"],"back_order_warning":true,"fields_rules_hide":false,"kit_items_back_order_warning_overload":[]}},"product_shopify_id_to_sku":{"id_4884954939525":"ZAF","id_4381431431301":"AIRNN","id_4381431529605":"ABP","id_4381431595141":"ANGNN","id_4381431660677":"ANN","id_3969818656879":"ACN","id_4381431726213":"BGNN","id_4381431824517":"BJPN","id_5246640914596":"BBST","id_8777680945316":"BLKLN","id_4381431890053":"BOLNN","id_4371046137989":"BCHSN","id_4371033817221":"BCOEBN","id_4381432021125":"BBNN","id_4381432152197":"BEPN","id_4381432217733":"BNN","id_4381432250501":"CLR","id_5342821974180":"CNAN","id_4381432348805":"CCR","id_4381432414341":"CDN","id_8777679437988":"CJP","id_4381432512645":"CNN2","id_3963660304495":"COENN","id_4381432578181":"CPN","id_4381432610949":"CTN","id_4381432676485":"CHH","id_4381432742021":"CHN2","id_4381432807557":"CRSR","id_4381432840325":"CCHA","id_4381432905861":"CCAP","id_4381432971397":"CCSN","id_4381433069701":"OEBA","id_4381433102469":"CACS","id_5246608670884":"CHC","id_4371050102917":"CHE","id_8777672556708":"CIS","id_4381433233541":"CNN","id_4381433299077":"CNB","id_4381433331845":"CNE","id_4381433397381":"CRR","id_5039291367557":"CSTA","id_4381433528453":"DLR","id_4381433593989":"DNHN","id_4381433626757":"DTN","id_4381433757829":"EEPN","id_4381433856133":"FUSS","id_5246819336356":"FMEH","id_5039291007109":"FMEN","id_4371040272517":"FCN","id_5039289860229":"FCOEIN","id_5039289761925":"FTRG","id_4381433921669":"GFA","id_4381433954437":"GHE","id_4381434019973":"GIPB","id_5246817403044":"GJP","id_4381434216581":"GTH","id_4381434282117":"GNN","id_4381434314885":"GSN","id_4885081063557":"HNN","id_4381434380421":"HSN","id_4381434413189":"HSPN","id_4371008946309":"HPN","id_5246976360612":"IACPN","id_4381434544261":"IDB","id_4381434577029":"IBR","id_4381434708101":"IBLB","id_4371053641861":"IBPN","id_4381434806405":"ICCE","id_4381434904709":"ICLR","id_8777643458724":"IC1","id_4381434937477":"ICH","id_4381435003013":"ICLB","id_4381435068549":"ICN","id_4381435232389":"IIPN","id_4381435297925":"ILH","id_4381435363461":"IMP","id_4381435396229":"IOP","id_4381435723909":"IRR","id_4371041288325":"IDR","id_4371014779013":"ILA","id_4381435789445":"IPCC","id_4371047514245":"GIPN","id_4381435854981":"JBPN","id_4381436051589":"LFIN","id_4381436084357":"LFL","id_5246961320100":"MJA","id_4381436248197":"MJH","id_4381436313733":"MJPN","id_4381436412037":"MACPN","id_5039281995909":"MBHE","id_4381436477573":"MCLR","id_4381436543109":"MCP","id_4381436641413":"MCCH","id_4381436706949":"MIRR","id_4381436772485":"MMN","id_4381436870789":"MPH","id_4381436936325":"MNBN","id_4381436969093":"MNHN","id_4381437034629":"MNSN","id_4381437067397":"OEDB","id_5240811061412":"OEBDN","id_4371054854277":"OEDLN","id_4381437100165":"OEIC","id_4371020939397":"OEIN2","id_4381437165701":"PLE","id_4885106655365":"PCN","id_4381437231237":"PCR","id_8777656172708":"PPN","id_4381437591685":"RNN","id_5241209716900":"RNL","id_4381437788293":"SBCN","id_4381437984901":"SPN","id_4381438017669":"SIN","id_4371007111301":"SNN","id_4381438083205":"SHCNN","id_4371030048901":"SSNN","id_4885113864325":"SSR","id_4381438181509":"SRR","id_4885115043973":"SIR","id_4370992169093":"SSN","id_4381438279813":"SNE","id_4885116518533":"SSD","id_4371050954885":"TCPN","id_4381439164549":"TMN","id_4381439262853":"TMN2","id_4381439393925":"TNN","id_8777652928676":"TSN","id_4381439656069":"VOENN","id_4381439721605":"VBCSN","id_4381439852677":"VSN","id_4381439885445":"WPN","id_4381439950981":"YTHE","id_4885122285701":"ZTN","id_4885122777221":"ZAFN","id_4371687538821":"THETSS","id_4885123858565":"RODS","id_5039262433413":"IZS","id_8777648668836":"TPS","id_4381438345349":"THEAS","id_4381438378117":"THECS","id_4381438607493":"THEDS","id_4381438640261":"THEGS","id_4381438705797":"THEHS","id_4381438738565":"THEHS2","id_4381438804101":"TIS","id_4381438836869":"TJS","id_8777642279076":"TKS","id_4381439033477":"THELS","id_8777618129060":"THELXS","id_4885130346629":"TLS","id_4381439197317":"TMJS","id_4381439295621":"THEMYS","id_4381439459461":"THEOS","id_4381439590533":"THESS","id_4885132771461":"TSS","id_4885133328517":"HFNN","id_4885133787269":"AMN","id_4885134213253":"HONN","id_5294910374052":"OEPN","id_4885134606469":"CSN","id_4885135065221":"CLB","id_4885135392901":"IH2","id_5296656351396":"SOAP","id_4960308691077":"CFN","id_4960355811461":"CFA","id_4960392904837":"CFB","id_4979631259781":"OELN","id_4979727597701":"CNH2","id_4994028568709":"GVL","id_5004814516357":"CHERNG","id_5004849676421":"CHRBN","id_5004879233157":"CLN","id_5004878839941":"CFFN","id_5246674993316":"GICLN","id_5007723593861":"HSH","id_5007732539525":"OEHE","id_5012402536581":"OETN","id_5015981326469":"SPN2","id_5016168628357":"TYA","id_5017073188997":"HBC","id_5017089835141":"LKN","id_5017135153285":"LNKH","id_5017146589317":"MCH","id_5017172377733":"OFN","id_5017201934469":"OESR","id_5296637083812":"TestItem1","id_5296637018276":"Test Item 2","id_5296636887204":"Kit Item Test","id_5296636821668":"Test Item 3","id_5241158533284":"FSE","id_5241575375012":"RPH","id_5296636362916":"SN","id_8602365788324":"INTSTD","id_8777618489508":"IC1pen","id_5425851072676":"VSB","id_5422434549924":"FCHN","id_5422479933604":"SSH","id_5432272978084":"REC","id_5454671380644":"LFC","id_5462265594020":"SES","id_5464107516068":"TBS","id_5464153358500":"TAS","id_5680865181860":"MRH","id_5690977091748":"IBB","id_5746855182500":"ABPpen","id_5790349164708":"HDCLR","id_5790389928100":"SCSR","id_5790411489444":"OHE","id_5790426661028":"BOHE","id_5801058435236":"HBA","id_5803245535396":"OECLR","id_5801254060196":"LCN","id_5801259237540":"DRCN","id_5801308160164":"FCHON","id_5801308094628":"TBCC","id_5801308029092":"TAPN","id_5801307963556":"HEPN","id_5801307898020":"IHN","id_5801383461028":"ICB","id_5801383362724":"CLA","id_5803181637796":"SPN3","id_5803074715812":"OETB","id_5840739958948":"IRN","id_5840806707364":"LBN","id_5840806576292":"ICPC","id_5840806510756":"TFA","id_5850603323556":"MCLN","id_7358246486180":"BPNpen","id_8777616818340":"BLKLNpen","id_8777619669156":"CHN2pen","id_14637623542127":"HPNpen","id_14673291051375":"IBPNpen","id_8777618456740":"IMPpen","id_8405152333988":"GIPNpen","id_8777618325668":"JBPNpen","id_8413695180964":"LFLpen","id_8278631448740":"MJPNpen","id_8197840863396":"MMNpen","id_8777617473700":"PPNpen","id_8411925282980":"TCPNpen","id_8413541105828":"TMNpen","id_5870625915044":"VSHB","id_5941774123172":"IIA","id_5963441602724":"AES","id_5979698331812":"LUS","id_5979753054372":"CHRS","id_8777604890788":"TES","id_5979963654308":"TDS","id_5980148924580":"TAES","id_6627402383524":"PSR","id_6627402514596":"WLR","id_6627403202724":"ACR","id_6627403268260":"YRR","id_6627403366564":"PLR","id_6627402645668":"TRR","id_6627402743972":"BGR","id_6627402842276":"MCR","id_6627402875044":"TCR","id_6627402940580":"TSR","id_6627402973348":"PUPR","id_6627403006116":"GBR","id_6627403432100":"SMR","id_6629104910500":"BLS","id_6629105434788":"CLS","id_6629105041572":"NLS","id_6629122572452":"WBC","id_6629122506916":"BPBC","id_6629121654948":"ACC","id_6629121720484":"CLC","id_6629121753252":"TORTC","id_6679434854564":"PBR","id_6679492034724":"GAR","id_6679481254052":"BR","id_6679487185060":"BRRR","id_6679458939044":"BCR","id_6679461494948":"WTR","id_6679484465316":"NLR","id_6679482859684":"BLR","id_6679502979236":"HR","id_6679553769636":"MR","id_6679555604644":"PBR1","id_6679569105060":"BCR1","id_6679576838308":"GBR1","id_6701097386148":"OMGR","id_6701125238948":"OGS","id_6710870442148":"BLGR","id_6710870016164":"BSR","id_6710869852324":"GGR","id_6710869262500":"SEASR","id_6711419699364":"FPN","id_6737123410084":"EHR","id_6737130455204":"EICLR","id_6737136222372":"ERR","id_6737143496868":"EBR","id_6737153032356":"EBRR","id_6737160306852":"PTC","id_6737163714724":"TABN","id_6737178788004":"HNHN","id_6782120984740":"ECN","id_6782121181348":"OBHE","id_6782121214116":"MTH","id_6782121443492":"DPCE","id_6782120591524":"MACB","id_6782120067236":"CULR","id_6799906537636":"BHE","id_6799906406564":"SFHE","id_6853805932708":"FIGC","id_6870721724580":"BHB","id_6867634192548":"BYYN","id_6867633209508":"BHN","id_6867632586916":"GHN","id_6867631341732":"ISNE","id_6867652772004":"LRIN","id_6867630129316":"PICN","id_6867629277348":"PHN","id_6867652214948":"PYYS","id_6867651887268":"PURYYS","id_6867651756196":"ROME","id_6867651297444":"RTDE","id_6867629801636":"TBFFN","id_6870721855652":"HOF","id_6868185481380":"PNN","id_6940919431332":"ANR","id_6940924346532":"ANGN","id_6871854940324":"PANN","id_6958527905956":"OFR","id_6996153467044":"CHR","id_6902441377956":"PYYN","id_6902441083044":"YYN","id_6902440100004":"BFR","id_6902439313572":"CBR","id_6902438133924":"PPR","id_6932302987428":"WIN","id_6932301250724":"WIN2","id_6932300628132":"SISN","id_6932300202148":"NURN","id_6932269170852":"NANN","id_6932285587620":"MOMN","id_6932285161636":"MOMNE","id_6932284145828":"MAMAN","id_6935640899748":"MION","id_6932493762724":"HCTBN","id_6932266156196":"GRANDN","id_6932265205924":"GIGIN","id_6932410400932":"GRADN","id_6932406730916":"SPDN","id_14638733623663":"FEN","id_6932481474724":"FEN2","id_6964210827428":"ANGR","id_6938431783076":"SSNAURA","id_6938432831652":"SDNAURA","id_6938433487012":"GIOAURA","id_6964177338532":"ANGN2","id_6972082946212":"GVB","id_6972082684068":"YYR","id_7023549677732":"VJC2","id_7092490764452":"CCAN","id_7092549419172":"GMR","id_7092684619940":"BSRI","id_7092687175844":"OTWR","id_7092690190500":"MOR","id_7092694483108":"CMR","id_7092697792676":"RGHR","id_7092699824292":"GGHR","id_7092701462692":"BEHB","id_7092711162020":"CANG","id_7092717093028":"PANGN","id_7092704837796":"EHEN","id_7092659683492":"MUSHN","id_7092656865444":"FPR","id_7092728889508":"CHHR","id_7124189937828":"OANH","id_7124104839332":"BANH","id_7396498047140":"OANHH","id_7396463870116":"BANHCOLLAB","id_7123918520484":"FKNN","id_7123918160036":"CHTN","id_7123734659236":"TFNN","id_7123950534820":"TFIPN","id_7123951091876":"TFTSR","id_7127215571108":"EMSN","id_7127211245732":"ECR","id_7127211180196":"BLSR","id_7127224221860":"BLHR","id_7127226777764":"WHR","id_7381656764580":"BMN","id_7288227758244":"BOX1WED","id_7288227463332":"BOX2WED","id_7288227201188":"BOX3WED","id_7331702505636":"CCANNN","id_7332071342244":"CCBFF","id_7323994783908":"AHE","id_7323994685604":"ASE","id_7322012319908":"TWTTH","id_7322805371044":"SNHBC","id_7322805338276":"FPWRN","id_7322802815140":"LSHBN","id_7322802782372":"OHCN","id_7322802749604":"BFLYH","id_7322802552996":"ASIFB","id_7322715291812":"PCHH","id_7322802520228":"RZRCN","id_7322012287140":"MRCN","id_7322802487460":"STRH","id_7322802454692":"RCANK","id_7322889126052":"CHRTR","id_7322802389156":"LVMN","id_7323994620068":"STARR","id_7414476374180":"RPCHN","id_7464347041956":"BLKHEIT","id_7366964740260":"OHBC","id_7366964543652":"EDBC","id_7443156828324":"BANHCI","id_7443143786660":"OANHCI","id_8149245526180":"WHOOD","id_8777691136164":"TRUCKHAT","id_14683784184175":"MTDC","id_14683781136751":"MTDB","id_7392351977636":"HERNN","id_7443145719972":"ANGNNUM","id_7110980534436":"OANHCOLLABS","id_7443189465252":"HPG","id_7427654680740":"THLSR","id_7427659727012":"DSNHC","id_7427643605156":"BREMN","id_7427642589348":"BRSAN","id_7427663167652":"TGMCN","id_7427665658020":"CRPARC","id_7427668017316":"ONPARC","id_7494148391076":"DHE","id_7494148358308":"TVC","id_7494148325540":"TIC","id_7494148292772":"ODC","id_7494148260004":"YLN","id_7494148194468":"SNR","id_7494148128932":"CTCN","id_7494148030628":"ODH","id_7494147997860":"EBRV","id_7494147899556":"TMNV","id_7494150455460":"HGTC","id_7494150422692":"HGTB","id_7494150389924":"BTC","id_7494150357156":"BTCB","id_7494150324388":"BNPN","id_7494150095012":"DNPN","id_7494150062244":"TFNPN","id_7504449732772":"VLC","id_7504236445860":"ADVENT","id_8177893408932":"CPNMEN","id_8161609482404":"UAN","id_8161596473508":"BADN","id_8161596178596":"MWHN","id_8161598472356":"TIGERSR","id_8161598832804":"TIGERSSR","id_8161607352484":"GTAFCT","id_8161607680164":"CRMT","id_8178722865316":"SCSMEN","id_8174116962468":"HMTE","id_8174112932004":"CGHE","id_8174117191844":"CHBN","id_8174119288996":"CHBB","id_8174155989156":"VIN1","id_8174156152996":"VIN2","id_8174156218532":"VIN3","id_8174156447908":"VIN4","id_8174156546212":"VIN5","id_8174156775588":"VIN6","id_8174156972196":"VIN7","id_8174157070500":"VIN8","id_8174157201572":"VIN9","id_8174157332644":"VIN10","id_8174157463716":"VIN11","id_8174158086308":"VIN12","id_8174158348452":"VIN13","id_8174158643364":"VIN14","id_8174133608612":"SBR","id_8174133936292":"TBLN","id_8174134001828":"BCN","id_8174134067364":"NYGH","id_8174134165668":"EDBB","id_8174134460580":"TSH","id_8174134231204":"RCE","id_8174134362276":"TER","id_14629235818863":"MPBC","id_8178707497124":"MRCMEN2","id_8178709659812":"MRCMEN4","id_8178711494820":"MRCMEN6","id_8178716442788":"MRCMEN8","id_8178719686820":"BCMEN3","id_8178720178340":"BCMEN5","id_8178721194148":"MCLBMEN","id_8178726437028":"RCSMEN","id_8178727747748":"OPNMEN","id_8178728632484":"MPNMEN","id_8178744262820":"FBMEN","id_8178746327204":"CLCMEN","id_8178749178020":"LUCMEN","id_8180180910244":"LUBMEN","id_8178750029988":"HERMEN6","id_8178751504548":"HERMEN3","id_8178720637092":"CSRMEN","id_8178745475236":"TFBMEN","id_8178747080868":"CLBMEN","id_8187579170980":"TSNK","id_8205904052388":"DSE","id_8205905690788":"VCN","id_8205905952932":"VBB","id_8223574392996":"VGIM","id_8205075873956":"IHE","id_8205077086372":"IRC","id_8205079675044":"HHSCN","id_8205390774436":"HSBC","id_8205444677796":"CBC","id_8222135353508":"VSG","id_8222093050020":"OUTLINEGRILL","id_8222156619940":"DCGRILLS","id_8222135189668":"VSGRILLDRIP","id_8222116249764":"DRIPGRILL","id_8222139678884":"VSGRILLBAR","id_8222139580580":"BARGRILL","id_8222155964580":"VSDCGRILL","id_8222179164324":"SINGLET","id_8222179131556":"VSSINGLET","id_8224005587108":"SOILDGRILL","id_8285732405412":"BCROSSN","id_8248743493796":"HNPB","id_8248747131044":"HNPA","id_8307029311652":"GEMBR","id_8307030720676":"HHERN","id_8307031343268":"TDEAR","id_8307031834788":"BALRNG","id_8307032096932":"CCUFFB","id_8307032490148":"CBLCFR","id_8307032785060":"LUXEN","id_8307033112740":"RSNKCH","id_8307033505956":"CONSTUD","id_8335817179300":"LFLP","id_8269690306724":"BLNKIT","id_8278221619364":"HPNKIT","id_8278637609124":"MJPNKIT","id_8284662366372":"JBPNKIT","id_8302981054628":"IC1KIT","id_8307130761380":"TSPLSET","id_8307307118756":"TELVSET","id_8312404246692":"THLDYSET","id_8313091063972":"TVSZNGSET","id_8313094078628":"TVTGEDSET","id_8313098174628":"TCRSHERSET","id_8313099026596":"TGOLDSET","id_8777589555364":"TELIASET","id_8316223291556":"ADVENTBOX2","id_8316264710308":"MXMLSET","id_8316270018724":"SWNASET","id_8316274901156":"STKEARSET","id_8316304425124":"CREARSET","id_8316323659940":"ESRNGSET","id_8316328411300":"SCRRNGSET","id_8319561793700":"TSETKIT","id_14660452122991":"TRAESET","id_8362035642532":"DHERCH","id_8366935277732":"FIGCH","id_8366936490148":"HERBLPN","id_8366938063012":"DBLPN","id_8366939472036":"FIGBLPN","id_8405152759972":"GIPNKIT","id_8405183791268":"IBFPNKIT","id_8405190279332":"IMPKIT","id_8405824176292":"PPNKIT","id_8405890728100":"CHN2KIT","id_8411944353956":"TCPNKIT","id_8413558112420":"TMNKIT","id_8414845599908":"CJPKIT","id_8777615671460":"CJPpen","id_8427437293732":"CEC","id_8427449974948":"AHEAR","id_8427457872036":"EXEST","id_8427469570212":"SIGLB","id_8427485528228":"TDBND","id_8450838593700":"SEAR","id_8450843934884":"OOFCHOKER","id_8443571110052":"TBCNECK","id_8450844786852":"BEBRACE","id_8572826714276":"THLOCK","id_8453069176996":"TPPNECK","id_8453069504676":"PRESRING","id_8453069799588":"TDUCHRING","id_8452912644260":"EDBSTACK","id_8453039587492":"WWSET","id_8453042929828":"CSSET","id_8504280842404":"TFIYH","id_8486611845284":"STH","id_8514920644772":"ELCH","id_8514928967844":"USH","id_8514928541860":"LYTH","id_8449297481892":"THLOCKKIT","id_8663213375652":"TCCUFF","id_8667362590884":"ABAND","id_14688295027055":"BNPNECK","id_8682184999076":"TCALNECK","id_8682231759012":"CIAOBEAR","id_8682254500004":"OHHOOPS","id_8682266263716":"NEAR","id_8682402709668":"MRING","id_8682410148004":"BUBBLEINECK","id_8682411786404":"CRING","id_8682451566756":"SCP","id_14683805352303":"POSPENN","id_8682526048420":"POSPENNKIT","id_8684364234916":"TSBELLYC","id_8684439175332":"AGEMNECK","id_8684441338020":"CBN","id_8684445466788":"CBAMBOOH","id_8684451692708":"CHBELLYC","id_8686324187300":"CHERGANK","id_8687949480100":"HERBELLYCHAIN","id_8687982379172":"TGOLDENHSET","id_8690081104036":"ENDSUMSET","id_8690314346660":"TCOASTSET","id_8696737988772":"BOXCANK","id_8696757026980":"MARCANK","id_8696770003108":"BEADCANK","id_8697624035492":"BALLCANK","id_8697976357028":"MYSTERYBOX2G","id_8697988153508":"MYSTERYBOX2S","id_8697992085668":"MYSTERYBOX3G","id_8697999786148":"MYSTERYBOX3S","id_8698002407588":"MYSTERYBOX4G","id_8698006077604":"MYSTERYBOX4S","id_14617997508975":"DDH","id_14618003145071":"HHEAR","id_14618003767663":"GFB","id_14618005406063":"HBRACE","id_14618005340527":"BACB","id_14618006880623":"THAC","id_14618008027503":"NFBAND","id_14617992888687":"TPR","id_14618013663599":"DCCB","id_14618007994735":"TLGN","id_14617994264943":"TCH","id_14619145273711":"GLBCN","id_14619148583279":"CARANECK","id_14619257766255":"VGC","id_14643957760367":"LC","id_14643957399919":"GLC","id_14619155530095":"LMC","id_14619155825007":"KC","id_14619279556975":"TEDBANG","id_14619155759471":"ABC","id_14619157365103":"GEMC","id_14619157332335":"WBCHARM","id_14619157266799":"LYC","id_14619157234031":"ISABC","id_14619157168495":"STARC","id_14619157037423":"ANGWINC","id_14619156971887":"BLESSC","id_14619156939119":"AMORC","id_14619156906351":"MARTC","id_14619156873583":"GOODVC","id_14618013565295":"BLKCR","id_14619131019631":"GLBCHARMNECK","id_14617988956527":"TESSET","id_14618033160559":"FCNECK","id_14618003571055":"INTIALCHARM","id_14619135869295":"CHARMLETTERS","id_14619239645551":"CHARM1","id_14619268284783":"CHARM2","id_14619278311791":"THREECHARMNECK","id_14625116946799":"CHATPIN","id_14625117831535":"ELYH","id_14625118454127":"VLYH","id_14630938902895":"BINSTDS","id_14636562514287":"MMCR","id_14636600197487":"TEDRING","id_14636628705647":"TGENBAND","id_14636652069231":"TISABAND","id_14636679954799":"TMBRACE","id_14636691390831":"THEOAK","id_14636740116847":"THEMARG","id_14636730089839":"BAGHUG","id_14636730057071":"GEMCPEN","id_14636741296495":"TOB","id_14636778226031":"THC","id_14636778094959":"SPENN","id_14636777472367":"TSE","id_14636747129199":"EH","id_14636747096431":"FAV","id_14636049695087":"DFIGAROC","id_14636054937967":"CASHSET","id_14636554453359":"CBKS","id_14636555501935":"TMMS","id_14637321159023":"TVSET","id_14637326958959":"FROSTSET","id_14638015644015":"THECLASSSET","id_14638017708399":"THESILVSET","id_14638019051887":"VSSTARTER","id_14640965943663":"4itemalt","id_14643023774063":"5itemmystery","id_14657969324399":"CDC","id_14657973420399":"CRCHARM","id_14657973387631":"CCCHARM","id_14657973354863":"CUPC","id_14657973322095":"BUCHARM","id_14657973289327":"PDHC","id_14657973191023":"CDHC","id_14658220556655":"BDCHARM","id_14658219606383":"MACHARM","id_14658218787183":"AOHC","id_14658505376111":"AOSC","id_14658505343343":"ROCHARM","id_14658505310575":"GBCHARM","id_14658505277807":"MCHARM","id_14670361919855":"PENMM","id_14683785134447":"TDAILYSET","id_14691751559535":"FIVEITEMMYSTERYSILVER","id_14696310079855":"SIXITEMGOLD","id_14696302182767":"SIXITEMSILVER","id_14696744681839":"SHRING","id_14697320841583":"JULHOOP","id_14697321726319":"OLRING","id_14698933879151":"MIXCUFF","id_14697321300335":"SAGEPEN","id_14697329295727":"HONHOOP","id_14697336177007":"VALBRAC","id_14697354166639":"LEMDEAR","id_14697355739503":"MONCRIS","id_14697367896431":"POPRING","id_14697367863663":"THYNECK","id_14697367830895":"GRHANDC","id_14697367798127":"CRYHANDC","id_14698413097327":"LOTPENDANT","id_14698902126959":"COCONECK","id_14698920608111":"CHOOSEBRACE","id_14698923622767":"CUSTOMCHARMBRACE","id_14698952950127":"CUSTOMBLOCKBRACE","id_14698959405423":"CUSTOMMULTIBLOCKNAME","id_14699700453743":"CKEYCHAIN","id_14699707728239":"LOTNECKIT","id_14699738399087":"CHKEYCHAIN","id_14699741675887":"CHNECKLACE","id_14713595363695":"GCPKIT","id_14729228452207":"DBINECK","id_14729228616047":"DBIBRACE","id_14728760885615":"TAE","id_14728760918383":"TME","id_14728748269935":"LEGCN","id_14728748237167":"SPNECK","id_14728747909487":"TMT","id_14728747647343":"SCNECK","id_14728748335471":"PLN","id_14728748597615":"LCNECK","id_14728729854319":"RESET","id_14728740045167":"TNEXTUP","id_14728748794223":"TWIY","id_14728752464239":"MCNECK","id_14728753217903":"MVPCUFF","id_14728754168175":"THBRACE","id_14728757543279":"TKCUFF","id_14728767471983":"EPB","id_14728780874095":"CHAMP","id_14729100362095":"TLEGH","id_14729100198255":"HOFAME","id_14729100820847":"PLAYCLUB","id_14729101377903":"ATHDEP","id_14729150071151":"OSRINGBRACE","id_14729149514095":"CALLYOURSHOT","id_14729148727663":"TGEMR","id_14729155936623":"CSRING","id_14729163735407":"ASTARR","id_14729236742511":"BEZBAND","id_14729237561711":"MLBAND","id_14753573699951":"MAHOGSET","id_14753599521135":"THESUMSET","id_14753614823791":"THEGEMSET","id_14753629307247":"THECHAMPSET"},"SNAPSHOT":"__SNAPSHOT__","SNAPSHOT_ID":"__SNAPSHOT_ID__","SNAPSHOT_TIME":"__SNAPSHOT_TIME__","test_page":0,"show_name":0,"file_time":"2025-06-24T18:26:30+00:00"}/*PARAMS_END*/;
}


  function replaceAll(search, replacement, str)
  {
    return str.split(search).join(replacement);
  };


	var loadScript = function(url, callback)
	{
		var script = document.createElement("script");
		script.type = "text/javascript";

		// If the browser is Internet Explorer.
		if (script.readyState)
		{
			script.onreadystatechange = function(){
			if (script.readyState == "loaded" || script.readyState == "complete")
			{
				script.onreadystatechange = null;
				callback();
			}
		};
	// For any other browser.
	}
	else
	{
		script.onload = function()
		{
			callback();
		};
	}

	script.src = url;
	document.getElementsByTagName("head")[0].appendChild(script);

};


function extOptsTrackError(t)
{
  var params = getExtOptsStorefrontParams();
	var url = params.error_track_url;
  var sku = '-';

  if (window.ShopifyAnalytics)
  {
    if (window.ShopifyAnalytics.meta)
    {
      if (sku = window.ShopifyAnalytics.meta['product'])
      {
        sku = window.ShopifyAnalytics.meta['product']['variants'][0]['sku'];
      }
    }
  }

  var text = t.toString();
  text += " === " + t.stack;
  console.log('eo-e- ', text);
  
  url = replaceAll('__text__', encodeURIComponent(text), url);
  url = replaceAll('__url__', encodeURIComponent(location.href), url);
  url = replaceAll('__sku__', encodeURIComponent(sku), url);
  url = replaceAll('__ver__', encodeURIComponent(params.ver), url);

	(new Image()).src = url;
}

function myAppJavaScriptWrapper(jQueryFunc)
{

  try
  {
    myAppJavaScript(jQueryFunc);
  }
	catch(e)
	{
    extOptsTrackError(e);
    console.log(e.stack);
  	throw e;
	}

}

if (window["ext_opts_js_theme_embedded"])
{
  //console.log('exit external js, discovered embedded');
  //return;
}
else
{
  //console.log('run external js, no embedded');
  window["ext_opts_js_external"] = true;

  /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
  we will load jQuery from the Google CDN, and when it's fully loaded, we will run
  our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
  as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7))
  {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function()
    {
      var jQuery191 = jQuery.noConflict(true);
      myAppJavaScriptWrapper(jQuery191);
    });
  }
  else
  {
    myAppJavaScriptWrapper(jQuery);
  }
};

})();



/* EXT_OPTS_JS_EMBED_END */

